{
  "ccommerce.commerce-payment-method-manage-ccp.email.subject.ach-direct-debit-dispute": [
    {
      "type": 0,
      "value": "Action required: ACH Direct debit payment failed"
    }
  ],
  "commerce-access-invalid-payment-ccp.email.subject": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "commerce-access-invalid-payment-hams.email.subject": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "commerce-auto-cancellation-uninvoiceable-ccp.email.get-in-touch": [
    {
      "type": 0,
      "value": "To understand more on why we couldn't generate your invoice, please "
    },
    {
      "type": 1,
      "value": "getInTouchLink"
    },
    {
      "type": 0,
      "value": " with us."
    }
  ],
  "commerce-auto-cancellation-uninvoiceable-ccp.email.get-in-touch-link": [
    {
      "type": 0,
      "value": "get in touch"
    }
  ],
  "commerce-auto-cancellation-uninvoiceable-ccp.email.no-invoice-generation": [
    {
      "type": 0,
      "value": "We couldn't generate an invoice for your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription ("
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": ") as we don't have\n\t\t\t\tyour complete billing information. As a result, your subscription has been canceled."
    }
  ],
  "commerce-auto-cancellation-uninvoiceable-ccp.email.reactivate-instructions-1": [
    {
      "type": 0,
      "value": "Once you’ve updated the billing details, reactivate your subscription by going to "
    }
  ],
  "commerce-auto-cancellation-uninvoiceable-ccp.email.reactivate-instructions-2": [
    {
      "type": 0,
      "value": "Subscriptions > Inactive "
    }
  ],
  "commerce-auto-cancellation-uninvoiceable-ccp.email.reactivate-instructions-3": [
    {
      "type": 0,
      "value": "tab"
    }
  ],
  "commerce-auto-cancellation-uninvoiceable-ccp.email.reactivate-instructions-4": [
    {
      "type": 0,
      "value": " > Reactivate"
    }
  ],
  "commerce-auto-cancellation-uninvoiceable-ccp.email.reactivate-instructions-5": [
    {
      "type": 0,
      "value": ". If you reactivate your subscription within 60 days of cancellation, your data and preferences will remain the same."
    }
  ],
  "commerce-auto-cancellation-uninvoiceable-ccp.email.title": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription has been canceled"
    }
  ],
  "commerce-auto-cancellation-uninvoiceable-ccp.email.update-billing-details-button": [
    {
      "type": 0,
      "value": "Update billing details"
    }
  ],
  "commerce-auto-cancellation-uninvoiceable-ccp.email.update-billing-details-partner-button": [
    {
      "type": 0,
      "value": "Update billing details"
    }
  ],
  "commerce-auto-cancellation-uninvoiceable-ccp.email.wrong-details": [
    {
      "type": 0,
      "value": "It could be because you’ve entered the wrong details, or that the information you’ve provided us is\n\t\t\t\tincomplete. Don't worry, you can reactivate your subscription after updating your billing information."
    }
  ],
  "commerce-cancellation-occurs-offering-archived-ccp.email.reactivate-instructions-1": [
    {
      "type": 0,
      "value": "To reactivate your subscription, go to "
    }
  ],
  "commerce-cancellation-occurs-offering-archived-ccp.email.reactivate-instructions-2": [
    {
      "type": 0,
      "value": "Subscriptions > Inactive "
    }
  ],
  "commerce-cancellation-occurs-offering-archived-ccp.email.reactivate-instructions-3": [
    {
      "type": 0,
      "value": "tab"
    }
  ],
  "commerce-cancellation-occurs-offering-archived-ccp.email.reactivate-instructions-4": [
    {
      "type": 0,
      "value": " > Reactivate."
    }
  ],
  "commerce-credit-account-deactivation-ccp.clear-unpaid-invoices": [
    {
      "type": 0,
      "value": "Clear any unpaid invoices associated with your account."
    }
  ],
  "commerce-credit-account-deactivation-ccp.message-template.deactivation.help-message": [
    {
      "type": 0,
      "value": "We understand that managing payments can sometimes be challenging, and we're here to help."
    }
  ],
  "commerce-credit-account-deactivation-ccp.message-template.deactivation.learn-reasons": [
    {
      "type": 0,
      "value": "Learn about possible reasons"
    }
  ],
  "commerce-credit-account-deactivation-ccp.message-template.deactivation.message": [
    {
      "type": 0,
      "value": "You can no longer use Net-"
    },
    {
      "type": 1,
      "value": "netTermsDuration"
    },
    {
      "type": 0,
      "value": " payment terms to place your orders as your billing account’s eligibility has been suspended. "
    },
    {
      "type": 1,
      "value": "learnReason"
    }
  ],
  "commerce-credit-account-deactivation-ccp.message-template.deactivation.title": [
    {
      "type": 0,
      "value": "You’re no longer eligible for Net-"
    },
    {
      "type": 1,
      "value": "netTermsDuration"
    },
    {
      "type": 0,
      "value": " terms"
    }
  ],
  "commerce-credit-account-deactivation-ccp.reach-out": [
    {
      "type": 0,
      "value": "Reach out to us so we can review your eligibility."
    }
  ],
  "commerce-credit-account-deactivation-ccp.reconsider-eligibility": [
    {
      "type": 0,
      "value": "If you’d like us to reconsider your eligibility for Net-"
    },
    {
      "type": 1,
      "value": "netTermsDuration"
    },
    {
      "type": 0,
      "value": " payment terms, we suggest you to:"
    }
  ],
  "commerce-credit-account-deactivation-ccp.view-unpaid-invoices-link": [
    {
      "type": 0,
      "value": "View unpaid invoices"
    }
  ],
  "commerce-credit-account-limit-increase-request-rejection-ccp.message-template.couldn't-approve-request": [
    {
      "type": 0,
      "value": "Unfortunately, we couldn’t approve your request because you’ve reached the maximum credit limit that we can offer at this time. You can check back in a few months to see if your eligibility has changed."
    }
  ],
  "commerce-credit-account-limit-increase-request-rejection-ccp.message-template.email.subject": [
    {
      "type": 0,
      "value": "Unable to offer a higher Net-"
    },
    {
      "type": 1,
      "value": "netTermsDuration"
    },
    {
      "type": 0,
      "value": " credit limit"
    }
  ],
  "commerce-credit-account-limit-increase-request-rejection-ccp.message-template.rejected.title": [
    {
      "type": 0,
      "value": "We’re unable to offer you a higher Net-"
    },
    {
      "type": 1,
      "value": "netTermsDuration"
    },
    {
      "type": 0,
      "value": " credit limit"
    }
  ],
  "commerce-credit-account-limit-increase-request-rejection-ccp.message-template.thank-you.submitting": [
    {
      "type": 0,
      "value": "Thank you for submitting your application for increasing your Atlassian Net-"
    },
    {
      "type": 1,
      "value": "netTermsDuration"
    },
    {
      "type": 0,
      "value": " credit limit."
    }
  ],
  "commerce-credit-account-limit-increase-request-rejection-ccp.move-forward": [
    {
      "type": 0,
      "value": "You can still move forward with your purchase. We suggest using a credit card to pay for your order. Reach out to us if you need further help in placing your order."
    }
  ],
  "commerce-credit-account-reactivation-ccp.message-template.good-news.restored.billing.account": [
    {
      "type": 0,
      "value": "Good news! We’ve restored your billing account’s eligibility for Net-"
    },
    {
      "type": 1,
      "value": "netTermsDuration"
    },
    {
      "type": 0,
      "value": " payment terms. Here are the details:"
    }
  ],
  "commerce-credit-account-reactivation-ccp.message-template.restored.title": [
    {
      "type": 0,
      "value": "Your eligibility has been restored"
    }
  ],
  "commerce-invoice-drawdown-ccp.message-template.confirm": [
    {
      "type": 0,
      "value": "This email confirms that we've generated your invoice "
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": ". The invoice is attached as a PDF for your records."
    }
  ],
  "commerce-invoice-drawdown-ccp.message-template.covered-by-wallet": [
    {
      "type": 0,
      "value": "This invoice is covered by the funds available in your wallet."
    }
  ],
  "commerce-invoice-drawdown-ccp.message-template.title": [
    {
      "type": 0,
      "value": "Your invoice has been generated"
    }
  ],
  "commerce-invoice-generated-ccp-g.message-template.confirm": [
    {
      "type": 0,
      "value": "Thanks for choosing Atlassian. This email is to confirm that we’ve generated your invoice "
    },
    {
      "type": 1,
      "value": "businessKey"
    },
    {
      "type": 0,
      "value": ". "
    }
  ],
  "commerce-invoice-generated-ccp-g.message-template.partner.confirm": [
    {
      "type": 0,
      "value": "This email is to confirm that we’ve generated the following invoice. The payment due date is "
    },
    {
      "type": 1,
      "value": "dueDate"
    }
  ],
  "commerce-invoice-generated-ccp-g.message-template.partner.invoice-attached": [
    {
      "type": 0,
      "value": "The invoice is attached as a PDF for your records."
    }
  ],
  "commerce-invoice-generated-ccp-g.message-template.title": [
    {
      "type": 0,
      "value": "Your invoice has been generated"
    }
  ],
  "commerce-invoice-generated-ccp.message-template.confirm": [
    {
      "type": 0,
      "value": "Thanks for choosing Atlassian. This email is to confirm that we’ve generated your invoice "
    },
    {
      "type": 1,
      "value": "businessKey"
    },
    {
      "type": 0,
      "value": ". "
    }
  ],
  "commerce-invoice-generated-ccp.message-template.partner.confirm": [
    {
      "type": 0,
      "value": "This email is to confirm that we’ve generated the following invoice. The payment due date is "
    },
    {
      "type": 1,
      "value": "dueDate"
    }
  ],
  "commerce-invoice-generated-ccp.message-template.partner.invoice-attached": [
    {
      "type": 0,
      "value": "The invoice is attached as a PDF for your records."
    }
  ],
  "commerce-invoice-generated-ccp.message-template.title": [
    {
      "type": 0,
      "value": "Your invoice has been generated"
    }
  ],
  "commerce-invoice-terms-payment-pending-ccp-g.message-template.dc-message": [
    {
      "type": 0,
      "value": "Thanks for choosing Atlassian. This email is to confirm that we’ve generated your invoice "
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": ". The\n\t\t\t\tinvoice is attached as a PDF for your records."
    }
  ],
  "commerce-invoice-terms-payment-pending-ccp-g.message-template.invoice-attached": [
    {
      "type": 0,
      "value": "The attached invoice is to be paid before the due date mentioned in the invoice."
    }
  ],
  "commerce-invoice-terms-payment-pending-ccp-g.message-template.manage-invoices": [
    {
      "type": 0,
      "value": "To view or manage your invoices and subscription, go to your site's Administration."
    }
  ],
  "commerce-invoice-terms-payment-pending-ccp-g.message-template.partner-message": [
    {
      "type": 0,
      "value": "This email is to confirm that we’ve generated the following invoice. The payment due date is "
    },
    {
      "type": 1,
      "value": "dueDate"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce-invoice-terms-payment-pending-ccp-g.message-template.partner.invoice-attached": [
    {
      "type": 0,
      "value": "The invoice is attached as a PDF for your records."
    }
  ],
  "commerce-invoice-terms-payment-pending-ccp-g.message-template.title": [
    {
      "type": 0,
      "value": "Your invoice has been generated"
    }
  ],
  "commerce-invoice-terms-payment-pending-ccp-g.message-template.view-subscription": [
    {
      "type": 0,
      "value": "View subscription"
    }
  ],
  "commerce-invoice-terms-payment-pending-ccp.message-template.dc-message": [
    {
      "type": 0,
      "value": "Thanks for choosing Atlassian. This email is to confirm that we’ve generated your invoice "
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": ". The\n\t\t\t\tinvoice is attached as a PDF for your records."
    }
  ],
  "commerce-invoice-terms-payment-pending-ccp.message-template.invoice-attached": [
    {
      "type": 0,
      "value": "The attached invoice is to be paid before the due date mentioned in the invoice."
    }
  ],
  "commerce-invoice-terms-payment-pending-ccp.message-template.manage-invoices": [
    {
      "type": 0,
      "value": "To view or manage your invoices and subscription, go to your site's Administration."
    }
  ],
  "commerce-invoice-terms-payment-pending-ccp.message-template.partner-message": [
    {
      "type": 0,
      "value": "This email is to confirm that we’ve generated the following invoice. The payment due date is "
    },
    {
      "type": 1,
      "value": "dueDate"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce-invoice-terms-payment-pending-ccp.message-template.partner.invoice-attached": [
    {
      "type": 0,
      "value": "The invoice is attached as a PDF for your records."
    }
  ],
  "commerce-invoice-terms-payment-pending-ccp.message-template.title": [
    {
      "type": 0,
      "value": "Your invoice has been generated"
    }
  ],
  "commerce-invoice-terms-payment-pending-ccp.message-template.view-subscription": [
    {
      "type": 0,
      "value": "View subscription"
    }
  ],
  "commerce-invoice-updated-ccp-g.message-template.invoice-attached": [
    {
      "type": 0,
      "value": "For your records, the invoice is attached as a PDF."
    }
  ],
  "commerce-invoice-updated-ccp-g.message-template.title": [
    {
      "type": 0,
      "value": "Your invoice has been updated"
    }
  ],
  "commerce-invoice-updated-ccp-g.message-template.updated": [
    {
      "type": 0,
      "value": "This is a follow up email about the credit note generated against your subscription cancellation\n                    request. To process this request, we've updated your existing invoice with the latest changes."
    }
  ],
  "commerce-invoice-updated-ccp-g.message-template.updated_partner": [
    {
      "type": 0,
      "value": "This is a follow up email about the credit note generated against a subscription cancellation\n\t\t\t\trequest. To process this request, we've updated your existing invoice with the latest changes."
    }
  ],
  "commerce-invoice-updated-ccp-g.message-template.view-invoice": [
    {
      "type": 0,
      "value": "View Invoice"
    }
  ],
  "commerce-invoice-updated-ccp.message-template.invoice-attached": [
    {
      "type": 0,
      "value": "For your records, the invoice is attached as a PDF."
    }
  ],
  "commerce-invoice-updated-ccp.message-template.title": [
    {
      "type": 0,
      "value": "Your invoice has been updated"
    }
  ],
  "commerce-invoice-updated-ccp.message-template.updated": [
    {
      "type": 0,
      "value": "This is a follow up email about the credit note generated against your subscription cancellation\n                    request. To process this request, we've updated your existing invoice with the latest changes."
    }
  ],
  "commerce-invoice-updated-ccp.message-template.updated_partner": [
    {
      "type": 0,
      "value": "This is a follow up email about the credit note generated against a subscription cancellation\n\t\t\t\trequest. To process this request, we've updated your existing invoice with the latest changes."
    }
  ],
  "commerce-invoice-updated-ccp.message-template.view-invoice": [
    {
      "type": 0,
      "value": "View Invoice"
    }
  ],
  "commerce-marketing-multiple-product-upgrade-ccp-multiple.message.entity.link.label": [
    {
      "type": 0,
      "value": "Atlassian Administration"
    }
  ],
  "commerce-marketing-multiple-product-upgrade-ccp-multiple.product.purchased.message.body.multiple": [
    {
      "type": 0,
      "value": "Get a free trial of "
    },
    {
      "type": 1,
      "value": "firstEntitlementProductName"
    },
    {
      "type": 0,
      "value": " & "
    },
    {
      "type": 1,
      "value": "secondEntitlementProductName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "firstEntitlementOfferingName"
    },
    {
      "type": 0,
      "value": " with your "
    },
    {
      "type": 1,
      "value": "purchasedEntitlementProductName"
    },
    {
      "type": 0,
      "value": " purchase."
    }
  ],
  "commerce-marketing-multiple-product-upgrade-ccp-multiple.product.purchased.message.title.different.trial.lengths.multiple": [
    {
      "type": 0,
      "value": "Try "
    },
    {
      "type": 1,
      "value": "firstEntitlementProductName"
    },
    {
      "type": 0,
      "value": " & "
    },
    {
      "type": 1,
      "value": "secondEntitlementProductName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "firstEntitlementOfferingName"
    },
    {
      "type": 0,
      "value": " free"
    }
  ],
  "commerce-marketing-multiple-product-upgrade-ccp-multiple.product.purchased.message.title.multiple": [
    {
      "type": 0,
      "value": "Try "
    },
    {
      "type": 1,
      "value": "firstEntitlementProductName"
    },
    {
      "type": 0,
      "value": " & "
    },
    {
      "type": 1,
      "value": "secondEntitlementProductName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "firstEntitlementOfferingName"
    },
    {
      "type": 0,
      "value": " free for "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " day"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " days"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "firstEntitlementTrialLength"
    }
  ],
  "commerce-marketing-multiple-product-upgrade-ccp-single.message.entity.link.label": [
    {
      "type": 0,
      "value": "Atlassian Administration"
    }
  ],
  "commerce-marketing-multiple-product-upgrade-ccp-single.product.purchased.message.title.single": [
    {
      "type": 0,
      "value": "Try "
    },
    {
      "type": 1,
      "value": "firstEntitlementProductName"
    }
  ],
  "commerce-marketing-multiple-product-upgrade-ccp-single.product.purchased.try.confluence.message.body.single": [
    {
      "type": 0,
      "value": "Tired of hunting for the right doc? Build a single source of truth for your team's info with Confluence "
    },
    {
      "type": 1,
      "value": "firstEntitlementOfferingName"
    },
    {
      "type": 0,
      "value": ". Free for "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " day"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " days"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "firstEntitlementTrialLength"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce-marketing-multiple-product-upgrade-ccp-single.product.purchased.try.jira.message.body.single": [
    {
      "type": 0,
      "value": "With Jira, your team can move fast, stay aligned, and build better - together. Try the "
    },
    {
      "type": 1,
      "value": "firstEntitlementOfferingName"
    },
    {
      "type": 0,
      "value": " plan free for "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " day"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " days"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "firstEntitlementTrialLength"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce-marketing-multiple-product-upgrade-ccp-single.product.purchased.try.jpd.message.body.single": [
    {
      "type": 0,
      "value": "Say goodbye to messy backlogs. Keep your brilliant ideas in one place with Jira Product Discovery "
    },
    {
      "type": 1,
      "value": "firstEntitlementOfferingName"
    },
    {
      "type": 0,
      "value": ". Free for "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " day"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " days"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "firstEntitlementTrialLength"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce-marketing-multiple-product-upgrade-ccp-single.product.purchased.try.jsm.message.body.single": [
    {
      "type": 0,
      "value": "Bring developers, IT, and ops on the same tool and make work visible across teams with the "
    },
    {
      "type": 1,
      "value": "firstEntitlementOfferingName"
    },
    {
      "type": 0,
      "value": " plan. Free for "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " day"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " days"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "firstEntitlementTrialLength"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce-marketing-multiple-product-upgrade-ccp.subtext": [
    {
      "type": 0,
      "value": "Atlassian Administration"
    }
  ],
  "commerce-on-account-approval-partner.email.attached-instructions": [
    {
      "type": 0,
      "value": "We've attached instructions outlining how to read your statement."
    }
  ],
  "commerce-on-account-approval-partner.email.good-news": [
    {
      "type": 0,
      "value": "Good news! We’ve approved your application for Pay on account with terms of Net-\n\t\t\t\t"
    },
    {
      "type": 1,
      "value": "netTermsDuration"
    },
    {
      "type": 0,
      "value": " days from statement date."
    }
  ],
  "commerce-on-account-approval-partner.email.list.billing-account": [
    {
      "type": 0,
      "value": "Billing account: "
    },
    {
      "type": 1,
      "value": "transactionAccountNum"
    }
  ],
  "commerce-on-account-approval-partner.email.list.payment-method": [
    {
      "type": 0,
      "value": "Payment method: Pay on account"
    }
  ],
  "commerce-on-account-approval-partner.email.list.payment-terms": [
    {
      "type": 0,
      "value": "Payment terms: Net-"
    },
    {
      "type": 1,
      "value": "netTermsDuration"
    }
  ],
  "commerce-on-account-approval-partner.email.payment-option-details": [
    {
      "type": 0,
      "value": "This payment option allows you to buy your Atlassian products now, and pay within\n\t\t\t\t"
    },
    {
      "type": 1,
      "value": "netTermsDuration"
    },
    {
      "type": 0,
      "value": " days from the statement date"
    }
  ],
  "commerce-on-account-approval-partner.email.statement-info": [
    {
      "type": 0,
      "value": "As Pay on account Partner, you will now receive a statement twice a month (on the 1st and 16th) covering\n\t\t\t\tinvoices for the periods 16th to last day and 1st to 15th respectively."
    }
  ],
  "commerce-on-account-approval-partner.email.subject": [
    {
      "type": 0,
      "value": "Your Pay on account request is approved"
    }
  ],
  "commerce-on-account-approval-partner.email.title": [
    {
      "type": 0,
      "value": "Your Pay on account request has been approved"
    }
  ],
  "commerce-on-account-deactivation-partner-ccp.email.accountsreceivable": [
    {
      "type": 0,
      "value": "accountsreceivable@atlassian.com"
    }
  ],
  "commerce-on-account-deactivation-partner-ccp.email.apply-again": [
    {
      "type": 0,
      "value": "You may apply again for Pay on account option after 6 months. Don’t worry, you can still place new orders using a credit card. "
    }
  ],
  "commerce-on-account-deactivation-partner-ccp.email.contact-us": [
    {
      "type": 0,
      "value": "Should you have questions or wish to discuss ways to reactivate your pay on account option, please contact us at "
    },
    {
      "type": 1,
      "value": "accountsReceivableEmail"
    }
  ],
  "commerce-on-account-deactivation-partner-ccp.email.list.billing-account": [
    {
      "type": 0,
      "value": "Billing account: "
    },
    {
      "type": 1,
      "value": "transactionAccountNum"
    }
  ],
  "commerce-on-account-deactivation-partner-ccp.email.list.payment-method": [
    {
      "type": 0,
      "value": "Payment method: Pay on account"
    }
  ],
  "commerce-on-account-deactivation-partner-ccp.email.on-account-being-deactivated": [
    {
      "type": 0,
      "value": "Your Pay on account option with Atlassian is being deactivated effective immediately, due to overdue balances and failure to meet the agreed payment terms. "
    }
  ],
  "commerce-on-account-deactivation-partner-ccp.email.reach-us": [
    {
      "type": 0,
      "value": "You can reach out to us if you need further help in placing your order."
    }
  ],
  "commerce-on-account-deactivation-partner-ccp.email.subject": [
    {
      "type": 0,
      "value": "Pay on account deactivation notice"
    }
  ],
  "commerce-on-account-deactivation-partner-ccp.email.title": [
    {
      "type": 0,
      "value": "Pay on account is deactivated"
    }
  ],
  "commerce-on-account-rejection-partner-ccp.email.accountsreceivable": [
    {
      "type": 0,
      "value": "accountsreceivable@atlassian.com"
    }
  ],
  "commerce-on-account-rejection-partner-ccp.email.apply-again": [
    {
      "type": 0,
      "value": "You can resubmit your application after 6 months to be considered again.  "
    }
  ],
  "commerce-on-account-rejection-partner-ccp.email.contact-us": [
    {
      "type": 0,
      "value": "You can still go ahead with your purchase. We suggest using a credit card to pay for your order. If you still need help placing an order contact us at  "
    },
    {
      "type": 1,
      "value": "accountsReceivableEmail"
    }
  ],
  "commerce-on-account-rejection-partner-ccp.email.list.billing-account": [
    {
      "type": 0,
      "value": "Billing account: "
    },
    {
      "type": 1,
      "value": "transactionAccountNum"
    }
  ],
  "commerce-on-account-rejection-partner-ccp.email.list.payment-method": [
    {
      "type": 0,
      "value": "Payment method: Pay on account"
    }
  ],
  "commerce-on-account-rejection-partner-ccp.email.on-account-application-rejected": [
    {
      "type": 0,
      "value": "Thank you for submitting your application for Pay on account. Unfortunately, we couldn’t approve your application because you didn’t meet our credit check requirements. "
    }
  ],
  "commerce-on-account-rejection-partner-ccp.email.sales-op-support.no-translate": [
    {
      "type": 0,
      "value": "sales-ops-support@atlassian.com"
    }
  ],
  "commerce-on-account-rejection-partner-ccp.email.subject": [
    {
      "type": 0,
      "value": "Pay on account application rejection notice"
    }
  ],
  "commerce-on-account-rejection-partner-ccp.email.title": [
    {
      "type": 0,
      "value": "We’re unable to approve your Pay on account request"
    }
  ],
  "commerce-payment-failure-ccp.email.trial.cc.org.4more.expiration.submit-request.faq": [
    {
      "type": 0,
      "value": "FAQ"
    }
  ],
  "commerce-payment-failure-hams.email.not-trial.without-cc.add-payment-details": [
    {
      "type": 0,
      "value": "We noticed you haven't added payment details for "
    },
    {
      "type": 1,
      "value": "allProductListString"
    },
    {
      "type": 0,
      "value": ". Add payment details today so your team can keep working without interruption."
    }
  ],
  "commerce-payment-failure-hams.email.not-trial.without-cc.cloud.4more.not-interested": [
    {
      "type": 0,
      "value": "If you're no longer interested, you can "
    },
    {
      "type": 1,
      "value": "linkToAdmin"
    },
    {
      "type": 0,
      "value": " at any time."
    }
  ],
  "commerce-payment-failure-hams.email.not-trial.without-cc.cloud.4more.not-interested.update-subscription": [
    {
      "type": 0,
      "value": "update your subscription"
    }
  ],
  "commerce-payment-failure-hams.email.not-trial.without-cc.not-cloud.4more.not-interested": [
    {
      "type": 0,
      "value": "If you're no longer interested, you can "
    },
    {
      "type": 1,
      "value": "linkToAdmin"
    },
    {
      "type": 0,
      "value": " at any time."
    }
  ],
  "commerce-payment-failure-hams.email.not-trial.without-cc.not-cloud.4more.not-interested.update-subscription": [
    {
      "type": 0,
      "value": "update your subscription"
    }
  ],
  "commerce-payment-failure-hams.email.subject": [
    {
      "type": 1,
      "value": "subject"
    }
  ],
  "commerce-payment-failure-hams.email.trial.cc.BB.4more.expiration.additional-actions": [
    {
      "type": 0,
      "value": "Or see "
    },
    {
      "type": 1,
      "value": "additionalActionsLink"
    },
    {
      "type": 0,
      "value": " you can take if you’re unable to make payments."
    }
  ],
  "commerce-payment-failure-hams.email.trial.cc.BB.4more.expiration.check-details": [
    {
      "type": 0,
      "value": "If your details look correct, please try a different payment method or contact your bank. Banks sometimes decline payments due to restrictions on international transactions."
    }
  ],
  "commerce-payment-failure-hams.email.trial.cc.BB.4more.expiration.not-processed": [
    {
      "type": 0,
      "value": "We're unable to process your payment for for Bitbucket ("
    },
    {
      "type": 1,
      "value": "bbAccountName"
    },
    {
      "type": 0,
      "value": ") due to a problem with your payment details. We're happy to try again, but we need your help."
    }
  ],
  "commerce-payment-failure-hams.email.trial.cc.BB.4more.expiration.submit-request": [
    {
      "type": 0,
      "value": "If you need to speak to one of our team members about your situation, please "
    },
    {
      "type": 1,
      "value": "submitRequestLink"
    },
    {
      "type": 0,
      "value": " to the Atlassian Support Team."
    }
  ],
  "commerce-payment-failure-hams.email.trial.cc.BB.4more.expiration.submit-request.contact-us": [
    {
      "type": 0,
      "value": "submit a request"
    }
  ],
  "commerce-payment-failure-hams.email.trial.cc.check-details": [
    {
      "type": 0,
      "value": "If your details look correct, please try a different payment method or alternatively contact your bank.Banks sometimes decline payments due to restrictions on international transactions."
    }
  ],
  "commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.additional-actions": [
    {
      "type": 0,
      "value": "Or see "
    },
    {
      "type": 1,
      "value": "additionalActionsLink"
    },
    {
      "type": 0,
      "value": " you can take if you’re unable to make payments."
    }
  ],
  "commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.check-details": [
    {
      "type": 0,
      "value": "If your details look correct, please try a different payment method or contact your bank. Banks sometimes decline payments due to restrictions on international transactions."
    }
  ],
  "commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.not-processed": [
    {
      "type": 0,
      "value": "We're unable to process your payment for Atlassian Cloud "
    },
    {
      "type": 1,
      "value": "linkToDomain"
    },
    {
      "type": 0,
      "value": " due to a problem with your payment details. We're happy to try again, but we need your help."
    }
  ],
  "commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.not-processed.part-1": [
    {
      "type": 0,
      "value": "We're unable to process your payment for the following products on "
    },
    {
      "type": 1,
      "value": "linkToDomain"
    },
    {
      "type": 0,
      "value": ":"
    }
  ],
  "commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.not-processed.part-2": [
    {
      "type": 0,
      "value": "This is due to a problem with your payment details. We're happy to try again, but we need your help."
    }
  ],
  "commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.submit-request": [
    {
      "type": 0,
      "value": "If you need to speak to one of our team members about your situation, please "
    },
    {
      "type": 1,
      "value": "submitRequestLink"
    },
    {
      "type": 0,
      "value": " to the Atlassian Support Team."
    }
  ],
  "commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.submit-request.contact-us": [
    {
      "type": 0,
      "value": "submit a request"
    }
  ],
  "commerce-payment-failure-hams.email.trial.cc.not-processed": [
    {
      "type": 0,
      "value": "We couldn't process payment for "
    },
    {
      "type": 1,
      "value": "allProductListString"
    },
    {
      "type": 0,
      "value": " due to a problem with your payment details. We're happy to try again, but we need your help."
    }
  ],
  "commerce-payment-failure-hams.email.trial.cc.org.4more.expiration.additional-actions": [
    {
      "type": 0,
      "value": "If you’re unable to make payments or you need to speak to one of our team members about your situation, please "
    },
    {
      "type": 1,
      "value": "submitRequestLink"
    },
    {
      "type": 0,
      "value": " to the Atlassian Support Team."
    }
  ],
  "commerce-payment-failure-hams.email.trial.cc.org.4more.expiration.check-details": [
    {
      "type": 0,
      "value": "If your details look correct, please try a different payment method or contact your bank. Banks sometimes decline payments due to restrictions on international transactions."
    }
  ],
  "commerce-payment-failure-hams.email.trial.cc.org.4more.expiration.check-details.submit": [
    {
      "type": 0,
      "value": "submit a request"
    }
  ],
  "commerce-payment-failure-hams.email.trial.cc.org.4more.expiration.not-processed": [
    {
      "type": 0,
      "value": "We're unable to process your payment for "
    },
    {
      "type": 1,
      "value": "orgProductListString"
    },
    {
      "type": 0,
      "value": " due to a problem with your payment details. We're happy to try again, but we need your help."
    }
  ],
  "commerce-payment-failure-hams.email.trial.cc.org.4more.expiration.submit-request": [
    {
      "type": 0,
      "value": "For more information about what happens when you’re unsubscribed from Atlassian Access, "
    },
    {
      "type": 1,
      "value": "submitRequestLink"
    }
  ],
  "commerce-payment-failure-hams.email.trial.cc.org.4more.expiration.submit-request.faq": [
    {
      "type": 0,
      "value": "see our FAQ"
    }
  ],
  "commerce-payment-failure-hams.email.trial.without-cc.2-4.expiration.learn-more": [
    {
      "type": 0,
      "value": "Learn more about our products and how teams use them to do great work at "
    },
    {
      "type": 1,
      "value": "supportLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce-payment-failure-hams.email.trial.without-cc.cloud.2-4.expiration.part-1": [
    {
      "type": 0,
      "value": "It’s okay, we all get busy! Your trial for the following products on "
    },
    {
      "type": 1,
      "value": "linkToDomain"
    },
    {
      "type": 0,
      "value": " has ended"
    }
  ],
  "commerce-payment-failure-hams.email.trial.without-cc.cloud.2-4.expiration.part-2": [
    {
      "type": 0,
      "value": "Your trial may have ended, but you can still add your payment details and keep the momentum going."
    }
  ],
  "commerce-payment-failure-hams.email.trial.without-cc.cloud.4more.expiration.expiration.part-1": [
    {
      "type": 0,
      "value": "Your Standard plan trial for the following products on "
    },
    {
      "type": 1,
      "value": "linkToDomain"
    },
    {
      "type": 0,
      "value": " has ended:"
    }
  ],
  "commerce-payment-failure-hams.email.trial.without-cc.cloud.4more.expiration.expiration.part-2": [
    {
      "type": 0,
      "value": "But it’s not too late! You can still add payment details and keep the work you’ve done so far."
    }
  ],
  "commerce-payment-failure-hams.email.trial.without-cc.cloud.4more.expiration.not-interested": [
    {
      "type": 0,
      "value": "If you're no longer interested, you can "
    },
    {
      "type": 1,
      "value": "linkToAdmin"
    },
    {
      "type": 0,
      "value": " at any time."
    }
  ],
  "commerce-payment-failure-hams.email.trial.without-cc.cloud.4more.expiration.not-interested.cancel-subscription": [
    {
      "type": 0,
      "value": "cancel your subscription"
    }
  ],
  "commerce-payment-failure-hams.email.trial.without-cc.cloud.less2.expiration.part-1": [
    {
      "type": 0,
      "value": "Your trial for the following products on "
    },
    {
      "type": 1,
      "value": "linkToDomain"
    },
    {
      "type": 0,
      "value": " has ended:"
    }
  ],
  "commerce-payment-failure-hams.email.trial.without-cc.cloud.less2.expiration.part-2": [
    {
      "type": 0,
      "value": "Your trial may have ended, but this could just be the beginning! Add payment details to keep working\n\t\t\t\t\t\t\t\t\t\twith your dream team."
    }
  ],
  "commerce-payment-failure-hams.email.trial.without-cc.less2.expiration.learn-more": [
    {
      "type": 0,
      "value": "Learn more about our products and how teams use them to do great work at "
    },
    {
      "type": 1,
      "value": "supportLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce-payment-failure-hams.email.trial.without-cc.less2.expiration.learn-more.support": [
    {
      "type": 0,
      "value": "support.atlassian.com"
    }
  ],
  "commerce-payment-failure-hams.email.trial.without-cc.org.2-4.expiration": [
    {
      "type": 0,
      "value": "It's okay, we all get busy! Your trial of "
    },
    {
      "type": 1,
      "value": "orgProductListString"
    },
    {
      "type": 0,
      "value": " has ended, but you can still add payment details and keep the momentum going."
    }
  ],
  "commerce-payment-failure-hams.email.trial.without-cc.org.4more.expiration.expiration": [
    {
      "type": 0,
      "value": "It's not too late! Your trial of "
    },
    {
      "type": 1,
      "value": "orgProductListString"
    },
    {
      "type": 0,
      "value": " has ended, but you can still add payment\n\t\t\t\t\t\t\t\t\tdetails and keep the work you've done so far."
    }
  ],
  "commerce-payment-failure-hams.email.trial.without-cc.org.less2.expiration": [
    {
      "type": 0,
      "value": "Your trial of "
    },
    {
      "type": 1,
      "value": "orgProductListString"
    },
    {
      "type": 0,
      "value": " has ended, but this could just be the beginning. Add payment details to keep working with your dream team"
    }
  ],
  "commerce-payment-failure-hams.email.trial.without-cc.without-cc.org.4more.expiration.not-interested": [
    {
      "type": 0,
      "value": "If you're no longer interested, you can unsubscribe at any time within the Manage Subscriptions area\n\t\t\t\t\t\t\t\t\tof your organization administration."
    }
  ],
  "commerce-payment-failure-hams.email.update-payment-details": [
    {
      "type": 0,
      "value": "Update Payment Detail"
    }
  ],
  "commerce-payment-failure-trials.add-payment": [
    {
      "type": 0,
      "value": "Add your payment details today to ensure continuous access to the product and prevent any potential loss of data and security configurations."
    }
  ],
  "commerce-payment-failure-trials.add-payment-without-access": [
    {
      "type": 0,
      "value": "Add your payment details today to ensure continuous access to the product and prevent any potential loss of data."
    }
  ],
  "commerce-payment-failure-trials.billing-cycle-label.no-translate": [
    {
      "type": 0,
      "value": " | "
    },
    {
      "type": 1,
      "value": "billingCycle"
    }
  ],
  "commerce-payment-failure-trials.billing-cycle-text-label.no-translate": [
    {
      "type": 0,
      "value": "| "
    },
    {
      "type": 1,
      "value": "billingCycle"
    }
  ],
  "commerce-payment-failure-trials.card-details": [
    {
      "type": 0,
      "value": "Card: "
    },
    {
      "type": 1,
      "value": "cardBrand"
    },
    {
      "type": 0,
      "value": " ending in "
    },
    {
      "type": 1,
      "value": "lastFourDigits"
    }
  ],
  "commerce-payment-failure-trials.contact-your-bank": [
    {
      "type": 0,
      "value": "Contact your bank if you need more information about the issue.\n                        Banks sometimes decline payments due to restrictions on international transactions."
    }
  ],
  "commerce-payment-failure-trials.contact_us": [
    {
      "type": 1,
      "value": "contactUs"
    },
    {
      "type": 0,
      "value": " to talk about your situation, or "
    },
    {
      "type": 1,
      "value": "downGradeToFreePlan"
    },
    {
      "type": 0,
      "value": ". We suggest you export your data before your subscription gets canceled. For more information, see our "
    },
    {
      "type": 1,
      "value": "dataStorageFAQs"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce-payment-failure-trials.contact_us_access": [
    {
      "type": 1,
      "value": "contactUs"
    },
    {
      "type": 0,
      "value": " to talk about your situation. We suggest you export your data before your subscription gets canceled. For more information, see our "
    },
    {
      "type": 1,
      "value": "dataStorageFAQs"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce-payment-failure-trials.contact_us_access.contact_us_link": [
    {
      "type": 0,
      "value": "Contact us"
    }
  ],
  "commerce-payment-failure-trials.contact_us_access.data_storage_link": [
    {
      "type": 0,
      "value": "Data Storage FAQs"
    }
  ],
  "commerce-payment-failure-trials.contact_us_access.downgrade_link": [
    {
      "type": 0,
      "value": "downgrade to a free plan"
    }
  ],
  "commerce-payment-failure-trials.couldnt-charge-card": [
    {
      "type": 0,
      "value": "We're reaching out as we couldn't charge your card for invoice "
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    }
  ],
  "commerce-payment-failure-trials.couldnt-charge-paypal": [
    {
      "type": 0,
      "value": "We couldn't charge your PayPal account for the invoice "
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": " because there was a problem with your account settings or the payment method selected from your PayPal wallet."
    }
  ],
  "commerce-payment-failure-trials.ent-org-name-with-space-label.no-translate": [
    {
      "type": 1,
      "value": "separator"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "entOrgName"
    },
    {
      "type": 0,
      "value": " "
    }
  ],
  "commerce-payment-failure-trials.entitlement-number-label.no-translate": [
    {
      "type": 0,
      "value": "("
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "commerce-payment-failure-trials.entitlement-number-text.no-translate": [
    {
      "type": 0,
      "value": "("
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "commerce-payment-failure-trials.has_payment_method.add-payment-caption": [
    {
      "type": 0,
      "value": "Add payment details to continue subscription"
    }
  ],
  "commerce-payment-failure-trials.has_payment_method.caption": [
    {
      "type": 0,
      "value": "Action required: Your payment was declined"
    }
  ],
  "commerce-payment-failure-trials.has_payment_method.could_not_process_payment_for_following": [
    {
      "type": 0,
      "value": "We couldn't process payment, based on the payment information we have for this account."
    }
  ],
  "commerce-payment-failure-trials.has_payment_method.has_company_name.could_not_process_payment_for_following": [
    {
      "type": 0,
      "value": "We couldn't process payment for "
    },
    {
      "type": 1,
      "value": "companyName"
    },
    {
      "type": 0,
      "value": ", based on the payment information we have for this account."
    }
  ],
  "commerce-payment-failure-trials.has_payment_method.no_retries.partners.caption": [
    {
      "type": 0,
      "value": "Action required: Update payment details by "
    },
    {
      "type": 1,
      "value": "dueDate"
    }
  ],
  "commerce-payment-failure-trials.has_payment_method.partners.payment-declined-title.has-next-retry.with-companyname": [
    {
      "type": 1,
      "value": "companyName"
    },
    {
      "type": 0,
      "value": " - "
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": ": Action required: Payment declined"
    }
  ],
  "commerce-payment-failure-trials.has_payment_method.partners.payment-declined-title.has-next-retry.without-companyName": [
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": ": Action required: Payment declined"
    }
  ],
  "commerce-payment-failure-trials.has_payment_method.partners.payment-declined-title.no-retries.with-companyname": [
    {
      "type": 1,
      "value": "companyName"
    },
    {
      "type": 0,
      "value": " - "
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": ": Action required to keep subscription"
    }
  ],
  "commerce-payment-failure-trials.has_payment_method.partners.payment-declined-title.no-retries.without-companyName": [
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": ": Action required to keep subscription"
    }
  ],
  "commerce-payment-failure-trials.has_payment_method.payment-declined-title": [
    {
      "type": 0,
      "value": "Action required: Payment declined for #"
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    }
  ],
  "commerce-payment-failure-trials.has_payment_method.update-credit-card--not-access": [
    {
      "type": 0,
      "value": "Update your credit card details, or add a different credit card. For monthly subscriptions, we don’t accept bank transfers."
    }
  ],
  "commerce-payment-failure-trials.has_payment_method.update-credit-card--not-access-contact-bank": [
    {
      "type": 0,
      "value": "Contact your bank if you need more information about the issue. Banks sometimes decline payments due to restrictions on international transactions."
    }
  ],
  "commerce-payment-failure-trials.has_payment_method.update-credit-card-access-annual": [
    {
      "type": 0,
      "value": "Update your payment details or add a different payment method to ensure continuous access to the product and prevent any potential loss of data and security configurations."
    }
  ],
  "commerce-payment-failure-trials.has_payment_method.update-credit-card-access-annual-contact-bank": [
    {
      "type": 0,
      "value": "Contact your bank if you need more information about the issue. Banks sometimes decline payments due to restrictions on international transactions."
    }
  ],
  "commerce-payment-failure-trials.has_payment_method.update-credit-card-access-annual-monthly-subscriptions": [
    {
      "type": 0,
      "value": "For monthly subscriptions, we don’t accept bank transfers."
    }
  ],
  "commerce-payment-failure-trials.has_payment_method.update-payment-caption": [
    {
      "type": 0,
      "value": "Update payment details to continue subscription"
    }
  ],
  "commerce-payment-failure-trials.has_payment_method.update-paypal": [
    {
      "type": 0,
      "value": "Log in to your PayPal account and go to your automatic payment settings. Select a different payment method for your Atlassian payment. You should also check that your account isn't restricted and allows international payments."
    }
  ],
  "commerce-payment-failure-trials.has_payment_method.we_could_not_process": [
    {
      "type": 0,
      "value": "We couldn't process payment for the invoice "
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": ", based on the payment information we have for this account."
    }
  ],
  "commerce-payment-failure-trials.invoice-number": [
    {
      "type": 1,
      "value": "element"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    }
  ],
  "commerce-payment-failure-trials.invoice-number-label": [
    {
      "type": 0,
      "value": "Invoice Number:"
    }
  ],
  "commerce-payment-failure-trials.invoice_pdf_attachment": [
    {
      "type": 0,
      "value": "For your records, the invoice with payment due is attached as a PDF."
    }
  ],
  "commerce-payment-failure-trials.item-description-label.no-translate": [
    {
      "type": 1,
      "value": "description"
    }
  ],
  "commerce-payment-failure-trials.item-description.no-translate": [
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "description"
    }
  ],
  "commerce-payment-failure-trials.log-in-paypal": [
    {
      "type": 0,
      "value": "Log in to PayPal"
    }
  ],
  "commerce-payment-failure-trials.no_payment_method.partners.add_your_payment_details": [
    {
      "type": 0,
      "value": "Add payment details today to avoid interruptions."
    }
  ],
  "commerce-payment-failure-trials.no_payment_method.partners.caption": [
    {
      "type": 0,
      "value": "Add payment details to avoid interruptions"
    }
  ],
  "commerce-payment-failure-trials.no_payment_method.partners.title.with-companyname": [
    {
      "type": 1,
      "value": "companyName"
    },
    {
      "type": 0,
      "value": " - "
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": ": Action required: Add payment details"
    }
  ],
  "commerce-payment-failure-trials.no_payment_method.partners.title.without-companyName": [
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": ": Action required: Add payment details"
    }
  ],
  "commerce-payment-failure-trials.no_payment_method.title": [
    {
      "type": 0,
      "value": "Action required: Add your payment details"
    }
  ],
  "commerce-payment-failure-trials.no_payment_method.unable_to_process_your_payment": [
    {
      "type": 0,
      "value": "We were unable to process your payment since we haven't received your payment details for your subscription."
    }
  ],
  "commerce-payment-failure-trials.no_payment_method.we_could_not_process": [
    {
      "type": 0,
      "value": "We couldn't process your payment for Atlassian products as you haven't provided us with payment details yet."
    }
  ],
  "commerce-payment-failure-trials.no_payment_method.we_could_not_process-access": [
    {
      "type": 0,
      "value": "We're reaching out as we couldn't process your recent payment for invoice "
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": " due to an issue with your account's payment details."
    }
  ],
  "commerce-payment-failure-trials.payment": [
    {
      "type": 0,
      "value": "This payment was for:"
    }
  ],
  "commerce-payment-failure-trials.paypal-details": [
    {
      "type": 0,
      "value": "PayPal account: "
    },
    {
      "type": 1,
      "value": "element"
    }
  ],
  "commerce-payment-failure-trials.sold-to-details.address": [
    {
      "type": 1,
      "value": "element"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "address"
    }
  ],
  "commerce-payment-failure-trials.sold-to-details.address-message": [
    {
      "type": 0,
      "value": "Address:"
    }
  ],
  "commerce-payment-failure-trials.sold-to-details.company": [
    {
      "type": 1,
      "value": "element"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "companyName"
    }
  ],
  "commerce-payment-failure-trials.sold-to-details.company-label": [
    {
      "type": 0,
      "value": "Company:"
    }
  ],
  "commerce-payment-failure-trials.sold-to-details.customer-contact": [
    {
      "type": 1,
      "value": "element"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "customerContact"
    }
  ],
  "commerce-payment-failure-trials.sold-to-details.customer-contact-label": [
    {
      "type": 0,
      "value": "Customer contact:"
    }
  ],
  "commerce-payment-failure-trials.total-bill": [
    {
      "type": 0,
      "value": "Your total bill is "
    },
    {
      "type": 1,
      "value": "element"
    }
  ],
  "commerce-payment-failure-trials.unable-to-pay": [
    {
      "type": 0,
      "value": "If you're unable to make payments:"
    }
  ],
  "commerce-payment-failure-trials.update-credit-card": [
    {
      "type": 0,
      "value": "Update your payment details today to ensure continuous access to the product and prevent any potential loss of data and security configurations."
    }
  ],
  "commerce-payment-failure-trials.update-credit-card-access": [
    {
      "type": 0,
      "value": "Update your credit card details, or add a different credit card to ensure continuous access to the product and prevent any potential loss of data and security configurations."
    }
  ],
  "commerce-payment-failure-trials.update-credit-card-without-access": [
    {
      "type": 0,
      "value": "Update your credit card details, or add a different credit card to ensure continuous access to the product and prevent any potential loss of data."
    }
  ],
  "commerce-payment-failure-trials.we_will_try_to_process_again": [
    {
      "type": 0,
      "value": "We’ll try to process your payment again on "
    },
    {
      "type": 1,
      "value": "dueDate"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce-payment-failure-trials.what-to-do": [
    {
      "type": 0,
      "value": "What you need to do:"
    }
  ],
  "commerce-payment-failure-trials.without-payment-faq-product-access-lost": [
    {
      "type": 0,
      "value": "Without this payment, product access will be lost, and product data will be permanently deleted soon after. See our "
    },
    {
      "type": 1,
      "value": "element"
    }
  ],
  "commerce-permission-request-add-payment-ccp.email.add-payment-request-text": [
    {
      "type": 0,
      "value": "There is an add payment request from "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": " ("
    },
    {
      "type": 1,
      "value": "email"
    },
    {
      "type": 0,
      "value": ") for the subscription: "
    }
  ],
  "commerce-permission-request-add-payment-ccp.email.begin-quotes.no-translate": [
    {
      "type": 0,
      "value": "❝ "
    }
  ],
  "commerce-permission-request-add-payment-ccp.email.end-quotes.no-translate": [
    {
      "type": 0,
      "value": " ❞"
    }
  ],
  "commerce-permission-request-add-payment-ccp.email.personal-note.no-translate": [
    {
      "options": {
        "other": {
          "value": [
            {
              "type": 0,
              "value": "Hi, I’d like to request an upgrade and need payment details added to this subscription."
            }
          ]
        },
        "true": {
          "value": [
            {
              "type": 1,
              "value": "customMessage"
            }
          ]
        }
      },
      "type": 5,
      "value": "hasCustomMessage"
    }
  ],
  "commerce-permission-request-add-payment-ccp.email.subtext-for-personal-note": [
    {
      "type": 0,
      "value": "To help you with more details, here’s a note from the requester: "
    }
  ],
  "commerce-permission-request-add-payment-ccp.email.title": [
    {
      "type": 0,
      "value": "Request from "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": " to add payment details"
    }
  ],
  "commerce-permission-request-add-payment-ccp.email.whats-next-subtext": [
    {
      "type": 0,
      "value": "If you approve the request, continue with adding payment details for the subscription and we’ll notify the requester. Ignore this email to deny. "
    }
  ],
  "commerce-permission-request-add-payment-response-ccp.email.add-payment-request-text": [
    {
      "type": 0,
      "value": "Great news! Your request has been approved. Billing admin has added payment details to your subscription."
    }
  ],
  "commerce-permission-request-add-payment-response-ccp.email.benefits-text": [
    {
      "type": 0,
      "value": "You can now enjoy the benefits of:"
    }
  ],
  "commerce-permission-request-add-payment-response-ccp.email.go-to-site": [
    {
      "type": 0,
      "value": "Go to site"
    }
  ],
  "commerce-permission-request-add-payment-response-ccp.email.title": [
    {
      "type": 0,
      "value": "Your request is complete"
    }
  ],
  "commerce-pre-comms-sp-add-on-merge-ccp.email.add-on-count": [
    {
      "type": 0,
      "value": "Units: "
    },
    {
      "type": 1,
      "value": "count"
    }
  ],
  "commerce-pre-comms-sp-add-on-merge-ccp.email.add-on-entitlement-number": [
    {
      "type": 1,
      "value": "entitlementNumber"
    }
  ],
  "commerce-pre-comms-sp-add-on-merge-ccp.email.free-entitlement.no-action": [
    {
      "type": 0,
      "value": "You don’t need to do anything, and your monthly Statuspage payments will remain the same."
    }
  ],
  "commerce-pre-comms-sp-add-on-merge-ccp.email.merged-addon": [
    {
      "type": 0,
      "value": "Over the next few days, we’ll simplify things for you by merging these "
    },
    {
      "type": 1,
      "value": "addOnName"
    },
    {
      "type": 0,
      "value": " add-on subscriptions into one:"
    }
  ],
  "commerce-pre-comms-sp-add-on-merge-ccp.email.multiple-addons": [
    {
      "type": 0,
      "value": "We noticed your Statuspage subscription "
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": " for "
    },
    {
      "type": 1,
      "value": "site"
    },
    {
      "type": 0,
      "value": " has more than one "
    },
    {
      "type": 1,
      "value": "addOnName"
    },
    {
      "type": 0,
      "value": " add-on: "
    }
  ],
  "commerce-pre-comms-sp-add-on-merge-ccp.email.paid-entitlement.merged-add-on": [
    {
      "type": 0,
      "value": "You’ll only see one Subscribers add-on listed on your next invoice."
    }
  ],
  "commerce-pre-comms-sp-add-on-merge-ccp.email.paid-entitlement.no-change": [
    {
      "type": 0,
      "value": "There’s no change to what you’ll pay each month."
    }
  ],
  "commerce-pre-comms-sp-add-on-merge-ccp.email.paid-entitlement.no-setup": [
    {
      "type": 0,
      "value": "You won’t need to set up or configure anything."
    }
  ],
  "commerce-pre-comms-sp-add-on-merge-ccp.email.title": [
    {
      "type": 0,
      "value": "We’re merging your "
    },
    {
      "type": 1,
      "value": "addOnName"
    },
    {
      "type": 0,
      "value": " add-ons for Statuspage"
    }
  ],
  "commerce-pre-comms-sp-add-on-merge-ccp.email.what-this-means": [
    {
      "type": 0,
      "value": "What this means for you"
    }
  ],
  "commerce-reactivation-order-to-paid-ccp.email.subject": [
    {
      "type": 0,
      "value": "Welcome back to "
    },
    {
      "type": 1,
      "value": "productName"
    }
  ],
  "commerce-subscription-auto-servco-upgrade-notification.message.link.view.apps": [
    {
      "type": 0,
      "value": "View apps"
    }
  ],
  "commerce-subscription-auto-servco-upgrade-notification.message.link.what.is.service.collection": [
    {
      "type": 0,
      "value": "What's Service Collection?"
    }
  ],
  "commerce-subscription-auto-servco-upgrade-notification.message.text": [
    {
      "type": 0,
      "value": "Jira Service Management has moved to Service Collection on your site. You can now use the new Customer Service Management app while your existing setup stays the same."
    }
  ],
  "commerce-subscription-auto-servco-upgrade-notification.message.title": [
    {
      "type": 0,
      "value": "Jira Service Management update"
    }
  ],
  "commerce-subscription-auto-upgrade-no-payment-method-ccp.commerce.auto.upgrade.no.payment.notification.body.full.agent": [
    {
      "type": 0,
      "value": "We upgraded you to a no-cost 14 day trial of "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " Standard, because you went over the "
    },
    {
      "type": 1,
      "value": "exceedingUsageCount"
    },
    {
      "type": 0,
      "value": "-"
    },
    {
      "type": 1,
      "value": "userType"
    },
    {
      "type": 0,
      "value": " for the Free plan. Add payment details before "
    },
    {
      "type": 1,
      "value": "trialEndDate"
    },
    {
      "type": 0,
      "value": " to avoid deactivation. Cancel anytime.\nYou can switch back to a Free plan anytime by reducing your "
    },
    {
      "type": 1,
      "value": "userType"
    },
    {
      "type": 0,
      "value": " count."
    }
  ],
  "commerce-subscription-auto-upgrade-no-payment-method-ccp.commerce.auto.upgrade.no.payment.notification.body.full.user": [
    {
      "type": 0,
      "value": "We upgraded you to a no-cost 14 day trial of "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " Standard, because you went over the "
    },
    {
      "type": 1,
      "value": "exceedingUsageCount"
    },
    {
      "type": 0,
      "value": "-"
    },
    {
      "type": 1,
      "value": "userType"
    },
    {
      "type": 0,
      "value": " for the Free plan. Add payment details before "
    },
    {
      "type": 1,
      "value": "trialEndDate"
    },
    {
      "type": 0,
      "value": " to avoid deactivation. Cancel anytime.\nYou can switch back to a Free plan anytime by reducing your "
    },
    {
      "type": 1,
      "value": "userType"
    },
    {
      "type": 0,
      "value": " count."
    }
  ],
  "commerce-subscription-auto-upgrade-no-payment-method-ccp.commerce.auto.upgrade.no.payment.notification.path.manage.billing": [
    {
      "type": 0,
      "value": "Manage billing"
    }
  ],
  "commerce-subscription-auto-upgrade-no-payment-method-ccp.commerce.auto.upgrade.no.payment.notification.primary.action": [
    {
      "type": 0,
      "value": "Add payment"
    }
  ],
  "commerce-subscription-auto-upgrade-no-payment-method-ccp.commerce.auto.upgrade.no.payment.notification.secondary.action": [
    {
      "type": 0,
      "value": "Manage subscriptions"
    }
  ],
  "commerce-subscription-auto-upgrade-no-payment-method-ccp.commerce.auto.upgrade.no.payment.notification.title.agent": [
    {
      "type": 0,
      "value": "Subscription upgraded: Add payment or remove "
    },
    {
      "type": 1,
      "value": "exceedingUsageCount"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "userType"
    },
    {
      "type": 0,
      "value": " before your trial ends"
    }
  ],
  "commerce-subscription-auto-upgrade-no-payment-method-ccp.commerce.auto.upgrade.no.payment.notification.title.user": [
    {
      "type": 0,
      "value": "Subscription upgraded: Add payment or remove "
    },
    {
      "type": 1,
      "value": "exceedingUsageCount"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "userType"
    },
    {
      "type": 0,
      "value": " before your trial ends"
    }
  ],
  "commerce-subscription-cancellation-ecc.email.subject": [
    {
      "type": 1,
      "value": "partnerName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " canceled"
    }
  ],
  "commerce-subscription-cancellation-occurs-ccp-g.email.reactivate-instructions-1": [
    {
      "type": 0,
      "value": "To reactivate your subscription, go to "
    }
  ],
  "commerce-subscription-cancellation-occurs-ccp-g.email.reactivate-instructions-2": [
    {
      "type": 0,
      "value": "Subscriptions > Inactive "
    }
  ],
  "commerce-subscription-cancellation-occurs-ccp-g.email.reactivate-instructions-3": [
    {
      "type": 0,
      "value": "tab"
    }
  ],
  "commerce-subscription-cancellation-occurs-ccp-g.email.reactivate-instructions-4": [
    {
      "type": 0,
      "value": " > Reactivate."
    }
  ],
  "commerce-subscription-cancellation-occurs-ccp.email.reactivate-instructions-1": [
    {
      "type": 0,
      "value": "To reactivate your subscription, go to "
    }
  ],
  "commerce-subscription-cancellation-occurs-ccp.email.reactivate-instructions-2": [
    {
      "type": 0,
      "value": "Subscriptions > Inactive "
    }
  ],
  "commerce-subscription-cancellation-occurs-ccp.email.reactivate-instructions-3": [
    {
      "type": 0,
      "value": "tab"
    }
  ],
  "commerce-subscription-cancellation-occurs-ccp.email.reactivate-instructions-4": [
    {
      "type": 0,
      "value": " > Reactivate."
    }
  ],
  "commerce-subscription-paid-trials-auto-conversion-off-ccp.subtext": [
    {
      "type": 1,
      "value": "entitlementNumber"
    }
  ],
  "commerce-subscription-paid-trials-auto-conversion-off-ccp.subtext-with-site-url": [
    {
      "type": 1,
      "value": "siteURL"
    },
    {
      "type": 0,
      "value": " &#x2022; "
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    }
  ],
  "commerce-subscription-paid-trials-ccp.subtext": [
    {
      "type": 1,
      "value": "entitlementNumber"
    }
  ],
  "commerce-subscription-paid-trials-ccp.subtext-with-site-url": [
    {
      "type": 1,
      "value": "siteURL"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    }
  ],
  "commerce-subscription-paid-trials-no-payment-method-ccp.subtext": [
    {
      "type": 1,
      "value": "entitlementNumber"
    }
  ],
  "commerce-subscription-paid-trials-no-payment-method-ccp.subtext-with-site-url": [
    {
      "type": 1,
      "value": "siteURL"
    },
    {
      "type": 0,
      "value": " &#x2022; "
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    }
  ],
  "commerce-subscription-reactivation-ccp.email.subject": [
    {
      "type": 0,
      "value": "Welcome back to "
    },
    {
      "type": 1,
      "value": "productName"
    }
  ],
  "commerce-subscription-reactivation-trial-ccp.email.subject": [
    {
      "type": 0,
      "value": "Welcome back to "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " trial"
    }
  ],
  "commerce-subscription-skip-trial-ccp.email.direct-customer.subject": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " subscription is active"
    }
  ],
  "commerce-subscription-skip-trial-ccp.email.estimated-bill": [
    {
      "type": 1,
      "value": "currency"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "amountExcludingTax"
    },
    {
      "type": 0,
      "value": " (excluding tax)"
    },
    {
      "type": 1,
      "value": "content"
    }
  ],
  "commerce-subscription-skip-trial-ccp.email.partner.subject": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": " - "
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": ": "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " subscription is active"
    }
  ],
  "commerce-subscription-skip-trial-ccp.email.subject": [
    {
      "type": 0,
      "value": "Enjoy your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "newPricingPlanName"
    },
    {
      "type": 0,
      "value": " subscription "
    }
  ],
  "commerce-subscription-systematic-downgrade-ccp.email.subject": [
    {
      "type": 0,
      "value": "Enjoy your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "oldPricingPlan"
    },
    {
      "type": 0,
      "value": " subscription "
    }
  ],
  "commerce.bill-estimate-common.key": [
    {
      "type": 0,
      "value": "Estimated bill:"
    }
  ],
  "commerce.bill-estimate-common.value": [
    {
      "type": 1,
      "value": "currency"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "amountExcludingTax"
    },
    {
      "type": 0,
      "value": " (excludes tax)"
    }
  ],
  "commerce.billing-cycle-common.key": [
    {
      "type": 0,
      "value": "Billing cycle:"
    }
  ],
  "commerce.billing-cycle-common.value": [
    {
      "type": 1,
      "value": "billingCycle"
    }
  ],
  "commerce.commerce-3ds-failure-generic-email-ccp.message-template.email.3ds-secure": [
    {
      "type": 0,
      "value": "3DS is a mechanism that makes your online card transactions more secure."
    }
  ],
  "commerce.commerce-3ds-failure-generic-email-ccp.message-template.email.caption": [
    {
      "type": 0,
      "value": "Action needed: Retry your payment with 3DS authentication"
    }
  ],
  "commerce.commerce-3ds-failure-generic-email-ccp.message-template.email.direct.help": [
    {
      "type": 0,
      "value": "We couldn't process your payment since we need your help to complete 3-D Secure (3DS) authentication."
    }
  ],
  "commerce.commerce-3ds-failure-generic-email-ccp.message-template.email.direct.retry": [
    {
      "type": 0,
      "value": "3DS is a mechanism that makes your online card transactions more secure. Please retry making the payment and complete 3DS authentication. You may be asked to verify through an app, enter a confirmation code sent to your phone, or be asked to authenticate in a different way."
    }
  ],
  "commerce.commerce-3ds-failure-generic-email-ccp.message-template.email.direct.subject": [
    {
      "type": 0,
      "value": "Action needed: Retry your payment with 3DS authentication"
    }
  ],
  "commerce.commerce-3ds-failure-generic-email-ccp.message-template.email.international-transactions": [
    {
      "type": 0,
      "value": "Keep in mind that banks sometimes decline payments due to restrictions on international transactions."
    }
  ],
  "commerce.commerce-3ds-failure-generic-email-ccp.message-template.email.partner-or-reseller.help": [
    {
      "type": 0,
      "value": "We couldn't process your payment for the following invoice because we need your help to complete 3-D Secure (3DS) authentication:"
    }
  ],
  "commerce.commerce-3ds-failure-generic-email-ccp.message-template.email.partner-or-reseller.retry": [
    {
      "type": 0,
      "value": "Retry making the payment and complete 3DS authentication. You may be asked to verify through an app, enter a confirmation code sent to your phone, or be asked to authenticate in a different way."
    }
  ],
  "commerce.commerce-3ds-failure-generic-email-ccp.message-template.email.partner-or-reseller.subject": [
    {
      "type": 1,
      "value": "companyName"
    },
    {
      "type": 0,
      "value": " - "
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": ": Action needed: Retry payment"
    }
  ],
  "commerce.commerce-3ds-failure-generic-email-ccp.message-template.email.retry-payment-button": [
    {
      "type": 0,
      "value": "Retry payment"
    }
  ],
  "commerce.commerce-approvals-received-author-notification.email.body": [
    {
      "type": 0,
      "value": "Your initiative ("
    },
    {
      "type": 1,
      "value": "initiativeName"
    },
    {
      "type": 0,
      "value": ") has been approved and is now ready for release."
    }
  ],
  "commerce.commerce-approvals-received-author-notification.email.cta.link": [
    {
      "type": 0,
      "value": "Click on the button below to release the initiative in Workbench."
    }
  ],
  "commerce.commerce-approvals-received-author-notification.email.initiative.link": [
    {
      "type": 0,
      "value": "Go to initiative"
    }
  ],
  "commerce.commerce-approvals-received-author-notification.email.regards": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "commerce.commerce-approvals-received-author-notification.email.your.workbench.team": [
    {
      "type": 0,
      "value": "Your Workbench team"
    }
  ],
  "commerce.commerce-approvals-received-author-notification.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Workbench"
    }
  ],
  "commerce.commerce-approvals-received-author-notification.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Your initiative is ready for release"
    }
  ],
  "commerce.commerce-approvals-received-author-notification.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "commerce.commerce-auto-cancellation-uninvoiceable-ccp.message-template.email.direct-customer.subject": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription has been canceled"
    }
  ],
  "commerce.commerce-auto-cancellation-uninvoiceable-ccp.message-template.email.partner.body.cancellation-reason": [
    {
      "type": 0,
      "value": "It could be because the information provided to us is incorrect or incomplete. Don't worry,\n                            the subscription can be reactivated after you update your billing information."
    }
  ],
  "commerce.commerce-auto-cancellation-uninvoiceable-ccp.message-template.email.partner.body.reactive-within": [
    {
      "type": 1,
      "value": "content"
    },
    {
      "type": 0,
      "value": " If you reactivate the subscription within 60 days of cancellation, we'll restore the relevant data and preferences. For trials, the reactivation period is 15 days."
    }
  ],
  "commerce.commerce-auto-cancellation-uninvoiceable-ccp.message-template.email.partner.body.subscription-cancellation-message": [
    {
      "type": 0,
      "value": "We couldn't generate an invoice for the following subscription as we don't have your complete billing information.\n                            As a result, the subscription has been canceled."
    }
  ],
  "commerce.commerce-auto-cancellation-uninvoiceable-ccp.message-template.email.partner.caption": [
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " subscription canceled - update billing details"
    }
  ],
  "commerce.commerce-auto-cancellation-uninvoiceable-ccp.message-template.email.partner.subject": [
    {
      "type": 1,
      "value": "title"
    },
    {
      "type": 0,
      "value": " canceled"
    }
  ],
  "commerce.commerce-billing-admin-notification-email-ccp.message-template.email.caption": [
    {
      "type": 0,
      "value": "Changes have been made to your billing account"
    }
  ],
  "commerce.commerce-billing-admin-notification-email-ccp.message-template.email.change.bill-to-party": [
    {
      "type": 0,
      "value": "your billing details were updated. The following changes were made:"
    }
  ],
  "commerce.commerce-billing-admin-notification-email-ccp.message-template.email.change.bill-to-price-eligibility": [
    {
      "type": 0,
      "value": "your bill-to pricing eligibility was changed."
    }
  ],
  "commerce.commerce-billing-admin-notification-email-ccp.message-template.email.change.invoice-group-recipients": [
    {
      "type": 0,
      "value": "your list of invoice recipients was changed."
    }
  ],
  "commerce.commerce-billing-admin-notification-email-ccp.message-template.email.change.ship-to-party": [
    {
      "type": 0,
      "value": "your sold-to details were updated. The following changes were made:"
    }
  ],
  "commerce.commerce-billing-admin-notification-email-ccp.message-template.email.change.ship-to-price-eligibility": [
    {
      "type": 0,
      "value": "your sold-to pricing eligibility was changed."
    }
  ],
  "commerce.commerce-billing-admin-notification-email-ccp.message-template.email.company-name-key": [
    {
      "type": 0,
      "value": "Company name:"
    }
  ],
  "commerce.commerce-billing-admin-notification-email-ccp.message-template.email.introduction": [
    {
      "type": 0,
      "value": "This email is to let you know that some changes were made to a billing account managed by you."
    }
  ],
  "commerce.commerce-billing-admin-notification-email-ccp.message-template.email.invoice-group.recipients": [
    {
      "type": 0,
      "value": "Updated list of recipients:"
    }
  ],
  "commerce.commerce-billing-admin-notification-email-ccp.message-template.email.notice": [
    {
      "type": 0,
      "value": "To centrally manage all your accounts, visit "
    },
    {
      "type": 1,
      "value": "adminHubLink"
    }
  ],
  "commerce.commerce-billing-admin-notification-email-ccp.message-template.email.party.phone-key": [
    {
      "type": 0,
      "value": "Phone:"
    }
  ],
  "commerce.commerce-billing-admin-notification-email-ccp.message-template.email.party.postal-address": [
    {
      "type": 0,
      "value": "Postal address:"
    }
  ],
  "commerce.commerce-billing-admin-notification-email-ccp.message-template.email.party.tax-id-key": [
    {
      "type": 0,
      "value": "Tax id:"
    }
  ],
  "commerce.commerce-billing-admin-notification-email-ccp.message-template.email.price-eligibility.academic": [
    {
      "type": 0,
      "value": "Price eligibility was updated to Academic."
    }
  ],
  "commerce.commerce-billing-admin-notification-email-ccp.message-template.email.price-eligibility.classroom": [
    {
      "type": 0,
      "value": "Price eligibility was updated to Classroom."
    }
  ],
  "commerce.commerce-billing-admin-notification-email-ccp.message-template.email.price-eligibility.community": [
    {
      "type": 0,
      "value": "Price eligibility was updated to Community."
    }
  ],
  "commerce.commerce-billing-admin-notification-email-ccp.message-template.email.price-eligibility.generic": [
    {
      "type": 0,
      "value": "Price eligibility was updated."
    }
  ],
  "commerce.commerce-billing-admin-notification-email-ccp.message-template.email.price-eligibility.opensource": [
    {
      "type": 0,
      "value": "Price eligibility was updated to Open Source."
    }
  ],
  "commerce.commerce-billing-admin-notification-email-ccp.message-template.email.subject": [
    {
      "type": 0,
      "value": "Atlassian billing account information was updated"
    }
  ],
  "commerce.commerce-billing-admin-notification-email-ccp.message-template.email.updated-at": [
    {
      "type": 0,
      "value": "At "
    },
    {
      "type": 1,
      "value": "updatedAt"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp-direct.message-template.email.subject": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productInfo"
    },
    {
      "type": 0,
      "value": " subscription has been canceled"
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.body.auto-cancellation-info.uninvoiceable": [
    {
      "type": 0,
      "value": "If you want to keep your subscription, you can update your billing details and then reactivate."
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.body.cta-direct-customer.billing-user": [
    {
      "type": 0,
      "value": "If you want to keep your subscription, you can ask a billing admin to reactivate it. "
    },
    {
      "type": 1,
      "value": "reactivateSubscriptionLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.body.cta-direct-customer.billing-user.link": [
    {
      "type": 0,
      "value": "Learn more about reactivation"
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.body.cta-direct-customer.support.link": [
    {
      "type": 0,
      "value": "see how to reactivate it"
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.body.cta-direct-customer.support.link.twc": [
    {
      "type": 0,
      "value": "reactivate your subscription"
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.body.ecc.partner-details": [
    {
      "type": 0,
      "value": "Your partner details are:"
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.body.how-to-reactivate-subscription": [
    {
      "type": 0,
      "value": "If you want to keep your subscription, you can "
    },
    {
      "type": 1,
      "value": "reactivateSubscriptionLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.body.how-to-reactivate-subscription.twc": [
    {
      "type": 0,
      "value": "We're sad to see you go, but if you change your mind, you can always "
    },
    {
      "type": 1,
      "value": "reactivateSubscriptionLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.body.partner.customer-details": [
    {
      "type": 0,
      "value": "Your customer details are:"
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.body.partner.subscription-details": [
    {
      "type": 0,
      "value": "Your subscription details are:"
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.body.personal-data-retention-summary.direct-customer": [
    {
      "type": 0,
      "value": "If you reactivate within 60 days (or 15 days for trials), we'll restore your app's data and preferences. You can also submit a "
    },
    {
      "type": 1,
      "value": "deletionOfPersonalDataLink"
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.body.personal-data-retention-summary.direct-customer.link": [
    {
      "type": 0,
      "value": "request for deletion of your personal data."
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.body.personal-data-retention-summary.direct-customer.link.twc": [
    {
      "type": 0,
      "value": "immediate deletion of your personal data"
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.body.personal-data-retention-summary.direct-customer.twc": [
    {
      "type": 0,
      "value": "If you reactivate your subscription within 60 days, your data and preferences will remain the same. For trials, data is stored for 15 days. You may also place a request for "
    },
    {
      "type": 1,
      "value": "deletionOfPersonalDataLink"
    },
    {
      "type": 0,
      "value": ". Learn about the "
    },
    {
      "type": 1,
      "value": "privacyPolicyLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.body.summary.dc-uncollectible": [
    {
      "type": 0,
      "value": "We’ve canceled the following subscription. This is because we weren’t able to process your payment."
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.body.summary.dc-uninvoiceable": [
    {
      "type": 0,
      "value": "We’ve canceled the following subscription. This is because we’re missing the right payment details, so we weren’t able to process your payment."
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.body.summary.partner": [
    {
      "type": 0,
      "value": "As requested, we've canceled the following subscription:"
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.caption.direct-customer": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productInfo"
    },
    {
      "type": 0,
      "value": " subscription has been canceled"
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.caption.partner-end-customer-contact": [
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " subscription has been canceled"
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.direct-customer.body.cta.reactivate-subscription": [
    {
      "type": 0,
      "value": "Reactivate subscription"
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.mpucup.body.cta.reactivate-button": [
    {
      "type": 0,
      "value": "Reactivate "
    },
    {
      "type": 1,
      "value": "productName"
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.mpucup.body.exceeded-user-limit": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription was canceled because your team exceeded the 10-user limit on the Free plan and payment details were not added to upgrade to the Standard plan."
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.mpucup.body.restore-within-15-days": [
    {
      "type": 0,
      "value": "You can restore your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription and all data within the next 15 days. After that, your data will be permanently deleted."
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.mpucup.body.restore-within-15-days-non-admin": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " admin can restore your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription and all data within the next 15 days. After that, your data will be permanently deleted."
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.mpucup.caption": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription has ended"
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.mpucup.subject": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription has ended"
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.subject.partner-billing-admin-and-billing-user": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": " - "
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": ": "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " canceled"
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.subject.partner-bu-and-ecc": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " subscription has been canceled"
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.texts.as-requested-we-have-cancelled-the-following-subscription": [
    {
      "type": 0,
      "value": "As requested, we've canceled the following subscription"
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.texts.as-requested-we-have-cancelled-your-customers-subscription": [
    {
      "type": 0,
      "value": "As requested, we've canceled your customer's subscription"
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.texts.if-you-reactivate-within-60-days-we-will-restore-customers-product-data": [
    {
      "type": 0,
      "value": "If you reactivate within 60 days (or 15 days for trials), we'll restore your customer's product data and preferences."
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.texts.if-you-reactivate-within-60-days-we-will-restore-product-data": [
    {
      "type": 0,
      "value": "If you reactivate within 60 days (or 15 days for trials), we'll restore your product's data and preferences."
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.texts.if-you-want-to-keep-your-subscription-reach-out-direct-customer-non-cloud": [
    {
      "type": 0,
      "value": "If you want to keep your subscription, "
    },
    {
      "type": 1,
      "value": "reachOutLinkForNonCloud"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.texts.if-you-want-to-keep-your-subscription-reach-out-to-your-billing-partner-to-reactivate": [
    {
      "type": 0,
      "value": "If you want to keep your subscription, reach out to your Atlassian billing partner to reactivate the subscription."
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.texts.if-your-customer-wants-to-keep-the-subscription-reach-out-to-us-to-reactivate": [
    {
      "type": 0,
      "value": "If your customer wants to keep the subscription, "
    },
    {
      "type": 1,
      "value": "reachOutLink"
    },
    {
      "type": 0,
      "value": " to reactivate the subscription."
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.texts.reach-out-to-us": [
    {
      "type": 0,
      "value": "reach out to us"
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.texts.request-for-deletion-of-their-personal-data": [
    {
      "type": 0,
      "value": "request for deletion of their personal data"
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.texts.request-for-deletion-of-your-personal-data": [
    {
      "type": 0,
      "value": "request for deletion of your personal data"
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.texts.special-char-colon": [
    {
      "type": 0,
      "value": ":"
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.texts.special-char-period": [
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.texts.this-is-because-we-do-not-have-your-customers-billing-information": [
    {
      "type": 0,
      "value": "This is because we don't have your customer's complete billing information. It could be because the information provided to us is incorrect or incomplete."
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.texts.this-is-because-we-were-not-able-to-collect-payment-for-an-invoice": [
    {
      "type": 0,
      "value": "This is because we weren't able to collect payment for an invoice."
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.texts.update-your-customers-billing-details-and-then-reach-out-to-us-to-reactivate": [
    {
      "type": 0,
      "value": "Update your customer's billing details and then "
    },
    {
      "type": 1,
      "value": "reachOutLink"
    },
    {
      "type": 0,
      "value": " to reactivate the subscription."
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.texts.we-have-cancelled-your-customers-subscription": [
    {
      "type": 0,
      "value": "We've canceled your customer's subscription."
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.texts.you-can-also-submit-a-request-for-deletion-of-your-personal-data": [
    {
      "type": 0,
      "value": "You can also submit a "
    },
    {
      "type": 1,
      "value": "requestForDeletionLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.texts.your-customer-can-also-submit-a-request-for-deletion-of-their-personal-data": [
    {
      "type": 0,
      "value": "Your customer can also submit a "
    },
    {
      "type": 1,
      "value": "requestForDeletionLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.email.caption": [
    {
      "type": 0,
      "value": "We're sad to see you go"
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.email.direct-customer.jsm-requirement": [
    {
      "type": 0,
      "value": "This is because our Marketplace app partner has updated the way this app is billed, which means it needs to be installed on Jira Service Management going forward. Since you don't have an active JSM subscription, the app can no longer be billed compatibly."
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.email.direct-customer.prevention-option": [
    {
      "type": 0,
      "value": "There's still time to prevent cancellation. You just need to purchase a Jira Service Management subscription before "
    },
    {
      "type": 1,
      "value": "cancellationDate"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.email.partner.caption": [
    {
      "type": 0,
      "value": "We're sad to see you go"
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.email.partner.caption.twc": [
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " scheduled for cancellation"
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.body.sub-cancel-note.twc": [
    {
      "type": 0,
      "value": "Your subscription will be canceled at the end of your current billing cycle on "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "nextBillingDate"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ". You can continue using "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " until then. We’ll send you an email once the cancellation has gone through."
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.direct-customer.body.billing-admin.keep-subscription": [
    {
      "type": 0,
      "value": "You can always "
    },
    {
      "type": 1,
      "value": "undoLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.direct-customer.body.billing-admin.manage-subscription-button": [
    {
      "type": 0,
      "value": "View subscription"
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.direct-customer.body.billing-admin.undo-cancellation-link": [
    {
      "type": 0,
      "value": "undo your cancellation"
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.direct-customer.body.billing-user.keep-subscription": [
    {
      "type": 0,
      "value": "You can always "
    },
    {
      "type": 1,
      "value": "undoLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.direct-customer.body.received-request": [
    {
      "type": 0,
      "value": "We've received your request to cancel your subscription:"
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.direct-customer.body.sub-cancel-note": [
    {
      "type": 0,
      "value": "Your subscription will be canceled at the end of your current billing cycle on "
    },
    {
      "type": 1,
      "value": "nextBillingDate"
    },
    {
      "type": 0,
      "value": ". You can continue using "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " until then. We’ll send you an email once the cancellation has gone through."
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.direct-customer.subject": [
    {
      "type": 0,
      "value": " Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " is scheduled for cancellation"
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.ecc.body.billing-partner-details.twc": [
    {
      "type": 0,
      "value": "Your billing partner details are:"
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.ecc.body.data-deletion-note": [
    {
      "type": 0,
      "value": "Product data will be deleted in 60 days from the date of cancellation. For trials, we retain data for 15 days. If you’d like to request deletion of personal data, "
    },
    {
      "type": 1,
      "value": "contactSupport"
    },
    {
      "type": 0,
      "value": ". Learn about "
    },
    {
      "type": 1,
      "value": "privacyPolicy"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.ecc.body.jira-decoupled.cancellation-notice": [
    {
      "type": 0,
      "value": "Your subscription will be canceled on "
    },
    {
      "type": 1,
      "value": "nextBillingDate"
    },
    {
      "type": 0,
      "value": ". You can continue using "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " until then. We'll send you an email once the cancellation has gone through."
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.ecc.body.jira-decoupled.contact-us": [
    {
      "type": 0,
      "value": "contact us"
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.ecc.body.jira-decoupled.data-deletion-note": [
    {
      "type": 0,
      "value": "Product data will be deleted 60 days from cancellation. For trials, we retain data for 15 days. If you'd like to request deletion of personal data, "
    },
    {
      "type": 1,
      "value": "contactUs"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.ecc.body.jira-decoupled.intro": [
    {
      "type": 0,
      "value": "Your app subscription is scheduled for cancellation. This is because our Marketplace app partner has updated the way this app is billed, which means it needs to be installed on Jira Service Management going forward. Since you don't have an active JSM subscription, the app can no longer be billed compatibly."
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.ecc.body.jira-decoupled.prevention-option": [
    {
      "type": 0,
      "value": "There's still time to prevent cancellation. You just need to contact your Atlassian billing partner to purchase a Jira Service Management subscription before "
    },
    {
      "type": 1,
      "value": "cancellationDate"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.ecc.body.received-request": [
    {
      "type": 0,
      "value": "We've received a request to cancel the following subscription:"
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.ecc.body.received-request.twc": [
    {
      "type": 0,
      "value": "We've received your request to cancel your subscription"
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.ecc.body.undo-cancellation": [
    {
      "type": 0,
      "value": "You can always "
    },
    {
      "type": 1,
      "value": "undoLink"
    },
    {
      "type": 0,
      "value": " from "
    },
    {
      "type": 1,
      "value": "partnerManagedSubscriptionsLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.ecc.body.undo-cancellation-link": [
    {
      "type": 0,
      "value": "undo your cancellation"
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.email.ecc.subject": [
    {
      "type": 1,
      "value": "billingPartnerName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " cancellation scheduled"
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.email.ecc.subject.twc": [
    {
      "type": 1,
      "value": "billingPartnerName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " is scheduled for cancellation"
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.billing-admin.keep-subscription": [
    {
      "type": 0,
      "value": "If needed, you can contact us to reverse the cancellation request. If you reactivate the subscription within 60 days of cancellation, we'll restore the relevant data and preferences. For trials, the reactivation period is 15 days."
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.billing-admin.undo-cancellation-link": [
    {
      "type": 0,
      "value": "undo your cancellation"
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.billing-user.keep-subscription": [
    {
      "type": 0,
      "value": "If needed, you can contact us to reverse the cancellation request. "
    },
    {
      "type": 1,
      "value": "undoLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.customer-details.twc": [
    {
      "type": 0,
      "value": "Your customer details are:"
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.ecc.atlassian-privacy-policy": [
    {
      "type": 0,
      "value": "Atlassian’s Privacy Policy"
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.ecc.contact-atlassian-support": [
    {
      "type": 0,
      "value": "contact Atlassian support"
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.ecc.contact-billing-partner": [
    {
      "type": 0,
      "value": "You can contact your Atlassian billing partner if you need help or want to reverse the cancellation request."
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.jira-decoupled.cancellation-notice": [
    {
      "type": 0,
      "value": "Your subscription will be canceled on "
    },
    {
      "type": 1,
      "value": "nextBillingDate"
    },
    {
      "type": 0,
      "value": ". You can continue using "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " until then. We'll send you an email once the cancellation has gone through."
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.jira-decoupled.intro": [
    {
      "type": 0,
      "value": "Your customer's app subscription is scheduled for cancellation. This is because our Marketplace app partner has updated the way this app is billed, which means it needs to be installed on Jira Service Management going forward. Since your customer doesn't have an active JSM subscription, the app can no longer be billed compatibly."
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.jira-decoupled.prevention-option": [
    {
      "type": 0,
      "value": "There's still time to prevent cancellation. You just need to purchase a Jira Service Management subscription before "
    },
    {
      "type": 1,
      "value": "cancellationDate"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.keep-subscription": [
    {
      "type": 0,
      "value": "Keeping the subscription"
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.keep-subscription.twc": [
    {
      "type": 0,
      "value": "Your customer contact can undo the cancellation at any time from "
    },
    {
      "type": 1,
      "value": "partnerManagedSubscriptionsLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.partner-managed-subscriptions-link": [
    {
      "type": 1,
      "value": "partnerManagedSubscriptionsLink"
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.partner.billing-admin.undo-cancellation-link": [
    {
      "type": 0,
      "value": "Learn how to undo a cancellation"
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.received-request": [
    {
      "type": 0,
      "value": "We’ve received a request to cancel the following subscription:"
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.received-request.twc": [
    {
      "type": 0,
      "value": "We’ve received your customer’s request to cancel their subscription."
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.sub-cancel-note": [
    {
      "type": 0,
      "value": "The subscription will be canceled at the end of the current billing cycle on "
    },
    {
      "type": 1,
      "value": "nextBillingDate"
    },
    {
      "type": 0,
      "value": ". You can continue using "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " until then. We’ll send you an email once the cancellation has gone through."
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.sub-cancel-note.twc": [
    {
      "type": 0,
      "value": "The subscription will be canceled at the end of the current billing cycle on "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "nextBillingDate"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ". Until then, the subscription can still be used. We’ll send you an email once the cancellation has gone through."
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.subscription-details.twc": [
    {
      "type": 0,
      "value": "Your subscription details are:"
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.subject.with-company-name": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": " : "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " cancellation scheduled"
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.subject.with-company-name.twc": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": " - "
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": " : "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " cancellation scheduled"
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.subject.without-company-name": [
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " cancellation scheduled"
    }
  ],
  "commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.subject.without-company-name.twc": [
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": " : "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " cancellation scheduled"
    }
  ],
  "commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.body.billing-faq-url": [
    {
      "type": 0,
      "value": "When and how will I be billed?"
    }
  ],
  "commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.breach-adjust-limit": [
    {
      "type": 0,
      "value": "Organization admins can adjust this limit anytime."
    }
  ],
  "commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.breach-body": [
    {
      "type": 0,
      "value": "Your organization has reached the monthly "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " limit set by your admin. As a result, some features will be restricted or unavailable until your usage reset date. "
    },
    {
      "type": 1,
      "value": "learnMoreLink"
    }
  ],
  "commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.breach-caption": [
    {
      "type": 0,
      "value": "Your organization has hit its "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " limit"
    }
  ],
  "commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.breach-visit-admin": [
    {
      "type": 0,
      "value": "Visit Atlassian Administration to get more details on "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " usage in your organization."
    }
  ],
  "commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.milestone-body": [
    {
      "type": 0,
      "value": "Your organization has used 80% of its "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " usage limit. This is a limit that was set by your admin, and is different to the allowance included with your subscriptions."
    }
  ],
  "commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.milestone-caption": [
    {
      "type": 0,
      "value": "80% of your "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " limit has been used"
    }
  ],
  "commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.milestone-visit-admin": [
    {
      "type": 0,
      "value": "Visit Atlassian Administration to get more details on "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " usage in your organization."
    }
  ],
  "commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.milestone-whats-next": [
    {
      "type": 0,
      "value": "Once your organization reaches the limit, some features will be restricted or unavailable until your usage resets. Organization admins can adjust this limit anytime."
    }
  ],
  "commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.milestone-whats-next.enforced": [
    {
      "type": 0,
      "value": "For the amount of usage above the allowance, at the end of the current cycle, you’ll receive a bill for extra usage incurred this cycle."
    }
  ],
  "commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.milestone-whats-next.non-enforced": [
    {
      "type": 0,
      "value": "Any usage beyond your allowance is considered extra usage. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "You won’t be billed for your extra usage at this time."
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "billingUrl"
    }
  ],
  "commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.subject.breach": [
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " limit reached"
    }
  ],
  "commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.subject.milestone": [
    {
      "type": 0,
      "value": "Your organization has used 80% of your "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " limit"
    }
  ],
  "commerce.commerce-cbp-hard-limit-breach-ccp.message-template.email.body.view-usage": [
    {
      "type": 0,
      "value": "View usage"
    }
  ],
  "commerce.commerce-cbp-hard-limit-breach-ccp.message-template.email.more-about-usage-charges-and-billing": [
    {
      "type": 0,
      "value": "More about usage charges and billing"
    }
  ],
  "commerce.commerce-cbp-hard-limit-breach-ccp.message-template.email.whats-next": [
    {
      "type": 0,
      "value": "What's next?"
    }
  ],
  "commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.breach-adjust-limit": [
    {
      "type": 0,
      "value": "You can adjust this limit anytime."
    }
  ],
  "commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.breach-body": [
    {
      "type": 0,
      "value": "Your customer has reached the monthly "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " limit you set. As a result, some features will be restricted or unavailable for your customer until their usage reset date. "
    },
    {
      "type": 1,
      "value": "learnMoreLink"
    }
  ],
  "commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.breach-caption": [
    {
      "type": 0,
      "value": "Your customer has hit their "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " limit"
    }
  ],
  "commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.breach-visit-ppc": [
    {
      "type": 0,
      "value": "Visit PPC to get more details on your customer's "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " usage."
    }
  ],
  "commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.milestone-body": [
    {
      "type": 0,
      "value": "Your customer has used 80% of their organization's "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " usage limit. This is a limit that was set by your customer's admin, and is different to the allowance included with your customer's subscriptions."
    }
  ],
  "commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.milestone-caption": [
    {
      "type": 0,
      "value": "80% of your customer's "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " limit has been used"
    }
  ],
  "commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.milestone-visit-ppc": [
    {
      "type": 0,
      "value": "Visit PPC to get more details on your customer's "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " usage."
    }
  ],
  "commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.milestone-whats-next": [
    {
      "type": 0,
      "value": "Once your customer reaches the limit, some features will be restricted or unavailable until their usage resets. You can adjust this limit anytime."
    }
  ],
  "commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.milestone.billable-usage-notice.enforced": [
    {
      "type": 0,
      "value": "For the amount of usage above the allowance, at the end of the current cycle, you’ll receive a bill for extra usage incurred this cycle."
    }
  ],
  "commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.milestone.billable-usage-notice.non-enforced": [
    {
      "type": 0,
      "value": "Any usage beyond your allowance is considered extra usage. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "You won’t be billed for your extra usage at this time."
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "billingUrl"
    }
  ],
  "commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.subject.breach": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": ": "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " limit reached"
    }
  ],
  "commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.subject.breach.without-company-name": [
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " limit reached"
    }
  ],
  "commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.subject.milestone": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": ": 80% of "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " limit"
    }
  ],
  "commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.subject.milestone.without-company-name": [
    {
      "type": 0,
      "value": "80% of "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " limit"
    }
  ],
  "commerce.commerce-credit-account-approval-ccp.email.list.credit-limit": [
    {
      "type": 0,
      "value": "Credit limit: "
    },
    {
      "type": 1,
      "value": "creditLimitFormatted"
    },
    {
      "type": 1,
      "value": "limitShareText"
    }
  ],
  "commerce.commerce-credit-account-approval-ccp.message-template.approved.title": [
    {
      "type": 0,
      "value": "Your Net-"
    },
    {
      "type": 1,
      "value": "netTermsDuration"
    },
    {
      "type": 0,
      "value": " payment terms application has been approved"
    }
  ],
  "commerce.commerce-credit-account-approval-ccp.message-template.email.subject": [
    {
      "type": 0,
      "value": "Approved for Net-"
    },
    {
      "type": 1,
      "value": "netTermsDuration"
    },
    {
      "type": 0,
      "value": " payment terms"
    }
  ],
  "commerce.commerce-credit-account-approval-ccp.message-template.good-news": [
    {
      "type": 0,
      "value": "Good news! We’ve approved your application for Net-"
    },
    {
      "type": 1,
      "value": "netTermsDuration"
    },
    {
      "type": 0,
      "value": " payment terms. Here are the details: "
    }
  ],
  "commerce.commerce-credit-account-deactivation-ccp.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Your account is now ineligible for Net-"
    },
    {
      "type": 1,
      "value": "netTermsDuration"
    },
    {
      "type": 0,
      "value": " payment terms"
    }
  ],
  "commerce.commerce-credit-account-limit-update-ccp.email.list.new-credit-limit": [
    {
      "type": 0,
      "value": "New Credit limit: "
    },
    {
      "type": 1,
      "value": "newCreditLimitFormatted"
    },
    {
      "type": 1,
      "value": "limitShareText"
    }
  ],
  "commerce.commerce-credit-account-limit-update-ccp.email.possible-reasons": [
    {
      "type": 0,
      "value": "Learn about possible reasons."
    }
  ],
  "commerce.commerce-credit-account-limit-update-ccp.email.statement-info": [
    {
      "type": 0,
      "value": "We’ve decreased your credit limit to "
    },
    {
      "type": 1,
      "value": "newCreditLimitFormatted"
    },
    {
      "type": 0,
      "value": ". Your previous credit limit was "
    },
    {
      "type": 1,
      "value": "creditLimitFormatted"
    },
    {
      "type": 0,
      "value": ". "
    },
    {
      "type": 1,
      "value": "possibleReasons"
    }
  ],
  "commerce.commerce-credit-account-limit-update-ccp.message-template.decrease.title": [
    {
      "type": 0,
      "value": "We’ve decreased your Net-"
    },
    {
      "type": 1,
      "value": "netTermsDuration"
    },
    {
      "type": 0,
      "value": " credit limit"
    }
  ],
  "commerce.commerce-credit-account-limit-update-ccp.message-template.email.decrease.subject": [
    {
      "type": 0,
      "value": "Your Net-"
    },
    {
      "type": 1,
      "value": "netTermsDuration"
    },
    {
      "type": 0,
      "value": " credit limit has been decreased"
    }
  ],
  "commerce.commerce-credit-account-limit-update-ccp.message-template.email.increase.subject": [
    {
      "type": 0,
      "value": "Your Net-"
    },
    {
      "type": 1,
      "value": "netTermsDuration"
    },
    {
      "type": 0,
      "value": " credit limit has been increased"
    }
  ],
  "commerce.commerce-credit-account-limit-update-ccp.message-template.good-news": [
    {
      "type": 0,
      "value": "Good news! We’ve increased your credit limit to "
    },
    {
      "type": 1,
      "value": "newCreditLimitFormatted"
    },
    {
      "type": 0,
      "value": ". Your previous credit limit was "
    },
    {
      "type": 1,
      "value": "creditLimitFormatted"
    },
    {
      "type": 0,
      "value": ". Here are the details: "
    }
  ],
  "commerce.commerce-credit-account-limit-update-ccp.message-template.increase.title": [
    {
      "type": 0,
      "value": "We’ve increased your Net-"
    },
    {
      "type": 1,
      "value": "netTermsDuration"
    },
    {
      "type": 0,
      "value": " credit limit"
    }
  ],
  "commerce.commerce-credit-account-reactivation-ccp.message-template.email.subject": [
    {
      "type": 0,
      "value": "Your account is now re-eligible for Net-"
    },
    {
      "type": 1,
      "value": "netTermsDuration"
    },
    {
      "type": 0,
      "value": " payment terms"
    }
  ],
  "commerce.commerce-credit-account-rejection-ccp.message-template.bad-news": [
    {
      "type": 0,
      "value": "Unfortunately, we couldn’t approve your application because you didn’t meet our credit check requirements."
    }
  ],
  "commerce.commerce-credit-account-rejection-ccp.message-template.email.subject": [
    {
      "type": 0,
      "value": "Couldn’t approve your Net-"
    },
    {
      "type": 1,
      "value": "netTermsDuration"
    },
    {
      "type": 0,
      "value": " payment terms application"
    }
  ],
  "commerce.commerce-credit-account-rejection-ccp.message-template.other-option": [
    {
      "type": 0,
      "value": "You can still move forward with your purchase. We suggest using a credit card to pay for your order. Reach out to us if you need further help in placing your order."
    }
  ],
  "commerce.commerce-credit-account-rejection-ccp.message-template.rejection.title": [
    {
      "type": 0,
      "value": "We’re unable to approve you for Net-"
    },
    {
      "type": 1,
      "value": "netTermsDuration"
    },
    {
      "type": 0,
      "value": " payment terms"
    }
  ],
  "commerce.commerce-credit-account-rejection-ccp.message-template.thanks": [
    {
      "type": 0,
      "value": "Thank you for submitting your application for Net-"
    },
    {
      "type": 1,
      "value": "netTermsDuration"
    },
    {
      "type": 0,
      "value": " payment terms."
    }
  ],
  "commerce.commerce-credit-application-severe-rejection-ccp.message-template.email.subject": [
    {
      "type": 0,
      "value": "Credit Application Result: Reject"
    }
  ],
  "commerce.commerce-credit-application-severe-rejection-ccp.message-template.how-to-move-forward": [
    {
      "type": 0,
      "value": "Here's how to move forward:"
    }
  ],
  "commerce.commerce-credit-application-severe-rejection-ccp.message-template.instruction.all-fields": [
    {
      "children": [
        {
          "type": 0,
          "value": "Double-check"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " that every field is filled in — this helps us complete our review faster."
    }
  ],
  "commerce.commerce-credit-application-severe-rejection-ccp.message-template.instruction.return-form": [
    {
      "children": [
        {
          "type": 0,
          "value": "Send them the form"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " and ask them to return it directly to us."
    }
  ],
  "commerce.commerce-credit-application-severe-rejection-ccp.message-template.instruction.sign": [
    {
      "children": [
        {
          "type": 0,
          "value": "Sign"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " the top of the form."
    }
  ],
  "commerce.commerce-credit-application-severe-rejection-ccp.message-template.instruction.vendors": [
    {
      "children": [
        {
          "type": 0,
          "value": "Choose two vendors"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " you've traded with for at least 12 months, whose trade volume with you exceeds the credit limit you're requesting. Please note: they can't be related entities."
    }
  ],
  "commerce.commerce-credit-application-severe-rejection-ccp.message-template.option.financial-statements": [
    {
      "children": [
        {
          "type": 0,
          "value": "Latest audited financial statements"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " (if you haven't already shared these), or"
    }
  ],
  "commerce.commerce-credit-application-severe-rejection-ccp.message-template.option.trade-references": [
    {
      "children": [
        {
          "type": 0,
          "value": "A completed trade references form"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " (attached)"
    }
  ],
  "commerce.commerce-credit-application-severe-rejection-ccp.message-template.reassessment": [
    {
      "type": 0,
      "value": "The good news? This isn't final — we'd be happy to reassess your account once we have a bit more information."
    }
  ],
  "commerce.commerce-credit-application-severe-rejection-ccp.message-template.reassessment-underway": [
    {
      "type": 0,
      "value": "Once we receive everything, we'll get your reassessment underway."
    }
  ],
  "commerce.commerce-credit-application-severe-rejection-ccp.message-template.rejection": [
    {
      "type": 0,
      "value": "Thank you for applying for payment terms with us. After carefully reviewing your application, we're unable to approve Net-30 terms at this time."
    }
  ],
  "commerce.commerce-credit-application-severe-rejection-ccp.message-template.resubmit-instructions": [
    {
      "type": 0,
      "value": "Once you have the additional information ready, you can resubmit a new Net-30 application directly from your account (the application link is available there). Just include "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "one"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " of the following with your resubmission:"
    }
  ],
  "commerce.commerce-credit-application-severe-rejection-ccp.message-template.trade-reference-intro": [
    {
      "type": 0,
      "value": "Using the trade references form? Just follow these 4 steps:"
    }
  ],
  "commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.card-expiry-warning-message": [
    {
      "type": 0,
      "value": "Heads up — your credit card expires in "
    },
    {
      "type": 1,
      "value": "expiryMonthAndYear"
    },
    {
      "type": 0,
      "value": ". To make sure your next payment is made on time so you can continue using your subscriptions without interruption, you’ll need to update your payment details before "
    },
    {
      "type": 1,
      "value": "dueDate"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.no-update-action": [
    {
      "type": 0,
      "value": "What happens if I don’t update my details?"
    }
  ],
  "commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.no-update-action-warning": [
    {
      "type": 0,
      "value": "Your next payment attempt will fail – this means your subscription could be deactivated and you could lose product access and data."
    }
  ],
  "commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.select": [
    {
      "type": 0,
      "value": "Select "
    }
  ],
  "commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Your credit card expires soon"
    }
  ],
  "commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.time-to-update-credit-card-details": [
    {
      "type": 0,
      "value": "Time to update your credit card details"
    }
  ],
  "commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.update-payment-details": [
    {
      "type": 0,
      "value": "Update payment details"
    }
  ],
  "commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.update-payment-details-note": [
    {
      "type": 0,
      "value": " below to edit your saved card."
    }
  ],
  "commerce.commerce-credit-trade-reference-request-ccp.message-template.email.subject": [
    {
      "type": 0,
      "value": "Additional information needed for your Net-30 application"
    }
  ],
  "commerce.commerce-credit-trade-reference-request-ccp.message-template.financial.balance-sheet": [
    {
      "type": 0,
      "value": "Balance Sheet"
    }
  ],
  "commerce.commerce-credit-trade-reference-request-ccp.message-template.financial.cash-flow": [
    {
      "type": 0,
      "value": "Cash Flow Statement"
    }
  ],
  "commerce.commerce-credit-trade-reference-request-ccp.message-template.financial.income-statement": [
    {
      "type": 0,
      "value": "Income Statement"
    }
  ],
  "commerce.commerce-credit-trade-reference-request-ccp.message-template.instruction.all-fields": [
    {
      "type": 0,
      "value": "Ensure all fields are completed so we can finalize the review without delays."
    }
  ],
  "commerce.commerce-credit-trade-reference-request-ccp.message-template.instruction.return-form": [
    {
      "type": 0,
      "value": "Send them the form and ask them to return it directly to us."
    }
  ],
  "commerce.commerce-credit-trade-reference-request-ccp.message-template.instruction.sign": [
    {
      "type": 0,
      "value": "Sign the top of the form."
    }
  ],
  "commerce.commerce-credit-trade-reference-request-ccp.message-template.instruction.vendors": [
    {
      "type": 0,
      "value": "Select two vendors you've traded with for at least 12 months, whose trade volume with you exceeds the credit limit you're requesting. Please note that they can't be related entities."
    }
  ],
  "commerce.commerce-credit-trade-reference-request-ccp.message-template.intro": [
    {
      "type": 0,
      "value": "Thank you for your interest in setting up Net-30 payment terms with us. After reviewing your D&B credit profile, we're unable to approve the request at this time."
    }
  ],
  "commerce.commerce-credit-trade-reference-request-ccp.message-template.option1-accounting-team": [
    {
      "type": 0,
      "value": "Your accounting team should be able to provide these. They'll give us a clearer view of your account and support our reassessment."
    }
  ],
  "commerce.commerce-credit-trade-reference-request-ccp.message-template.option1-heading": [
    {
      "type": 0,
      "value": "Option 1: Provide your audited financial statements"
    }
  ],
  "commerce.commerce-credit-trade-reference-request-ccp.message-template.option1-intro": [
    {
      "type": 0,
      "value": "If you haven't already shared these, please send your most recent:"
    }
  ],
  "commerce.commerce-credit-trade-reference-request-ccp.message-template.option2-heading": [
    {
      "type": 0,
      "value": "Option 2: Provide trade references"
    }
  ],
  "commerce.commerce-credit-trade-reference-request-ccp.message-template.option2-intro": [
    {
      "type": 0,
      "value": "If you'd prefer this option, please complete the attached trade reference form. Here's what we'll need:"
    }
  ],
  "commerce.commerce-credit-trade-reference-request-ccp.message-template.reconsider": [
    {
      "type": 0,
      "value": "If you'd like us to reconsider, we'd be glad to take another look with some additional information from your end."
    }
  ],
  "commerce.commerce-credit-trade-reference-request-ccp.message-template.thank-you": [
    {
      "type": 0,
      "value": "Thank you again for being an Atlassian customer. We appreciate your business and look forward to hearing from you soon."
    }
  ],
  "commerce.commerce-credit-trade-reference-request-ccp.message-template.two-options": [
    {
      "type": 0,
      "value": "You have two options:"
    }
  ],
  "commerce.commerce-credit-trade-reference-request-ccp.message-template.whats-next-body": [
    {
      "type": 0,
      "value": "Please let us know which option you'd like to pursue, or feel free to reach out with any questions. We're here to support you and want to make this process as straightforward as possible."
    }
  ],
  "commerce.commerce-credit-trade-reference-request-ccp.message-template.whats-next-heading": [
    {
      "type": 0,
      "value": "What happens next?"
    }
  ],
  "commerce.commerce-customer-contact-remove-digest.email.body.removed-contact": [
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": " ("
    },
    {
      "type": 1,
      "value": "email"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "commerce.commerce-customer-contact-remove-digest.message-template.email.body.caption": [
    {
      "type": 0,
      "value": "Customer contact removed"
    }
  ],
  "commerce.commerce-customer-contact-remove-digest.message-template.email.body.contact-removed": [
    {
      "type": 0,
      "value": "Contact removed: "
    }
  ],
  "commerce.commerce-customer-contact-remove-digest.message-template.email.body.impacted-subscriptions": [
    {
      "type": 0,
      "value": "Impacted subscriptions:"
    }
  ],
  "commerce.commerce-customer-contact-remove-digest.message-template.email.body.intro": [
    {
      "type": 0,
      "value": "We've removed a key customer contact from a billing profile."
    }
  ],
  "commerce.commerce-customer-contact-remove-digest.message-template.email.body.questions": [
    {
      "type": 0,
      "value": "If you have any questions, please reach out to your Atlassian billing partner."
    }
  ],
  "commerce.commerce-customer-contact-remove-digest.message-template.email.body.removed-by": [
    {
      "type": 0,
      "value": "Removed by: "
    }
  ],
  "commerce.commerce-customer-contact-remove-digest.message-template.email.body.view-changes": [
    {
      "type": 0,
      "value": "You can view the changes at "
    },
    {
      "type": 1,
      "value": "url"
    },
    {
      "type": 0,
      "value": " page."
    }
  ],
  "commerce.commerce-customer-contact-remove-digest.message-template.email.body.view-changes-link": [
    {
      "type": 0,
      "value": "partner managed subscriptions"
    }
  ],
  "commerce.commerce-customer-contact-remove-digest.message-template.email.remaining-subs": [
    {
      "type": 0,
      "value": "+ "
    },
    {
      "type": 1,
      "value": "remainingCount"
    },
    {
      "type": 0,
      "value": " subscriptions."
    }
  ],
  "commerce.commerce-customer-contact-remove-digest.message-template.email.subject": [
    {
      "type": 0,
      "value": "Customer contact removed"
    }
  ],
  "commerce.commerce-customers-deactivation-eve.email.body-p1": [
    {
      "type": 0,
      "value": "U.S. law prohibits Atlassian, an Australian corporation with offices in the United States, from providing you with access to our products and services. After analyzing the applicable lists of restricted parties maintained by the U.S. Government, we were unable to confirm that your name was not affiliated with a restricted party."
    }
  ],
  "commerce.commerce-customers-deactivation-eve.email.body-p2": [
    {
      "type": 0,
      "value": "If this is a case of misidentification, please reply with two different copies of official documentation to verify your identity."
    }
  ],
  "commerce.commerce-customers-deactivation-eve.email.body-p3": [
    {
      "type": 0,
      "value": "Official documentation includes, but is not limited to, a government-issued driver's license or identification card, passport, utility bill, mortgage or bank statement, etc. Please make sure your full name and address are clearly visible."
    }
  ],
  "commerce.commerce-customers-deactivation-eve.email.body-p4": [
    {
      "type": 0,
      "value": "You may check out these resources for more information: U.S. export controls ("
    },
    {
      "type": 1,
      "value": "exportControl"
    },
    {
      "type": 0,
      "value": ") | Consolidated Screening List ("
    },
    {
      "type": 1,
      "value": "csl"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "commerce.commerce-customers-deactivation-eve.email.body-p5": [
    {
      "type": 0,
      "value": "Please reply directly via email with any further questions and the identification requested."
    }
  ],
  "commerce.commerce-customers-deactivation-eve.email.body-p6": [
    {
      "type": 0,
      "value": "We look forward to your reply."
    }
  ],
  "commerce.commerce-customers-deactivation-eve.email.body.csl": [
    {
      "type": 0,
      "value": "https://www.trade.gov/consolidated-screening-list"
    }
  ],
  "commerce.commerce-customers-deactivation-eve.email.body.exportControl": [
    {
      "type": 0,
      "value": "https://www.trade.gov/us-export-controls"
    }
  ],
  "commerce.commerce-customers-deactivation-eve.email.caption": [
    {
      "type": 0,
      "value": "Deactivated Atlassian Account"
    }
  ],
  "commerce.commerce-customers-deactivation-eve.email.salutation": [
    {
      "type": 0,
      "value": "Dear Atlassian user,"
    }
  ],
  "commerce.commerce-customers-deactivation-eve.email.subject": [
    {
      "type": 0,
      "value": "Deactivated Atlassian Account"
    }
  ],
  "commerce.commerce-decoupled-offering-ccp.message-template.email.billed-based-on-the-users": [
    {
      "type": 0,
      "value": "Until now, billing for this app has been linked to your total user count for Jira. The change will mean that you'll be billed based on the number of agents who use the Jira Service Management subscription instead."
    }
  ],
  "commerce.commerce-decoupled-offering-ccp.message-template.email.billing-flexibility-info-message": [
    {
      "type": 0,
      "value": "Billing flexibility is now available for your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " for Jira Service Management app."
    }
  ],
  "commerce.commerce-decoupled-offering-ccp.message-template.email.body.this-change-will-introduce-pricing-updates": [
    {
      "type": 0,
      "value": "The change will introduce pricing updates that are set out by our Marketplace partners. These updates will come into effect with the new way of billing, even if your user count isn't updated."
    }
  ],
  "commerce.commerce-decoupled-offering-ccp.message-template.email.body.we-will-make-the-change": [
    {
      "type": 0,
      "value": "We'll automatically make the change on "
    },
    {
      "type": 1,
      "value": "nextBillingDate"
    }
  ],
  "commerce.commerce-decoupled-offering-ccp.message-template.email.caption": [
    {
      "type": 0,
      "value": "Have more billing flexibility and only pay for what you need"
    }
  ],
  "commerce.commerce-decoupled-offering-ccp.message-template.email.if-you-dont-do-anything": [
    {
      "type": 0,
      "value": "If you don't do anything"
    }
  ],
  "commerce.commerce-decoupled-offering-ccp.message-template.email.maximize-your-billing-efficiency": [
    {
      "type": 0,
      "value": "Maximize your billing efficiency"
    }
  ],
  "commerce.commerce-decoupled-offering-ccp.message-template.email.need-more-info": [
    {
      "type": 0,
      "value": "Need more info? See our guide on "
    },
    {
      "type": 1,
      "value": "howMarketplaceAreBilled"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-decoupled-offering-ccp.message-template.email.partner.billed-based-on-the-users": [
    {
      "type": 0,
      "value": "Until now, billing for this app has been linked to your customer's total user count for Jira. The change will mean that your customer will be billed based on the number of agents who use the Jira Service Management subscription instead."
    }
  ],
  "commerce.commerce-decoupled-offering-ccp.message-template.email.partner.billing-flexibility-info-message": [
    {
      "type": 0,
      "value": "Billing flexibility is now available for your customer's "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " for Jira Service Management app."
    }
  ],
  "commerce.commerce-decoupled-offering-ccp.message-template.email.partner.body.this-change-will-introduce-pricing-updates": [
    {
      "type": 0,
      "value": "The change will introduce pricing updates that are set out by our Marketplace partners. These updates will come into effect with the new way of billing, even if your user count isn't updated."
    }
  ],
  "commerce.commerce-decoupled-offering-ccp.message-template.email.partner.body.we-will-make-the-change": [
    {
      "type": 0,
      "value": "We'll automatically make the change on "
    },
    {
      "type": 1,
      "value": "nextBillingDate"
    }
  ],
  "commerce.commerce-decoupled-offering-ccp.message-template.email.partner.caption": [
    {
      "type": 0,
      "value": "Give your customer more billing flexibility"
    }
  ],
  "commerce.commerce-decoupled-offering-ccp.message-template.email.partner.customer-label": [
    {
      "type": 0,
      "value": "Customer: "
    },
    {
      "type": 1,
      "value": "customerName"
    }
  ],
  "commerce.commerce-decoupled-offering-ccp.message-template.email.partner.pay-for-what-you-need": [
    {
      "type": 0,
      "value": "To only pay for what you need, your customer can update the number of JSM agents by heading to Atlassian Administration."
    }
  ],
  "commerce.commerce-decoupled-offering-ccp.message-template.email.partner.pay-only-for-users-who-need-access": [
    {
      "type": 0,
      "value": "This means they have the option to only pay for the users that really need access."
    }
  ],
  "commerce.commerce-decoupled-offering-ccp.message-template.email.partner.review-your-bill": [
    {
      "type": 0,
      "value": "Make the switch now so your customer can start making the most of billing flexibility for this app. Keep in mind that the bill may be impacted, and can be changed by the organization admin by managing JSM access as needed. We'd recommend reviewing the bill as you make the change."
    }
  ],
  "commerce.commerce-decoupled-offering-ccp.message-template.email.pay-for-what-you-need": [
    {
      "type": 0,
      "value": "To only pay for what you need, your organization admin can update the number of JSM agents by heading to Atlassian Administration."
    }
  ],
  "commerce.commerce-decoupled-offering-ccp.message-template.email.pay-only-for-users-who-need-access": [
    {
      "type": 0,
      "value": "This means you have the option to only pay for the users that really need access."
    }
  ],
  "commerce.commerce-decoupled-offering-ccp.message-template.email.review-your-bill": [
    {
      "type": 0,
      "value": "Make the switch now to start making the most of billing flexibility for this app. Keep in mind that your bill may be impacted, and can be changed by the organization admin by managing JSM access as needed. We'd recommend reviewing your bill as you make the change."
    }
  ],
  "commerce.commerce-decoupled-offering-ccp.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Update billing for your Marketplace app"
    }
  ],
  "commerce.commerce-decoupled-offering-ccp.message-template.email.what-do-i-need-to-do": [
    {
      "type": 0,
      "value": "What do I need to do?"
    }
  ],
  "commerce.commerce-decoupled-offering-ccp.message-template.email.what-does-this-mean": [
    {
      "type": 0,
      "value": "What does this mean?"
    }
  ],
  "commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.body.direct.p1": [
    {
      "type": 0,
      "value": "As requested, we've updated the way you're billed for "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " for Jira Service Management. You can now enjoy more control over who has access to and is charged for the app, and your bill will be based on the number of Jira Service Management agents, instead of the user count for Jira."
    }
  ],
  "commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.body.direct.p2": [
    {
      "type": 0,
      "value": "It's a good idea to review who you'd like to have access to the app. Keep in mind that your bill may be impacted, and organization admins can change it by managing who has access to the app as needed."
    }
  ],
  "commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.body.partner.p1": [
    {
      "type": 0,
      "value": "As requested, we've updated the way your customer is billed for "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " for Jira Service Management. They can now enjoy more control over who has access to and is charged for the app, and the bill will be linked to the number of JSM agents instead of the user count for Jira."
    }
  ],
  "commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.body.partner.p2": [
    {
      "type": 0,
      "value": "It's a good idea to remind your customer to review who they'd like to have access to the app, and their bill may be impacted. Organization admins can adjust the bill by managing who has access to the app as needed."
    }
  ],
  "commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.button.view-subscription": [
    {
      "type": 0,
      "value": "View subscription"
    }
  ],
  "commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.help": [
    {
      "type": 0,
      "value": "Have a question? We're here to help. "
    },
    {
      "type": 1,
      "value": "getInTouch"
    }
  ],
  "commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.link.get-in-touch": [
    {
      "type": 0,
      "value": "Get in touch"
    }
  ],
  "commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.link.how-billed": [
    {
      "type": 0,
      "value": "Find out more about how Marketplace apps are billed."
    }
  ],
  "commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.signoff": [
    {
      "type": 0,
      "value": "Thanks,"
    }
  ],
  "commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.subject.direct": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " for JSM billing has been updated"
    }
  ],
  "commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.subject.partner": [
    {
      "type": 0,
      "value": "Update billing for your customer's Marketplace app"
    }
  ],
  "commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.team": [
    {
      "type": 0,
      "value": "The Atlassian team"
    }
  ],
  "commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.title.direct": [
    {
      "type": 0,
      "value": "Enjoy more control over your Marketplace app billing"
    }
  ],
  "commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.title.partner": [
    {
      "type": 0,
      "value": "Enjoy more control over your customer's app billing"
    }
  ],
  "commerce.commerce-dunning-cancellation-credit-ccp.message-template.email.credit-note-button": [
    {
      "type": 0,
      "value": "View credit note"
    }
  ],
  "commerce.commerce-dunning-cancellation-credit-ccp.message-template.email.direct.caption": [
    {
      "type": 0,
      "value": "Your credit note has been generated"
    }
  ],
  "commerce.commerce-dunning-cancellation-credit-ccp.message-template.email.direct.processed": [
    {
      "type": 0,
      "value": "We have processed your cancellation request for subscriptions under the invoice "
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": ". We've generated a credit note "
    },
    {
      "type": 1,
      "value": "creditNoteNumber"
    },
    {
      "type": 0,
      "value": " against your invoice and adjusted the outstanding amount."
    }
  ],
  "commerce.commerce-dunning-cancellation-credit-ccp.message-template.email.direct.subject": [
    {
      "type": 0,
      "value": "Credit note generated against invoice "
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    }
  ],
  "commerce.commerce-dunning-cancellation-credit-ccp.message-template.email.no-refund": [
    {
      "type": 0,
      "value": "Please note that this credit note will not result in any refund since it is generated against an unpaid invoice."
    }
  ],
  "commerce.commerce-dunning-cancellation-credit-ccp.message-template.email.partner-or-reseller.caption": [
    {
      "type": 0,
      "value": "Credit note generated"
    }
  ],
  "commerce.commerce-dunning-cancellation-credit-ccp.message-template.email.partner-or-reseller.processed": [
    {
      "type": 0,
      "value": "We've processed a cancellation request for subscriptions under the following invoice. We've generated a credit note against the invoice and adjusted the outstanding amount."
    }
  ],
  "commerce.commerce-dunning-cancellation-credit-ccp.message-template.email.partner-or-reseller.subject": [
    {
      "type": 1,
      "value": "companyName"
    },
    {
      "type": 0,
      "value": " - "
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": ": Credit note generated"
    }
  ],
  "commerce.commerce-dynamic-content-test-cns.message-template.email.greeting.custom": [
    {
      "type": 1,
      "value": "greetingText"
    }
  ],
  "commerce.commerce-dynamic-content-test-cns.message-template.email.greeting.default": [
    {
      "type": 0,
      "value": "Dear "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "commerce.commerce-dynamic-content-test-cns.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "commerce.commerce-invoice-drawdown-ccp.message-template.email.subject": [
    {
      "type": 0,
      "value": "Your Atlassian invoice is ready"
    }
  ],
  "commerce.commerce-invoice-generated-ccp-g.message-template.email.partner.subject": [
    {
      "type": 1,
      "value": "message"
    }
  ],
  "commerce.commerce-invoice-generated-ccp-g.message-template.email.subject": [
    {
      "type": 0,
      "value": "Your invoice has been processed"
    }
  ],
  "commerce.commerce-invoice-generated-ccp.message-template.email.partner.subject": [
    {
      "type": 1,
      "value": "companyName"
    },
    {
      "type": 0,
      "value": " - "
    },
    {
      "type": 1,
      "value": "businessKey"
    },
    {
      "type": 0,
      "value": " generated"
    }
  ],
  "commerce.commerce-invoice-generated-ccp.message-template.email.subject": [
    {
      "type": 0,
      "value": "Your invoice has been processed"
    }
  ],
  "commerce.commerce-invoice-resend-email-ccp.message-template.email.body": [
    {
      "type": 0,
      "value": "As requested, we've attached a copy of your invoice ("
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": ")."
    }
  ],
  "commerce.commerce-invoice-resend-email-ccp.message-template.email.caption": [
    {
      "type": 0,
      "value": "Your invoice is ready"
    }
  ],
  "commerce.commerce-invoice-resend-email-ccp.message-template.email.direct.subject": [
    {
      "type": 0,
      "value": "Your invoice is attached ("
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "commerce.commerce-invoice-resend-email-ccp.message-template.email.partner-or-reseller.subject": [
    {
      "type": 1,
      "value": "companyName"
    },
    {
      "type": 0,
      "value": " invoice is attached ("
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "commerce.commerce-invoice-resend-email-ccp.message-template.email.view-invoices.body": [
    {
      "type": 0,
      "value": "You can also access your invoices in your billing account."
    }
  ],
  "commerce.commerce-invoice-resend-email-ccp.message-template.email.view-invoices.partner.body": [
    {
      "type": 0,
      "value": "You can also access your invoices in the Partner Purchasing Center."
    }
  ],
  "commerce.commerce-invoice-resend-email-ccp.message-template.email.view-invoices.view-invoices": [
    {
      "type": 0,
      "value": "View invoices"
    }
  ],
  "commerce.commerce-invoice-resend-email-ccp.view-invoices.view-invoices": [
    {
      "type": 0,
      "value": "View invoices"
    }
  ],
  "commerce.commerce-invoice-terms-payment-pending-ccp-g.message-template.email.partner.company-name.subject": [
    {
      "type": 1,
      "value": "companyName"
    },
    {
      "type": 0,
      "value": " - "
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": " Invoice generated"
    }
  ],
  "commerce.commerce-invoice-terms-payment-pending-ccp-g.message-template.email.partner.subject": [
    {
      "type": 0,
      "value": "Invoice "
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": " generated"
    }
  ],
  "commerce.commerce-invoice-terms-payment-pending-ccp-g.message-template.email.subject": [
    {
      "type": 0,
      "value": "Your invoice "
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": " has been processed"
    }
  ],
  "commerce.commerce-invoice-terms-payment-pending-ccp.message-template.email.partner.company-name.subject": [
    {
      "type": 1,
      "value": "companyName"
    },
    {
      "type": 0,
      "value": " - "
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": " Invoice generated"
    }
  ],
  "commerce.commerce-invoice-terms-payment-pending-ccp.message-template.email.partner.subject": [
    {
      "type": 0,
      "value": "Invoice "
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": " generated"
    }
  ],
  "commerce.commerce-invoice-terms-payment-pending-ccp.message-template.email.subject": [
    {
      "type": 0,
      "value": "Your invoice "
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": " has been processed"
    }
  ],
  "commerce.commerce-invoice-terms-payment-received-email-ccp.message-template.email.caption": [
    {
      "type": 0,
      "value": "Your payment has been processed"
    }
  ],
  "commerce.commerce-invoice-terms-payment-received-email-ccp.message-template.email.direct.confirm": [
    {
      "type": 0,
      "value": "Thanks for choosing Atlassian. This email is to confirm that we've received your payment for the invoice "
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": ". The invoice is attached as a PDF for your records."
    }
  ],
  "commerce.commerce-invoice-terms-payment-received-email-ccp.message-template.email.direct.subject": [
    {
      "type": 0,
      "value": "Your payment has been processed for the invoice "
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    }
  ],
  "commerce.commerce-invoice-terms-payment-received-email-ccp.message-template.email.invoice-attached": [
    {
      "type": 0,
      "value": "The invoice is attached as a PDF for your records."
    }
  ],
  "commerce.commerce-invoice-terms-payment-received-email-ccp.message-template.email.partner-or-reseller.confirm": [
    {
      "type": 0,
      "value": "This email is to confirm we've received payment for the following invoice:"
    }
  ],
  "commerce.commerce-invoice-terms-payment-received-email-ccp.message-template.email.partner-or-reseller.subject": [
    {
      "type": 1,
      "value": "companyName"
    },
    {
      "type": 0,
      "value": " - "
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": ": Payment processed"
    }
  ],
  "commerce.commerce-invoice-terms-post-uncollectible-dunning-email-ccp.message-template.email.amount-label": [
    {
      "type": 0,
      "value": "Amount Due:"
    }
  ],
  "commerce.commerce-invoice-terms-post-uncollectible-dunning-email-ccp.message-template.email.attached-pdf": [
    {
      "type": 0,
      "value": "Please find attached a copy of the invoice for your reference with payment instructions. To ensure uninterrupted service, we request that you settle this outstanding amount as soon as possible."
    }
  ],
  "commerce.commerce-invoice-terms-post-uncollectible-dunning-email-ccp.message-template.email.caption": [
    {
      "type": 0,
      "value": "Reactivation of Services and Payment Reminder"
    }
  ],
  "commerce.commerce-invoice-terms-post-uncollectible-dunning-email-ccp.message-template.email.contact-us": [
    {
      "type": 0,
      "value": "If there are any issues or if you require any additional information, feel free to "
    },
    {
      "type": 1,
      "value": "contactUs"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-invoice-terms-post-uncollectible-dunning-email-ccp.message-template.email.contact-us-link": [
    {
      "type": 0,
      "value": "contact us"
    }
  ],
  "commerce.commerce-invoice-terms-post-uncollectible-dunning-email-ccp.message-template.email.details": [
    {
      "type": 0,
      "value": "Upon reactivation of your subscription, we wish to remind you that your "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "previous invoice is overdue"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": ". See below details:"
    }
  ],
  "commerce.commerce-invoice-terms-post-uncollectible-dunning-email-ccp.message-template.email.due-date-label": [
    {
      "type": 0,
      "value": "Due Date:"
    }
  ],
  "commerce.commerce-invoice-terms-post-uncollectible-dunning-email-ccp.message-template.email.invoice-date-label": [
    {
      "type": 0,
      "value": "Invoice Date:"
    }
  ],
  "commerce.commerce-invoice-terms-post-uncollectible-dunning-email-ccp.message-template.email.invoice-number-label": [
    {
      "type": 0,
      "value": "Invoice:"
    }
  ],
  "commerce.commerce-invoice-terms-post-uncollectible-dunning-email-ccp.message-template.email.payment-confirm": [
    {
      "type": 0,
      "value": "If you have already made the payment, please send remittance advice to "
    },
    {
      "type": 1,
      "value": "arLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-invoice-terms-post-uncollectible-dunning-email-ccp.message-template.email.reactivation-date-label": [
    {
      "type": 0,
      "value": "Reactivation Date:"
    }
  ],
  "commerce.commerce-invoice-terms-post-uncollectible-dunning-email-ccp.message-template.email.subject": [
    {
      "type": 0,
      "value": "Reactivation of Services and Payment Reminder - Invoice "
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    }
  ],
  "commerce.commerce-invoice-terms-post-uncollectible-dunning-email-ccp.message-template.email.thank-you": [
    {
      "type": 0,
      "value": "Thank you for your prompt attention to this matter."
    }
  ],
  "commerce.commerce-invoice-updated-ccp-g.message-template.email.partner.company-name.subject": [
    {
      "type": 1,
      "value": "companyName"
    },
    {
      "type": 0,
      "value": " - "
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": " updated"
    }
  ],
  "commerce.commerce-invoice-updated-ccp-g.message-template.email.partner.subject": [
    {
      "type": 0,
      "value": "Invoice "
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": " updated"
    }
  ],
  "commerce.commerce-invoice-updated-ccp-g.message-template.email.subject": [
    {
      "type": 0,
      "value": "Invoice "
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": " updated"
    }
  ],
  "commerce.commerce-invoice-updated-ccp.message-template.email.partner.company-name.subject": [
    {
      "type": 1,
      "value": "companyName"
    },
    {
      "type": 0,
      "value": " - "
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": " updated"
    }
  ],
  "commerce.commerce-invoice-updated-ccp.message-template.email.partner.subject": [
    {
      "type": 0,
      "value": "Invoice "
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": " updated"
    }
  ],
  "commerce.commerce-invoice-updated-ccp.message-template.email.subject": [
    {
      "type": 0,
      "value": "Invoice "
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": " updated"
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.confluence.offer-message": [
    {
      "type": 0,
      "value": "When you use the two together, you can centralize your docs, connect work across teams and more. With the Standard plan, you get:"
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.confluence.single-congratulations-message": [
    {
      "type": 0,
      "value": "Did you know that "
    },
    {
      "type": 1,
      "value": "purchasedProductName"
    },
    {
      "type": 0,
      "value": " works even better with Confluence?"
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.confluence.single-product-caption": [
    {
      "type": 0,
      "value": "Build a single source of truth for all your team’s important info"
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.confluence.welcome": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.cta.try-now": [
    {
      "type": 0,
      "value": "Try now"
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jpd.offer-message": [
    {
      "type": 0,
      "value": "Together, the products help you capture ideas and prioritize work, so you’re always organized. With the Standard plan, you get:"
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jpd.single-congratulations-message": [
    {
      "type": 0,
      "value": "Did you know "
    },
    {
      "type": 1,
      "value": "purchasedProductName"
    },
    {
      "type": 0,
      "value": " works even better with Jira Product Discovery?"
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jpd.single-product-caption": [
    {
      "type": 0,
      "value": "Say goodbye to messy backlogs"
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jpd.welcome": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsm.offer-message": [
    {
      "type": 0,
      "value": "With the Standard plan, you get:"
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsm.single-congratulations-message": [
    {
      "type": 0,
      "value": "People who use Jira Service Management say that work is more visible for all teams involved, from request to resolution."
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsm.single-product-caption": [
    {
      "type": 0,
      "value": "Bring developers, IT, and operations onto the same platform"
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsm.welcome": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsw.offer-message": [
    {
      "type": 0,
      "value": "With Jira, your team can move fast, stay aligned, and build better - together. With the Standard plan, you get:"
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsw.single-congratulations-message": [
    {
      "type": 0,
      "value": "Jira and "
    },
    {
      "type": 1,
      "value": "purchasedProductName"
    },
    {
      "type": 0,
      "value": " can help you visualize and deliver work, fast."
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsw.single-product-caption": [
    {
      "type": 0,
      "value": "Break down silos and connect the dots between teams"
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsw.welcome": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.multi-congratulations-message": [
    {
      "type": 0,
      "value": "Congrats on purchasing "
    },
    {
      "type": 1,
      "value": "purchasedProductTitle"
    },
    {
      "type": 0,
      "value": "! Get free trials of these products and unlock these advanced features:"
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.multi-product-caption": [
    {
      "type": 0,
      "value": "Get free trials of "
    },
    {
      "type": 1,
      "value": "productName1"
    },
    {
      "type": 0,
      "value": " & "
    },
    {
      "type": 1,
      "value": "productName2"
    },
    {
      "type": 0,
      "value": " Standard with your "
    },
    {
      "type": 1,
      "value": "purchasedProductName"
    },
    {
      "type": 0,
      "value": " purchase"
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.trial-length-message": [
    {
      "type": 0,
      "value": "Free "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": "-day trial"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": "-day trial"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "trialLength"
    },
    {
      "type": 0,
      "value": ". Cancel anytime."
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.welcome": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.multi-entitlement-with-trial-length.subject": [
    {
      "type": 0,
      "value": "Try "
    },
    {
      "type": 1,
      "value": "firstProduct"
    },
    {
      "type": 0,
      "value": " & "
    },
    {
      "type": 1,
      "value": "secondProduct"
    },
    {
      "type": 0,
      "value": " free for "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " day"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " days"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "trialLength"
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.multi-entitlement.subject": [
    {
      "type": 0,
      "value": "Try "
    },
    {
      "type": 1,
      "value": "firstProduct"
    },
    {
      "type": 0,
      "value": " & "
    },
    {
      "type": 1,
      "value": "secondProduct"
    },
    {
      "type": 0,
      "value": " free"
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.single-entitlement.subject": [
    {
      "type": 0,
      "value": "Try "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " free for "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " day"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " days"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "trialLength"
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.advanced-user-project-permissions": [
    {
      "type": 0,
      "value": "Advanced user & project permissions"
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.advanced-user-space-permissions": [
    {
      "type": 0,
      "value": "Advanced user & space permissions"
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.custom-project-roles": [
    {
      "type": 0,
      "value": "Custom project roles"
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.higher-automation-limit": [
    {
      "type": 0,
      "value": "Higher automation limit"
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.insights-into-page-views": [
    {
      "type": 0,
      "value": "Get insights into page views"
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.on-call-management": [
    {
      "type": 0,
      "value": "On-call management"
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.published-views": [
    {
      "type": 0,
      "value": "Published views"
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.storage": [
    {
      "type": 0,
      "value": "250 GB of storage"
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.trial-length": [
    {
      "type": 0,
      "value": "Free "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": "-day trial"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": "-day trial"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "trialLength"
    },
    {
      "type": 0,
      "value": ". Cancel anytime."
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.unlimited-agents": [
    {
      "type": 0,
      "value": "Unlimited agents"
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.unlimited-agents-storage": [
    {
      "type": 0,
      "value": "Unlocked agent & storage limits"
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.unlimited-creator-storage": [
    {
      "type": 0,
      "value": "Unlocked creator & storage limits"
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.unlimited-creators": [
    {
      "type": 0,
      "value": "Unlimited creators"
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.unlimited-user-storage": [
    {
      "type": 0,
      "value": "Unlocked user & storage limits"
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.unlimited-users": [
    {
      "type": 0,
      "value": "Unlimited users"
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.user-project-permissions": [
    {
      "type": 0,
      "value": "Advanced user & project permissions"
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade.email.confluence-logo.alt-text": [
    {
      "type": 0,
      "value": "Confluence logo"
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade.email.icon-archive.alt-text": [
    {
      "type": 0,
      "value": "Icon - Archive"
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade.email.icon-check-circle.alt-text": [
    {
      "type": 0,
      "value": "Icon - Check circle"
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade.email.icon-graph.alt-text": [
    {
      "type": 0,
      "value": "Icon - Graph"
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade.email.icon-lightning.alt-text": [
    {
      "type": 0,
      "value": "Icon - Lightning"
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade.email.icon-link.alt-text": [
    {
      "type": 0,
      "value": "Icon - Link"
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade.email.icon-people.alt-text": [
    {
      "type": 0,
      "value": "Icon - People"
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade.email.icon-phone.alt-text": [
    {
      "type": 0,
      "value": "Icon - Phone"
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade.email.icon-unlock.alt-text": [
    {
      "type": 0,
      "value": "Icon - Unlock"
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade.email.jira-logo.alt-text": [
    {
      "type": 0,
      "value": "Jira logo"
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade.email.jpd-logo.alt-text": [
    {
      "type": 0,
      "value": "Jira Product Discovery logo"
    }
  ],
  "commerce.commerce-marketing-multiple-product-upgrade.email.jsm-logo.alt-text": [
    {
      "type": 0,
      "value": "Jira Service Management logo"
    }
  ],
  "commerce.commerce-migration-jwm-to-jira.message-template.email.body.billing": [
    {
      "type": 1,
      "value": "billingUrl"
    }
  ],
  "commerce.commerce-migration-jwm-to-jira.message-template.email.body.faq": [
    {
      "type": 0,
      "value": "FAQs"
    }
  ],
  "commerce.commerce-migration-jwm-to-jira.message-template.email.body.migrate": [
    {
      "type": 0,
      "value": "You have been successfully migrated from Jira Work Management to Jira, within "
    },
    {
      "type": 1,
      "value": "site"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-migration-jwm-to-jira.message-template.email.body.options": [
    {
      "type": 0,
      "value": "To view pricing, auto-renewal, and cancellation options, go to "
    },
    {
      "type": 1,
      "value": "billing"
    }
  ],
  "commerce.commerce-migration-jwm-to-jira.message-template.email.body.site": [
    {
      "type": 1,
      "value": "siteUrl"
    }
  ],
  "commerce.commerce-migration-jwm-to-jira.message-template.email.body.subsciption": [
    {
      "type": 0,
      "value": "The current price of your subscription has not changed. However, pricing may vary if changes are made to your user tier, plan, and/or licensing. See "
    },
    {
      "type": 1,
      "value": "faq"
    },
    {
      "type": 0,
      "value": " for more details."
    }
  ],
  "commerce.commerce-migration-jwm-to-jira.message-template.email.caption": [
    {
      "type": 0,
      "value": "You’ve been successfully migrated to Jira"
    }
  ],
  "commerce.commerce-migration-jwm-to-jira.message-template.email.subject": [
    {
      "type": 0,
      "value": "Your migration was successful"
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.CMK.encryption-policy-info": [
    {
      "type": 0,
      "value": "CMK policy enrollment is required for activation. "
    },
    {
      "type": 1,
      "value": "supportInfo"
    },
    {
      "type": 0,
      "value": " to self-enroll before provisioning Atlassian app instances. For step-by-step instructions, refer to the support "
    },
    {
      "type": 1,
      "value": "CMKSupportUrl"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.CMK.manage-subscription": [
    {
      "type": 0,
      "value": "Please click ‘Manage Subscription’"
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.CMK.partner-managed-subscription": [
    {
      "type": 0,
      "value": "Please visit your partner-managed subscriptions page"
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.CMK.view-subscription": [
    {
      "type": 0,
      "value": "Please click ‘View all Subscriptions’"
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.body.rovo-dev-credits-usage-details": [
    {
      "type": 0,
      "value": "Remember, extra usage charges can now be accrued — any extra usage will be charged at USD 0.01 per extra Rovo Dev credit and added to your next invoice. Don’t worry — we’ve set an extra usage limit of 2,000 Rovo Dev credits per user, which means extra usage charges per user is currently limited to USD 20 (unless it’s already been adjusted). To keep spending predictable, organization admins can adjust this usage limit or disable extra usage anytime in Atlassian Administration. You can view a detailed breakdown of your team’s usage in your billing account."
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.allowance-contributions-enforcement-ubp5": [
    {
      "type": 0,
      "value": "Remember, any usage above your allowance may incur extra usage charges, which will be added to your bill at the end of your bill cycle. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Find out more about usage charges and billing"
        }
      ],
      "type": 8,
      "value": "UsageChargesAndBillingLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.cbp-details": [
    {
      "type": 0,
      "value": "Your plan includes:"
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.manual-provisioning": [
    {
      "type": 0,
      "value": "Your order includes DX products that require manual provisioning. Our team will reach out via email with setup instructions, typically within [X business days]."
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.more-information": [
    {
      "type": 0,
      "value": "You can visit "
    },
    {
      "type": 1,
      "value": "supportUrl"
    },
    {
      "type": 0,
      "value": " to learn more about how billing works."
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.no-payment.expect-final-invoice": [
    {
      "type": 0,
      "value": "We’ll send the final invoice within 24 hours, which will include all the details and payment options for your order."
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.payment-processing": [
    {
      "type": 0,
      "value": "We’re processing your payment and will email the final invoice within 24 hours."
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.set-up-your-cloud-site": [
    {
      "type": 0,
      "value": "Dive right in and "
    },
    {
      "type": 1,
      "value": "getStartedUrl"
    },
    {
      "type": 0,
      "value": " by setting up your new "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 0,
              "value": "subscription"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "subscriptions"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "entitlementsLength"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.thanks-for-choosing-atlassian": [
    {
      "type": 0,
      "value": "Thanks for choosing Atlassian. We’ve received your order."
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.view-subscription": [
    {
      "type": 0,
      "value": "You can view your "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 0,
              "value": "subscription"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "subscriptions"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "entitlementsLength"
    },
    {
      "type": 0,
      "value": " details from your "
    },
    {
      "type": 1,
      "value": "hostingDetails"
    },
    {
      "type": 0,
      "value": " at "
    },
    {
      "type": 1,
      "value": "billingUrl"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.button.manage-subscription": [
    {
      "type": 0,
      "value": "Manage subscription"
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.button.view-subscription": [
    {
      "type": 0,
      "value": "View all Subscriptions"
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.caption": [
    {
      "type": 0,
      "value": "Your order is confirmed"
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.non-cloud.billing-info": [
    {
      "type": 0,
      "value": "Go to your billing account to set up your new subscriptions."
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.subject": [
    {
      "type": 0,
      "value": "Order "
    },
    {
      "type": 1,
      "value": "orderNumber"
    },
    {
      "type": 0,
      "value": " confirmed"
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.direct.future-dated-with-date.body.intro": [
    {
      "type": 0,
      "value": "You'll be able to set up and start using your "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 0,
              "value": "subscription"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "subscriptions"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "entitlementsLength"
    },
    {
      "type": 0,
      "value": " on "
    },
    {
      "type": 1,
      "value": "futureStartDate"
    },
    {
      "type": 0,
      "value": ". We'll send you a reminder when they're ready."
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.direct.future-dated.body.intro": [
    {
      "type": 0,
      "value": "You'll be able to set up and start using your "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 0,
              "value": "subscription from its start date"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "subscriptions from their start dates"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "entitlementsLength"
    },
    {
      "type": 0,
      "value": ". We'll send you a reminder when they're ready."
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.admin-permission-url": [
    {
      "type": 0,
      "value": "how to give users admin permissions"
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.atlassian-billing-partner": [
    {
      "type": 0,
      "value": "Atlassian billing partner: "
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.atlassian-billing-reseller": [
    {
      "type": 0,
      "value": "Atlassian reseller: "
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.give-admin-permission": [
    {
      "type": 0,
      "value": "Setting up your "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 0,
              "value": "subscription"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "subscriptions"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "entitlementsLength"
    },
    {
      "type": 0,
      "value": " means you’ll automatically get admin permissions as an org and site admin. You can also give admin roles to others - see "
    },
    {
      "type": 1,
      "value": "giveUserAdminPermissionUrl"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.intro": [
    {
      "type": 0,
      "value": "Good news — we’ve received the order placed by your Atlassian billing partner. The "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 0,
              "value": "subscription is"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "subscriptions are"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "entitlementsLength"
    },
    {
      "type": 0,
      "value": " now active and ready to use."
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.intro.reseller": [
    {
      "type": 0,
      "value": "Good news — we’ve received the order placed by your Atlassian reseller. The "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 0,
              "value": "subscription is"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "subscriptions are"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "entitlementsLength"
    },
    {
      "type": 0,
      "value": " now active and ready to use."
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.manage-reseller": [
    {
      "type": 0,
      "value": "You can view or cancel your "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 0,
              "value": "subscription"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "subscriptions"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "entitlementsLength"
    },
    {
      "type": 0,
      "value": " at any time by going to "
    },
    {
      "type": 1,
      "value": "manageSubscriptionUrl"
    },
    {
      "type": 0,
      "value": " and following the steps."
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.manage-subscription": [
    {
      "type": 0,
      "value": "You can view or cancel "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 0,
              "value": "the subscription"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "these subscriptions"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "entitlementsLength"
    },
    {
      "type": 0,
      "value": " from "
    },
    {
      "type": 1,
      "value": "partnerManagedSubscriptionUrl"
    },
    {
      "type": 0,
      "value": " page."
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.setup-your-site": [
    {
      "type": 0,
      "value": "Get started straight away by setting up your new "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 0,
              "value": "subscription"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "subscriptions"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "entitlementsLength"
    },
    {
      "type": 0,
      "value": ":"
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.site-heading": [
    {
      "type": 0,
      "value": "Site: "
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.site-url": [
    {
      "children": [
        {
          "type": 1,
          "value": "siteURL"
        }
      ],
      "type": 8,
      "value": "a"
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.button.get-started": [
    {
      "type": 0,
      "value": "Get started"
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.caption": [
    {
      "type": 0,
      "value": "Your order is confirmed"
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.ecc-reseller-managed-subscription.url": [
    {
      "type": 0,
      "value": "your Subscription overview"
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.future-dated-with-date.body-ecc.intro.reseller": [
    {
      "type": 0,
      "value": "Good news — we’ve received an order from your Atlassian reseller, and the products will be ready for use on "
    },
    {
      "type": 1,
      "value": "futureStartDate"
    },
    {
      "type": 0,
      "value": ". We’ll send a reminder when they are active."
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.future-dated-with-date.body.intro": [
    {
      "type": 0,
      "value": "Good news — we’ve received an order from your Atlassian billing partner, and the products will be ready for use on "
    },
    {
      "type": 1,
      "value": "futureStartDate"
    },
    {
      "type": 0,
      "value": ". We’ll send a reminder when they are active."
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.future-dated.body.intro": [
    {
      "type": 0,
      "value": "Good news — we’ve received an order from your Atlassian billing partner, and the products will be ready for use from their start dates. We’ll send a reminder when they are active."
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.future-dated.body.intro.reseller": [
    {
      "type": 0,
      "value": "Good news — we’ve received an order from your Atlassian reseller, and the products will be ready for use from their start dates. We’ll send a reminder when they are active."
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.partner-managed-subscription.url": [
    {
      "type": 0,
      "value": "your partner-managed subscriptions"
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.subject": [
    {
      "type": 1,
      "value": "billToPartyName"
    },
    {
      "type": 0,
      "value": ": Atlassian product order confirmed"
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.allowance-contributions-enforcement-ubp5": [
    {
      "type": 0,
      "value": "Remember, any usage above the allowance may incur extra usage charges, which will be added to your customer’s bill at the end of the bill cycle. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Find out more about usage charges and billing"
        }
      ],
      "type": 8,
      "value": "UsageChargesAndBillingLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.auto_prov_notification": [
    {
      "type": 0,
      "value": "The products will be added to your customer’s account shortly."
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.cbp-details": [
    {
      "type": 0,
      "value": "The plan also includes the following:"
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.customer_contact_info": [
    {
      "type": 0,
      "value": "Your customer contact can view or cancel "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 0,
              "value": "this subscription"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "these subscriptions"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "entitlementsLength"
    },
    {
      "type": 0,
      "value": " at any time."
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.get-started": [
    {
      "type": 0,
      "value": "You can get started straight away by setting up the subscriptions. We’ve also sent a notification to your customer with a setup link to get started. "
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.intro": [
    {
      "type": 0,
      "value": "Thanks for choosing Atlassian. We’ve received your order."
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.manage-subscription": [
    {
      "type": 0,
      "value": "You can manage "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 0,
              "value": "this subscription"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "these subscriptions"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "entitlementsLength"
    },
    {
      "type": 0,
      "value": " from our "
    },
    {
      "type": 1,
      "value": "ppcHomePage"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.next_steps_invoice_info": [
    {
      "type": 0,
      "value": "We’ll email the invoice with all the details within 24 hours."
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.next_steps_notification": [
    {
      "type": 0,
      "value": "We’ll also send a notification to your customer with a link to set up their new "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 0,
              "value": "subscription"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "subscriptions"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "entitlementsLength"
    },
    {
      "type": 0,
      "value": " and get started."
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.rovo-dev-credits-usage-details": [
    {
      "type": 0,
      "value": "Remember, extra usage charges can now be accrued — any extra usage will be charged at USD 0.01 per extra Rovo Dev credit and added to the next invoice. We’ve set an extra usage limit of 2,000 Rovo Dev credits per user, which means extra usage charges per user is currently limited to USD 20 (unless it’s already been adjusted). To keep spending predictable, organization admins can adjust this usage limit or disable extra usage anytime in Atlassian Administration."
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.rovo-dev-details": [
    {
      "type": 0,
      "value": "We’ll send you an invoice with all the details within 24 hours. We’ll also send an email to your customer with a link to set up and get started with their new subscription. You can get started straight away by setting up the subscriptions."
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.partner.button.get-started": [
    {
      "type": 0,
      "value": "Get started"
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.partner.caption": [
    {
      "type": 0,
      "value": "Your order is confirmed"
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.partner.future-dated-with-date.body.intro": [
    {
      "type": 0,
      "value": "Thanks for choosing Atlassian. We’ve received your order, and the products will be ready to use on "
    },
    {
      "type": 1,
      "value": "futureStartDate"
    },
    {
      "type": 0,
      "value": ". We’ll send a reminder to your customer when they are active."
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.partner.future-dated.body.intro": [
    {
      "type": 0,
      "value": "Thanks for choosing Atlassian. We've received your order, and the products will be ready for use from their start dates. We’ll send a reminder to your customer when they are active."
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.partner.subject": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": ": Order "
    },
    {
      "type": 1,
      "value": "orderNumber"
    },
    {
      "type": 0,
      "value": " confirmed"
    }
  ],
  "commerce.commerce-order-fulfilled-ccp.message-template.email.remaining-subs": [
    {
      "type": 0,
      "value": "+ "
    },
    {
      "type": 1,
      "value": "remainingCount"
    },
    {
      "type": 0,
      "value": " more subscriptions."
    }
  ],
  "commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.future.date.reminder": [
    {
      "type": 0,
      "value": "You'll be able to set up and start using your subscriptions from their start dates. We'll send you a reminder when they're ready."
    }
  ],
  "commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.future.with.date.reminder": [
    {
      "type": 0,
      "value": "You'll be able to set up and start using your subscription/s on "
    },
    {
      "type": 1,
      "value": "futureStartDate"
    },
    {
      "type": 0,
      "value": ". We'll send you a reminder when they're ready."
    }
  ],
  "commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.more-information": [
    {
      "type": 0,
      "value": "For more information on how to manage your subscriptions and billing, visit "
    },
    {
      "type": 1,
      "value": "supportUrl"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.no-payment.expect-final-invoice": [
    {
      "type": 0,
      "value": "Expect the final invoice within 24 hours, which will include all the necessary details and payment options for your order."
    }
  ],
  "commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.payment-processing": [
    {
      "type": 0,
      "value": "We’re processing your payment and will email the final invoice within 24 hours."
    }
  ],
  "commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.set-up-your-cloud-site": [
    {
      "type": 0,
      "value": "Dive right in and "
    },
    {
      "type": 1,
      "value": "getStartedUrl"
    },
    {
      "type": 0,
      "value": " by setting up your cloud site for your new subscription."
    }
  ],
  "commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.thanks-for-choosing-atlassian": [
    {
      "type": 0,
      "value": "Thanks for choosing Atlassian. We’ve received your order."
    }
  ],
  "commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.view-subscription": [
    {
      "type": 0,
      "value": "You can view your subscription details from your site’s "
    },
    {
      "type": 1,
      "value": "siteAdmin"
    },
    {
      "type": 0,
      "value": " at "
    },
    {
      "type": 1,
      "value": "billingUrl"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.button.manage-subscription": [
    {
      "type": 0,
      "value": "Manage subscription"
    }
  ],
  "commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.button.view-subscription": [
    {
      "type": 0,
      "value": "View all Subscriptions"
    }
  ],
  "commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.caption": [
    {
      "type": 0,
      "value": "Your order is confirmed"
    }
  ],
  "commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.subject": [
    {
      "type": 0,
      "value": "Your Atlassian order "
    },
    {
      "type": 1,
      "value": "orderNumber"
    },
    {
      "type": 0,
      "value": " is confirmed"
    }
  ],
  "commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.body.atlassian-billing-partner": [
    {
      "type": 0,
      "value": "Atlassian billing partner: "
    }
  ],
  "commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.body.intro": [
    {
      "type": 0,
      "value": "Good news – we’ve received your order for:"
    }
  ],
  "commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.body.subscription-list-title": [
    {
      "type": 0,
      "value": "Subscription list:"
    }
  ],
  "commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.caption": [
    {
      "type": 0,
      "value": "Your order is confirmed"
    }
  ],
  "commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.future-date.subject": [
    {
      "type": 1,
      "value": "partnerName"
    },
    {
      "type": 0,
      "value": ": Order "
    },
    {
      "type": 1,
      "value": "orderNumber"
    },
    {
      "type": 0,
      "value": " confirmed"
    }
  ],
  "commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.future-dated-with-date.body.intro": [
    {
      "type": 0,
      "value": "Good news — we’ve received an order from your Atlassian billing partner, and the products will be ready for use on "
    },
    {
      "type": 1,
      "value": "futureStartDate"
    },
    {
      "type": 0,
      "value": ". We’ll send a reminder when they are active."
    }
  ],
  "commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.future-dated.body.intro": [
    {
      "type": 0,
      "value": "Good news — we’ve received an order from your Atlassian billing partner, and the products will be ready for use from their start dates. We’ll send a reminder when they are active."
    }
  ],
  "commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.partner-manage-subscriptions": [
    {
      "type": 0,
      "value": "You can view the subscription from "
    },
    {
      "type": 1,
      "value": "partnerManagedSubscriptionUrl"
    },
    {
      "type": 0,
      "value": " page."
    }
  ],
  "commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.partner-managed-subscription.url": [
    {
      "type": 0,
      "value": "your partner-managed subscriptions"
    }
  ],
  "commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.body.intro": [
    {
      "type": 0,
      "value": "Good news – we’ve received your order for:"
    }
  ],
  "commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.body.next_steps": [
    {
      "type": 0,
      "value": "Get started by setting up your customer’s cloud site for the new subscription."
    }
  ],
  "commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.body.ppc_homepage": [
    {
      "type": 0,
      "value": " You can also view and manage the subscription details from our Partner Purchasing Center. "
    },
    {
      "type": 1,
      "value": "viewQuoteUrl"
    }
  ],
  "commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.body.processing": [
    {
      "type": 0,
      "value": "We’re processing the payment and will email the final invoice within 24 hours."
    }
  ],
  "commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.body.subscription-list-title": [
    {
      "type": 0,
      "value": "Subscription list:"
    }
  ],
  "commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.caption": [
    {
      "type": 0,
      "value": "Your order is confirmed"
    }
  ],
  "commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.future-date.subject": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": ": Order "
    },
    {
      "type": 1,
      "value": "orderNumber"
    },
    {
      "type": 0,
      "value": " confirmed"
    }
  ],
  "commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.future-dated-with-date.body.intro": [
    {
      "type": 0,
      "value": "Good news — we’ve received your order, and the products will be ready for use on "
    },
    {
      "type": 1,
      "value": "futureStartDate"
    },
    {
      "type": 0,
      "value": ". We’ll send a reminder to your customer when they are active."
    }
  ],
  "commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.future-dated.body.intro": [
    {
      "type": 0,
      "value": "Good news — we’ve received your order, and the products will be ready for use from their start dates. We’ll send a reminder to your customer when they are active."
    }
  ],
  "commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.subject": [
    {
      "type": 0,
      "value": "We’ve received your order for "
    },
    {
      "type": 1,
      "value": "customerCompanyName"
    }
  ],
  "commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.remaining-subs": [
    {
      "type": 0,
      "value": "+ "
    },
    {
      "type": 1,
      "value": "remainingCount"
    },
    {
      "type": 0,
      "value": " more subscriptions."
    }
  ],
  "commerce.commerce-order-fulfilled-from-quote-no-payment-method-ccp.message-template.email.subject": [
    {
      "type": 0,
      "value": "This template has been deprecated"
    }
  ],
  "commerce.commerce-order-fulfilled-from-quote-no-payment-method-ccp.message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This template has been deprecated as it has been merged along with 'commerce-quote-order-fulfilled-ccp' template with dynamic content added to differentiate between pull/push payment method."
    }
  ],
  "commerce.commerce-partner-cancellation-personal-data-deletion-link": [
    {
      "type": 0,
      "value": "personal data deletion request form"
    }
  ],
  "commerce.commerce-partner-personal-data-deletion": [
    {
      "type": 0,
      "value": "If your customer would like to place a request for immediate deletion of personal data after cancellation, they can submit a "
    },
    {
      "type": 1,
      "value": "formLink"
    },
    {
      "type": 0,
      "value": ". Otherwise, the data will be deleted in accordance with Atlassian’s standard "
    },
    {
      "type": 1,
      "value": "policyLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-payment-confirmation-generic-email-ccp.email.direct.caption": [
    {
      "type": 0,
      "value": "Your payment has been processed"
    }
  ],
  "commerce.commerce-payment-confirmation-generic-email-ccp.email.direct.confirm": [
    {
      "type": 0,
      "value": "Thanks for choosing Atlassian. This email is to confirm that we've received your payment for the invoice "
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": ". The invoice is attached as a PDF for your records."
    }
  ],
  "commerce.commerce-payment-confirmation-generic-email-ccp.email.partner-or-reseller.caption": [
    {
      "type": 0,
      "value": "Your payment has been processed"
    }
  ],
  "commerce.commerce-payment-confirmation-generic-email-ccp.email.partner-or-reseller.confirm": [
    {
      "type": 0,
      "value": "This email is to confirm we have received payment for the following invoice:"
    }
  ],
  "commerce.commerce-payment-confirmation-generic-email-ccp.message-template.email.direct.subject": [
    {
      "type": 0,
      "value": "Your payment has been processed for the invoice "
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    }
  ],
  "commerce.commerce-payment-confirmation-generic-email-ccp.message-template.email.invoice-attached": [
    {
      "type": 0,
      "value": "The invoice is attached as a PDF for your records."
    }
  ],
  "commerce.commerce-payment-confirmation-generic-email-ccp.message-template.email.partner-or-reseller.subject": [
    {
      "type": 1,
      "value": "companyName"
    },
    {
      "type": 0,
      "value": " - "
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": ": Payment processed"
    }
  ],
  "commerce.commerce-payment-method-manage-ccp.account-ending-key": [
    {
      "type": 0,
      "value": "Account ending: "
    }
  ],
  "commerce.commerce-payment-method-manage-ccp.account-ending-value": [
    {
      "type": 1,
      "value": "last4"
    }
  ],
  "commerce.commerce-payment-method-manage-ccp.account-holder-name-key": [
    {
      "type": 0,
      "value": "Account holder name: "
    }
  ],
  "commerce.commerce-payment-method-manage-ccp.account-holder-name-value": [
    {
      "type": 1,
      "value": "accountHolder"
    }
  ],
  "commerce.commerce-payment-method-manage-ccp.authorization-date-key": [
    {
      "type": 0,
      "value": "Authorization date: "
    }
  ],
  "commerce.commerce-payment-method-manage-ccp.authorization-date-value": [
    {
      "type": 1,
      "value": "authorizationDate"
    }
  ],
  "commerce.commerce-payment-method-manage-ccp.authorization-details": [
    {
      "type": 0,
      "value": "Authorization details"
    }
  ],
  "commerce.commerce-payment-method-manage-ccp.bank-name-key": [
    {
      "type": 0,
      "value": "Bank name: "
    }
  ],
  "commerce.commerce-payment-method-manage-ccp.bank-name-value": [
    {
      "type": 1,
      "value": "bankName"
    }
  ],
  "commerce.commerce-payment-method-manage-ccp.caption.direct-debit-authorization": [
    {
      "type": 0,
      "value": "Direct debit authorization"
    }
  ],
  "commerce.commerce-payment-method-manage-ccp.caption.direct-debit-dispute": [
    {
      "type": 0,
      "value": "Update payment details to continue subscription"
    }
  ],
  "commerce.commerce-payment-method-manage-ccp.caption.flex-wallet-active": [
    {
      "type": 0,
      "value": "Your wallet is active"
    }
  ],
  "commerce.commerce-payment-method-manage-ccp.could-not-process-payment": [
    {
      "type": 0,
      "value": "We couldn't process your recent payment due to a dispute raised with your bank."
    }
  ],
  "commerce.commerce-payment-method-manage-ccp.direct-debit-legal-terms": [
    {
      "type": 0,
      "value": "You have authorized Atlassian to debit the bank account specified above for any amount owed for charges arising from your use of Atlassian’ services and/or purchase of products from Atlassian, pursuant to Atlassian’ website and terms, until this authorization is revoked. You have authorized Atlassian to debit your bank account periodically if and when you use Atlassian’ services or purchase more than one of Atlassian’ products periodically pursuant to Atlassian terms. Payments that fall outside the regular debits authorized above will only be debited after your authorization is obtained."
    }
  ],
  "commerce.commerce-payment-method-manage-ccp.email.subject.ach-direct-debit-mandate": [
    {
      "type": 0,
      "value": "Confirmation: Direct debit authorization"
    }
  ],
  "commerce.commerce-payment-method-manage-ccp.email.subject.flex-wallet-active": [
    {
      "type": 0,
      "value": "Your Atlassian wallet is active"
    }
  ],
  "commerce.commerce-payment-method-manage-ccp.flex-contact-us": [
    {
      "type": 0,
      "value": "Contact us"
    }
  ],
  "commerce.commerce-payment-method-manage-ccp.flex-view-wallet-details": [
    {
      "type": 0,
      "value": "View your Wallet details"
    }
  ],
  "commerce.commerce-payment-method-manage-ccp.flex-wallet-active-intro": [
    {
      "type": 0,
      "value": "Thanks for choosing Atlassian. Your wallet is now active, and the Atlassian subscriptions linked to your wallet will bill against it from your next billing cycle."
    }
  ],
  "commerce.commerce-payment-method-manage-ccp.flex-wallet-no-separate-payment": [
    {
      "type": 0,
      "value": "Charges for these subscriptions are paid from your wallet, so no separate payment is required from you."
    }
  ],
  "commerce.commerce-payment-method-manage-ccp.flex-wallet-question": [
    {
      "type": 0,
      "value": "Have a question about your wallet? Your Atlassian account team is here to help. "
    },
    {
      "type": 1,
      "value": "contactUs"
    }
  ],
  "commerce.commerce-payment-method-manage-ccp.how-to-cancel-direct-debit": [
    {
      "type": 0,
      "value": "You can cancel this direct debit at any time by deleting the linked bank account from your "
    },
    {
      "type": 1,
      "value": "paymentMethods"
    },
    {
      "type": 0,
      "value": " page"
    }
  ],
  "commerce.commerce-payment-method-manage-ccp.payment-methods": [
    {
      "type": 0,
      "value": "Payment methods"
    }
  ],
  "commerce.commerce-payment-method-manage-ccp.received-authorization": [
    {
      "type": 0,
      "value": "We’ve received your authorization for direct debit."
    }
  ],
  "commerce.commerce-payment-method-manage-ccp.routing-number-key": [
    {
      "type": 0,
      "value": "Routing number: "
    }
  ],
  "commerce.commerce-payment-method-manage-ccp.routing-number-value": [
    {
      "type": 1,
      "value": "routingNumber"
    }
  ],
  "commerce.commerce-payment-method-manage-ccp.update-bank-details": [
    {
      "type": 0,
      "value": "Update your bank account details, or link a different bank account. For monthly subscriptions, we don’t accept bank transfers."
    }
  ],
  "commerce.commerce-permission-request-add-payment-ccp.message-template.email.subject": [
    {
      "type": 0,
      "value": "Action needed: You have an add payment request"
    }
  ],
  "commerce.commerce-permission-request-add-payment-response-ccp.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Request complete: Payment details added by billing admin "
    }
  ],
  "commerce.commerce-permission-request-grant-ba-role-ccp.body.cta.accept-billing-admin-request": [
    {
      "type": 0,
      "value": "Review billing admin request"
    }
  ],
  "commerce.commerce-permission-request-grant-ba-role-ccp.body.feature.manage-payment-method": [
    {
      "type": 0,
      "value": "Manage payment methods and addresses"
    }
  ],
  "commerce.commerce-permission-request-grant-ba-role-ccp.body.feature.receive-emails": [
    {
      "type": 0,
      "value": "Receive emails about products, billing and orders"
    }
  ],
  "commerce.commerce-permission-request-grant-ba-role-ccp.body.feature.view-and-manage": [
    {
      "type": 0,
      "value": "View and manage all subscriptions in your account"
    }
  ],
  "commerce.commerce-permission-request-grant-ba-role-ccp.body.feature.view-and-manage-invoices": [
    {
      "type": 0,
      "value": "View and manage invoices and quotes"
    }
  ],
  "commerce.commerce-permission-request-grant-ba-role-ccp.email.account-name": [
    {
      "type": 1,
      "value": "transactionAccountName"
    }
  ],
  "commerce.commerce-permission-request-grant-ba-role-ccp.email.account-number": [
    {
      "type": 1,
      "value": "transactionAccountNumber"
    }
  ],
  "commerce.commerce-permission-request-grant-ba-role-ccp.email.ba-request-text": [
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": " ("
    },
    {
      "type": 1,
      "value": "email"
    },
    {
      "type": 0,
      "value": ") is requesting billing admin permission for the following account: "
    }
  ],
  "commerce.commerce-permission-request-grant-ba-role-ccp.email.begin-quotes.no-translate": [
    {
      "type": 0,
      "value": "❝ "
    }
  ],
  "commerce.commerce-permission-request-grant-ba-role-ccp.email.end-quotes.no-translate": [
    {
      "type": 0,
      "value": " ❞"
    }
  ],
  "commerce.commerce-permission-request-grant-ba-role-ccp.email.personal-note.no-translate": [
    {
      "type": 1,
      "value": "customMessage"
    }
  ],
  "commerce.commerce-permission-request-grant-ba-role-ccp.email.subtext-for-personal-note": [
    {
      "type": 0,
      "value": "The request was sent with the following note: "
    }
  ],
  "commerce.commerce-permission-request-grant-ba-role-ccp.email.title": [
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": " is requesting billing admin access"
    }
  ],
  "commerce.commerce-permission-request-grant-ba-role-ccp.email.total-entitlements": [
    {
      "type": 1,
      "value": "totalEntitlements"
    },
    {
      "type": 0,
      "value": " subscriptions"
    }
  ],
  "commerce.commerce-permission-request-grant-ba-role-ccp.email.what-they-can-do": [
    {
      "type": 0,
      "value": "If you approve, they'll be able to:"
    }
  ],
  "commerce.commerce-permission-request-grant-ba-role-ccp.email.whats-next-subtext": [
    {
      "type": 0,
      "value": "If you accept the request, we'll notify the requester. If you don't want to grant billing admin access, you can decline the request."
    }
  ],
  "commerce.commerce-permission-request-grant-ba-role-ccp.message-template.email.subject": [
    {
      "type": 0,
      "value": "Action needed: "
    },
    {
      "type": 1,
      "value": "requesterName"
    },
    {
      "type": 0,
      "value": " is requesting Billing admin access"
    }
  ],
  "commerce.commerce-permission-request-grant-ba-role-response-ccp.body.cta.manageSubscription": [
    {
      "type": 0,
      "value": "Manage subscription"
    }
  ],
  "commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.manage-payment-method": [
    {
      "type": 0,
      "value": "Manage payment methods and addresses"
    }
  ],
  "commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.receive-emails": [
    {
      "type": 0,
      "value": "Receive emails about products, billing and orders"
    }
  ],
  "commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.receive-emails-for-changes": [
    {
      "type": 0,
      "value": "Receive emails about any changes"
    }
  ],
  "commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.request-billing-admin": [
    {
      "type": 0,
      "value": "Request billing admins to make changes to subscriptions"
    }
  ],
  "commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.view-and-manage": [
    {
      "type": 0,
      "value": "View and manage all subscriptions in your account"
    }
  ],
  "commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.view-and-manage-invoices": [
    {
      "type": 0,
      "value": "View and manage invoices and quotes"
    }
  ],
  "commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.view-and-manage-site": [
    {
      "type": 0,
      "value": "View, upgrade, downgrade and cancel subscriptions in your site"
    }
  ],
  "commerce.commerce-permission-request-grant-ba-role-response-ccp.email.account-name": [
    {
      "type": 1,
      "value": "transactionAccountName"
    }
  ],
  "commerce.commerce-permission-request-grant-ba-role-response-ccp.email.account-number": [
    {
      "type": 1,
      "value": "transactionAccountNumber"
    }
  ],
  "commerce.commerce-permission-request-grant-ba-role-response-ccp.email.ba-approved-text": [
    {
      "type": 0,
      "value": "Great news - your billing admin request has been approved for the following account: "
    }
  ],
  "commerce.commerce-permission-request-grant-ba-role-response-ccp.email.ba-declined-text": [
    {
      "type": 0,
      "value": "Your request to become a billing admin on the following account has been declined."
    }
  ],
  "commerce.commerce-permission-request-grant-ba-role-response-ccp.email.title-approved": [
    {
      "type": 0,
      "value": "You're now a billing admin"
    }
  ],
  "commerce.commerce-permission-request-grant-ba-role-response-ccp.email.title-declined": [
    {
      "type": 0,
      "value": "Your billing admin request has been declined"
    }
  ],
  "commerce.commerce-permission-request-grant-ba-role-response-ccp.email.total-entitlements": [
    {
      "type": 1,
      "value": "totalEntitlements"
    },
    {
      "type": 0,
      "value": " subscriptions"
    }
  ],
  "commerce.commerce-permission-request-grant-ba-role-response-ccp.email.what-you-get": [
    {
      "type": 0,
      "value": "You'll now be able to:"
    }
  ],
  "commerce.commerce-permission-request-grant-ba-role-response-ccp.email.what-you-get-without-access": [
    {
      "type": 0,
      "value": "You'll still be able to:"
    }
  ],
  "commerce.commerce-permission-request-grant-ba-role-response-ccp.message-template.email.subject.approved": [
    {
      "type": 0,
      "value": "Your billing admin request has been approved"
    }
  ],
  "commerce.commerce-permission-request-grant-ba-role-response-ccp.message-template.email.subject.declined": [
    {
      "type": 0,
      "value": "Your billing admin request has been declined"
    }
  ],
  "commerce.commerce-pre-comms-sp-add-on-merge-ccp.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Important information about your Statuspage add-ons"
    }
  ],
  "commerce.commerce-pre-dunning-ccp.mpucup.email.body-text": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " Standard "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "trial has ended."
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " You're currently over the 10-user limit for our Free plan. Add payment details now to keep your team active - otherwise, your team will lose access to "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " and your data will be permanently deleted."
    }
  ],
  "commerce.commerce-pre-dunning-ccp.mpucup.email.body-text-within-limit": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " Standard "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "trial has ended."
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " Add payment details now to keep your team on Standard - otherwise, your team will lose access to some "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " features and be downgraded to the Free plan."
    }
  ],
  "commerce.commerce-pre-dunning-ccp.mpucup.email.heading": [
    {
      "type": 0,
      "value": "Last chance to keep your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " site and data"
    }
  ],
  "commerce.commerce-pre-dunning-ccp.mpucup.email.not-ready-heading": [
    {
      "type": 0,
      "value": "Not ready to upgrade?"
    }
  ],
  "commerce.commerce-pre-dunning-ccp.mpucup.email.subject": [
    {
      "type": 0,
      "value": "Last chance to keep your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription"
    }
  ],
  "commerce.commerce-pre-dunning-ccp.mpucup.email.switch-back-to-free-admin": [
    {
      "type": 0,
      "value": "You can switch back to a Free plan by "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "reducing your user count"
        }
      ],
      "type": 8,
      "value": "link"
    },
    {
      "type": 0,
      "value": " to 10 or fewer."
    }
  ],
  "commerce.commerce-pre-dunning-ccp.mpucup.email.switch-back-to-free-non-admin": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " admin can switch back to a Free plan by reducing your user count to 10 or fewer."
    }
  ],
  "commerce.commerce-pre-dunning-ccp.v2.email.contact-us": [
    {
      "type": 0,
      "value": "Please "
    },
    {
      "type": 1,
      "value": "contactUs"
    },
    {
      "type": 0,
      "value": " with any questions, we're always happy to help."
    }
  ],
  "commerce.commerce-pre-dunning-ccp.v2.email.greeting": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "commerce.commerce-pre-dunning-ccp.v2.email.total-bill": [
    {
      "type": 0,
      "value": "Your total estimated bill is "
    },
    {
      "type": 1,
      "value": "amount"
    },
    {
      "type": 0,
      "value": " (excludes tax)"
    }
  ],
  "commerce.commerce-quote-expired-ccp.email.caption": [
    {
      "type": 0,
      "value": "Your quote has expired"
    }
  ],
  "commerce.commerce-quote-expired-ccp.email.contact-us": [
    {
      "type": 0,
      "value": "Contact us"
    }
  ],
  "commerce.commerce-quote-expired-ccp.email.ready-to-order": [
    {
      "type": 0,
      "value": "If you’d like to try Atlassian products, opt for a free trial."
    }
  ],
  "commerce.commerce-quote-expired-ccp.email.reminder-before-expiry": [
    {
      "type": 0,
      "value": "Your quote "
    },
    {
      "type": 1,
      "value": "quoteNumber"
    },
    {
      "type": 0,
      "value": " has expired. You’ll no longer be able to pay for it."
    }
  ],
  "commerce.commerce-quote-expired-ccp.email.view-quote": [
    {
      "type": 0,
      "value": "You can always create a new quote by reaching out to us."
    }
  ],
  "commerce.commerce-quote-expired-ccp.message-template.email.subject": [
    {
      "type": 0,
      "value": "Your Atlassian quote "
    },
    {
      "type": 1,
      "value": "quoteNumber"
    },
    {
      "type": 0,
      "value": " has expired"
    }
  ],
  "commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.direct-customer.caption": [
    {
      "type": 0,
      "value": "It’s time to renew your subscription"
    }
  ],
  "commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.direct-customer.request-quote-to-avoid-losing-access": [
    {
      "type": 0,
      "value": "To avoid losing access to your products, request a quote that is valid until the end of your billing cycle. When you are ready to pay, simply review the quote and place your order. "
    }
  ],
  "commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.list-subscriptions": [
    {
      "type": 0,
      "value": "Subscriptions list:"
    }
  ],
  "commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.partner.caption": [
    {
      "type": 0,
      "value": "It’s time to renew"
    }
  ],
  "commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.partner.subject.with-customer-name": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": " : Request quote to renew subscription"
    }
  ],
  "commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.reach-out-to-create-quote": [
    {
      "type": 0,
      "value": "Reach out to us to create a quote."
    }
  ],
  "commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.request-quote-to-avoid-customer-losing-access": [
    {
      "type": 0,
      "value": "To avoid losing access to the products, request a quote valid until the end of your billing cycle. When your customer is ready to pay, they can simply review the quote and place an order."
    }
  ],
  "commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.subject": [
    {
      "type": 0,
      "value": "Request quote to renew subscription"
    }
  ],
  "commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.subscriptions-are-expiring": [
    {
      "type": 0,
      "value": "Just a heads up that you have subscriptions that are approaching their end date, so it’s time to renew."
    }
  ],
  "commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.subscriptions-are-expiring-for-customer-company": [
    {
      "type": 0,
      "value": "Just a heads up that you have subscriptions for "
    },
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": " that are approaching their end date, so it’s time to renew."
    }
  ],
  "commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.direct-customer.body.reach-us": [
    {
      "type": 0,
      "value": "Reach out to us to create a quote."
    }
  ],
  "commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.direct-customer.body.request-a-quote-message": [
    {
      "type": 0,
      "value": "You’re on a free trial of "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " ("
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": ") that ends on "
    },
    {
      "type": 1,
      "value": "quoteEndDate"
    },
    {
      "type": 0,
      "value": ". To avoid losing access to your product after the trial ends, request a quote valid until the trial expiry date. When you are ready to pay simply review the quote and place your order."
    }
  ],
  "commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.direct-customer.caption": [
    {
      "type": 0,
      "value": "Create a quote for your trial"
    }
  ],
  "commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.direct-customer.subject": [
    {
      "type": 0,
      "value": "Request quote for "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    }
  ],
  "commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.partner.body.request-a-quote-message": [
    {
      "type": 0,
      "value": "The free trial trial of Confluence Premium ("
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": ") subscription for "
    },
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": " ends on "
    },
    {
      "type": 1,
      "value": "quoteEndDate"
    },
    {
      "type": 0,
      "value": ". To avoid losing access to the product after the trial ends, request a quote that’s valid until the trial expiry date. When your customer is ready to pay, they can simply review the quote and place an order."
    }
  ],
  "commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.partner.caption": [
    {
      "type": 0,
      "value": "Create a quote for subscription trial "
    }
  ],
  "commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.partner.subject.with-customer-name": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": " - "
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": " : Request a quote"
    }
  ],
  "commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.partner.subject.without-customer-name": [
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": " : Request a quote"
    }
  ],
  "commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.partners.body.reach-us": [
    {
      "type": 0,
      "value": "Reach out to us to create a quote."
    }
  ],
  "commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.direct-customer.body.reach-us": [
    {
      "type": 0,
      "value": "Reach out to us to create a quote."
    }
  ],
  "commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.direct-customer.body.request-a-quote-message": [
    {
      "type": 0,
      "value": "You’re on a free trial of "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " ("
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": ") that ends on "
    },
    {
      "type": 1,
      "value": "quoteEndDate"
    },
    {
      "type": 0,
      "value": ". To avoid losing access to your product after the trial ends, request a quote valid until the trial expiry date. When you are ready to pay simply review the quote and place your order."
    }
  ],
  "commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.direct-customer.caption": [
    {
      "type": 0,
      "value": "Create a quote for your trial"
    }
  ],
  "commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.direct-customer.subject": [
    {
      "type": 0,
      "value": "Request quote for "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    }
  ],
  "commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.partner.body.request-a-quote-message": [
    {
      "type": 0,
      "value": "The free trial trial of Confluence Premium ("
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": ") subscription for "
    },
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": " ends on "
    },
    {
      "type": 1,
      "value": "quoteEndDate"
    },
    {
      "type": 0,
      "value": ". To avoid losing access to the product after the trial ends, request a quote that’s valid until the trial expiry date. When your customer is ready to pay, they can simply review the quote and place an order."
    }
  ],
  "commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.partner.caption": [
    {
      "type": 0,
      "value": "Create a quote for subscription trial "
    }
  ],
  "commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.partner.subject.with-customer-name": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": " - "
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": " : Request a quote"
    }
  ],
  "commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.partner.subject.without-customer-name": [
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": " : Request a quote"
    }
  ],
  "commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.partners.body.reach-us": [
    {
      "type": 0,
      "value": "Reach out to us to create a quote."
    }
  ],
  "commerce.commerce-quote-open-auto-fix-billing-period-email-ccp.email.caption": [
    {
      "type": 0,
      "value": "We've updated your quote billing period"
    }
  ],
  "commerce.commerce-quote-open-auto-fix-billing-period-email-ccp.email.ppc-homepage": [
    {
      "type": 0,
      "value": "You can also view the quote from our "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Partner Purchasing Center."
        }
      ],
      "type": 8,
      "value": "RawLink"
    }
  ],
  "commerce.commerce-quote-open-auto-fix-billing-period-email-ccp.email.subject": [
    {
      "type": 1,
      "value": "companyName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "quoteNumber"
    },
    {
      "type": 0,
      "value": " quote billing period change"
    }
  ],
  "commerce.commerce-quote-open-auto-fix-billing-period-email-ccp.email.updated-quote-body": [
    {
      "type": 0,
      "value": "We've updated the quote billing period for "
    },
    {
      "type": 1,
      "value": "quoteNumber"
    },
    {
      "type": 0,
      "value": ". This is because there was a change to the subscription plan, user tier or billing cycle since the quote was created, which changed the start date for one or more items on the quote."
    }
  ],
  "commerce.commerce-quote-open-auto-fix-billing-period-email-ccp.email.valid-until": [
    {
      "type": 0,
      "value": "The quote is valid until "
    },
    {
      "type": 1,
      "value": "quoteExpiry"
    },
    {
      "type": 0,
      "value": ". To view the updated details, select 'View quote' and download the PDF."
    }
  ],
  "commerce.commerce-quote-open-auto-fix-billing-period-email-ccp.email.view-quote-button": [
    {
      "type": 0,
      "value": "View quote"
    }
  ],
  "commerce.commerce-quote-open-auto-fix-bp-and-estimates-email-ccp.email.caption": [
    {
      "type": 0,
      "value": "We've updated your quote"
    }
  ],
  "commerce.commerce-quote-open-auto-fix-bp-and-estimates-email-ccp.email.estimates-changed": [
    {
      "type": 0,
      "value": "Changing the billing period has changed how we calculate the quote total, which means that the quote total has now been updated."
    }
  ],
  "commerce.commerce-quote-open-auto-fix-bp-and-estimates-email-ccp.email.ppc-homepage": [
    {
      "type": 0,
      "value": "You can also view the quote from our "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Partner Purchasing Center."
        }
      ],
      "type": 8,
      "value": "RawLink"
    }
  ],
  "commerce.commerce-quote-open-auto-fix-bp-and-estimates-email-ccp.email.subject": [
    {
      "type": 1,
      "value": "companyName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "quoteNumber"
    },
    {
      "type": 0,
      "value": " quote billing period and total change"
    }
  ],
  "commerce.commerce-quote-open-auto-fix-bp-and-estimates-email-ccp.email.updated-quote-body": [
    {
      "type": 0,
      "value": "We've updated the quote billing period and quote total for "
    },
    {
      "type": 1,
      "value": "quoteNumber"
    },
    {
      "type": 0,
      "value": ". This is because there was a change to the subscription plan, user tier or billing cycle since the quote was created, which changed the start date for one or more items on the quote."
    }
  ],
  "commerce.commerce-quote-open-auto-fix-bp-and-estimates-email-ccp.email.valid-until": [
    {
      "type": 0,
      "value": "The quote is valid until "
    },
    {
      "type": 1,
      "value": "quoteExpiry"
    },
    {
      "type": 0,
      "value": ". To view the updated details, select 'View quote' and download the PDF."
    }
  ],
  "commerce.commerce-quote-open-auto-fix-bp-and-estimates-email-ccp.email.view-quote-button": [
    {
      "type": 0,
      "value": "View quote"
    }
  ],
  "commerce.commerce-quote-open-auto-fix-estimate-email-ccp.email.caption": [
    {
      "type": 0,
      "value": "We've updated your quote total"
    }
  ],
  "commerce.commerce-quote-open-auto-fix-estimate-email-ccp.email.ppc-homepage": [
    {
      "type": 0,
      "value": "You can also view the quote from our "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Partner Purchasing Center."
        }
      ],
      "type": 8,
      "value": "RawLink"
    }
  ],
  "commerce.commerce-quote-open-auto-fix-estimate-email-ccp.email.subject": [
    {
      "type": 1,
      "value": "companyName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "quoteNumber"
    },
    {
      "type": 0,
      "value": " quote total change"
    }
  ],
  "commerce.commerce-quote-open-auto-fix-estimate-email-ccp.email.updated-quote": [
    {
      "type": 0,
      "value": "We've updated the quote total for "
    },
    {
      "type": 1,
      "value": "quoteNumber"
    },
    {
      "type": 0,
      "value": ". This is because the billing address or sold-to address or subscription's user count linked to the quote was updated since the quote was created, which changes how we estimate the quote total."
    }
  ],
  "commerce.commerce-quote-open-auto-fix-estimate-email-ccp.email.valid-until": [
    {
      "type": 0,
      "value": "The quote is valid until "
    },
    {
      "type": 1,
      "value": "quoteExpiry"
    },
    {
      "type": 0,
      "value": ". To view the updated details, select 'View quote' and download the PDF."
    }
  ],
  "commerce.commerce-quote-open-auto-fix-estimate-email-ccp.email.view-quote-button": [
    {
      "type": 0,
      "value": "View quote"
    }
  ],
  "commerce.commerce-quote-open-auto-fix-estimate.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "commerce.commerce-quote-open-auto-fix-estimate.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "commerce.commerce-quote-open-auto-fix-estimate.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "commerce.commerce-quote-open-auto-fix-estimate.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "commerce.commerce-quote-open-auto-fix-estimate.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "commerce.commerce-quote-open-auto-fix-estimate.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "commerce.commerce-quote-open-auto-fix-estimate.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "commerce.commerce-quote-open-auto-renewal-ccp.ecc.partner.caption": [
    {
      "type": 0,
      "value": "It’s time to renew "
    }
  ],
  "commerce.commerce-quote-open-auto-renewal-ccp.ecc.partner.get-in-touch": [
    {
      "type": 0,
      "value": "Get in touch with your Atlassian Billing Partner to get started on your renewal. They’ll be able to help you with your quote and any next steps."
    }
  ],
  "commerce.commerce-quote-open-auto-renewal-ccp.ecc.partner.let-you-know": [
    {
      "type": 0,
      "value": "We hope you’ve been enjoying your Atlassian products. We wanted to let you know that your subscription/s expire soon, so it’s time to renew."
    }
  ],
  "commerce.commerce-quote-open-auto-renewal-ccp.ecc.partner.what-you-need-to-do": [
    {
      "type": 0,
      "value": "What do I need to do?"
    }
  ],
  "commerce.commerce-quote-open-auto-renewal-ccp.message-template.email.ecc.subject": [
    {
      "type": 0,
      "value": "Contact your Atlassian Billing Partner to renew "
    }
  ],
  "commerce.commerce-quote-open-auto-renewal-email-ccp.email.caption": [
    {
      "type": 0,
      "value": "Renew your subscription"
    }
  ],
  "commerce.commerce-quote-open-auto-renewal-email-ccp.email.partner.caption": [
    {
      "type": 0,
      "value": "It's time to renew your subscription"
    }
  ],
  "commerce.commerce-quote-open-auto-renewal-email-ccp.email.partner.create-order": [
    {
      "type": 0,
      "value": "When your customer is ready to convert the quote to an order, proceed to pay and confirm the order. You can also head to our Partner Purchasing Center to create an order. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Learn more"
        }
      ],
      "type": 8,
      "value": "learnMoreLink"
    }
  ],
  "commerce.commerce-quote-open-auto-renewal-email-ccp.email.partner.create-order-title": [
    {
      "type": 0,
      "value": "To create an order"
    }
  ],
  "commerce.commerce-quote-open-auto-renewal-email-ccp.email.partner.intro": [
    {
      "type": 0,
      "value": "Hi, "
    },
    {
      "children": [
      ],
      "type": 8,
      "value": "br"
    },
    {
      "type": 0,
      "value": "Just a heads up that the subscription for "
    },
    {
      "type": 1,
      "value": "companyName"
    },
    {
      "type": 0,
      "value": " expires soon and is ready to be renewed. To review the subscription details and the cost, we've created a quote that's valid until the end of your customer's billing cycle."
    }
  ],
  "commerce.commerce-quote-open-auto-renewal-email-ccp.email.partner.view-quote-button": [
    {
      "type": 0,
      "value": "View quote"
    }
  ],
  "commerce.commerce-quote-open-auto-renewal-email-ccp.email.quote-created": [
    {
      "type": 0,
      "value": "This is a friendly reminder that you have subscriptions up for renewal on "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "renewalDate"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ". To review your subscription details and assess the cost, we've created a quote("
    },
    {
      "type": 1,
      "value": "quoteNumber"
    },
    {
      "type": 0,
      "value": ") that's valid until the end of your current billing cycle. To view the details, download the attached quote PDF."
    }
  ],
  "commerce.commerce-quote-open-auto-renewal-email-ccp.email.ready-to-pay": [
    {
      "children": [
        {
          "type": 0,
          "value": "Ready to pay?"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "commerce.commerce-quote-open-auto-renewal-email-ccp.email.reseller.create-order": [
    {
      "type": 0,
      "value": "When your customer is ready to convert the quote to an order, proceed to pay and confirm the order. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Learn more"
        }
      ],
      "type": 8,
      "value": "learnMoreLink"
    }
  ],
  "commerce.commerce-quote-open-auto-renewal-email-ccp.email.view-details": [
    {
      "type": 0,
      "value": "When you're ready to renew your subscription, access the quote from the "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Quotes"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " page of your "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "billing account"
        }
      ],
      "type": 8,
      "value": "billingLink"
    },
    {
      "type": 0,
      "value": " and place an order."
    }
  ],
  "commerce.commerce-quote-open-auto-renewal-email-ccp.email.view-quote-button": [
    {
      "type": 0,
      "value": "View quote"
    }
  ],
  "commerce.commerce-quote-open-auto-renewal-email-ccp.email.what-happens-answer": [
    {
      "type": 0,
      "value": "Your subscription will be canceled, unless you renew for the next billing cycle."
    }
  ],
  "commerce.commerce-quote-open-auto-renewal-email-ccp.email.what-happens-question": [
    {
      "children": [
        {
          "type": 0,
          "value": "What happens after my current billing cycle ends?"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "commerce.commerce-quote-open-auto-renewal-email-ccp.message-template.email.subject.direct": [
    {
      "type": 0,
      "value": "Renew now: your subscription expires soon"
    }
  ],
  "commerce.commerce-quote-open-auto-renewal-email-ccp.message-template.email.subject.partner": [
    {
      "type": 0,
      "value": "Quote created for "
    },
    {
      "type": 1,
      "value": "companyName"
    },
    {
      "type": 0,
      "value": " ("
    },
    {
      "type": 1,
      "value": "quoteNumber"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "commerce.commerce-quote-open-auto-trial-ccp.email.caption": [
    {
      "type": 0,
      "value": "Your quote is ready"
    }
  ],
  "commerce.commerce-quote-open-auto-trial-ccp.email.place-order": [
    {
      "type": 0,
      "value": "Ready to start your paid subscription? Simply review the quote and place your order."
    }
  ],
  "commerce.commerce-quote-open-auto-trial-ccp.email.quote-created": [
    {
      "type": 0,
      "value": "We've created a quote for your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "edition"
    },
    {
      "type": 0,
      "value": " trial ("
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": "), to help you assess if it's the right plan for you. The quote is valid until your trial ends on "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "trialExpiry"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-quote-open-auto-trial-ccp.email.reminder": [
    {
      "type": 0,
      "value": "Just a reminder – be sure to order before your trial ends to avoid losing access to your product."
    }
  ],
  "commerce.commerce-quote-open-auto-trial-ccp.email.view-details": [
    {
      "type": 0,
      "value": "To view the details, download the attached quote PDF or go to the "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Quotes"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " page of your "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "billing account"
        }
      ],
      "type": 8,
      "value": "billingLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-quote-open-auto-trial-ccp.email.view-quote-button": [
    {
      "type": 0,
      "value": "View quote"
    }
  ],
  "commerce.commerce-quote-open-auto-trial-ccp.message-template.email.subject": [
    {
      "type": 0,
      "value": "Quote created: "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "edition"
    },
    {
      "type": 0,
      "value": " trial ("
    },
    {
      "type": 1,
      "value": "quoteNumber"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "commerce.commerce-quote-open-ccp.email.contract-type-non-standard": [
    {
      "type": 0,
      "value": "When you're ready to convert the quote to an order, contact your customer advocate."
    }
  ],
  "commerce.commerce-quote-open-ccp.email.contract-type-standard": [
    {
      "type": 0,
      "value": "When you're ready to convert the quote to an order, go to the quote in your billing account and proceed to create an order."
    }
  ],
  "commerce.commerce-quote-open-ccp.email.direct-customer": [
    {
      "type": 0,
      "value": "Your quote ("
    },
    {
      "type": 1,
      "value": "quoteNumber"
    },
    {
      "type": 0,
      "value": ") is ready and will be valid until "
    },
    {
      "type": 1,
      "value": "quoteExpiry"
    },
    {
      "type": 0,
      "value": ". To view the details of the quote, download the attached PDF or go to your site's "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Administration"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " at "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "admin.atlassian.com/billing"
        }
      ],
      "type": 8,
      "value": "billingUrl"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-quote-open-ccp.email.direct-customer-caption": [
    {
      "type": 0,
      "value": "Here’s the quote you requested"
    }
  ],
  "commerce.commerce-quote-open-ccp.email.direct-customer-quote-open": [
    {
      "type": 0,
      "value": "Your quote ("
    },
    {
      "type": 1,
      "value": "quoteNumber"
    },
    {
      "type": 0,
      "value": ") is ready and will be valid until "
    },
    {
      "type": 1,
      "value": "quoteExpiry"
    },
    {
      "type": 0,
      "value": ". To view the details of the quote, download the attached PDF or go to your site's "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Administration"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " at "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "billingUrlText"
        }
      ],
      "type": 8,
      "value": "billingUrl"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-quote-open-ccp.email.direct-customer-quote-open-reminder": [
    {
      "type": 0,
      "value": "Keep in mind, if you have product trials in the quote, we recommend placing your order before the trial ends. If you need more time, "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "reach out to us"
        }
      ],
      "type": 8,
      "value": "RawLink"
    },
    {
      "type": 0,
      "value": " to extend your quote validity."
    }
  ],
  "commerce.commerce-quote-open-ccp.email.manage-subscription": [
    {
      "type": 0,
      "value": "You can view subscription and billing details on your "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Manage Subscriptions"
        }
      ],
      "type": 8,
      "value": "RawLink"
    },
    {
      "type": 0,
      "value": " page."
    }
  ],
  "commerce.commerce-quote-open-ccp.email.partner-or-reseller-caption": [
    {
      "type": 0,
      "value": "Here’s the quote you requested"
    }
  ],
  "commerce.commerce-quote-open-ccp.email.partner-or-reseller-quote-open": [
    {
      "type": 0,
      "value": "Good news – the quote you requested is now ready:"
    }
  ],
  "commerce.commerce-quote-open-ccp.email.partner-or-reseller-quote-open-details": [
    {
      "type": 0,
      "value": "The quote will be valid until "
    },
    {
      "type": 1,
      "value": "quoteExpiry"
    },
    {
      "type": 0,
      "value": ". To view the details, select ‘View quote’ and download the PDF."
    }
  ],
  "commerce.commerce-quote-open-ccp.email.partner-or-reseller-view-quote-button": [
    {
      "type": 0,
      "value": "View quote"
    }
  ],
  "commerce.commerce-quote-open-ccp.email.partner-ppc-homepage": [
    {
      "type": 0,
      "value": "You can also view quotes and manage these subscriptions from our Partner Purchasing Center. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Learn more"
        }
      ],
      "type": 8,
      "value": "RawLink"
    }
  ],
  "commerce.commerce-quote-open-ccp.email.view-quote-button": [
    {
      "type": 0,
      "value": "View quote"
    }
  ],
  "commerce.commerce-quote-open-ccp.message-template.email.subject.direct": [
    {
      "type": 0,
      "value": "Your Atlassian quote "
    },
    {
      "type": 1,
      "value": "quoteNumber"
    },
    {
      "type": 0,
      "value": " is here!"
    }
  ],
  "commerce.commerce-quote-open-ccp.message-template.email.subject.partner-or-reseller": [
    {
      "type": 1,
      "value": "companyName"
    },
    {
      "type": 0,
      "value": " quote "
    },
    {
      "type": 1,
      "value": "quoteNumber"
    },
    {
      "type": 0,
      "value": " is ready"
    }
  ],
  "commerce.commerce-quote-reminder-expiry-ccp.email.administration": [
    {
      "type": 0,
      "value": "Administration"
    }
  ],
  "commerce.commerce-quote-reminder-expiry-ccp.email.caption": [
    {
      "type": 0,
      "value": "Your quote will expire soon"
    }
  ],
  "commerce.commerce-quote-reminder-expiry-ccp.email.order-in-bac": [
    {
      "type": 0,
      "value": " at "
    },
    {
      "type": 1,
      "value": "billingUrl"
    },
    {
      "type": 0,
      "value": " and create an order."
    }
  ],
  "commerce.commerce-quote-reminder-expiry-ccp.email.ready-to-order": [
    {
      "type": 0,
      "value": "When you’re ready to convert your quote to an order, go to your site's "
    }
  ],
  "commerce.commerce-quote-reminder-expiry-ccp.email.reminder-before-expiry": [
    {
      "type": 0,
      "value": "This is a friendly reminder that your quote "
    },
    {
      "type": 1,
      "value": "quoteNumber"
    },
    {
      "type": 0,
      "value": " will expire on "
    },
    {
      "type": 1,
      "value": "quoteExpiry"
    },
    {
      "type": 0,
      "value": ". Once expired, the quote will be canceled and you have to create a new one."
    }
  ],
  "commerce.commerce-quote-reminder-expiry-ccp.email.view-quote": [
    {
      "type": 0,
      "value": "View quote"
    }
  ],
  "commerce.commerce-quote-reminder-expiry-ccp.message-template.email.subject": [
    {
      "type": 0,
      "value": "Your Atlassian quote "
    },
    {
      "type": 1,
      "value": "quoteNumber"
    },
    {
      "type": 0,
      "value": " will expire soon"
    }
  ],
  "commerce.commerce-quote-stale-ccp.email.body": [
    {
      "type": 0,
      "value": "Just a heads up that your quote for "
    },
    {
      "type": 1,
      "value": "companyName"
    },
    {
      "type": 0,
      "value": " needs to be updated before it can be moved back to OPEN."
    }
  ],
  "commerce.commerce-quote-stale-ccp.email.caption": [
    {
      "type": 0,
      "value": "Your quote needs to be reviewed"
    }
  ],
  "commerce.commerce-quote-stale-ccp.email.update-line-item": [
    {
      "type": 0,
      "value": "Head to the effected line item/s on the quote and follow the prompts from the error to update it. If that doesn't work, you'll need to raise a GSAC ticket so that an Atlassian Customer Advocate can look into it."
    }
  ],
  "commerce.commerce-quote-stale-ccp.message-template.email.subject": [
    {
      "type": 0,
      "value": "Action required: "
    },
    {
      "type": 1,
      "value": "companyName"
    },
    {
      "type": 0,
      "value": " quote "
    },
    {
      "type": 1,
      "value": "quoteNumber"
    },
    {
      "type": 0,
      "value": " needs review"
    }
  ],
  "commerce.commerce-reactivation-order-to-paid-ccp.email.body.caption": [
    {
      "type": 0,
      "value": " Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription has been successfully reactivated"
    }
  ],
  "commerce.commerce-reactivation-order-to-paid-ccp.email.body.great-news": [
    {
      "type": 0,
      "value": "Great news - you’re now on a "
    },
    {
      "type": 1,
      "value": "newPricingPlanName"
    },
    {
      "type": 0,
      "value": ", "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription."
    }
  ],
  "commerce.commerce-reactivation-order-to-paid-ccp.email.body.we-will-charge": [
    {
      "type": 0,
      "value": "We’ll charge your chosen payment method and send you an invoice within 24 hours."
    }
  ],
  "commerce.commerce-reactivation-order-to-paid-ccp.email.body.welcome-back": [
    {
      "type": 0,
      "value": "Welcome back! As requested, we’ve reactivated your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription ("
    },
    {
      "type": 1,
      "value": "entNumber"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "commerce.commerce-reactivation-order-to-paid-ccp.personal-information": [
    {
      "type": 0,
      "value": "Since you reactivated your subscription within 60 days of cancellation, your data and preferences\n                    are as you left them. You can jump right in and get started!"
    }
  ],
  "commerce.commerce-refund-credit-grant-ccp.message-template.email.cannot-be-refunded": [
    {
      "type": 0,
      "value": "Please note that this balance can't be refunded or exchanged for cash."
    }
  ],
  "commerce.commerce-refund-credit-grant-ccp.message-template.email.caption": [
    {
      "type": 0,
      "value": "Your Service Credits adjustment has been processed"
    }
  ],
  "commerce.commerce-refund-credit-grant-ccp.message-template.email.direct.completed": [
    {
      "type": 0,
      "value": "We have successfully processed your request for SLA Compensation. You are entitled to receive Service Credits, as per our service level commitment. These credits will be added to your account balance and will be used in future invoices."
    }
  ],
  "commerce.commerce-refund-credit-grant-ccp.message-template.email.direct.subject": [
    {
      "type": 0,
      "value": "Your Service Credits adjustment has been processed"
    }
  ],
  "commerce.commerce-refund-credit-grant-ccp.message-template.email.direct.terms": [
    {
      "type": 0,
      "value": "Service Credits are applied to your account governed by the terms in "
    },
    {
      "type": 1,
      "value": "slaLink"
    },
    {
      "type": 0,
      "value": ". To read more about Service Credits, click "
    },
    {
      "type": 1,
      "value": "hereLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-refund-credit-grant-ccp.message-template.email.here-link-text": [
    {
      "type": 0,
      "value": "here"
    }
  ],
  "commerce.commerce-refund-credit-grant-ccp.message-template.email.partner-or-reseller.completed": [
    {
      "type": 0,
      "value": "We've successfully processed a request for SLA Compensation. You're entitled to receive Service Credits, as per our service level commitment. These credits will be added to your account balance and used in future invoices."
    }
  ],
  "commerce.commerce-refund-credit-grant-ccp.message-template.email.partner-or-reseller.subject": [
    {
      "type": 1,
      "value": "companyName"
    },
    {
      "type": 0,
      "value": ": Your Service Credits adjustment has been processed"
    }
  ],
  "commerce.commerce-refund-credit-grant-ccp.message-template.email.partner-or-reseller.terms": [
    {
      "type": 0,
      "value": "Service Credits are applied to your account governed by the terms in "
    },
    {
      "type": 1,
      "value": "slaLink"
    },
    {
      "type": 0,
      "value": ". Read more about "
    },
    {
      "type": 1,
      "value": "serviceCreditsLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-refund-credit-grant-ccp.message-template.email.service-credits-link-text": [
    {
      "type": 0,
      "value": "Service Credits"
    }
  ],
  "commerce.commerce-refund-credit-grant-ccp.message-template.email.sla-link-text": [
    {
      "type": 0,
      "value": "Atlassian Service Level Agreement"
    }
  ],
  "commerce.commerce-refund-generic-email-ccp.email.direct.caption": [
    {
      "type": 0,
      "value": "Your refund has been processed"
    }
  ],
  "commerce.commerce-refund-generic-email-ccp.email.partner-or-reseller.caption": [
    {
      "type": 0,
      "value": "Your refund has been processed"
    }
  ],
  "commerce.commerce-refund-generic-email-ccp.email.partner-or-reseller.completed": [
    {
      "type": 0,
      "value": "We have completed the refund related to the following invoice:"
    }
  ],
  "commerce.commerce-refund-generic-email-ccp.email.partner-or-reseller.refund-amount": [
    {
      "type": 0,
      "value": "The refund has been credited to the payment method used in the original purchase. Please allow 2-3 business days for the refunded amount to appear on your bank statement. Please note that any subscription changes based on your refund request will reflect on your account shortly."
    }
  ],
  "commerce.commerce-refund-generic-email-ccp.message-template.email.cash-refund": [
    {
      "type": 0,
      "value": "If you would like to receive a cash refund instead, please reach out to "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "accountsreceivable@atlassian.com"
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-refund-generic-email-ccp.message-template.email.completed": [
    {
      "type": 0,
      "value": "We have completed the refund related to the invoice "
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-refund-generic-email-ccp.message-template.email.credit-issued": [
    {
      "type": 0,
      "value": "The credits issued on this credit note will be applied to any outstanding unpaid invoices you may have."
    }
  ],
  "commerce.commerce-refund-generic-email-ccp.message-template.email.direct.subject": [
    {
      "type": 0,
      "value": "Refund processed for invoice "
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    }
  ],
  "commerce.commerce-refund-generic-email-ccp.message-template.email.more-info": [
    {
      "type": 0,
      "value": "For more information about invoices and subscriptions, go to your sites "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Administration"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-refund-generic-email-ccp.message-template.email.partner-or-reseller.subject": [
    {
      "type": 1,
      "value": "companyName"
    },
    {
      "type": 0,
      "value": " - "
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": ": Refund processed"
    }
  ],
  "commerce.commerce-refund-generic-email-ccp.message-template.email.refund-amount": [
    {
      "type": 0,
      "value": "The refunded amount should appear on your bank statement in 2-3 business days. Any subscription changes based on your refund request will reflect on your account soon."
    }
  ],
  "commerce.commerce-refund-generic-email-ccp.message-template.email.refund-credited-to-cc": [
    {
      "type": 0,
      "value": "A refund from the invoice "
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": " has been credited to your card "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "cardBrand"
        },
        {
          "type": 0,
          "value": " ending in "
        },
        {
          "type": 1,
          "value": "maskedNumber"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-refund-generic-email-ccp.message-template.email.refund-credited-to-paypal": [
    {
      "type": 0,
      "value": "A refund from the invoice "
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": " has been credited to your "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "PayPal account, "
        },
        {
          "type": 1,
          "value": "paypalEmail"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-refund-generic-email-ccp.message-template.email.terms-completed": [
    {
      "type": 0,
      "value": "We have completed the refund related to the invoice "
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": " and generated a credit note "
    },
    {
      "type": 1,
      "value": "creditNoteNumber"
    },
    {
      "type": 0,
      "value": " against it."
    }
  ],
  "commerce.commerce-refund-internal-ccp.message-template.email.adc-refund.body": [
    {
      "type": 0,
      "value": "Advocate Central REFUND LINK - "
    },
    {
      "type": 1,
      "value": "advocateCentralUrl"
    },
    {
      "type": 0,
      "value": "/refunds/"
    },
    {
      "type": 1,
      "value": "refundId"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-refund-internal-ccp.message-template.email.refund-bank-transfer.subject": [
    {
      "type": 0,
      "value": "Bank Refund Request - Refund #"
    },
    {
      "type": 1,
      "value": "refundId"
    }
  ],
  "commerce.commerce-refund-internal-ccp.message-template.email.refund-onAccount.subject": [
    {
      "type": 0,
      "value": "Expert Account Refund Request - Refund #"
    },
    {
      "type": 1,
      "value": "refundId"
    }
  ],
  "commerce.commerce-refund-internal-ccp.message-template.email.refund.body": [
    {
      "type": 0,
      "value": "CASSI REFUND LINK - "
    },
    {
      "type": 1,
      "value": "cassiUrl"
    },
    {
      "type": 0,
      "value": "/ui/refunds/"
    },
    {
      "type": 1,
      "value": "refundId"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.dc.email.breached-caption": [
    {
      "type": 0,
      "value": "Users in your site have used up their Rovo Dev credits"
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.dc.email.milestone-caption": [
    {
      "type": 0,
      "value": "Users in your site are using up their Rovo Dev credits"
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.dc.email.subject.breached": [
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " credit allowance used"
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.dc.email.subject.milestone": [
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " credit allowance running low"
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.breached.need-to-know-list-admin-can-limit-usage": [
    {
      "type": 0,
      "value": "Organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.breached.need-to-know-list-extra-usage-charges": [
    {
      "type": 0,
      "value": "Extra usage will be charged at USD 0.01 per extra Rovo Dev credit — any extra charges will be added to your next invoice. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "More about Rovo Dev billing"
        }
      ],
      "type": 8,
      "value": "SubscriptionAndBillingSupportUrl"
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.breached.need-to-know-list-user-can-use-extra": [
    {
      "type": 0,
      "value": "Unless an organization admin has adjusted the extra usage limit or disabled extra usage, users will be able to use up to 2,000 extra Rovo Dev credits for an extra charge on top of the 2,000 credits included in the subscription."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.need-to-know-list-extra-charges-in-invoice": [
    {
      "type": 0,
      "value": "Once users exceed their allowance of Rovo Dev credits, extra usage will be charged at USD 0.01 per extra Rovo Dev credit — any extra charges will be added to your next invoice."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.need-to-know-list-monitor-usage": [
    {
      "type": 0,
      "value": "It's a good idea to monitor usage in your billing account."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.need-to-know-list-org-admin-can-limit": [
    {
      "type": 0,
      "value": "Organization admins can adjust the extra usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.view-subscription": [
    {
      "type": 0,
      "value": "View subscription"
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.view-usage": [
    {
      "type": 0,
      "value": "View usage"
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.dc.breached-info-message": [
    {
      "type": 0,
      "value": "At least one of your users has used up their Rovo Dev credit allowance."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.dc.breached.monitoring-message": [
    {
      "type": 0,
      "value": "Monitor what your team's using by viewing a detailed breakdown of their usage in your billing account."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.dc.milestone-info-message": [
    {
      "type": 0,
      "value": "At least one of your users has used up "
    },
    {
      "type": 1,
      "value": "usageMilestone"
    },
    {
      "type": 0,
      "value": "% of their Rovo Dev credit allowance."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.partner.body.breached.need-to-know-list-extra-usage-charges": [
    {
      "type": 0,
      "value": "Extra usage will extra usage will be charged at USD 0.01 per extra Rovo Dev credit — any extra charges will be added to the next invoice."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.partner.body.breached.need-to-know-list-org-admin-can-limit": [
    {
      "type": 0,
      "value": "Organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.partner.body.milestone.need-to-know-list-monitor-usage": [
    {
      "type": 0,
      "value": "It’s a good idea to encourage your customer to monitor their usage in their billing account."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.partner.body.milestone.need-to-know-list-org-admin-can-limit": [
    {
      "type": 0,
      "value": "Organization admins can adjust the extra usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.partner.breached-info-message": [
    {
      "type": 0,
      "value": "At least one of your customer's users has used up their "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " credit allowance."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.partner.milestone-info-message": [
    {
      "type": 0,
      "value": "At least one of your customer's users has used up "
    },
    {
      "type": 1,
      "value": "usageMilestone"
    },
    {
      "type": 0,
      "value": "% of their "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " credit allowance."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.what-you-need": [
    {
      "type": 0,
      "value": "What you need to know:"
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.partner.email.body.breached.need-to-know-list-users-can-use-extra": [
    {
      "type": 0,
      "value": "Unless an organization admin has adjusted the extra usage limit or disabled extra usage, users will be able to use up to 2,000 extra Rovo Dev credits for an extra charge on top of the 2,000 credits included in the subscription."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.partner.email.body.milestone.need-to-know-list-users-can-use-extra": [
    {
      "type": 0,
      "value": "Once users exceed their allowance of Rovo Dev credits, extra usage will be charged at USD 0.01 per extra Rovo Dev credit — any extra charges will be added to the next invoice."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.partner.email.breached-caption": [
    {
      "type": 0,
      "value": "Users in your customer's site have used up their "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " credits"
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.partner.email.milestone-caption": [
    {
      "type": 0,
      "value": "Users in your customer's site are using up their "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " credits"
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.partner.email.subject.breached.with-company-name": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": ": Users have used up their "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " credits"
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.partner.email.subject.milestone.with-company-name": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": ": Users are using up their "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " credits"
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.breached-caption": [
    {
      "type": 0,
      "value": "Users in your site have used up their Rovo Dev credits"
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.breached-caption-announcement": [
    {
      "type": 1,
      "value": "usageMilestone"
    },
    {
      "type": 0,
      "value": "% of your "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " allowance has been used"
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.breached-caption-announcement.ubp5": [
    {
      "type": 1,
      "value": "usageMilestone"
    },
    {
      "type": 0,
      "value": "% of your "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " allowance has been used"
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.breached-rde-caption": [
    {
      "type": 0,
      "value": "Upgrade to Rovo Dev Standard to get more Rovo Dev credits"
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.milestone-caption": [
    {
      "type": 0,
      "value": "Users in your site are using up their Rovo Dev credits"
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.milestone-caption-allowance-announencement": [
    {
      "type": 1,
      "value": "usageMilestone"
    },
    {
      "type": 0,
      "value": "% of your "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " allowance has been used"
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.milestone-caption-allowance-announencement.ubp5": [
    {
      "type": 1,
      "value": "usageMilestone"
    },
    {
      "type": 0,
      "value": "% of your "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " allowance has been used"
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.subject.breached": [
    {
      "type": 0,
      "value": "Rovo Dev credit allowance used"
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.subject.breached.pooled-meter": [
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " allowance used"
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.subject.milestone": [
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " credit allowance running low"
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.subject.milestone.pooled-meter": [
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " allowance is running low"
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.need-to-know-list-admin-can-limit-usage": [
    {
      "type": 0,
      "value": "Organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.need-to-know-list-extra-usage-charges": [
    {
      "type": 0,
      "value": "Extra usage will be charged at USD 0.01 per extra Rovo Dev credit — any extra charges will be added to your next invoice. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "More about Rovo Dev billing"
        }
      ],
      "type": 8,
      "value": "SubscriptionAndBillingSupportUrl"
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.need-to-know-list-user-can-use-extra": [
    {
      "type": 0,
      "value": "Unless an organization admin has adjusted the extra usage limit or disabled extra usage, users will be able to use up to 2,000 extra Rovo Dev credits for an extra charge on top of the 2,000 credits included in the subscription."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.rde.need-to-know-list-monitor": [
    {
      "type": 0,
      "value": "You can monitor usage in your billing account to see which users have used their allowance."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.rde.need-to-know-list-ugrade-to-standard": [
    {
      "type": 0,
      "value": "To increase Rovo Dev credits and allow extra usage, organization admins can upgrade to Rovo Dev Standard."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.rde.need-to-know-list-user-cannot-use-extra": [
    {
      "type": 0,
      "value": "Users who are at their credit limit won't be able to use any Rovo Dev features until the next billing cycle."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.trials.need-to-know-list-admin-can-limit-usage": [
    {
      "type": 0,
      "value": "Organization admins can adjust the extra usage limit or disable extra usage for when the paid plan starts — this can be done anytime in Atlassian Administration to keep costs predictable. "
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.trials.need-to-know-list-extra-usage-charges": [
    {
      "type": 0,
      "value": "If you want to allow extra usage before the trial ends, you can end the trial early and start the paid plan. If you do this, usage will reset and any usage over the allocated amount will be charged at USD 0.01 per extra Rovo Dev credit and added to the next invoice."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.trialsneed-to-know-list-function-disabled": [
    {
      "type": 0,
      "value": "Rovo Dev functionality is disabled for users who reach their allowance, and usage resets when the paid plan starts."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.need-to-know-list-extra-charges-in-invoice": [
    {
      "type": 0,
      "value": "Once users exceed their allowance of Rovo Dev credits, extra usage will be charged at USD 0.01 per extra Rovo Dev credit — any extra charges will be added to your next invoice."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.need-to-know-list-monitor-usage": [
    {
      "type": 0,
      "value": "It's a good idea to monitor usage in your billing account."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.need-to-know-list-org-admin-can-limit": [
    {
      "type": 0,
      "value": "Organization admins can adjust the extra usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.trials.need-to-know-list-extra-charges-in-invoice": [
    {
      "type": 0,
      "value": "If you want to allow extra usage before the trial ends, you can end the trial early and start the paid plan. If you do this, usage will reset and any usage over the allocated amount will be charged at USD 0.01 per extra Rovo Dev credit and added to the next invoice."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.trials.need-to-know-list-org-admin-can-limit": [
    {
      "type": 0,
      "value": "Organization admins can adjust the extra usage limit or disable extra usage for when the paid plan starts — this can be done at any time in Atlassian Administration to keep costs predictable."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.trials.need-to-know-list-will-be-disabled": [
    {
      "type": 0,
      "value": "Once users use up their Rovo Dev credits, Rovo Dev functionality will be disabled until usage resets when the paid plan starts."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.view-subscription": [
    {
      "type": 0,
      "value": "View subscription"
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.view-usage": [
    {
      "type": 0,
      "value": "View usage"
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.billing-faq-url": [
    {
      "type": 0,
      "value": "When and how will I be billed?"
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached-billable-usage-notice": [
    {
      "type": 0,
      "value": "Any usage beyond your allowance is considered billable usage. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "You won’t be billed for your billable usage at this time."
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "billingUrl"
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached-details.ubp5": [
    {
      "type": 0,
      "value": "Visit Atlassian Administration to get more details on "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " usage in your organization."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached-info-message": [
    {
      "type": 0,
      "value": "At least one of your users has used up their Rovo Dev credit allowance."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached-info-message-announcement.ubp5": [
    {
      "type": 0,
      "value": "Your org has used "
    },
    {
      "type": 1,
      "value": "usageMilestone"
    },
    {
      "type": 0,
      "value": "% of their "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " allowance."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached-rde-info-message": [
    {
      "type": 0,
      "value": "At least one of your users has used up their free Rovo Dev credit allowance in Jira."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached-update-limits.ubp5": [
    {
      "type": 0,
      "value": "Your org admin can update your usage limits anytime."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached-what-next.ubp5": [
    {
      "type": 0,
      "value": "If your org admin has enabled extra usage, you’ll incur extra usage charges up to your extra usage limit. If extra usage is disabled, some features will be restricted or unavailable until your usage resets."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached.monitoring-message": [
    {
      "type": 0,
      "value": "Monitor what your team's using by viewing a detailed breakdown of their usage in your billing account."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.milestone-billable-usage-notice": [
    {
      "type": 0,
      "value": "Once your organization exceeds your allowance, you’ll start to incur billable usage. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "You won’t be billed for your billable usage at this time."
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "billingUrl"
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.milestone-info-message": [
    {
      "type": 0,
      "value": "At least one of your users has used up "
    },
    {
      "type": 1,
      "value": "usageMilestone"
    },
    {
      "type": 0,
      "value": "% of their Rovo Dev credit allowance."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.milestone-info-message-allowance-announcement": [
    {
      "type": 0,
      "value": "Your organization has used "
    },
    {
      "type": 1,
      "value": "usageMilestone"
    },
    {
      "type": 0,
      "value": "% of its "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " allowance."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.milestone-info-message-allowance-announcement.ubp5": [
    {
      "type": 0,
      "value": "Your org has used "
    },
    {
      "type": 1,
      "value": "usageMilestone"
    },
    {
      "type": 0,
      "value": "% of their "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " allowance."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.milestone-info-message-allowance-org-details.ubp5": [
    {
      "type": 0,
      "value": "Visit Atlassian Administration to get more details on "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " usage in your organization."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.milestone-what-next.ubp5": [
    {
      "type": 0,
      "value": "If your org reaches 100% of their allowance, extra usage charges will be incurred if extra usage is enabled. Otherwise, some features will be restricted or unavailable until your usage resets."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.usage-details-announcement": [
    {
      "type": 0,
      "value": "Visit Atlassian Administration to get more details on "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " usage in your organization."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.billing-faq-url": [
    {
      "type": 0,
      "value": "When and how will they be billed?"
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.body.breached.need-to-know-list-extra-usage-charges": [
    {
      "type": 0,
      "value": "Extra usage will extra usage will be charged at USD 0.01 per extra Rovo Dev credit — any extra charges will be added to the next invoice."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.body.breached.need-to-know-list-org-admin-can-limit": [
    {
      "type": 0,
      "value": "Organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.body.milestone.need-to-know-list-monitor-usage": [
    {
      "type": 0,
      "value": "It’s a good idea to encourage your customer to monitor their usage in their billing account."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.body.milestone.need-to-know-list-org-admin-can-limit": [
    {
      "type": 0,
      "value": "Organization admins can adjust the extra usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.breached-billable-usage-notice": [
    {
      "type": 0,
      "value": "Any usage beyond your customer’s allowance is considered billable usage. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "You won’t be billed for your billable usage at this time."
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "billingUrl"
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.breached-details.ubp5": [
    {
      "type": 0,
      "value": "Visit PPC to get more details on your customer’s "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " usage."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.breached-info-message": [
    {
      "type": 0,
      "value": "At least one of your customer's users has used up their "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " credit allowance."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.breached-info-message-pooled-meter.ubp5": [
    {
      "type": 0,
      "value": "Your customer has used "
    },
    {
      "type": 1,
      "value": "usageMilestone"
    },
    {
      "type": 0,
      "value": "% of their "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " allowance."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.breached-update-limits.ubp5": [
    {
      "type": 0,
      "value": "You can update your customer’s usage limits anytime."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.breached-what-next.ubp5": [
    {
      "type": 0,
      "value": "If you've enabled extra usage for your customer, they’ll incur extra usage charges up to the extra usage limit. If extra usage is disabled, some features will be restricted or unavailable until their usage resets."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.milestone-billable-usage-notice": [
    {
      "type": 0,
      "value": "Once your customer’s organization exceeds their allowance, they’ll start to incur billable usage. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "You won’t be billed for your billable usage at this time."
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "billingUrl"
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.milestone-details.ubp5": [
    {
      "type": 0,
      "value": "Visit PPC to get more details on your customer’s "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " usage."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.milestone-info-message": [
    {
      "type": 0,
      "value": "At least one of your customer's users has used up "
    },
    {
      "type": 1,
      "value": "usageMilestone"
    },
    {
      "type": 0,
      "value": "% of their "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " credit allowance."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.milestone-info-message-pooled-meter": [
    {
      "type": 0,
      "value": "Your customer has used "
    },
    {
      "type": 1,
      "value": "usageMilestone"
    },
    {
      "type": 0,
      "value": "% of their organization’s "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " allowance."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.milestone-info-message-pooled-meter.ubp5": [
    {
      "type": 0,
      "value": "Your customer has used "
    },
    {
      "type": 1,
      "value": "usageMilestone"
    },
    {
      "type": 0,
      "value": "% of their "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " allowance."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.milestone-info-message-vist-ppc-pooled-meter": [
    {
      "type": 0,
      "value": "Visit PPC to get more details on your customer’s "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " usage."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.milestone-what-next.ubp5": [
    {
      "type": 0,
      "value": "If your customer reaches 100% of their allowance, extra usage charges will be incurred if extra usage is enabled. Otherwise, some features will be restricted or unavailable until their usage resets."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.what-you-need": [
    {
      "type": 0,
      "value": "What you need to know:"
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.whats-next.ubp5": [
    {
      "type": 0,
      "value": "What’s next?"
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.body.breached.need-to-know-list-users-can-use-extra": [
    {
      "type": 0,
      "value": "Unless an organization admin has adjusted the extra usage limit or disabled extra usage, users will be able to use up to 2,000 extra Rovo Dev credits for an extra charge on top of the 2,000 credits included in the subscription."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.body.milestone.need-to-know-list-users-can-use-extra": [
    {
      "type": 0,
      "value": "Once users exceed their allowance of Rovo Dev credits, extra usage will be charged at USD 0.01 per extra Rovo Dev credit — any extra charges will be added to the next invoice."
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.breached-caption": [
    {
      "type": 0,
      "value": "Users in your customer's site have used up their "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " credits"
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.breached-caption-pooled-meter": [
    {
      "type": 1,
      "value": "usageMilestone"
    },
    {
      "type": 0,
      "value": "% of your customer’s "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " allowance has been used"
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.breached-caption-pooled-meter.ubp5": [
    {
      "type": 1,
      "value": "usageMilestone"
    },
    {
      "type": 0,
      "value": "% of your customer’s "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " allowance has been used"
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.milestone-caption": [
    {
      "type": 0,
      "value": "Users in your customer's site are using up their "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " credits"
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.milestone-caption-pooled-meter.ubp5": [
    {
      "type": 1,
      "value": "usageMilestone"
    },
    {
      "type": 0,
      "value": "% of your customer’s "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " allowance has been used"
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.subject.breached.pooled-meter": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " allowance used"
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.subject.breached.with-company-name": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": ": Users have used up their "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " credits"
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.subject.milestone.pooled-meter": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " allowance is running low "
    }
  ],
  "commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.subject.milestone.with-company-name": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": ": Users are using up their "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " credits"
    }
  ],
  "commerce.commerce-ship-to-party-archival-ccp.body.initimation": [
    {
      "type": 0,
      "value": "Please note that this sold-to address is no longer available for billing."
    }
  ],
  "commerce.commerce-ship-to-party-archival-ccp.body.partner.p3": [
    {
      "type": 0,
      "value": "To view the changes, head to "
    },
    {
      "type": 1,
      "value": "ppcHomePageLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-ship-to-party-archival-ccp.email.body.disclaimer": [
    {
      "type": 0,
      "value": "We've deactivated the below sold-to address:"
    }
  ],
  "commerce.commerce-ship-to-party-archival-ccp.message-template.email.subject": [
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": " Sold to address deactivated"
    }
  ],
  "commerce.commerce-soft-limit-breach-ccp.email.automatic-upgrade": [
    {
      "type": 0,
      "value": "Automatic upgrade"
    }
  ],
  "commerce.commerce-soft-limit-breach-ccp.email.manage-users": [
    {
      "type": 0,
      "value": "Manage "
    },
    {
      "type": 1,
      "value": "product"
    }
  ],
  "commerce.commerce-soft-limit-breach-ccp.email.no-upgrade": [
    {
      "type": 0,
      "value": "Don't want to upgrade? "
    }
  ],
  "commerce.commerce-soft-limit-breach-ccp.email.no-upgrade-text": [
    {
      "type": 0,
      "value": "We recommend removing "
    },
    {
      "type": 1,
      "value": "exceededLimit"
    },
    {
      "type": 0,
      "value": " users before your upgrade date. You can do this by selecting Manage users in your "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " subscription"
    }
  ],
  "commerce.commerce-soft-limit-breach-ccp.email.note1": [
    {
      "type": 0,
      "value": "If no changes are made, you'll be upgraded and we'll send you an invoice of prorated costs for the remainder of your billing period."
    }
  ],
  "commerce.commerce-soft-limit-breach-ccp.email.note2": [
    {
      "type": 0,
      "value": "You don't need to take any action. We'll automatically upgrade your account and the new charges will be applied."
    }
  ],
  "commerce.commerce-soft-limit-breach-ccp.email.product-limit-exceeded": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " user limit of "
    },
    {
      "type": 1,
      "value": "lowerLimit"
    },
    {
      "type": 0,
      "value": "-"
    },
    {
      "type": 1,
      "value": "upperLimit"
    },
    {
      "type": 0,
      "value": " has exceeded by "
    },
    {
      "type": 1,
      "value": "exceededLimit"
    },
    {
      "type": 0,
      "value": " users."
    }
  ],
  "commerce.commerce-soft-limit-breach-ccp.message-template.email.final-reminder": [
    {
      "type": 0,
      "value": "In a few days you’ll be automatically upgraded to a new limit of "
    },
    {
      "type": 1,
      "value": "lowerLimit"
    },
    {
      "type": 0,
      "value": "-"
    },
    {
      "type": 1,
      "value": "upperLimit"
    },
    {
      "type": 0,
      "value": " to accommodate your growing user count."
    }
  ],
  "commerce.commerce-soft-limit-breach-ccp.message-template.email.final-reminder-caption": [
    {
      "type": 0,
      "value": "You’re about to be upgraded"
    }
  ],
  "commerce.commerce-soft-limit-breach-ccp.message-template.email.first-reminder": [
    {
      "type": 0,
      "value": "Soon you'll be automatically upgraded to a new limit of "
    },
    {
      "type": 1,
      "value": "lowerLimit"
    },
    {
      "type": 0,
      "value": "-"
    },
    {
      "type": 1,
      "value": "upperLimit"
    },
    {
      "type": 0,
      "value": " to accommodate your growing user count."
    }
  ],
  "commerce.commerce-soft-limit-breach-ccp.message-template.email.first-reminder-caption": [
    {
      "type": 0,
      "value": "Your team is growing"
    }
  ],
  "commerce.commerce-soft-limit-breach-ccp.message-template.email.second-reminder": [
    {
      "type": 0,
      "value": "In the next week, you’ll be automatically upgraded to a new limit of "
    },
    {
      "type": 1,
      "value": "lowerLimit"
    },
    {
      "type": 0,
      "value": "-"
    },
    {
      "type": 1,
      "value": "upperLimit"
    },
    {
      "type": 0,
      "value": " to accommodate your growing user count. "
    }
  ],
  "commerce.commerce-soft-limit-breach-ccp.message-template.email.second-reminder-caption": [
    {
      "type": 0,
      "value": "You’ll be upgraded soon"
    }
  ],
  "commerce.commerce-soft-limit-breach-ccp.message-template.email.subject.final-reminder": [
    {
      "type": 0,
      "value": "Last chance: manage users before automatic upgrade"
    }
  ],
  "commerce.commerce-soft-limit-breach-ccp.message-template.email.subject.reminder": [
    {
      "type": 0,
      "value": "Action required before automatic upgrade"
    }
  ],
  "commerce.commerce-subscription-activation-ccp.message-template.ecc.start-set-up": [
    {
      "type": 0,
      "value": "Start set up"
    }
  ],
  "commerce.commerce-subscription-activation-ccp.message-template.email.ecc.admin-permission-url": [
    {
      "type": 0,
      "value": "how to give users admin permissions"
    }
  ],
  "commerce.commerce-subscription-activation-ccp.message-template.email.ecc.body.atlassian-billing-partner": [
    {
      "type": 0,
      "value": "Atlassian reseller: "
    }
  ],
  "commerce.commerce-subscription-activation-ccp.message-template.email.ecc.body.manage-subscription": [
    {
      "type": 0,
      "value": "You can view or cancel your subscriptions at any time by going to "
    },
    {
      "type": 1,
      "value": "partnerManagedSubscriptionUrl"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-activation-ccp.message-template.email.ecc.body.setup-site": [
    {
      "type": 0,
      "value": "Setting up the site means you’ll automatically get admin permissions as an org and site admin. You can also give admin roles to others - see "
    },
    {
      "type": 1,
      "value": "giveUserAdminPermissionUrl"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-activation-ccp.message-template.email.ecc.body.site-heading": [
    {
      "type": 0,
      "value": "Site: "
    }
  ],
  "commerce.commerce-subscription-activation-ccp.message-template.email.ecc.caption.with-site": [
    {
      "type": 0,
      "value": "Your products are ready for use "
    }
  ],
  "commerce.commerce-subscription-activation-ccp.message-template.email.ecc.caption.without-site": [
    {
      "type": 0,
      "value": "Set up your subscription and get started"
    }
  ],
  "commerce.commerce-subscription-activation-ccp.message-template.email.ecc.partner-managed-subscription.url": [
    {
      "type": 0,
      "value": "your partner-managed subscriptions"
    }
  ],
  "commerce.commerce-subscription-activation-ccp.message-template.email.ecc.reseller.body.atlassian-billing-partner": [
    {
      "type": 0,
      "value": "Atlassian billing partner: "
    }
  ],
  "commerce.commerce-subscription-activation-ccp.message-template.email.ecc.reseller.subscriptions-active": [
    {
      "type": 0,
      "value": "Great news! Your Atlassian partner had placed an order for Atlassian products on "
    },
    {
      "type": 1,
      "value": "orderDate"
    },
    {
      "type": 0,
      "value": ". The subscriptions are now active and ready to use."
    },
    {
      "type": 1,
      "value": "contentForSite"
    }
  ],
  "commerce.commerce-subscription-activation-ccp.message-template.email.ecc.set-up-subscriptions": [
    {
      "type": 0,
      "value": "Get started by setting up your "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 0,
              "value": "subscription"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "subscriptions"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "entitlementsLength"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-activation-ccp.message-template.email.ecc.site-info": [
    {
      "type": 0,
      "value": "They'll be added to your site shortly."
    }
  ],
  "commerce.commerce-subscription-activation-ccp.message-template.email.ecc.subscriptions-active": [
    {
      "type": 0,
      "value": "Great news! Your Atlassian reseller had placed an order for Atlassian products on "
    },
    {
      "type": 1,
      "value": "orderDate"
    },
    {
      "type": 0,
      "value": ". The subscriptions are now active and ready to use."
    },
    {
      "type": 1,
      "value": "contentForSite"
    }
  ],
  "commerce.commerce-subscription-activation-ccp.message-template.email.partner.body.manage-subscription": [
    {
      "type": 0,
      "value": "You can manage these subscriptions from our "
    },
    {
      "type": 1,
      "value": "ppcHomePage"
    }
  ],
  "commerce.commerce-subscription-activation-ccp.message-template.email.partner.ppc-url": [
    {
      "type": 0,
      "value": "Partner Purchasing Center"
    }
  ],
  "commerce.commerce-subscription-activation-ccp.message-template.email.partner.subscriptions-active": [
    {
      "type": 0,
      "value": "Great news — the subscriptions that you ordered for your customer on "
    },
    {
      "type": 1,
      "value": "orderDate"
    },
    {
      "type": 0,
      "value": " are now active and ready to use. We’ve also informed your customer that they can get started."
    }
  ],
  "commerce.commerce-subscription-activation-ccp.message-template.email.remaining-subs": [
    {
      "type": 0,
      "value": "+ "
    },
    {
      "type": 1,
      "value": "remainingCount"
    },
    {
      "type": 0,
      "value": " more subscriptions."
    }
  ],
  "commerce.commerce-subscription-activation-ccp.message-template.email.reseller.body.manage-subscription": [
    {
      "type": 0,
      "value": "You can view or cancel your subscriptions at any time by going to your "
    },
    {
      "type": 1,
      "value": "managedSubscriptionUrl"
    },
    {
      "type": 0,
      "value": " page and following the steps."
    }
  ],
  "commerce.commerce-subscription-activation-ccp.message-template.email.reseller.partner-managed-subscription.url": [
    {
      "type": 0,
      "value": "Subscription overview"
    }
  ],
  "commerce.commerce-subscription-activation-ccp.message-template.email.set-up-subscriptions": [
    {
      "type": 0,
      "value": "Get started by setting up your "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 0,
              "value": "subscription"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "subscriptions"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "entitlementsLength"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-activation-ccp.message-template.email.subject.ecc": [
    {
      "type": 0,
      "value": "It’s time to set up your subscription"
    }
  ],
  "commerce.commerce-subscription-activation-ccp.message-template.email.subject.partner": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": ": it’s time to set up subscriptions"
    }
  ],
  "commerce.commerce-subscription-activation-ccp.message-template.email.subject.singular": [
    {
      "type": 0,
      "value": "It's time to set up your "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 0,
              "value": "subscription"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "subscriptions"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "entitlementsLength"
    }
  ],
  "commerce.commerce-subscription-activation-ccp.message-template.email.subscriptions-active": [
    {
      "type": 0,
      "value": "Great news — the "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 0,
              "value": "subscription that you ordered on "
            },
            {
              "type": 1,
              "value": "orderDate"
            },
            {
              "type": 0,
              "value": " is"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "subscriptions that you ordered on "
            },
            {
              "type": 1,
              "value": "orderDate"
            },
            {
              "type": 0,
              "value": " are"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "entitlementsLength"
    },
    {
      "type": 0,
      "value": " now active."
    }
  ],
  "commerce.commerce-subscription-activation-ccp.message-template.email.time-to-get-set-up": [
    {
      "type": 0,
      "value": "It's time to get set up"
    }
  ],
  "commerce.commerce-subscription-add-on-usage-reminder-ccp-g.body.dc.p3": [
    {
      "type": 0,
      "value": "You can manage the subscription from your Subscription details page."
    }
  ],
  "commerce.commerce-subscription-add-on-usage-reminder-ccp-g.body.partner.p3": [
    {
      "type": 0,
      "value": "You can manage the subscription from our "
    },
    {
      "type": 1,
      "value": "ppcSubscriptionLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-add-on-usage-reminder-ccp.body.dc.p3": [
    {
      "type": 0,
      "value": "You can manage the subscription from your Subscription details page."
    }
  ],
  "commerce.commerce-subscription-add-on-usage-reminder-ccp.body.partner.p3": [
    {
      "type": 0,
      "value": "You can manage the subscription from our "
    },
    {
      "type": 1,
      "value": "ppcSubscriptionLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-add-on-usage-reminder-ccp.message-template.email.dc.add-on.cta": [
    {
      "type": 0,
      "value": "Increase usage limit"
    }
  ],
  "commerce.commerce-subscription-add-on-usage-reminder-ccp.message-template.email.dc.cta": [
    {
      "type": 0,
      "value": "Get add-on"
    }
  ],
  "commerce.commerce-subscription-add-on-usage-reminder-ccp.message-template.email.partner.add-on.cta": [
    {
      "type": 0,
      "value": "Get quote for higher limit"
    }
  ],
  "commerce.commerce-subscription-add-on-usage-reminder-ccp.message-template.email.partner.cta": [
    {
      "type": 0,
      "value": "Get add-on"
    }
  ],
  "commerce.commerce-subscription-auto-downgrade-ccp.email.partner.subject.with.company.name": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": ":"
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " now on Free plan"
    }
  ],
  "commerce.commerce-subscription-auto-downgrade-ccp.limted.features.info": [
    {
      "type": 0,
      "value": "This way, your customer can still use "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": ", but with limited features."
    }
  ],
  "commerce.commerce-subscription-auto-downgrade-ccp.message-template.dc.email.subject": [
    {
      "type": 0,
      "value": "You’re now on "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan"
    }
  ],
  "commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.body.summary.partner-uncollectible": [
    {
      "type": 0,
      "value": "We’ve moved the below subscription to the Free plan. This is because we weren’t able to process your payment."
    }
  ],
  "commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.body.summary.partner-uninvoiceable": [
    {
      "type": 0,
      "value": "We’ve moved the below subscription to the Free plan. This is because we don’t have your customer’s complete billing information. It could be because the information provided to us is incorrect or incomplete."
    }
  ],
  "commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.body.request-deletion-of-personal-data-link": [
    {
      "type": 0,
      "value": "request for deletion of your personal data"
    }
  ],
  "commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.caption-v3": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription has moved to the "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan"
    }
  ],
  "commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.summary": [
    {
      "type": 0,
      "value": "As requested, your "
    },
    {
      "type": 1,
      "value": "previousOfferingName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription has moved to the "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan."
    }
  ],
  "commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.body.go-back-original-plan": [
    {
      "type": 0,
      "value": "Want to go back on the original plan?"
    }
  ],
  "commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.body.manage-subscription": [
    {
      "type": 0,
      "value": "Manage subscription"
    }
  ],
  "commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.body.review-and-manage-subscription": [
    {
      "type": 0,
      "value": "Review the customer’s billing details from our Partner Purchasing Center and change the subscription."
    }
  ],
  "commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.body.subscription-downgraded-message": [
    {
      "type": 0,
      "value": "We couldn't collect payment for an invoice generated for this subscription. As a result, we've moved the subscription to the Free plan. This way, "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " can still be used, but with limited features."
    }
  ],
  "commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.body.you-may-request-deletion-of-personal-data": [
    {
      "type": 0,
      "value": "Your customer can also place a "
    },
    {
      "type": 1,
      "value": "requestForDeletionOfPersonalDataLink"
    }
  ],
  "commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.caption": [
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " moved to Free plan due to payment issue"
    }
  ],
  "commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.add-payment": [
    {
      "type": 0,
      "value": "Add payment"
    }
  ],
  "commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.body": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " has been downgraded to the Free plan. Restore your "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan to keep access to unlimited users, AI credits, and more storage for your team."
    }
  ],
  "commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.current-plan-label": [
    {
      "type": 0,
      "value": "Current plan"
    }
  ],
  "commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.current-plan-name": [
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " Free"
    }
  ],
  "commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.greeting": [
    {
      "type": 0,
      "value": "Hello "
    },
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.heading": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " trial has ended"
    }
  ],
  "commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.subject": [
    {
      "type": 0,
      "value": "You’re now on "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " Free"
    }
  ],
  "commerce.commerce-subscription-auto-downgrade-ccp.message-template.partner.email.body.personal-data-retention-summary.link": [
    {
      "type": 0,
      "value": "request for deletion of their personal data."
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-ccp.learn-how-to-do-this": [
    {
      "type": 0,
      "value": "Learn how to do this"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-ccp.legal-update-twcg-1465.downgrade": [
    {
      "type": 0,
      "value": "downgrade"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-ccp.legal-update-twcg-1465.reduce-your-user-count": [
    {
      "type": 0,
      "value": "reduce your user count"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-admin-partner.body.switch-to-back-free-plan": [
    {
      "type": 0,
      "value": "You can switch back to a Free plan at any time from our "
    },
    {
      "type": 1,
      "value": "partnerPurchasingCenterLink"
    },
    {
      "type": 0,
      "value": ". Your customer’s site or organization admin will first need to reduce the "
    },
    {
      "type": 1,
      "value": "userType"
    },
    {
      "type": 0,
      "value": " count for the product to 10 or fewer."
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-admin-partner.caption": [
    {
      "type": 0,
      "value": "Your customer can now enjoy the benefits of "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "planName"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-admin-partner.subject": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": ": "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "planName"
    },
    {
      "type": 0,
      "value": " trial"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-user-partner.body.more-information": [
    {
      "type": 0,
      "value": "For help or more information, contact your Atlassian billing partner."
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-user-partner.body.partner-managed-subscriptions": [
    {
      "type": 0,
      "value": "You can also cancel your subscription at any time by going to your "
    },
    {
      "type": 1,
      "value": "partnerManagedSubscriptions"
    },
    {
      "type": 0,
      "value": " and following the steps. [Link to ECC section on admin hub]"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-user-partner.body.stay-on-plan": [
    {
      "type": 0,
      "value": "If you’d like to stay on the "
    },
    {
      "type": 1,
      "value": "planName"
    },
    {
      "type": 0,
      "value": " plan, with instructions."
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-user-partner.caption": [
    {
      "type": 0,
      "value": "Enjoy the benefits of "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "planName"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-user-partner.subject": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": ": "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "planName"
    },
    {
      "type": 0,
      "value": " trial"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.body.subscription-trial": [
    {
      "type": 0,
      "value": "We’ve upgraded you to a free 14-day trial of "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "planName"
    },
    {
      "type": 0,
      "value": ". This is because the "
    },
    {
      "type": 1,
      "value": "exceedingUsageCount"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "userType"
    },
    {
      "type": 0,
      "value": " limit for the Free plan was exceeded."
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.body.switch-to-back-free-plan": [
    {
      "type": 0,
      "value": "You can switch back to a Free plan at any time by reducing your "
    },
    {
      "type": 1,
      "value": "userType"
    },
    {
      "type": 0,
      "value": " count. "
    },
    {
      "type": 1,
      "value": "learnHowToDoThis"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.direct-customer.body.stay-on-plan": [
    {
      "type": 0,
      "value": "If you’d like to stay on the "
    },
    {
      "type": 1,
      "value": "planName"
    },
    {
      "type": 0,
      "value": " plan, you don’t need to do anything."
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.direct-customer.body.subscription-trial": [
    {
      "type": 0,
      "value": "We’ve upgraded the following subscription to a free 14-day trial of "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": ". This is because you went over the "
    },
    {
      "type": 1,
      "value": "exceedingUsageCount"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "userType"
    },
    {
      "type": 0,
      "value": " limit for the Free plan."
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.direct-customer.caption": [
    {
      "type": 0,
      "value": "Enjoy the benefits of "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.direct-customer.subject": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " trial"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.body.switch-to-back-free-plan": [
    {
      "type": 0,
      "value": "To stay on the Standard plan, you don't need to do anything. We'll charge your saved payment method when your trial ends. To return to the Free plan, first "
    },
    {
      "type": 1,
      "value": "reduceYourUserCount"
    },
    {
      "type": 0,
      "value": " to meet the plan limit, then "
    },
    {
      "type": 1,
      "value": "downgrade"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.contextual-info.next-bill-date-label": [
    {
      "type": 0,
      "value": "Next bill date"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.contextual-info.next-bill-estimate-label": [
    {
      "type": 0,
      "value": "Next bill estimate"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.contextual-info.next-bill-estimate-value": [
    {
      "type": 1,
      "value": "amount"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "billingCycle"
    },
    {
      "type": 0,
      "value": " (excluding taxes)"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.contextual-info.plan-label": [
    {
      "type": 0,
      "value": "Plan"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.contextual-info.plan-name": [
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "planName"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.direct-customer.body.explore-standard-cta": [
    {
      "type": 0,
      "value": "Explore Standard"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.direct-customer.body.subscription-trial": [
    {
      "type": 0,
      "value": "You've reached the user limit for your Free plan, so "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "we've upgraded you"
        }
      ],
      "type": 8,
      "value": "bold"
    },
    {
      "type": 0,
      "value": " to our Standard plan. It's free for 14 days."
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "You can now add unlimited users to your projects and help your team ship faster."
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.direct-customer.body.subscription-trial-with-end-date": [
    {
      "type": 0,
      "value": "You've reached the user limit for your Free plan, so "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "we've upgraded you"
        }
      ],
      "type": 8,
      "value": "bold"
    },
    {
      "type": 0,
      "value": " to our Standard plan. It's free for 14 days."
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "You can now add unlimited users to your projects and help your team ship faster. Your trial ends on "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "trialEndDate"
        }
      ],
      "type": 8,
      "value": "bold"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.direct-customer.caption": [
    {
      "type": 0,
      "value": "Your Standard trial has started"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.direct-customer.subject": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " trial has started"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.direct-customer.subscription-details-heading": [
    {
      "type": 0,
      "value": "Subscription details"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.direct-customer.what-happens-next-heading": [
    {
      "type": 0,
      "value": "What happens next?"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.header.atlassian-logo-alt": [
    {
      "type": 0,
      "value": "Atlassian"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.header.confluence-logo-alt": [
    {
      "type": 0,
      "value": "Confluence"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.header.jira-logo-alt": [
    {
      "type": 0,
      "value": "Jira"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.header.jpd-logo-alt": [
    {
      "type": 0,
      "value": "Jira Product Discovery"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.unlocks-additional-features": [
    {
      "type": 0,
      "value": "Your new "
    },
    {
      "type": 1,
      "value": "planName"
    },
    {
      "type": 0,
      "value": " plan unlocks additional features to help your team achieve more together:"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.want-to-stay-on-standard": [
    {
      "type": 0,
      "value": "Don't want to stay on "
    },
    {
      "type": 1,
      "value": "planName"
    },
    {
      "type": 0,
      "value": "?"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-ccp.partner-managed-subscriptions-link": [
    {
      "type": 0,
      "value": "partner-managed subscriptions"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-ccp.partner-purchasing-link'": [
    {
      "type": 0,
      "value": "Partner Purchasing Center"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.email.icon-warning.alt-text": [
    {
      "type": 0,
      "value": "Icon - Warning"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.learn-how-to-do-this": [
    {
      "type": 0,
      "value": "Learn how to do this"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-admin-partner.body.switch-to-back-free-plan": [
    {
      "type": 0,
      "value": "You can switch back to a Free plan at any time from our "
    },
    {
      "type": 1,
      "value": "partnerPurchasingCenterLink"
    },
    {
      "type": 0,
      "value": ". Your customer’s site or organization admin will first need to reduce the "
    },
    {
      "type": 1,
      "value": "userType"
    },
    {
      "type": 0,
      "value": " count for the product to 10 or fewer."
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-admin-partner.caption": [
    {
      "type": 0,
      "value": "Add payment details to enjoy the benefits of "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "planName"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-admin-partner.subject": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": ": Important things to know about "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "planName"
    },
    {
      "type": 0,
      "value": " trial"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-user-partner.body.more-information": [
    {
      "type": 0,
      "value": "For help or more information, contact your Atlassian billing partner."
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-user-partner.body.partner-managed-subscriptions": [
    {
      "type": 0,
      "value": "You can also cancel your subscription at any time by going to your "
    },
    {
      "type": 1,
      "value": "partnerManagedSubscriptions"
    },
    {
      "type": 0,
      "value": " and following the steps. [Link to ECC section on admin hub]"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-user-partner.body.stay-on-plan": [
    {
      "type": 0,
      "value": "If you’d like to stay on the "
    },
    {
      "type": 1,
      "value": "planName"
    },
    {
      "type": 0,
      "value": " plan, you’ll just need to make sure your Atlassian billing partner has the correct billing details. We’ve also sent them an email with instructions."
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-user-partner.caption": [
    {
      "type": 0,
      "value": "Enjoy the benefits of "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "planName"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-user-partner.subject": [
    {
      "type": 1,
      "value": "partnerName"
    },
    {
      "type": 0,
      "value": ": Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription has been upgraded to the "
    },
    {
      "type": 1,
      "value": "planName"
    },
    {
      "type": 0,
      "value": " plan"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.add-payment-details": [
    {
      "type": 0,
      "value": "Add payment details before the trial ends on "
    },
    {
      "type": 1,
      "value": "trialEndDate"
    },
    {
      "type": 0,
      "value": ", otherwise the subscription will be deactivated."
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.subscription-trial": [
    {
      "type": 0,
      "value": "We’ve upgraded you to a free 14-day trial of "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "planName"
    },
    {
      "type": 0,
      "value": ". This is because the "
    },
    {
      "type": 1,
      "value": "exceedingUsageCount"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "chargeElement"
    },
    {
      "type": 0,
      "value": " limit for the Free plan was exceeded."
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.switch-to-back-free-plan": [
    {
      "type": 0,
      "value": "You can switch back to a Free plan at any time by reducing your "
    },
    {
      "type": 1,
      "value": "userType"
    },
    {
      "type": 0,
      "value": " count. "
    },
    {
      "type": 1,
      "value": "learnHowToDoThis"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.take-action-or-lose-access": [
    {
      "type": 0,
      "value": "You’ll lose access to "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " if you don’t take action "
    },
    {
      "type": 1,
      "value": "takeActionBy"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.take-action-or-lose-access.take-action-by-trial-end-date-available": [
    {
      "type": 0,
      "value": "by "
    },
    {
      "type": 1,
      "value": "trialEndMonth"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "offset": 0,
      "options": {
        "few": {
          "value": [
            {
              "type": 0,
              "value": "$rd"
            }
          ]
        },
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": "st"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": "th"
            }
          ]
        },
        "two": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": "nd"
            }
          ]
        }
      },
      "pluralType": "ordinal",
      "type": 6,
      "value": "trialEndDate"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.take-action-or-lose-access.take-action-by-trial-end-date-not-available": [
    {
      "type": 0,
      "value": "soon"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.what-you-need-to-do": [
    {
      "type": 0,
      "value": "What you need to do"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.you-can-switch-back-to-free-plan-billing-admin": [
    {
      "type": 0,
      "value": "You can switch back to a Free plan at any time by "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "reducing your user count"
        }
      ],
      "type": 8,
      "value": "Link"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.you-can-switch-back-to-free-plan-mpucup-user": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " admin can switch back to a Free plan at any time by reducing your user count."
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.body-intro": [
    {
      "type": 0,
      "value": "Your team now has a "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "free 14-day trial"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " of "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " Standard because you reached the 10-user limit on the Free plan."
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.features.confluence.invite-team": [
    {
      "children": [
        {
          "type": 0,
          "value": "Invite your team."
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Add as many people as you need to your spaces."
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.features.confluence.page-insights": [
    {
      "children": [
        {
          "type": 0,
          "value": "Measure impact."
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Track views and engagement with page insights."
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.features.confluence.rovo-ai": [
    {
      "children": [
        {
          "type": 0,
          "value": "Draft faster."
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Generate ideas and first drafts with Rovo AI."
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.features.jira.automation": [
    {
      "children": [
        {
          "type": 0,
          "value": "Automate tedious tasks."
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Set rules for repetitive updates."
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.features.jira.invite-team": [
    {
      "children": [
        {
          "type": 0,
          "value": "Invite your team."
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Add as many people as you need to your spaces."
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.features.jira.rovo-agents": [
    {
      "children": [
        {
          "type": 0,
          "value": "Put agents to work."
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Call on Rovo agents for specialized tasks."
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.heading": [
    {
      "type": 0,
      "value": "We've upgraded you to "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " Standard"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.payment-deadline": [
    {
      "type": 0,
      "value": "Add payment details before your trial ends on "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "trialEndDate"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " to keep all your users and features. If you don't add payment details or reduce your user count to 10 or fewer by "
    },
    {
      "type": 1,
      "value": "trialEndDate"
    },
    {
      "type": 0,
      "value": ", you will lose access to "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " and your data will be permanently deleted."
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.what-you-need-to-do": [
    {
      "type": 0,
      "value": "What you need to do"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.direct-customer.body.stay-on-plan": [
    {
      "type": 0,
      "value": "If you’ve already added your payment details, you don’t need to do anything."
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.direct-customer.body.subscription-trial": [
    {
      "type": 0,
      "value": "We’ve upgraded the following subscription to a free 14-day trial of "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": ". This is because you went over the "
    },
    {
      "type": 1,
      "value": "exceedingUsageCount"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "userType"
    },
    {
      "type": 0,
      "value": " limit for the Free plan."
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.direct-customer.caption": [
    {
      "type": 0,
      "value": "Add payment details to enjoy the benefits of "
    },
    {
      "type": 1,
      "value": "productName"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.direct-customer.subject": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " trial"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.direct-customer.subject3": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " plan has changed to Standard"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.billing-admin-partner.add-payment-or-remove-users": [
    {
      "type": 0,
      "value": "Add payment to keep unlimited users and stay on Standard, or have your customer’s admin remove users so you can switch back to Free in the "
    },
    {
      "type": 1,
      "value": "partnerPurchasingCenterLink"
    },
    {
      "type": 0,
      "value": ". Take action "
    },
    {
      "type": 1,
      "value": "takeActionBy"
    },
    {
      "type": 0,
      "value": " to avoid site deactivation."
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.billing-user-partner.add-payment-or-remove-users": [
    {
      "type": 0,
      "value": "To keep unlimited and users stay on Standard, ensure your Atlassian billing partner updates your billing details. We’ve also sent them instructions. To switch back to Free, "
    },
    {
      "type": 1,
      "value": "removeUsersLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.billing-user-partner.take-action": [
    {
      "type": 0,
      "value": "Take action "
    },
    {
      "type": 1,
      "value": "takeActionBy"
    },
    {
      "type": 0,
      "value": " to avoid site deactivation. For help, contact your Atlassian billing partner."
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.direct-customer.add-payment-or-remove-users": [
    {
      "type": 0,
      "value": "Add payment to keep unlimited users and stay on Standard, or "
    },
    {
      "type": 1,
      "value": "removeUsersLink"
    },
    {
      "type": 0,
      "value": " to switch back to the Free plan. Take action "
    },
    {
      "type": 1,
      "value": "takeActionBy"
    },
    {
      "type": 0,
      "value": " to avoid site deactivation."
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.over-free-limit-moved-to-standard": [
    {
      "type": 0,
      "value": "You're over the Free user limit, so we moved you to Standard, which includes unlimited users."
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.partner-purchasing-center": [
    {
      "type": 0,
      "value": "Partner Purchasing Center"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.remove-users": [
    {
      "type": 0,
      "value": "remove users"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.take-action-by-trial-end-date-available": [
    {
      "type": 0,
      "value": "by "
    },
    {
      "type": 1,
      "value": "trialEndMonth"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "offset": 0,
      "options": {
        "few": {
          "value": [
            {
              "type": 0,
              "value": "$rd"
            }
          ]
        },
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": "st"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": "th"
            }
          ]
        },
        "two": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": "nd"
            }
          ]
        }
      },
      "pluralType": "ordinal",
      "type": 6,
      "value": "trialEndDate"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.take-action-by-trial-end-date-not-available": [
    {
      "type": 0,
      "value": "soon"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.unlocks-additional-features": [
    {
      "type": 0,
      "value": "Your new "
    },
    {
      "type": 1,
      "value": "planName"
    },
    {
      "type": 0,
      "value": " plan unlocks additional features to help your team achieve more together:"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.want-to-stay-on-standard": [
    {
      "type": 0,
      "value": "Don't want to stay on "
    },
    {
      "type": 1,
      "value": "planName"
    },
    {
      "type": 0,
      "value": "?"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.partner-managed-subscriptions-link": [
    {
      "type": 0,
      "value": "partner-managed subscriptions"
    }
  ],
  "commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.partner-purchasing-link'": [
    {
      "type": 0,
      "value": "Partner Purchasing Center"
    }
  ],
  "commerce.commerce-subscription-bill-date-change-ccp.message-template-template.email.body.caption": [
    {
      "type": 0,
      "value": "Your bill date will soon be changed"
    }
  ],
  "commerce.commerce-subscription-bill-date-change-ccp.message-template-template.email.body.closing-line": [
    {
      "type": 0,
      "value": "Your new bill date will be in effect from the next billing cycle. To transition you to the new\n\t\t\t\t\t  bill date, pro-rated adjustments will be applied to your next invoice."
    }
  ],
  "commerce.commerce-subscription-bill-date-change-ccp.message-template-template.email.body.first-line": [
    {
      "type": 0,
      "value": "We've processed your request to change the bill date for your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": "\n\t\t\t\t\t\t("
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": ") subscription to "
    },
    {
      "type": 1,
      "value": "requestedNextBillingDate"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-bill-date-change-ccp.message-template-template.email.body.second-line": [
    {
      "type": 0,
      "value": "If you have any other product and subscriptions on the same site that belong to the same product family,\n            they need to be billed together. That means we’ve changed the bill date for those subscriptions too."
    }
  ],
  "commerce.commerce-subscription-bill-date-change-ccp.message-template.email.subject": [
    {
      "type": 0,
      "value": "Your bill date will soon be changed"
    }
  ],
  "commerce.commerce-subscription-cancellation-ecc.email.body.billing-partner": [
    {
      "type": 0,
      "value": "Atlassian billing partner"
    }
  ],
  "commerce.commerce-subscription-cancellation-ecc.email.body.caption": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offering"
    },
    {
      "type": 0,
      "value": " subscription is canceled"
    }
  ],
  "commerce.commerce-subscription-cancellation-ecc.email.body.contact-atlassian-support": [
    {
      "type": 0,
      "value": "contact Atlassian support"
    }
  ],
  "commerce.commerce-subscription-cancellation-ecc.email.body.data-will-be-deleted": [
    {
      "type": 0,
      "value": "Data will be deleted within 60 days from the date of cancellation. If you’d like to request deletion of the data earlier, "
    }
  ],
  "commerce.commerce-subscription-cancellation-ecc.email.body.reactivate": [
    {
      "type": 0,
      "value": "Your Atlassian billing partner can ask us to reactivate the subscription if needed. If you weren’t expecting this email, you can contact us."
    }
  ],
  "commerce.commerce-subscription-cancellation-ecc.email.body.this-is-to-let-you-know": [
    {
      "type": 0,
      "value": "This is to let you know that we’ve canceled the following subscription:"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp-direct.message-template.email.subject": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productInfo"
    },
    {
      "type": 0,
      "value": " subscription has been canceled"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp-g-direct.message-template.email.subject": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productInfo"
    },
    {
      "type": 0,
      "value": " subscription has been canceled"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.auto-cancellation-info.uninvoiceable": [
    {
      "type": 0,
      "value": "If you want to keep your subscription, you can update your billing details and then reactivate."
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.cta-direct-customer.billing-user": [
    {
      "type": 0,
      "value": "If you want to keep your subscription, you can ask a billing admin to reactivate it. "
    },
    {
      "type": 1,
      "value": "reactivateSubscriptionLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.cta-direct-customer.billing-user.link": [
    {
      "type": 0,
      "value": "Learn more about reactivation"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.cta-direct-customer.support.link": [
    {
      "type": 0,
      "value": "see how to reactivate it"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.cta-direct-customer.support.link.twc": [
    {
      "type": 0,
      "value": "reactivate your subscription"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.ecc.partner-details": [
    {
      "type": 0,
      "value": "Your partner details are:"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.how-to-reactivate-subscription": [
    {
      "type": 0,
      "value": "If you want to keep your subscription, you can "
    },
    {
      "type": 1,
      "value": "reactivateSubscriptionLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.how-to-reactivate-subscription.twc": [
    {
      "type": 0,
      "value": "We're sad to see you go, but if you change your mind, you can always "
    },
    {
      "type": 1,
      "value": "reactivateSubscriptionLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.partner.customer-details": [
    {
      "type": 0,
      "value": "Your customer details are:"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.partner.subscription-details": [
    {
      "type": 0,
      "value": "Your subscription details are:"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.personal-data-retention-summary.direct-customer": [
    {
      "type": 0,
      "value": "If you reactivate within 60 days (or 15 days for trials), we'll restore your product's data and preferences. You can also submit a "
    },
    {
      "type": 1,
      "value": "deletionOfPersonalDataLink"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.personal-data-retention-summary.direct-customer.link": [
    {
      "type": 0,
      "value": "request for deletion of your personal data."
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.personal-data-retention-summary.direct-customer.link.twc": [
    {
      "type": 0,
      "value": "immediate deletion of your personal data"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.personal-data-retention-summary.direct-customer.twc": [
    {
      "type": 0,
      "value": "If you reactivate your subscription within 60 days, your data and preferences will remain the same. For trials, data is stored for 15 days. You may also place a request for "
    },
    {
      "type": 1,
      "value": "deletionOfPersonalDataLink"
    },
    {
      "type": 0,
      "value": ". Learn about the "
    },
    {
      "type": 1,
      "value": "privacyPolicyLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.summary.dc-uncollectible": [
    {
      "type": 0,
      "value": "We’ve canceled the following subscription. This is because we weren’t able to process your payment."
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.summary.dc-uninvoiceable": [
    {
      "type": 0,
      "value": "We’ve canceled the following subscription. This is because we’re missing the right payment details, so we weren’t able to process your payment."
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.summary.partner": [
    {
      "type": 0,
      "value": "As requested, we've canceled the following subscription:"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.caption.direct-customer": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productInfo"
    },
    {
      "type": 0,
      "value": " subscription has been canceled"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.caption.partner-end-customer-contact": [
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " subscription has been canceled"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.direct-customer.body.cta.reactivate-subscription": [
    {
      "type": 0,
      "value": "Reactivate subscription"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.subject.partner-billing-admin-and-billing-user": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": " - "
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": ": "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " canceled"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.subject.partner-bu-and-ecc": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " subscription has been canceled"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.as-requested-we-have-cancelled-the-following-subscription": [
    {
      "type": 0,
      "value": "As requested, we've canceled the following subscription"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.as-requested-we-have-cancelled-your-customers-subscription": [
    {
      "type": 0,
      "value": "As requested, we've canceled your customer's subscription"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.if-you-reactivate-within-60-days-we-will-restore-customers-product-data": [
    {
      "type": 0,
      "value": "If you reactivate within 60 days (or 15 days for trials), we'll restore your customer's product data and preferences."
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.if-you-reactivate-within-60-days-we-will-restore-product-data": [
    {
      "type": 0,
      "value": "If you reactivate within 60 days (or 15 days for trials), we'll restore your product's data and preferences."
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.if-you-want-to-keep-your-subscription-reach-out-to-your-billing-partner-to-reactivate": [
    {
      "type": 0,
      "value": "If you want to keep your subscription, reach out to your Atlassian billing partner to reactivate the subscription."
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.if-your-customer-wants-to-keep-the-subscription-reach-out-to-us-to-reactivate": [
    {
      "type": 0,
      "value": "If your customer wants to keep the subscription, "
    },
    {
      "type": 1,
      "value": "reachOutLink"
    },
    {
      "type": 0,
      "value": " to reactivate the subscription."
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.reach-out-to-us": [
    {
      "type": 0,
      "value": "reach out to us"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.request-for-deletion-of-their-personal-data": [
    {
      "type": 0,
      "value": "request for deletion of their personal data"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.request-for-deletion-of-your-personal-data": [
    {
      "type": 0,
      "value": "request for deletion of your personal data"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.special-char-colon": [
    {
      "type": 0,
      "value": ":"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.special-char-period": [
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.this-is-because-we-do-not-have-your-customers-billing-information": [
    {
      "type": 0,
      "value": "This is because we don't have your customer's complete billing information. It could be because the information provided to us is incorrect or incomplete."
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.this-is-because-we-were-not-able-to-collect-payment-for-an-invoice": [
    {
      "type": 0,
      "value": "This is because we weren't able to collect payment for an invoice."
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.update-your-customers-billing-details-and-then-reach-out-to-us-to-reactivate": [
    {
      "type": 0,
      "value": "Update your customer's billing details and then "
    },
    {
      "type": 1,
      "value": "reachOutLink"
    },
    {
      "type": 0,
      "value": " to reactivate the subscription."
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.we-have-cancelled-your-customers-subscription": [
    {
      "type": 0,
      "value": "We've canceled your customer's subscription."
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.you-can-also-submit-a-request-for-deletion-of-your-personal-data": [
    {
      "type": 0,
      "value": "You can also submit a "
    },
    {
      "type": 1,
      "value": "requestForDeletionLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.your-customer-can-also-submit-a-request-for-deletion-of-their-personal-data": [
    {
      "type": 0,
      "value": "Your customer can also submit a "
    },
    {
      "type": 1,
      "value": "requestForDeletionLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.auto-cancellation-info.uninvoiceable": [
    {
      "type": 0,
      "value": "If you want to keep your subscription, you can update your billing details and then reactivate."
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.cta-direct-customer.billing-user": [
    {
      "type": 0,
      "value": "If you want to keep your subscription, you can ask a billing admin to reactivate it. "
    },
    {
      "type": 1,
      "value": "reactivateSubscriptionLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.cta-direct-customer.billing-user.link": [
    {
      "type": 0,
      "value": "Learn more about reactivation"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.cta-direct-customer.support.link": [
    {
      "type": 0,
      "value": "see how to reactivate it"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.cta-direct-customer.support.link.twc": [
    {
      "type": 0,
      "value": "reactivate your subscription"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.ecc.partner-details": [
    {
      "type": 0,
      "value": "Your partner details are:"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.how-to-reactivate-subscription": [
    {
      "type": 0,
      "value": "If you want to keep your subscription, you can "
    },
    {
      "type": 1,
      "value": "reactivateSubscriptionLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.how-to-reactivate-subscription.twc": [
    {
      "type": 0,
      "value": "We're sad to see you go, but if you change your mind, you can always "
    },
    {
      "type": 1,
      "value": "reactivateSubscriptionLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.partner.customer-details": [
    {
      "type": 0,
      "value": "Your customer details are:"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.partner.subscription-details": [
    {
      "type": 0,
      "value": "Your subscription details are:"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.personal-data-retention-summary.direct-customer": [
    {
      "type": 0,
      "value": "If you reactivate within 60 days (or 15 days for trials), we'll restore your app's data and preferences. You can also submit a "
    },
    {
      "type": 1,
      "value": "deletionOfPersonalDataLink"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.personal-data-retention-summary.direct-customer.link": [
    {
      "type": 0,
      "value": "request for deletion of your personal data."
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.personal-data-retention-summary.direct-customer.link.twc": [
    {
      "type": 0,
      "value": "immediate deletion of your personal data"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.personal-data-retention-summary.direct-customer.twc": [
    {
      "type": 0,
      "value": "If you reactivate your subscription within 60 days, your data and preferences will remain the same. For trials, data is stored for 15 days. You may also place a request for "
    },
    {
      "type": 1,
      "value": "deletionOfPersonalDataLink"
    },
    {
      "type": 0,
      "value": ". Learn about the "
    },
    {
      "type": 1,
      "value": "privacyPolicyLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.summary.dc-uncollectible": [
    {
      "type": 0,
      "value": "We’ve canceled the following subscription. This is because we weren’t able to process your payment."
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.summary.dc-uninvoiceable": [
    {
      "type": 0,
      "value": "We’ve canceled the following subscription. This is because we’re missing the right payment details, so we weren’t able to process your payment."
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.summary.partner": [
    {
      "type": 0,
      "value": "As requested, we've canceled the following subscription:"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.caption.direct-customer": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productInfo"
    },
    {
      "type": 0,
      "value": " subscription has been canceled"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.caption.partner-end-customer-contact": [
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " subscription has been canceled"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.direct-customer.body.cta.reactivate-subscription": [
    {
      "type": 0,
      "value": "Reactivate subscription"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.mpucup.body.cta.reactivate-button": [
    {
      "type": 0,
      "value": "Reactivate "
    },
    {
      "type": 1,
      "value": "productName"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.mpucup.body.exceeded-user-limit": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription was canceled because your team exceeded the 10-user limit on the Free plan and payment details were not added to upgrade to the Standard plan."
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.mpucup.body.restore-within-15-days": [
    {
      "type": 0,
      "value": "You can restore your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription and all data within the next 15 days. After that, your data will be permanently deleted."
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.mpucup.body.restore-within-15-days-non-admin": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " admin can restore your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription and all data within the next 15 days. After that, your data will be permanently deleted."
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.mpucup.caption": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription has ended"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.mpucup.subject": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription has ended"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.subject.partner-billing-admin-and-billing-user": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": " - "
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": ": "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " canceled"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.subject.partner-bu-and-ecc": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " subscription has been canceled"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.as-requested-we-have-cancelled-the-following-subscription": [
    {
      "type": 0,
      "value": "As requested, we've canceled the following subscription"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.as-requested-we-have-cancelled-your-customers-subscription": [
    {
      "type": 0,
      "value": "As requested, we've canceled your customer's subscription"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.if-you-reactivate-within-60-days-we-will-restore-customers-product-data": [
    {
      "type": 0,
      "value": "If you reactivate within 60 days (or 15 days for trials), we'll restore your customer's product data and preferences."
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.if-you-reactivate-within-60-days-we-will-restore-product-data": [
    {
      "type": 0,
      "value": "If you reactivate within 60 days (or 15 days for trials), we'll restore your product's data and preferences."
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.if-you-want-to-keep-your-subscription-reach-out-direct-customer-non-cloud": [
    {
      "type": 0,
      "value": "If you want to keep your subscription, "
    },
    {
      "type": 1,
      "value": "reachOutLinkForNonCloud"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.if-you-want-to-keep-your-subscription-reach-out-to-your-billing-partner-to-reactivate": [
    {
      "type": 0,
      "value": "If you want to keep your subscription, reach out to your Atlassian billing partner to reactivate the subscription."
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.if-your-customer-wants-to-keep-the-subscription-reach-out-to-us-to-reactivate": [
    {
      "type": 0,
      "value": "If your customer wants to keep the subscription, "
    },
    {
      "type": 1,
      "value": "reachOutLink"
    },
    {
      "type": 0,
      "value": " to reactivate the subscription."
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.reach-out-to-us": [
    {
      "type": 0,
      "value": "reach out to us"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.request-for-deletion-of-their-personal-data": [
    {
      "type": 0,
      "value": "request for deletion of their personal data"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.request-for-deletion-of-your-personal-data": [
    {
      "type": 0,
      "value": "request for deletion of your personal data"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.special-char-colon": [
    {
      "type": 0,
      "value": ":"
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.special-char-period": [
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.this-is-because-we-do-not-have-your-customers-billing-information": [
    {
      "type": 0,
      "value": "This is because we don't have your customer's complete billing information. It could be because the information provided to us is incorrect or incomplete."
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.this-is-because-we-were-not-able-to-collect-payment-for-an-invoice": [
    {
      "type": 0,
      "value": "This is because we weren't able to collect payment for an invoice."
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.update-your-customers-billing-details-and-then-reach-out-to-us-to-reactivate": [
    {
      "type": 0,
      "value": "Update your customer's billing details and then "
    },
    {
      "type": 1,
      "value": "reachOutLink"
    },
    {
      "type": 0,
      "value": " to reactivate the subscription."
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.we-have-cancelled-your-customers-subscription": [
    {
      "type": 0,
      "value": "We've canceled your customer's subscription."
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.you-can-also-submit-a-request-for-deletion-of-your-personal-data": [
    {
      "type": 0,
      "value": "You can also submit a "
    },
    {
      "type": 1,
      "value": "requestForDeletionLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.your-customer-can-also-submit-a-request-for-deletion-of-their-personal-data": [
    {
      "type": 0,
      "value": "Your customer can also submit a "
    },
    {
      "type": 1,
      "value": "requestForDeletionLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.email.caption": [
    {
      "type": 0,
      "value": "We're sad to see you go"
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.email.direct-customer.jsm-requirement": [
    {
      "type": 0,
      "value": "This is because our Marketplace app partner has updated the way this app is billed, which means it needs to be installed on Jira Service Management going forward. Since you don't have an active JSM subscription, the app can no longer be billed compatibly."
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.email.direct-customer.prevention-option": [
    {
      "type": 0,
      "value": "There's still time to prevent cancellation. You just need to purchase a Jira Service Management subscription before "
    },
    {
      "type": 1,
      "value": "cancellationDate"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.email.partner.caption": [
    {
      "type": 0,
      "value": "We're sad to see you go"
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.email.partner.caption.twc": [
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " scheduled for cancellation"
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.body.sub-cancel-note.twc": [
    {
      "type": 0,
      "value": "Your subscription will be canceled at the end of your current billing cycle on "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "nextBillingDate"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ". You can continue using "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " until then. We’ll send you an email once the cancellation has gone through."
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.body.billing-admin.keep-subscription": [
    {
      "type": 0,
      "value": "You can always "
    },
    {
      "type": 1,
      "value": "undoLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.body.billing-admin.manage-subscription-button": [
    {
      "type": 0,
      "value": "View subscription"
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.body.billing-admin.undo-cancellation-link": [
    {
      "type": 0,
      "value": "undo your cancellation"
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.body.billing-user.keep-subscription": [
    {
      "type": 0,
      "value": "You can always "
    },
    {
      "type": 1,
      "value": "undoLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.body.received-request": [
    {
      "type": 0,
      "value": "We've received your request to cancel your subscription:"
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.body.sub-cancel-note": [
    {
      "type": 0,
      "value": "Your subscription will be canceled at the end of your current billing cycle on "
    },
    {
      "type": 1,
      "value": "nextBillingDate"
    },
    {
      "type": 0,
      "value": ". You can continue using "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " until then. We’ll send you an email once the cancellation has gone through."
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.subject": [
    {
      "type": 0,
      "value": " Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " is scheduled for cancellation"
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.billing-partner-details.twc": [
    {
      "type": 0,
      "value": "Your billing partner details are:"
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.data-deletion-note": [
    {
      "type": 0,
      "value": "Product data will be deleted in 60 days from the date of cancellation. For trials, we retain data for 15 days. If you’d like to request deletion of personal data, "
    },
    {
      "type": 1,
      "value": "contactSupport"
    },
    {
      "type": 0,
      "value": ". Learn about "
    },
    {
      "type": 1,
      "value": "privacyPolicy"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.jira-decoupled.cancellation-notice": [
    {
      "type": 0,
      "value": "Your subscription will be canceled on "
    },
    {
      "type": 1,
      "value": "nextBillingDate"
    },
    {
      "type": 0,
      "value": ". You can continue using "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " until then. We'll send you an email once the cancellation has gone through."
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.jira-decoupled.contact-us": [
    {
      "type": 0,
      "value": "contact us"
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.jira-decoupled.data-deletion-note": [
    {
      "type": 0,
      "value": "Product data will be deleted 60 days from cancellation. For trials, we retain data for 15 days. If you'd like to request deletion of personal data, "
    },
    {
      "type": 1,
      "value": "contactUs"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.jira-decoupled.intro": [
    {
      "type": 0,
      "value": "Your app subscription is scheduled for cancellation. This is because our Marketplace app partner has updated the way this app is billed, which means it needs to be installed on Jira Service Management going forward. Since you don't have an active JSM subscription, the app can no longer be billed compatibly."
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.jira-decoupled.prevention-option": [
    {
      "type": 0,
      "value": "There's still time to prevent cancellation. You just need to contact your Atlassian billing partner to purchase a Jira Service Management subscription before "
    },
    {
      "type": 1,
      "value": "cancellationDate"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.received-request": [
    {
      "type": 0,
      "value": "We've received a request to cancel the following subscription:"
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.received-request.twc": [
    {
      "type": 0,
      "value": "We've received your request to cancel your subscription"
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.undo-cancellation": [
    {
      "type": 0,
      "value": "You can always "
    },
    {
      "type": 1,
      "value": "undoLink"
    },
    {
      "type": 0,
      "value": " from "
    },
    {
      "type": 1,
      "value": "partnerManagedSubscriptionsLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.undo-cancellation-link": [
    {
      "type": 0,
      "value": "undo your cancellation"
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.email.ecc.subject": [
    {
      "type": 1,
      "value": "billingPartnerName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " cancellation scheduled"
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.email.ecc.subject.twc": [
    {
      "type": 1,
      "value": "billingPartnerName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " is scheduled for cancellation"
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.billing-admin.keep-subscription": [
    {
      "type": 0,
      "value": "If needed, you can contact us to reverse the cancellation request. If you reactivate the subscription within 60 days of cancellation, we'll restore the relevant data and preferences. For trials, the reactivation period is 15 days."
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.billing-admin.undo-cancellation-link": [
    {
      "type": 0,
      "value": "undo your cancellation"
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.billing-user.keep-subscription": [
    {
      "type": 0,
      "value": "If needed, you can contact us to reverse the cancellation request. "
    },
    {
      "type": 1,
      "value": "undoLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.customer-details.twc": [
    {
      "type": 0,
      "value": "Your customer details are:"
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.ecc.atlassian-privacy-policy": [
    {
      "type": 0,
      "value": "Atlassian’s Privacy Policy"
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.ecc.contact-atlassian-support": [
    {
      "type": 0,
      "value": "contact Atlassian support"
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.ecc.contact-billing-partner": [
    {
      "type": 0,
      "value": "You can contact your Atlassian billing partner if you need help or want to reverse the cancellation request."
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.jira-decoupled.cancellation-notice": [
    {
      "type": 0,
      "value": "Your subscription will be canceled on "
    },
    {
      "type": 1,
      "value": "nextBillingDate"
    },
    {
      "type": 0,
      "value": ". You can continue using "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " until then. We'll send you an email once the cancellation has gone through."
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.jira-decoupled.intro": [
    {
      "type": 0,
      "value": "Your customer's app subscription is scheduled for cancellation. This is because our Marketplace app partner has updated the way this app is billed, which means it needs to be installed on Jira Service Management going forward. Since your customer doesn't have an active JSM subscription, the app can no longer be billed compatibly."
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.jira-decoupled.prevention-option": [
    {
      "type": 0,
      "value": "There's still time to prevent cancellation. You just need to purchase a Jira Service Management subscription before "
    },
    {
      "type": 1,
      "value": "cancellationDate"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.keep-subscription": [
    {
      "type": 0,
      "value": "Keeping the subscription"
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.keep-subscription.twc": [
    {
      "type": 0,
      "value": "Your customer contact can undo the cancellation at any time from "
    },
    {
      "type": 1,
      "value": "partnerManagedSubscriptionsLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.partner-managed-subscriptions-link": [
    {
      "type": 1,
      "value": "partnerManagedSubscriptionsLink"
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.partner.billing-admin.undo-cancellation-link": [
    {
      "type": 0,
      "value": "Learn how to undo a cancellation"
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.received-request": [
    {
      "type": 0,
      "value": "We’ve received a request to cancel the following subscription:"
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.received-request.twc": [
    {
      "type": 0,
      "value": "We’ve received your customer’s request to cancel their subscription."
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.sub-cancel-note": [
    {
      "type": 0,
      "value": "The subscription will be canceled at the end of the current billing cycle on "
    },
    {
      "type": 1,
      "value": "nextBillingDate"
    },
    {
      "type": 0,
      "value": ". You can continue using "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " until then. We’ll send you an email once the cancellation has gone through."
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.sub-cancel-note.twc": [
    {
      "type": 0,
      "value": "The subscription will be canceled at the end of the current billing cycle on "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "nextBillingDate"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ". Until then, the subscription can still be used. We’ll send you an email once the cancellation has gone through."
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.subscription-details.twc": [
    {
      "type": 0,
      "value": "Your subscription details are:"
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.subject.with-company-name": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": " : "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " cancellation scheduled"
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.subject.with-company-name.twc": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": " - "
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": " : "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " cancellation scheduled"
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.subject.without-company-name": [
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " cancellation scheduled"
    }
  ],
  "commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.subject.without-company-name.twc": [
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": " : "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " cancellation scheduled"
    }
  ],
  "commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.direct-customer.body.could-not-process-payment": [
    {
      "type": 0,
      "value": "This is to let you know that we’ve canceled the following subscription since we were unable to process your payment. "
    }
  ],
  "commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.direct-customer.caption": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription has been canceled."
    }
  ],
  "commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.direct-customer.subject": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription has been canceled"
    }
  ],
  "commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.mpucup.body.cta.reactivate-button": [
    {
      "type": 0,
      "value": "Reactivate "
    },
    {
      "type": 1,
      "value": "productName"
    }
  ],
  "commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.mpucup.body.exceeded-user-limit": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription was canceled because your team exceeded the 10-user limit on the Free plan and payment details were not added to upgrade to the Standard plan."
    }
  ],
  "commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.mpucup.body.restore-within-15-days": [
    {
      "type": 0,
      "value": "You can restore your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription and all data within the next 15 days. After that, your data will be permanently deleted."
    }
  ],
  "commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.mpucup.body.restore-within-15-days-admin": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " admin can restore your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription and all data within the next 15 days. After that, your data will be permanently deleted."
    }
  ],
  "commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.mpucup.caption": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription has ended"
    }
  ],
  "commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.mpucup.subject": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription has ended"
    }
  ],
  "commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.partner.body.could-not-process-payment": [
    {
      "type": 0,
      "value": "We couldn't collect payment for an invoice generated for the following subscription.As a result, the subscription has been canceled."
    }
  ],
  "commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.partner.caption": [
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription has been canceled"
    }
  ],
  "commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.partner.subject": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": " - "
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": ": Subscription canceled due to non-payment"
    }
  ],
  "commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.partner.subject.no-customer-company-name": [
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": ": Subscription canceled due to non-payment"
    }
  ],
  "commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.body.cta-direct-customer.reactivate-subscription": [
    {
      "type": 0,
      "value": "Don’t worry, all’s not lost! You can "
    },
    {
      "type": 1,
      "value": "reactivateSubscriptionLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.body.personal-data-retention-summary.direct-customer": [
    {
      "type": 0,
      "value": "If you reactivate within 60 days, we'll restore your product's data and preferences. You can also submit a "
    },
    {
      "type": 1,
      "value": "deletionOfPersonalDataLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.body.personal-data-retention-summary.direct-customer.link": [
    {
      "type": 0,
      "value": "request for deletion of your personal data"
    }
  ],
  "commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.body.could-not-process-payment": [
    {
      "type": 0,
      "value": "We couldn't process payment for your invoice ("
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": ") due to an issue with your payment details. As a result, we've canceled your plan changes scheduled for "
    },
    {
      "type": 1,
      "value": "scheduleStartDate"
    },
    {
      "type": 0,
      "value": ". "
    }
  ],
  "commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.body.cta.reactivate-subscription-button": [
    {
      "type": 0,
      "value": "Reactivate subscription"
    }
  ],
  "commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.body.product-list-item": [
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "planName"
    },
    {
      "type": 0,
      "value": " ("
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": " | "
    },
    {
      "type": 1,
      "value": "siteUrl"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.body.subscription-is-still-active": [
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription is still active, but the scheduled changes won't happen."
    }
  ],
  "commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.body.update-payment-details": [
    {
      "type": 0,
      "value": "We recommend updating your payment details to ensure this doesn't happen again."
    }
  ],
  "commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.caption": [
    {
      "type": 0,
      "value": "Your scheduled changes have been canceled"
    }
  ],
  "commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.subject": [
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " scheduled changes have been canceled"
    }
  ],
  "commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.partner.body.could-not-process-payment": [
    {
      "type": 0,
      "value": "We couldn't process payment for your invoice ("
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": ") due to an issue with your payment details. As a result, we've canceled your plan changes scheduled for "
    },
    {
      "type": 1,
      "value": "scheduleStartDate"
    },
    {
      "type": 0,
      "value": ". "
    }
  ],
  "commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.partner.body.payment-details-up-to-date": [
    {
      "type": 0,
      "value": "To avoid this in the future, ensure your payment details are up to date."
    }
  ],
  "commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.partner.body.subscription-is-still-active": [
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription is still active, but the scheduled changes won't happen."
    }
  ],
  "commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.partner.caption": [
    {
      "type": 0,
      "value": "Your scheduled changes have been canceled"
    }
  ],
  "commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.partner.subject": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": " - "
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": ": "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " scheduled changes canceled"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp-g.dc.breached-upgrade-plan-info": [
    {
      "type": 0,
      "value": "If you want to increase your included quantity, you can upgrade your plan."
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp-g.dc.breached-upgrade-plan-info.partner": [
    {
      "type": 0,
      "value": "If you want to increase the included quantity, you can upgrade your customer’s plan."
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp-g.dc.siteAdmin": [
    {
      "type": 0,
      "value": "Administration"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp-g.dc.what-you-need-to-do": [
    {
      "type": 0,
      "value": "What do I need to do?"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp-g.email.dc.billing-url": [
    {
      "type": 1,
      "value": "url"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.dc.email.milestone-caption": [
    {
      "type": 0,
      "value": "Your included quantity of "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " in "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " is running low"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.dc.email.subject.breached": [
    {
      "type": 0,
      "value": "You’ve exceeded your included quantity for "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " in "
    },
    {
      "type": 1,
      "value": "productName"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.dc.email.subject.milestone": [
    {
      "type": 0,
      "value": "You’re running out of included quantity for "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " in "
    },
    {
      "type": 1,
      "value": "productName"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.body.subscription-details": [
    {
      "type": 0,
      "value": "Subscription details:"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.breached-caption": [
    {
      "type": 0,
      "value": "You’ll now be charged extra for using "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.breached-info-message": [
    {
      "type": 0,
      "value": "We wanted to let you know that you’ve reached your included quantity for "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " on "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.dc.body.included-qty-info": [
    {
      "type": 0,
      "value": "Your plan includes "
    },
    {
      "type": 1,
      "value": "includedQuantity"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "unit"
    },
    {
      "type": 0,
      "value": " of "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": ". "
    },
    {
      "type": 1,
      "value": "viewUsage"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.dc.milestone-info-message": [
    {
      "type": 0,
      "value": "We wanted to let you know that you’ve reached "
    },
    {
      "type": 1,
      "value": "usageMilestone"
    },
    {
      "type": 0,
      "value": "% of your included quantity for "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " on "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.direct-customer.body.breached-what-to-know": [
    {
      "type": 0,
      "value": "You can continue to use your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription as normal, but keep in mind that any "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " you use from now on will incur extra charges. Any extra usage charges will be reflected in your next invoice, and can be viewed in your site’s "
    },
    {
      "type": 1,
      "value": "admin"
    },
    {
      "type": 0,
      "value": " at "
    },
    {
      "type": 1,
      "value": "billingUrl"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.direct-customer.body.extra-charge-details": [
    {
      "type": 0,
      "value": "Any extra charges will be reflected in your subscription details page"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.direct-customer.body.extra-charge-info": [
    {
      "type": 0,
      "value": "If you go over this amount, extra usage charges will be added to your next invoice"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.direct-customer.body.upgrade-plan": [
    {
      "type": 0,
      "value": "Upgrade your plan"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.direct-customer.body.upgrade-plan-increase-qty": [
    {
      "type": 0,
      "value": "You can upgrade your plan to increase your included quantity"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.body.breached-what-to-know": [
    {
      "type": 0,
      "value": "Your customer can continue to use their "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription as normal, but any "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " they use from now on will incur extra charges.Any extra charges will be reflected in the next bill, and can be viewed in the Partner Purchasing Centre."
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.body.extra-charge-details": [
    {
      "type": 0,
      "value": "Any extra charges will be reflected in the subscription details page"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.body.extra-charge-info": [
    {
      "type": 0,
      "value": "If they go over this amount, extra usage charges will be added to their next invoice"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.body.included-qty-info": [
    {
      "type": 0,
      "value": "This plan includes "
    },
    {
      "type": 1,
      "value": "includedQuantity"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "unit"
    },
    {
      "type": 0,
      "value": " of "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": ". "
    },
    {
      "type": 1,
      "value": "viewUsage"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.body.upgrade-plan-increase-qty": [
    {
      "type": 0,
      "value": "You can upgrade the plan to increase your customer’s included quantity"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.breached-caption": [
    {
      "type": 0,
      "value": "Your customer will now be charged extra for using "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.breached-info-message": [
    {
      "type": 0,
      "value": "Your customer has reached their included quantity for "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " on "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.milestone-info-message": [
    {
      "type": 0,
      "value": "Your customer has reached "
    },
    {
      "type": 1,
      "value": "usageMilestone"
    },
    {
      "type": 0,
      "value": "% of their included quantity for "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " on "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.what-you-need": [
    {
      "type": 0,
      "value": "What you need to know:"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.partner.email.milestone-caption": [
    {
      "type": 0,
      "value": "Included quantity of "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " in "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " is running low"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.partner.email.subject.breached.with-company-name": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": " has exceeded their included quantity for "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " in "
    },
    {
      "type": 1,
      "value": "productName"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.partner.email.subject.milestone.with-company-name": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": " is running out of included quantity for "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " in "
    },
    {
      "type": 1,
      "value": "productName"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp.dc.breached-upgrade-plan-info": [
    {
      "type": 0,
      "value": "If you want to increase your included quantity, you can upgrade your plan."
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp.dc.breached-upgrade-plan-info.partner": [
    {
      "type": 0,
      "value": "If you want to increase the included quantity, you can upgrade your customer’s plan."
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp.dc.siteAdmin": [
    {
      "type": 0,
      "value": "Administration"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp.dc.what-you-need-to-do": [
    {
      "type": 0,
      "value": "What do I need to do?"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp.email.dc.billing-url": [
    {
      "type": 1,
      "value": "url"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.dc.email.milestone-caption": [
    {
      "type": 0,
      "value": "Your included quantity of "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " in "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " is running low"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.dc.email.subject.breached": [
    {
      "type": 0,
      "value": "You’ve exceeded your included quantity for "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " in "
    },
    {
      "type": 1,
      "value": "productName"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.dc.email.subject.milestone": [
    {
      "type": 0,
      "value": "You’re running out of included quantity for "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " in "
    },
    {
      "type": 1,
      "value": "productName"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.body.subscription-details": [
    {
      "type": 0,
      "value": "Subscription details:"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.breached-caption": [
    {
      "type": 0,
      "value": "You’ll now be charged extra for using "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.breached-info-message": [
    {
      "type": 0,
      "value": "We wanted to let you know that you’ve reached your included quantity for "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " on "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.dc.body.included-qty-info": [
    {
      "type": 0,
      "value": "Your plan includes "
    },
    {
      "type": 1,
      "value": "includedQuantity"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "unit"
    },
    {
      "type": 0,
      "value": " of "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": ". "
    },
    {
      "type": 1,
      "value": "viewUsage"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.dc.milestone-info-message": [
    {
      "type": 0,
      "value": "We wanted to let you know that you’ve reached "
    },
    {
      "type": 1,
      "value": "usageMilestone"
    },
    {
      "type": 0,
      "value": "% of your included quantity for "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " on "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.direct-customer.body.breached-what-to-know": [
    {
      "type": 0,
      "value": "You can continue to use your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription as normal, but keep in mind that any "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " you use from now on will incur extra charges. Any extra usage charges will be reflected in your next invoice, and can be viewed in your site’s "
    },
    {
      "type": 1,
      "value": "admin"
    },
    {
      "type": 0,
      "value": " at "
    },
    {
      "type": 1,
      "value": "billingUrl"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.direct-customer.body.extra-charge-details": [
    {
      "type": 0,
      "value": "Any extra charges will be reflected in your subscription details page"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.direct-customer.body.extra-charge-info": [
    {
      "type": 0,
      "value": "If you go over this amount, extra usage charges will be added to your next invoice"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.direct-customer.body.upgrade-plan": [
    {
      "type": 0,
      "value": "Upgrade your plan"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.direct-customer.body.upgrade-plan-increase-qty": [
    {
      "type": 0,
      "value": "You can upgrade your plan to increase your included quantity"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.body.breached-what-to-know": [
    {
      "type": 0,
      "value": "Your customer can continue to use their "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription as normal, but any "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " they use from now on will incur extra charges.Any extra charges will be reflected in the next bill, and can be viewed in the Partner Purchasing Centre."
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.body.extra-charge-details": [
    {
      "type": 0,
      "value": "Any extra charges will be reflected in the subscription details page"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.body.extra-charge-info": [
    {
      "type": 0,
      "value": "If they go over this amount, extra usage charges will be added to their next invoice"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.body.included-qty-info": [
    {
      "type": 0,
      "value": "This plan includes "
    },
    {
      "type": 1,
      "value": "includedQuantity"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "unit"
    },
    {
      "type": 0,
      "value": " of "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": ". "
    },
    {
      "type": 1,
      "value": "viewUsage"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.body.upgrade-plan-increase-qty": [
    {
      "type": 0,
      "value": "You can upgrade the plan to increase your customer’s included quantity"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.breached-caption": [
    {
      "type": 0,
      "value": "Your customer will now be charged extra for using "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.breached-info-message": [
    {
      "type": 0,
      "value": "Your customer has reached their included quantity for "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " on "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.milestone-info-message": [
    {
      "type": 0,
      "value": "Your customer has reached "
    },
    {
      "type": 1,
      "value": "usageMilestone"
    },
    {
      "type": 0,
      "value": "% of their included quantity for "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " on "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.what-you-need": [
    {
      "type": 0,
      "value": "What you need to know:"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.partner.email.milestone-caption": [
    {
      "type": 0,
      "value": "Included quantity of "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " in "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " is running low"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.partner.email.subject.breached.with-company-name": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": " has exceeded their included quantity for "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " in "
    },
    {
      "type": 1,
      "value": "productName"
    }
  ],
  "commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.partner.email.subject.milestone.with-company-name": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": " is running out of included quantity for "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " in "
    },
    {
      "type": 1,
      "value": "productName"
    }
  ],
  "commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.caption": [
    {
      "type": 0,
      "value": "Let’s take it to the next level"
    }
  ],
  "commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.caption.ecc": [
    {
      "type": 0,
      "value": "Subscription moved from monthly to annual"
    }
  ],
  "commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.caption.partner": [
    {
      "type": 0,
      "value": "Subscription moved from monthly to annual"
    }
  ],
  "commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.current-plan": [
    {
      "type": 0,
      "value": "We’re glad you’re enjoying your monthly "
    },
    {
      "type": 1,
      "value": "newPricingPlan"
    },
    {
      "type": 0,
      "value": " plan for "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " ("
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.direct-customer-caption": [
    {
      "type": 0,
      "value": "Subscription moved from monthly to annual"
    }
  ],
  "commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.ecc-subscription-moved": [
    {
      "type": 0,
      "value": "Based on a quote that’s already paid, you have subscriptions that are now on annual from monthly."
    }
  ],
  "commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.ecc-view-cancel-subscription": [
    {
      "type": 0,
      "value": "You can view or cancel the subscription at any time from "
    },
    {
      "type": 1,
      "value": "partnerManagedSubscriptionsUrl"
    }
  ],
  "commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.managed-subscriptions-url": [
    {
      "type": 1,
      "value": "url"
    }
  ],
  "commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.partner-manage-subscription": [
    {
      "type": 0,
      "value": "You can manage the subscription from the "
    },
    {
      "type": 1,
      "value": "partnerPurchaseCentralUrl"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.partner-subscription-moved": [
    {
      "type": 0,
      "value": "Based on a quote that’s already paid, your customer’s subscriptions are now on annual from monthly."
    }
  ],
  "commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.partner-view-cancel-subscription": [
    {
      "type": 0,
      "value": "Your customer contact can view and cancel the subscription at any time from "
    },
    {
      "type": 1,
      "value": "partnerManagedSubscriptionsUrl"
    }
  ],
  "commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.subscription-moved.direct-customer-subscription-list": [
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " ("
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": ")"
    },
    {
      "type": 1,
      "value": "siteUrlSeparator"
    },
    {
      "children": [
        {
          "type": 1,
          "value": "siteUrl"
        }
      ],
      "type": 8,
      "value": "siteUrlLink"
    }
  ],
  "commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.subscription-moved.direct-customer-subscription-moved": [
    {
      "type": 0,
      "value": "Based on a quote that you’ve already paid, you have subscriptions that are now on annual from monthly."
    }
  ],
  "commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.subscription-moved.direct-customer-view-cancel-subscription": [
    {
      "type": 0,
      "value": "You can view and manage your subscription from your billing account. "
    }
  ],
  "commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.body.charge-note.auto-renewal": [
    {
      "type": 0,
      "value": " We’ll charge your chosen payment details annually, and your subscription will be renewed automatically each year. Don’t worry – we’ll let you know when your renewal is coming up."
    }
  ],
  "commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.body.charge-note.termed": [
    {
      "type": 0,
      "value": "We'll charge your chosen payment details and let you know when your renewal is coming up."
    }
  ],
  "commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.body.plan-note.auto-renewal": [
    {
      "type": 0,
      "value": "As requested, your subscription has now been moved to the annual (auto-renewal) plan."
    }
  ],
  "commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.body.plan-note.termed": [
    {
      "type": 0,
      "value": "As requested, your subscription has now been moved to the annual plan."
    }
  ],
  "commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.subject": [
    {
      "type": 0,
      "value": "Enjoy your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "newPricingPlan"
    },
    {
      "type": 0,
      "value": " subscription"
    }
  ],
  "commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.subject.ECC": [
    {
      "type": 0,
      "value": "["
    },
    {
      "type": 1,
      "value": "customerName"
    },
    {
      "type": 0,
      "value": "] Billing cycle changed from monthly to annual"
    }
  ],
  "commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.subject.direct": [
    {
      "type": 0,
      "value": "Billing cycle changed from monthly to annual"
    }
  ],
  "commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.subject.nonpause-billing": [
    {
      "type": 0,
      "value": "Enjoy your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "newPricingPlan"
    },
    {
      "type": 0,
      "value": " subscription"
    }
  ],
  "commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.subject.partner": [
    {
      "type": 0,
      "value": "["
    },
    {
      "type": 1,
      "value": "customerName"
    },
    {
      "type": 0,
      "value": "] Billing cycle changed from monthly to annual"
    }
  ],
  "commerce.commerce-subscription-cycle-change-trial-to-trial-ccp.message-template.email.body.caption": [
    {
      "type": 0,
      "value": "Let’s make it long term"
    }
  ],
  "commerce.commerce-subscription-cycle-change-trial-to-trial-ccp.message-template.email.body.charge-note.auto-renewal": [
    {
      "type": 0,
      "value": "We’ll charge your chosen payment details annually for this subscription, and it will be renewed automatically each year. Don’t worry – we’ll let you know when your renewal is coming up."
    }
  ],
  "commerce.commerce-subscription-cycle-change-trial-to-trial-ccp.message-template.email.body.charge-note.termed": [
    {
      "type": 0,
      "value": " We'll charge your chosen payment details and let you know when your renewal is coming up."
    }
  ],
  "commerce.commerce-subscription-cycle-change-trial-to-trial-ccp.message-template.email.body.subscription-note.auto-renewal": [
    {
      "type": 0,
      "value": "We hope you've enjoyed your monthly "
    },
    {
      "type": 1,
      "value": "oldPricingPlan"
    },
    {
      "type": 0,
      "value": " trial for "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " ("
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": ").\n\t\t\t\tAs requested, your subscription has been moved to an annual (auto-renewal) plan, which will start after\n\t\t\t\tyour trial period has ended."
    }
  ],
  "commerce.commerce-subscription-cycle-change-trial-to-trial-ccp.message-template.email.body.subscription-note.termed": [
    {
      "type": 0,
      "value": "We hope you've enjoyed your monthly "
    },
    {
      "type": 1,
      "value": "oldPricingPlan"
    },
    {
      "type": 0,
      "value": " trial for "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " ("
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": ").\n                As requested, your subscription has been moved to an annual plan, which will start after your trial\n                period has ended."
    }
  ],
  "commerce.commerce-subscription-cycle-change-trial-to-trial-ccp.message-template.email.subject": [
    {
      "type": 0,
      "value": "Let’s make it long term"
    }
  ],
  "commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.direct-customer.body.charge-quantities-added-message": [
    {
      "type": 0,
      "value": "You added new "
    },
    {
      "type": 1,
      "value": "maximumBillingUsageName"
    },
    {
      "type": 0,
      "value": " to your subscription. Based on these changes, we’ve adjusted your billed "
    },
    {
      "type": 1,
      "value": "maximumBillingUsageName"
    },
    {
      "type": 0,
      "value": " to "
    },
    {
      "type": 1,
      "value": "maximumBillingUsageValue"
    },
    {
      "type": 0,
      "value": " and prorated the cost for new "
    },
    {
      "type": 1,
      "value": "maximumBillingUsageName"
    },
    {
      "type": 0,
      "value": " for the remaining time in your billing period."
    }
  ],
  "commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.direct-customer.body.estimated-bill": [
    {
      "type": 0,
      "value": "Your estimated bill for the next billing cycle is "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "currency"
        },
        {
          "type": 0,
          "value": " "
        },
        {
          "type": 1,
          "value": "amountExcludingTax"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " (excluding tax)."
    }
  ],
  "commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.direct-customer.body.final-invoice-details": [
    {
      "type": 0,
      "value": "Your final invoice will reflect all "
    },
    {
      "type": 1,
      "value": "maximumBillingUsageName"
    },
    {
      "type": 0,
      "value": " added before the end of your current billing period and the subsequent prorated charges."
    }
  ],
  "commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.direct-customer.body.to-view-bill": [
    {
      "type": 0,
      "value": "To view your bill breakdown and usage details, visit your "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Subscription details"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " page."
    }
  ],
  "commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.direct-customer.caption": [
    {
      "type": 0,
      "value": "Your team is growing"
    }
  ],
  "commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.direct-customer.subject": [
    {
      "type": 0,
      "value": "New "
    },
    {
      "type": 1,
      "value": "maximumBillingUsageName"
    },
    {
      "type": 0,
      "value": " added to "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    }
  ],
  "commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.body.charge-quantities-added-message": [
    {
      "type": 0,
      "value": "More "
    },
    {
      "type": 1,
      "value": "maximumBillingUsageName"
    },
    {
      "type": 0,
      "value": " have been added to the following subscription:"
    }
  ],
  "commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.body.final-invoice-details": [
    {
      "type": 0,
      "value": "The final invoice will reflect the total number of "
    },
    {
      "type": 1,
      "value": "maximumBillingUsageName"
    },
    {
      "type": 0,
      "value": " added before the end of the current billing cycle."
    }
  ],
  "commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.body.p2-billing-adjusted": [
    {
      "type": 0,
      "value": "The billed "
    },
    {
      "type": 1,
      "value": "maximumBillingUsageName"
    },
    {
      "type": 0,
      "value": " have been adjusted to "
    },
    {
      "type": 1,
      "value": "maximumBillingUsageValue"
    },
    {
      "type": 0,
      "value": " and the cost for the new "
    },
    {
      "type": 1,
      "value": "maximumBillingUsageName"
    },
    {
      "type": 0,
      "value": " has been prorated for the remaining time in the billing period."
    }
  ],
  "commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.body.ppc": [
    {
      "type": 0,
      "value": "You can view the usage details from our "
    },
    {
      "type": 1,
      "value": "ppcSubscriptionsPageLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.caption": [
    {
      "type": 0,
      "value": "Your customer’s team is growing"
    }
  ],
  "commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.subject.with-customer-name": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": " New "
    },
    {
      "type": 1,
      "value": "maximumBillingUsageName"
    },
    {
      "type": 0,
      "value": " for "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    }
  ],
  "commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.subject.without-customer-name": [
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": " New "
    },
    {
      "type": 1,
      "value": "maximumBillingUsageName"
    },
    {
      "type": 0,
      "value": " for "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    }
  ],
  "commerce.commerce-subscription-offering-cancellation-ccp.email.app-retiring": [
    {
      "type": 0,
      "value": "We wanted to let you know that we’re no longer offering "
    },
    {
      "type": 1,
      "value": "appName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": ". "
    }
  ],
  "commerce.commerce-subscription-offering-cancellation-ccp.email.atlassian-suite": [
    {
      "type": 0,
      "value": "Atlassian suite"
    }
  ],
  "commerce.commerce-subscription-offering-cancellation-ccp.email.cancelled-at-end-of-billing-cycle": [
    {
      "type": 0,
      "value": "This means your subscription will be canceled at the end of your last billing cycle."
    }
  ],
  "commerce.commerce-subscription-offering-cancellation-ccp.email.cancelled-immediately": [
    {
      "type": 0,
      "value": "This means your subscription will be canceled 30 days from the date of this email."
    }
  ],
  "commerce.commerce-subscription-offering-cancellation-ccp.email.cancelled-on-offering-expiry-date": [
    {
      "type": 0,
      "value": "This means your subscription will be canceled on "
    },
    {
      "type": 1,
      "value": "expiryDate"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-offering-cancellation-ccp.email.caption": [
    {
      "type": 1,
      "value": "appName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " is being retired"
    }
  ],
  "commerce.commerce-subscription-offering-cancellation-ccp.email.marketplace-apps": [
    {
      "type": 0,
      "value": "Marketplace apps"
    }
  ],
  "commerce.commerce-subscription-offering-cancellation-ccp.email.other-plans-available": [
    {
      "type": 0,
      "value": "There may still be other "
    },
    {
      "type": 1,
      "value": "appName"
    },
    {
      "type": 0,
      "value": " plans available — you can check out our "
    },
    {
      "type": 1,
      "value": "atlassianSuite"
    },
    {
      "type": 0,
      "value": " of products or "
    },
    {
      "type": 1,
      "value": "marketplaceApps"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-offering-cancellation-ccp.message-template.email.body.subscription-details": [
    {
      "type": 0,
      "value": "Subscription details:"
    }
  ],
  "commerce.commerce-subscription-offering-cancellation-ccp.message-template.email.subject": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "appName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " subscription will be canceled"
    }
  ],
  "commerce.commerce-subscription-offering-movement-ccp.email.app-getting-replaced": [
    {
      "type": 0,
      "value": " The developers of "
    },
    {
      "type": 1,
      "value": "appName"
    },
    {
      "type": 0,
      "value": " are retiring this app and replacing it with a free version. Your paid\n                subscription will transition to "
    },
    {
      "type": 1,
      "value": "freeAppName"
    },
    {
      "type": 0,
      "value": ". From the end of your last billing cycle, you’ll no \n\t\t\t\tlonger be charged for this app."
    }
  ],
  "commerce.commerce-subscription-offering-movement-ccp.email.caption": [
    {
      "type": 0,
      "value": "Your paid subscription for this app will convert to a free subscription"
    }
  ],
  "commerce.commerce-subscription-offering-movement-ccp.message-template.email.subject": [
    {
      "type": 1,
      "value": "appName"
    },
    {
      "type": 0,
      "value": " is being retired."
    }
  ],
  "commerce.commerce-subscription-opt-out-ccp-g.direct.message-template.email.body.billing-info": [
    {
      "type": 0,
      "value": "We’ll charge you for your "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan and send you an invoice within 24 hours along with payment confirmation. You may first be charged a prorated amount to align your bill date with your previous plan. Any remaining days of your "
    },
    {
      "type": 1,
      "value": "oldOfferingName"
    },
    {
      "type": 0,
      "value": " plan will be adjusted as credits in your invoice."
    }
  ],
  "commerce.commerce-subscription-opt-out-ccp-g.direct.message-template.email.body.caption": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " free trial has ended"
    }
  ],
  "commerce.commerce-subscription-opt-out-ccp-g.direct.message-template.email.body.intimation": [
    {
      "type": 0,
      "value": "We hope you enjoyed your free trial of "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "oldOfferingName"
    },
    {
      "type": 0,
      "value": ". Your paid "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan has now started from date "
    },
    {
      "type": 1,
      "value": "billingStartDate"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-opt-out-ccp-g.message-template.email.subject": [
    {
      "type": 0,
      "value": "Your no-cost, trial period on "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " paid plan has ended"
    }
  ],
  "commerce.commerce-subscription-opt-out-ccp-g.partner.message-template.email.body.billing-info": [
    {
      "type": 0,
      "value": "We’ll charge for the "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan and send you an invoice within 24 hours along with payment confirmation. Your customer may first be charged a prorated amount to align their bill date with the previous plan. Any remaining days of the "
    },
    {
      "type": 1,
      "value": "oldOfferingName"
    },
    {
      "type": 0,
      "value": " plan will be adjusted as credits in the invoice."
    }
  ],
  "commerce.commerce-subscription-opt-out-ccp-g.partner.message-template.email.body.caption": [
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "oldOfferingName"
    },
    {
      "type": 0,
      "value": " trial has ended"
    }
  ],
  "commerce.commerce-subscription-opt-out-ccp-g.partner.message-template.email.body.upgradation": [
    {
      "type": 0,
      "value": "The subscription is now upgraded from a "
    },
    {
      "type": 1,
      "value": "oldOfferingName"
    },
    {
      "type": 0,
      "value": " paid plan to a "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " paid plan."
    }
  ],
  "commerce.commerce-subscription-opt-out-ccp-g.partner.message-template.email.intimation": [
    {
      "type": 0,
      "value": "The free "
    },
    {
      "type": 1,
      "value": "oldOfferingName"
    },
    {
      "type": 0,
      "value": " plan trial for the following product has ended."
    }
  ],
  "commerce.commerce-subscription-opt-out-ccp-grouped.email.direct.body.allowance-contributions-enforcement-ubp5": [
    {
      "type": 0,
      "value": "Remember — if your organization admin has enabled extra usage, any usage above the allowance will incur extra usage charges. These will be reflected on your bill at the end of the cycle. Organization admins can adjust usage limits anytime. "
    }
  ],
  "commerce.commerce-subscription-opt-out-ccp-grouped.email.partner.body.allowance-contributions-enforcement-ubp5": [
    {
      "type": 0,
      "value": "Remember — if you’ve enabled extra usage, any usage above the allowance will incur extra usage charges. These will be reflected on your bill at the end of the cycle. You can adjust usage limits anytime."
    }
  ],
  "commerce.commerce-subscription-opt-out-ccp.direct.message-template.email.body.billing-info": [
    {
      "type": 0,
      "value": "We’ll charge you for your "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan and send you an invoice within 24 hours along with payment confirmation. You may first be charged a prorated amount to align your bill date with your previous plan. Any remaining days of your "
    },
    {
      "type": 1,
      "value": "oldOfferingName"
    },
    {
      "type": 0,
      "value": " plan will be adjusted as credits in your invoice."
    }
  ],
  "commerce.commerce-subscription-opt-out-ccp.direct.message-template.email.body.caption": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " free trial has ended"
    }
  ],
  "commerce.commerce-subscription-opt-out-ccp.direct.message-template.email.body.intimation": [
    {
      "type": 0,
      "value": "We hope you enjoyed your free trial of "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "oldOfferingName"
    },
    {
      "type": 0,
      "value": ". Your paid "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan has now started from date "
    },
    {
      "type": 1,
      "value": "billingStartDate"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-opt-out-ccp.email.direct.body.allowance-contributions-enforcement-ubp5": [
    {
      "type": 0,
      "value": "Remember, if your organization admin has enabled extra usage, any usage above the allowance may incur extra usage charges, which will be added to your bill at the end of your bill cycle. Organization admins can set and adjust usage limits anytime. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Find out more about usage charges and billing"
        }
      ],
      "type": 8,
      "value": "UsageChargesAndBillingLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-opt-out-ccp.email.partner.body.allowance-contributions-enforcement-ubp5": [
    {
      "type": 0,
      "value": "Remember, any usage above the allowance may incur extra usage charges, which will be added to your customer's bill at the end of the bill cycle. Organization admins can set and adjust usage limits anytime. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Find out more about usage charges and billing"
        }
      ],
      "type": 8,
      "value": "UsageChargesAndBillingLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-opt-out-ccp.message-template.email.subject": [
    {
      "type": 0,
      "value": "Your no-cost, trial period on "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " paid plan has ended"
    }
  ],
  "commerce.commerce-subscription-opt-out-ccp.partner.message-template.email.body.billing-info": [
    {
      "type": 0,
      "value": "We’ll charge for the "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan and send you an invoice within 24 hours along with payment confirmation. Your customer may first be charged a prorated amount to align their bill date with the previous plan. Any remaining days of the "
    },
    {
      "type": 1,
      "value": "oldOfferingName"
    },
    {
      "type": 0,
      "value": " plan will be adjusted as credits in the invoice."
    }
  ],
  "commerce.commerce-subscription-opt-out-ccp.partner.message-template.email.body.caption": [
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "oldOfferingName"
    },
    {
      "type": 0,
      "value": " trial has ended"
    }
  ],
  "commerce.commerce-subscription-opt-out-ccp.partner.message-template.email.body.upgradation": [
    {
      "type": 0,
      "value": "The subscription is now upgraded from a "
    },
    {
      "type": 1,
      "value": "oldOfferingName"
    },
    {
      "type": 0,
      "value": " paid plan to a "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " paid plan."
    }
  ],
  "commerce.commerce-subscription-opt-out-ccp.partner.message-template.email.intimation": [
    {
      "type": 0,
      "value": "The free "
    },
    {
      "type": 1,
      "value": "oldOfferingName"
    },
    {
      "type": 0,
      "value": " plan trial for the following product has ended."
    }
  ],
  "commerce.commerce-subscription-order-fulfilled-ccp.message-template.email.reseller.body.manage-subscription": [
    {
      "type": 0,
      "value": "You can view "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 0,
              "value": "subscription"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "subscriptions"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "entitlementsLength"
    },
    {
      "type": 0,
      "value": " and billing details on your "
    },
    {
      "type": 1,
      "value": "manageSubscriptionUrl"
    },
    {
      "type": 0,
      "value": " page."
    }
  ],
  "commerce.commerce-subscription-order-fulfilled-ccp.message-template.email.reseller.manage-url": [
    {
      "type": 0,
      "value": "Manage Subscriptions"
    }
  ],
  "commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.ba-when-the-trial-ends": [
    {
      "type": 0,
      "value": "Your subscription will be canceled, unless you place an order for the paid plan before the trial end date. "
    },
    {
      "type": 1,
      "value": "upGradeTrialContent"
    }
  ],
  "commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.bu-when-the-trial-ends": [
    {
      "type": 0,
      "value": "When you're ready to start paid subscription, your billing admin will need to use the quote we send them to place an order."
    }
  ],
  "commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.caption-new": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " trial has started"
    }
  ],
  "commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.caption-partner-new": [
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " trial has started"
    }
  ],
  "commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.p1": [
    {
      "type": 0,
      "value": "Good news - you're now on a free "
    },
    {
      "type": 1,
      "value": "trialLength"
    },
    {
      "type": 0,
      "value": " trial of "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": ". The trial ends on "
    },
    {
      "type": 1,
      "value": "trialEndDate"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.p1.partner": [
    {
      "type": 0,
      "value": "This is to notify you that your customer's free "
    },
    {
      "type": 1,
      "value": "trialLength"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " has started."
    }
  ],
  "commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.p2.partner": [
    {
      "type": 0,
      "value": "When trial ends, the subscription will be deactivated. To extend the trial "
    },
    {
      "type": 1,
      "value": "reachOutTous"
    },
    {
      "type": 0,
      "value": " before the trial end date. You may also request a quote, valid until the trial expiry date."
    }
  ],
  "commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.p3": [
    {
      "type": 0,
      "value": "We've sent a quote to your billing admin. When you're ready to start your paid subscription, your billing admin will need to use the quote to place an order."
    }
  ],
  "commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.p3-admin": [
    {
      "type": 0,
      "value": "During your trial, we'll send you a quote. When you're ready to start your paid subscription, you can use the quote to place the order."
    }
  ],
  "commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.reach-out-us": [
    {
      "type": 0,
      "value": "reach out to us"
    }
  ],
  "commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.twc.p1": [
    {
      "type": 0,
      "value": "Good news - you're now on a free "
    },
    {
      "type": 1,
      "value": "trialLength"
    },
    {
      "type": 0,
      "value": " trial of "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": ". The trial ends on "
    },
    {
      "type": 1,
      "value": "trialEndDate"
    },
    {
      "type": 0,
      "value": " - to start making the most of it, make sure you "
    },
    {
      "type": 1,
      "value": "setUpCollectionUrl"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.twc.p1.partner": [
    {
      "type": 0,
      "value": "This is to notify you that your customer's free "
    },
    {
      "type": 1,
      "value": "trialLength"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " has started. To start making the most of it, make sure you or your customer "
    },
    {
      "type": 1,
      "value": "setUpCollectionUrl"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.ba.upgrade-trial-description": [
    {
      "type": 0,
      "value": "Your customer will be charged for their existing "
    },
    {
      "type": 1,
      "value": "oldOfferingName"
    },
    {
      "type": 0,
      "value": " plan and any included quantities until then."
    }
  ],
  "commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.cbp-details": [
    {
      "type": 0,
      "value": "Your trial includes:"
    }
  ],
  "commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.cbps-description": [
    {
      "type": 0,
      "value": "As part of the free trial, usage can’t exceed the included quantity or allocation for each applicable usage type. Once the paid plan starts, extra usage will be allowed, and extra usage charges will be added to the invoice as required. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "More about how billing works."
        }
      ],
      "type": 8,
      "value": "SubscriptionAndBillingSupportUrl"
    }
  ],
  "commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.partner.cbp-description": [
    {
      "type": 0,
      "value": "As part of the free trial, your customer can only use up to the included amount for each quota. If they want extra usage straight away you can contact us. Otherwise, they’ll be able to use more than the included quantity once their paid plan starts, and extra usage charges will be added to the invoice as per their usage."
    }
  ],
  "commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.partner.cbp-details": [
    {
      "type": 0,
      "value": "The subscription also includes the following quotas:"
    }
  ],
  "commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.partner.trial-ends": [
    {
      "type": 0,
      "value": "The trial ends on "
    },
    {
      "type": 1,
      "value": "trialEndDate"
    }
  ],
  "commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.partner.trial-ends-description": [
    {
      "type": 0,
      "value": "Your trial will be automatically converted to the paid plan once your trial ends. "
    },
    {
      "type": 1,
      "value": "upGradeTrialContent"
    }
  ],
  "commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.partner.upgrade-trial-cbp-description": [
    {
      "type": 0,
      "value": " When we invoice your customer for their upgraded plan, we’ll also include any extra usage charges from the previous plan."
    }
  ],
  "commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.partner.upgrade-trial-description": [
    {
      "type": 0,
      "value": "Your customer will be charged for their existing "
    },
    {
      "type": 1,
      "value": "oldOfferingName"
    },
    {
      "type": 0,
      "value": " plan and any included quantities until then."
    }
  ],
  "commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.rovo-dev-credit-usage": [
    {
      "type": 0,
      "value": "Rovo Dev credit usage"
    }
  ],
  "commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.rovo-dev-credits-usage-details": [
    {
      "type": 0,
      "value": "As part of the free trial, users can only use up to 2,000 Rovo Dev credits. Rovo Dev functionality will be disabled for any user who reaches this usage. Once the paid plan starts, they’ll be able to use more for USD 0.01 per extra Rovo Dev credit. To keep spending predictable, organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration. You can view detailed usage in your billing account. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "More about Rovo Dev billing"
        }
      ],
      "type": 8,
      "value": "SubscriptionAndBillingSupportUrl"
    }
  ],
  "commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.upgrade-cbp-details": [
    {
      "type": 0,
      "value": "Your new plan includes:"
    }
  ],
  "commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.upgrade-trial-cbp-description": [
    {
      "type": 0,
      "value": " When we invoice you for your upgraded plan, we’ll also include any extra usage charges from your previous plan."
    }
  ],
  "commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.dc.body.ubp5-enforcement": [
    {
      "type": 0,
      "value": "During your trial, you can only use the allowances included in your subscription."
    }
  ],
  "commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.dc.twc.body.ubp5-enforcement": [
    {
      "type": 0,
      "value": "During your trial, you can only use the allowances included in your subscription."
    }
  ],
  "commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.partner.body.twc.ubp5-enforcement": [
    {
      "type": 0,
      "value": "During the trial, your customer can only use the allowances included in their subscription."
    }
  ],
  "commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.partner.body.ubp5-enforcement": [
    {
      "type": 0,
      "value": "During the trial, your customer can only use the allowances included in their subscription."
    }
  ],
  "commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.partner.body.upgraded-cbp-details": [
    {
      "type": 0,
      "value": "The new plan includes:"
    }
  ],
  "commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.partner.subject": [
    {
      "type": 1,
      "value": "companyName"
    },
    {
      "type": 0,
      "value": " - "
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": ": "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " trial"
    }
  ],
  "commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.subject-new": [
    {
      "type": 0,
      "value": "Your new "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " trial"
    }
  ],
  "commerce.commerce-subscription-paid-trials-cc.message-template.email.direct-customer.body.view-subscription": [
    {
      "type": 0,
      "value": "View subscription"
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.caption-new": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " trial has started"
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.cbp-details": [
    {
      "type": 0,
      "value": "Your trial includes:"
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.cbps-description": [
    {
      "type": 0,
      "value": "As part of the free trial, usage can’t exceed the included quantity or allowance for each applicable usage type. Once the paid plan starts, extra usage will be allowed, and extra usage charges will be added to the invoice as required. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "More about how billing works."
        }
      ],
      "type": 8,
      "value": "SubscriptionAndBillingSupportUrl"
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.good-news": [
    {
      "type": 0,
      "value": "Good news - you're now on a free "
    },
    {
      "type": 1,
      "value": "trialLength"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " trial. Your trial ends on "
    },
    {
      "type": 1,
      "value": "trialEndDate"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.manual-provisioning-description": [
    {
      "type": 0,
      "value": "DX provisioning is handled separately from other Atlassian products. Our team will reach out within [X business days] with your setup instructions and access details. No action is needed from you right now."
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.as-requested": [
    {
      "type": 0,
      "value": "Your customer's free "
    },
    {
      "type": 1,
      "value": "trialLength"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " has started."
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.caption-new": [
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " trial has started"
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.cbps-description": [
    {
      "type": 0,
      "value": "During the trial, your customer can only use the allowances included in their subscription."
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.change-subscription": [
    {
      "type": 0,
      "value": "Change the subscription by visiting the "
    },
    {
      "type": 1,
      "value": "ppcSubscriptionsPageLink"
    },
    {
      "type": 0,
      "value": ". You won't be charged if you switch before the trial ends."
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.rovo-dev-description": [
    {
      "type": 0,
      "value": "As part of the free trial, your customer can only use up to 2,000 Rovo Dev credits. Rovo Dev functionality will be disabled for any user who reaches this usage. Once the paid plan starts, they’ll be able to use more for USD 0.01 per extra Rovo Dev credit. To keep spending predictable, organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration."
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.subscription-includes": [
    {
      "type": 0,
      "value": "The subscription also includes the following:"
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.trial-ends-description": [
    {
      "type": 0,
      "value": "Your trial will be automatically converted to the paid plan once your trial ends. "
    },
    {
      "type": 1,
      "value": "upGradeTrialContent"
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.trial-ends-on": [
    {
      "type": 0,
      "value": "The trial ends on "
    },
    {
      "type": 1,
      "value": "trialEndDate"
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.twc-as-requested": [
    {
      "type": 0,
      "value": "Your customer's free "
    },
    {
      "type": 1,
      "value": "trialLength"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " has started. To start making the most of it, make sure you or your customer "
    },
    {
      "type": 1,
      "value": "setUpCollectionUrl"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.upgrade-trial-cbp-description": [
    {
      "type": 0,
      "value": " When we invoice your customer for their upgraded plan, we’ll also include any extra usage charges from the previous plan."
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.upgrade-trial-description": [
    {
      "type": 0,
      "value": "Your customer will be charged for their existing "
    },
    {
      "type": 1,
      "value": "oldOfferingName"
    },
    {
      "type": 0,
      "value": " plan and any included quantities until then."
    },
    {
      "type": 1,
      "value": "upgradeTrialCbpContent"
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.rovo-dev-credit-usage": [
    {
      "type": 0,
      "value": "Rovo Dev credit usage"
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.rovo-dev-credits-usage-details": [
    {
      "type": 0,
      "value": "As part of the free trial, users can only use up to 2,000 Rovo Dev credits. Rovo Dev functionality will be disabled for any user who reaches this usage. Once the paid plan starts, they’ll be able to use more for USD 0.01 per extra Rovo Dev credit. To keep spending predictable, organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration. You can view detailed usage in your billing account. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "More about Rovo Dev billing"
        }
      ],
      "type": 8,
      "value": "SubscriptionAndBillingSupportUrl"
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.trial-ends-description": [
    {
      "type": 0,
      "value": "Your trial will be automatically converted to the paid plan once your trial ends"
    },
    {
      "type": 1,
      "value": "upGradeTrialContent"
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.twc-good-news": [
    {
      "type": 0,
      "value": "Good news - you're now on a free "
    },
    {
      "type": 1,
      "value": "trialLength"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " trial. Your trial ends on "
    },
    {
      "type": 1,
      "value": "trialEndDate"
    },
    {
      "type": 0,
      "value": " - to start making the most of it, make sure you "
    },
    {
      "type": 1,
      "value": "setUpCollectionUrl"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.upgrade-trial-cbp-description": [
    {
      "type": 0,
      "value": " When we invoice you for your upgraded plan, we’ll also include any extra usage charges from your previous plan."
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.upgrade-trial-description": [
    {
      "type": 0,
      "value": ", and you’ll continue to be charged for your existing "
    },
    {
      "type": 1,
      "value": "oldOfferingName"
    },
    {
      "type": 0,
      "value": " plan and any included quantities until then."
    },
    {
      "type": 1,
      "value": "upgradeTrialCbpContent"
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.dc.body.ubp5-enforcement": [
    {
      "type": 0,
      "value": "During your trial, you can only use the allowances included in your subscription."
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.dc.twc.body.ubp5-enforcement": [
    {
      "type": 0,
      "value": "During your trial, you can only use the allowances included in your subscription."
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-direct-trial-optimization.caption": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " trial has started"
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-direct-trial-optimization.changed-your-mind": [
    {
      "type": 0,
      "value": "Changed your mind?"
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-direct-trial-optimization.subtitle": [
    {
      "type": 0,
      "value": "Your free "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "trialLength"
        },
        {
          "type": 0,
          "value": " trial"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " has started. Your trial ends on "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "trialEndDate"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-direct-trial-optimization.view-subscription": [
    {
      "type": 0,
      "value": "View subscription"
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.cta.get-started": [
    {
      "type": 0,
      "value": "Get started"
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.confluence.access": [
    {
      "children": [
        {
          "type": 0,
          "value": "Set access guardrails."
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Control what users can create and see."
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.confluence.docs": [
    {
      "children": [
        {
          "type": 0,
          "value": "Create docs instantly."
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Generate plans, roadmaps, and more with AI."
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.confluence.find": [
    {
      "children": [
        {
          "type": 0,
          "value": "Find what you need."
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Search across all your connected apps in one place."
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.jira.access": [
    {
      "children": [
        {
          "type": 0,
          "value": "Set access guardrails."
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Control what users can create and see."
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.jira.automate": [
    {
      "children": [
        {
          "type": 0,
          "value": "Automate tedious tasks."
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Set rules for repetitive updates."
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.jira.plans": [
    {
      "children": [
        {
          "type": 0,
          "value": "Turn plans into work."
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Create work items from docs using AI."
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.jpd.access": [
    {
      "children": [
        {
          "type": 0,
          "value": "Set access guardrails."
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Control what users can create and see."
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.jpd.align": [
    {
      "children": [
        {
          "type": 0,
          "value": "Align your team."
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Share plans with co-workers, no sign up required."
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.jpd.prioritize": [
    {
      "children": [
        {
          "type": 0,
          "value": "Prioritize ideas."
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Define and refine your opportunities in one place."
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.loom.edit": [
    {
      "children": [
        {
          "type": 0,
          "value": "Edit your videos."
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Cut “ums” and more with trim and stitch tools."
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.loom.engagement": [
    {
      "children": [
        {
          "type": 0,
          "value": "Understand engagement."
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " See who watched and for how long."
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.loom.record": [
    {
      "children": [
        {
          "type": 0,
          "value": "Record without limits."
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Create and share unlimited videos."
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.twc.confluence": [
    {
      "children": [
        {
          "type": 0,
          "value": "Create docs instantly."
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Generate plans, roadmaps, and more with AI."
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.twc.jira": [
    {
      "children": [
        {
          "type": 0,
          "value": "Turn plans into work."
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Create work items from docs using AI."
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.twc.loom": [
    {
      "children": [
        {
          "type": 0,
          "value": "Align without meetings."
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Explain work or decisions with async video."
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.twc.rovo": [
    {
      "children": [
        {
          "type": 0,
          "value": "Put agents to work."
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Create AI agents to handle specific tasks."
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.how-trial-works.bullet-full-access": [
    {
      "type": 0,
      "value": "You get full access to all "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "planName"
        },
        {
          "type": 0,
          "value": " features"
        }
      ],
      "type": 8,
      "value": "link"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.how-trial-works.bullet-refund": [
    {
      "type": 0,
      "value": "You can request a refund within 30 days if you forget to cancel."
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.how-trial-works.bullet-reminder": [
    {
      "type": 0,
      "value": "We'll remind you 3 days before your trial ends. Cancel anytime."
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.how-trial-works.title": [
    {
      "type": 0,
      "value": "How your trial works"
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subject": [
    {
      "type": 0,
      "value": "Your new "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " trial"
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subscription-details.next-bill-date.label": [
    {
      "type": 0,
      "value": "Next bill date"
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subscription-details.next-bill-estimate.label": [
    {
      "type": 0,
      "value": "Next bill estimate"
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subscription-details.next-bill-estimate.value": [
    {
      "type": 1,
      "value": "amount"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "billingCycle"
    },
    {
      "type": 0,
      "value": " (excluding taxes)"
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subscription-details.plan.label": [
    {
      "type": 0,
      "value": "Plan"
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subscription-details.rovo-credits.label": [
    {
      "type": 0,
      "value": "Rovo credits"
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subscription-details.rovo-credits.value": [
    {
      "type": 1,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": " per user / month"
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subscription-details.title": [
    {
      "type": 0,
      "value": "Subscription details"
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subtitle": [
    {
      "type": 0,
      "value": "Your free "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "trialLength"
        },
        {
          "type": 0,
          "value": " trial"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " has started. "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " gives you unlimited users and advanced features that help you:"
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.title.confluence": [
    {
      "type": 0,
      "value": "Create and collaborate in one place"
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.title.jira": [
    {
      "type": 0,
      "value": "Start building better workflows"
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.title.jpd": [
    {
      "type": 0,
      "value": "Discover your next great product idea"
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.title.loom": [
    {
      "type": 0,
      "value": "Align your team without extra meetings"
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.title.twc": [
    {
      "type": 0,
      "value": "Sync work across teams, all in one place"
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-trial-optimization.features.keep-work": [
    {
      "type": 0,
      "value": "Keep all of your work if you change plans."
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-trial-optimization.features.refund": [
    {
      "type": 0,
      "value": "Get a refund if you forget to cancel within 30 days."
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-trial-optimization.features.reminder": [
    {
      "type": 0,
      "value": "We'll remind you 3 days before your trial ends. Cancel anytime."
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.partner.body.twc.ubp5-enforcement": [
    {
      "type": 0,
      "value": "During the trial, your customer can only use the allowances included in their subscription."
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.partner.body.ubp5-enforcement": [
    {
      "type": 0,
      "value": "During the trial, your customer can only use the allowances included in their subscription."
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.subject-new": [
    {
      "type": 0,
      "value": "Your new "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " trial"
    }
  ],
  "commerce.commerce-subscription-paid-trials-ccp.message-template.email.subject-new.partners": [
    {
      "type": 1,
      "value": "companyName"
    },
    {
      "type": 0,
      "value": " - "
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": ": new "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " trial"
    }
  ],
  "commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.cbps-description": [
    {
      "type": 0,
      "value": "As part of the free trial, usage can’t exceed the included quantity or allocation for each applicable usage type. Once the paid plan starts, extra usage will be allowed, and extra usage charges will be added to the invoice as required. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "More about how billing works."
        }
      ],
      "type": 8,
      "value": "SubscriptionAndBillingSupportUrl"
    }
  ],
  "commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.cta-admin-button": [
    {
      "type": 0,
      "value": "Add payment details"
    }
  ],
  "commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.cta-user": [
    {
      "type": 0,
      "value": "For a seamless transition when your trial ends, your billing admin will need to add payment details before "
    },
    {
      "type": 1,
      "value": "trialEndDate"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.downgrade-to-free": [
    {
      "type": 0,
      "value": "Add your payment details by "
    },
    {
      "type": 1,
      "value": "trialEndDate"
    },
    {
      "type": 0,
      "value": " to continue using "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " without any disruption. If you’re under the user limit and don’t add payment, you’ll automatically switch to the Free plan at the end of your trial."
    }
  ],
  "commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.rovo-dev-credit-usage": [
    {
      "type": 0,
      "value": "Rovo Dev credit usage"
    }
  ],
  "commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.rovo-dev-credits-usage-details": [
    {
      "type": 0,
      "value": "As part of the free trial, users can only use up to 2,000 Rovo Dev credits. Rovo Dev functionality will be disabled for any user who reaches this usage. Once the paid plan starts, they’ll be able to use more for USD 0.01 per extra Rovo Dev credit. To keep spending predictable, organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration. You can view detailed usage in your billing account. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "More about Rovo Dev billing"
        }
      ],
      "type": 8,
      "value": "SubscriptionAndBillingSupportUrl"
    }
  ],
  "commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.trial-started": [
    {
      "type": 0,
      "value": "Good news - you're now on a free "
    },
    {
      "type": 1,
      "value": "trialLength"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " trial. Your trial ends on "
    },
    {
      "type": 1,
      "value": "trialEndDate"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.twc.trial-started": [
    {
      "type": 0,
      "value": "Good news - you're now on a free "
    },
    {
      "type": 1,
      "value": "trialLength"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " trial. Your trial ends on "
    },
    {
      "type": 1,
      "value": "trialEndDate"
    },
    {
      "type": 0,
      "value": " - to start making the most of it, make sure you "
    },
    {
      "type": 1,
      "value": "setUpCollectionUrl"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.caption-new": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " trial has started"
    }
  ],
  "commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.early-reverse-trial.cta-button": [
    {
      "type": 0,
      "value": "Add payment details"
    }
  ],
  "commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.early-reverse-trial.heading": [
    {
      "type": 0,
      "value": "Add payment details to keep your current features"
    }
  ],
  "commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.early-reverse-trial.intro": [
    {
      "type": 0,
      "value": "Your team has been busy in "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": ", and we want to make sure you have everything you need to keep moving forward."
    }
  ],
  "commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.early-reverse-trial.keep-plan-consequence": [
    {
      "type": 0,
      "value": "You won't be charged until your trial ends. If you don't add payment details, your site will automatically move to the "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " Free plan."
    }
  ],
  "commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.early-reverse-trial.keep-plan.confluence-premium": [
    {
      "type": 0,
      "value": "To keep using "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " features like advanced permissions and analytics after your trial ends, add your payment details before "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "trialEndDate"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.early-reverse-trial.keep-plan.confluence-standard": [
    {
      "type": 0,
      "value": "To keep using "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " features like audit logs and 250 GB of storage after your trial ends, add your payment details before "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "trialEndDate"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.early-reverse-trial.keep-plan.generic": [
    {
      "type": 0,
      "value": "To keep using "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " features after your trial ends, add your payment details before "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "trialEndDate"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.early-reverse-trial.keep-plan.jira-premium": [
    {
      "type": 0,
      "value": "To keep using "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " features like advanced planning and unlimited automation after your trial ends, add your payment details before "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "trialEndDate"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.early-reverse-trial.keep-plan.jira-standard": [
    {
      "type": 0,
      "value": "To keep using "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " features like audit logs and increased user limits after your trial ends, add your payment details before "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "trialEndDate"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.early-reverse-trial.section-heading": [
    {
      "type": 0,
      "value": "Stay on your current plan"
    }
  ],
  "commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.early-reverse-trial.subject": [
    {
      "type": 0,
      "value": "You're currently using "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    }
  ],
  "commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.early-reverse-trial.subject.confluence": [
    {
      "type": 0,
      "value": "You're using "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " features, here's how to keep them 💡"
    }
  ],
  "commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.early-reverse-trial.trial-details": [
    {
      "type": 0,
      "value": "When you signed up, we started you on a "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "trialLength"
        },
        {
          "type": 0,
          "value": " trial"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " of "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " so you could experience our most powerful features. Your trial ends on "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "trialEndDate"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.subject-new": [
    {
      "type": 0,
      "value": "Your new "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " trial"
    }
  ],
  "commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.caption": [
    {
      "type": 0,
      "value": "Your subscription is successfully reactivated"
    }
  ],
  "commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.caption.grouped": [
    {
      "type": 0,
      "value": "Your subscription is successfully reactivated"
    }
  ],
  "commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.plans": [
    {
      "type": 0,
      "value": "If you decide "
    },
    {
      "type": 1,
      "value": "toOfferingName"
    },
    {
      "type": 0,
      "value": " isn’t for you – no problem. You can either cancel or change the plan from your account before the trial ends."
    }
  ],
  "commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.plans.grouped": [
    {
      "type": 0,
      "value": "If you decide "
    },
    {
      "type": 1,
      "value": "toOfferingName"
    },
    {
      "type": 0,
      "value": " isn’t for you – no problem. You can either cancel or change the plan from your account before the trial ends."
    }
  ],
  "commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.preferences": [
    {
      "type": 0,
      "value": "Your data and preferences are just as you left them, so jump right in and get started. "
    }
  ],
  "commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.preferences.grouped": [
    {
      "type": 0,
      "value": "Your data and preferences are just as you left them, so jump right in and get started. "
    }
  ],
  "commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.reactivation": [
    {
      "type": 0,
      "value": "Welcome back! As requested, we’ve reactivated your subscription:"
    }
  ],
  "commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.reactivation.grouped": [
    {
      "type": 0,
      "value": "Welcome back! As requested, we’ve reactivated your subscription:"
    }
  ],
  "commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.subject": [
    {
      "type": 0,
      "value": "Welcome back to "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " trial"
    }
  ],
  "commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.subject.grouped": [
    {
      "type": 0,
      "value": "Welcome back to "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " trial"
    }
  ],
  "commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.subscription-details": [
    {
      "type": 0,
      "value": "Your subscription will move back to the "
    },
    {
      "type": 1,
      "value": "fromOfferingName"
    },
    {
      "type": 0,
      "value": " plan at the end of the trial period. To keep your subscription on the "
    },
    {
      "type": 1,
      "value": "toOfferingName"
    },
    {
      "type": 0,
      "value": " plan, "
    },
    {
      "type": 1,
      "value": "contactUs"
    },
    {
      "type": 0,
      "value": " before "
    },
    {
      "type": 1,
      "value": "trialEndDate"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.subscription-details.grouped": [
    {
      "type": 0,
      "value": "Your subscription will move back to the "
    },
    {
      "type": 1,
      "value": "fromOfferingName"
    },
    {
      "type": 0,
      "value": " plan at the end of the trial period. To keep your subscription on the "
    },
    {
      "type": 1,
      "value": "toOfferingName"
    },
    {
      "type": 0,
      "value": " plan, "
    },
    {
      "type": 1,
      "value": "contactUs"
    },
    {
      "type": 0,
      "value": " before "
    },
    {
      "type": 1,
      "value": "trialEndDate"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.trial-ends": [
    {
      "type": 0,
      "value": "What happens when the trial ends?"
    }
  ],
  "commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.trial-ends.grouped": [
    {
      "type": 0,
      "value": "What happens when the trial ends?"
    }
  ],
  "commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.email.body.caption": [
    {
      "type": 0,
      "value": "Subscription successfully reactivated"
    }
  ],
  "commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.email.body.caption.grouped": [
    {
      "type": 0,
      "value": "Subscription successfully reactivated"
    }
  ],
  "commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.email.body.info": [
    {
      "type": 0,
      "value": "Welcome back! As requested, we’ve reactivated your customer’s subscription."
    }
  ],
  "commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.email.body.info.grouped": [
    {
      "type": 0,
      "value": "Welcome back! As requested, we’ve reactivated your customer’s subscription."
    }
  ],
  "commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.message-template.email.plans": [
    {
      "type": 0,
      "value": "If your customer decides "
    },
    {
      "type": 1,
      "value": "toOfferingName"
    },
    {
      "type": 0,
      "value": " isn’t for them, go to our Partner Purchasing Center and change the plan before the trial ends."
    }
  ],
  "commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.message-template.email.plans.grouped": [
    {
      "type": 0,
      "value": "If your customer decides "
    },
    {
      "type": 1,
      "value": "toOfferingName"
    },
    {
      "type": 0,
      "value": " isn’t for them, go to our Partner Purchasing Center and change the plan before the trial ends."
    }
  ],
  "commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.message-template.email.subscription-details": [
    {
      "type": 0,
      "value": "The subscription will move back to the "
    },
    {
      "type": 1,
      "value": "fromOfferingName"
    },
    {
      "type": 0,
      "value": " plan at the end of the trial period. If your customer wants to keep the subscription on the "
    },
    {
      "type": 1,
      "value": "toOfferingName"
    },
    {
      "type": 0,
      "value": " plan, "
    },
    {
      "type": 1,
      "value": "contactUs"
    },
    {
      "type": 0,
      "value": " before "
    },
    {
      "type": 1,
      "value": "trialEndDate"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.message-template.email.subscription-details.grouped": [
    {
      "type": 0,
      "value": "The subscription will move back to the "
    },
    {
      "type": 1,
      "value": "fromOfferingName"
    },
    {
      "type": 0,
      "value": " plan at the end of the trial period. If your customer wants to keep the subscription on the "
    },
    {
      "type": 1,
      "value": "toOfferingName"
    },
    {
      "type": 0,
      "value": " plan, "
    },
    {
      "type": 1,
      "value": "contactUs"
    },
    {
      "type": 0,
      "value": " before "
    },
    {
      "type": 1,
      "value": "trialEndDate"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.message-template.email.trial-ends": [
    {
      "type": 0,
      "value": "What happens when the trial ends?"
    }
  ],
  "commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.message-template.email.trial-ends.grouped": [
    {
      "type": 0,
      "value": "What happens when the trial ends?"
    }
  ],
  "commerce.commerce-subscription-reactivation-ccp-g.paid.personal-data-information": [
    {
      "type": 0,
      "value": "If you have reactivated your subscription within 60 days of cancellation, your data and preferences will be as you left them. You can jump right in and get started!"
    }
  ],
  "commerce.commerce-subscription-reactivation-ccp.email.body.caption": [
    {
      "type": 0,
      "value": "Your subscription is successfully reactivated"
    }
  ],
  "commerce.commerce-subscription-reactivation-ccp.email.body.welcome-back": [
    {
      "type": 0,
      "value": "Welcome back! As requested, we’ve reactivated your subscription:"
    }
  ],
  "commerce.commerce-subscription-reactivation-ccp.free.personal-information": [
    {
      "type": 0,
      "value": "Your data and preferences are just as you left them, so jump right in and get started!"
    }
  ],
  "commerce.commerce-subscription-reactivation-ccp.free.personal-information.partner": [
    {
      "type": 0,
      "value": "Your customer’s data and preferences are just as you left them."
    }
  ],
  "commerce.commerce-subscription-reactivation-ccp.paid.personal-data-information": [
    {
      "type": 0,
      "value": "If you have reactivated your subscription within 60 days of cancellation, your data and preferences will be as you\n\t\t\t\t\t\t\t\tleft them. You can jump right in and get started!"
    }
  ],
  "commerce.commerce-subscription-reactivation-ccp.paid.personal-information-next": [
    {
      "type": 0,
      "value": "If you’ve already settled the outstanding amount, you’re all set. If not, settling it immediately will ensure uninterrupted service and prevent any future deactivations."
    }
  ],
  "commerce.commerce-subscription-reactivation-ccp.paid.personal-information.partner": [
    {
      "type": 0,
      "value": "If you have reactivated your subscription within 60 days of cancellation, your customer’s data and preferences will be as you left them."
    }
  ],
  "commerce.commerce-subscription-reactivation-ccp.paid.what's-next": [
    {
      "type": 0,
      "value": "What’s next"
    }
  ],
  "commerce.commerce-subscription-reactivation-ccp.partner.email.body.caption": [
    {
      "type": 0,
      "value": "Subscription trial successfully reactivated"
    }
  ],
  "commerce.commerce-subscription-reactivation-ccp.partner.email.body.info": [
    {
      "type": 0,
      "value": "Welcome back! As requested, we’ve reactivated your customer’s subscription trial."
    }
  ],
  "commerce.commerce-subscription-reactivation-ccp.partner.trial.email.body.caption": [
    {
      "type": 0,
      "value": "Subscription successfully reactivated"
    }
  ],
  "commerce.commerce-subscription-reactivation-ccp.partner.trial.email.body.info": [
    {
      "type": 0,
      "value": "Welcome back! As requested, we’ve reactivated your customer’s subscription."
    }
  ],
  "commerce.commerce-subscription-reactivation-ccp.subject.email.partner.subject.customerCompanyName": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": ": Welcome back to "
    },
    {
      "type": 1,
      "value": "productName"
    }
  ],
  "commerce.commerce-subscription-reactivation-ccp.subject.email.partner.trial.subject": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": ": Welcome back to "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " trial"
    }
  ],
  "commerce.commerce-subscription-reactivation-ccp.trial.personal-information": [
    {
      "type": 0,
      "value": "When your trial ends, we’ll charge your chosen payment method and send you an invoice within 24 hours."
    }
  ],
  "commerce.commerce-subscription-reactivation-ccp.trial.personal-information-next": [
    {
      "type": 0,
      "value": "Your data and preferences are just as you left them, so jump right in and get started"
    }
  ],
  "commerce.commerce-subscription-reactivation-ccp.trial.personal-information-next.partner": [
    {
      "type": 0,
      "value": "Your customer’s data and preferences are just as you left them."
    }
  ],
  "commerce.commerce-subscription-reactivation-ccp.trial.personal-information.partner": [
    {
      "type": 0,
      "value": "When the trial ends, we’ll charge the chosen payment method and send an invoice within 24 hours."
    }
  ],
  "commerce.commerce-subscription-reactivations-digest.message-template.email.body.caption": [
    {
      "type": 0,
      "value": "We've reactivated your subscriptions"
    }
  ],
  "commerce.commerce-subscription-reactivations-digest.message-template.email.body.details": [
    {
      "type": 0,
      "value": "Your data and preferences are just as you left them, so your team can jump back in straight away."
    }
  ],
  "commerce.commerce-subscription-reactivations-digest.message-template.email.body.intro": [
    {
      "type": 0,
      "value": "As requested, we've reactivated "
    },
    {
      "type": 1,
      "value": "numOfReactivatedSubscriptions"
    },
    {
      "type": 0,
      "value": " subscriptions in the last 24 hours."
    }
  ],
  "commerce.commerce-subscription-reactivations-digest.message-template.email.subject": [
    {
      "type": 0,
      "value": "Your daily reactivations"
    }
  ],
  "commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.change-your-plan": [
    {
      "type": 0,
      "value": "To change your plan"
    }
  ],
  "commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.could-not-process-payment": [
    {
      "type": 0,
      "value": "We couldn't process payment for your invoice ("
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": ") due to an issue with your payment details. To ensure your service continues smoothly, we've moved you back on your previous plan."
    }
  ],
  "commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.manage-subscription": [
    {
      "type": 0,
      "value": "Manage subscription"
    }
  ],
  "commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.manage-subscription-change-plan": [
    {
      "type": 0,
      "value": "Go to Manage subscription, then Change plan. "
    }
  ],
  "commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.payment-details-up-to-date": [
    {
      "type": 0,
      "value": "Make sure your payment details are up to date."
    }
  ],
  "commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.update-plan": [
    {
      "type": 0,
      "value": "You may need to remove users if the number of users you have exceeds the user limit allowed on your updated plan. You can do this by heading to your Directory in Administration Hub."
    }
  ],
  "commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.what-you-need-to-do": [
    {
      "type": 0,
      "value": "What you need to do"
    }
  ],
  "commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.caption": [
    {
      "type": 0,
      "value": "Your subscription has been changed"
    }
  ],
  "commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.subject": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription has been changed"
    }
  ],
  "commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.body.change-your-plan": [
    {
      "type": 0,
      "value": "To change your plan"
    }
  ],
  "commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.body.could-not-process-payment": [
    {
      "type": 0,
      "value": "We couldn't process payment for your invoice ("
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": ") due to an issue with your payment details. To ensure service continues smoothly, we've changed the subscription back to its previous plan."
    }
  ],
  "commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.body.manage-subscription": [
    {
      "type": 0,
      "value": "Manage subscription"
    }
  ],
  "commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.body.update-plan": [
    {
      "type": 0,
      "value": "You may need to remove users if the number of users exceeds the user limit allowed on the updated plan. You can do this from the Directory in Administration Hub."
    }
  ],
  "commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.body.what-you-need-to-do": [
    {
      "type": 0,
      "value": "What you need to do"
    }
  ],
  "commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.caption": [
    {
      "type": 0,
      "value": "Your subscription has been changed"
    }
  ],
  "commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.manage-subscription": [
    {
      "type": 0,
      "value": "Ensure the payment details are up to date then manage the subscription in Partner Purchasing Center."
    }
  ],
  "commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.subject": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": " - "
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": ": "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription changed"
    }
  ],
  "commerce.commerce-subscription-rewind-uncollectible.user-count-key": [
    {
      "type": 0,
      "value": "Users:"
    }
  ],
  "commerce.commerce-subscription-rewind-uncollectible.user-count-value": [
    {
      "type": 1,
      "value": "users"
    }
  ],
  "commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.accepted-request.direct-customer-whats-next": [
    {
      "type": 0,
      "value": "You can use your current plan, but you won’t be able to make any changes. You’ll need to "
    },
    {
      "type": 1,
      "value": "contactLink"
    },
    {
      "type": 0,
      "value": " for any modifications."
    }
  ],
  "commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.accepted-request.nonpause-billing-accepted-request": [
    {
      "type": 0,
      "value": "We've accepted your request to move your subscription from monthly to annual (auto-renewal) plan, which will start at the end of your current billing cycle."
    }
  ],
  "commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.caption.ecc": [
    {
      "type": 0,
      "value": "Scheduled changes to billing cycle"
    }
  ],
  "commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.caption.nonpause-billing-caption": [
    {
      "type": 0,
      "value": "Let’s take it to the next level"
    }
  ],
  "commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.caption.partner": [
    {
      "type": 0,
      "value": "Scheduled changes to billing cycle"
    }
  ],
  "commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.direct-customer-caption": [
    {
      "type": 0,
      "value": "Scheduled changes to billing cycle"
    }
  ],
  "commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.ecc-accepted-request": [
    {
      "type": 0,
      "value": "You can use the current plan, but your partner would need to contact us for any modifications. "
    }
  ],
  "commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.ecc-details": [
    {
      "children": [
        {
          "type": 0,
          "value": "Subscription:"
        }
      ],
      "type": 8,
      "value": "bold"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " ("
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": ")"
    },
    {
      "type": 1,
      "value": "siteUrlSeparator"
    },
    {
      "children": [
        {
          "type": 1,
          "value": "siteUrl"
        }
      ],
      "type": 8,
      "value": "siteUrlLink"
    }
  ],
  "commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.ecc-details-billing-partner": [
    {
      "children": [
        {
          "type": 0,
          "value": "Atlassian billing partner:"
        }
      ],
      "type": 8,
      "value": "bold"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "billingPartner"
    }
  ],
  "commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.ecc-subscription-moved": [
    {
      "type": 0,
      "value": "The billing cycle for one of your subscriptions will be moved from monthly to annual on "
    },
    {
      "type": 1,
      "value": "futureStartDate"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.ecc-wont-billed": [
    {
      "type": 0,
      "value": "You won't be billed between the end of your current monthly billing cycle and the start of your annual billing."
    }
  ],
  "commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.nonpause-billing-current-plan": [
    {
      "type": 0,
      "value": "We’re glad you’re enjoying your monthly "
    },
    {
      "type": 1,
      "value": "newPricingPlan"
    },
    {
      "type": 0,
      "value": " plan for "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " ("
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": ")."
    }
  ],
  "commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.partner-accepted-request": [
    {
      "type": 0,
      "value": "The customer can continue with the existing plan, but you won’t be able to make any changes. You’ll need to "
    },
    {
      "type": 1,
      "value": "contactLink"
    },
    {
      "type": 0,
      "value": " for any modifications."
    }
  ],
  "commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.partner-subscription-moved": [
    {
      "type": 0,
      "value": "The billing cycle for one of your customer’s subscriptions will be moved from monthly to annual on "
    },
    {
      "type": 1,
      "value": "futureStartDate"
    },
    {
      "type": 0,
      "value": ". We’ve also informed your customer about the change."
    }
  ],
  "commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.partner-wont-billed": [
    {
      "type": 0,
      "value": "Your customer won't be billed between the end of the current monthly billing cycle and the start of the annual billing."
    }
  ],
  "commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.subscription-moved.direct-customer-subscription-list": [
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " ("
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": ")"
    },
    {
      "type": 1,
      "value": "siteUrlSeparator"
    },
    {
      "children": [
        {
          "type": 1,
          "value": "siteUrl"
        }
      ],
      "type": 8,
      "value": "siteUrlLink"
    }
  ],
  "commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.subscription-moved.direct-customer-subscription-moved": [
    {
      "type": 0,
      "value": "The billing cycle for one of your subscriptions will be moved from monthly to annual on "
    },
    {
      "type": 1,
      "value": "futureStartDate"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.wont-billed.direct-customer-wont-billed": [
    {
      "type": 0,
      "value": "You won't be billed between the end of your current monthly billing cycle and the start of your annual billing."
    }
  ],
  "commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.message-template.email.subject.ECC": [
    {
      "type": 0,
      "value": "["
    },
    {
      "type": 1,
      "value": "customerName"
    },
    {
      "type": 0,
      "value": "]: Billing cycle change scheduled"
    }
  ],
  "commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.message-template.email.subject.direct": [
    {
      "type": 0,
      "value": "Billing cycle change scheduled"
    }
  ],
  "commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.message-template.email.subject.nonpause-billing": [
    {
      "type": 0,
      "value": "Enjoy your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "newPricingPlan"
    },
    {
      "type": 0,
      "value": " subscription"
    }
  ],
  "commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.message-template.email.subject.partner": [
    {
      "type": 0,
      "value": "["
    },
    {
      "type": 1,
      "value": "customerName"
    },
    {
      "type": 0,
      "value": "]: Billing cycle change scheduled"
    }
  ],
  "commerce.commerce-subscription-scheduled-cycle-change-sp-ccp.email.caption": [
    {
      "type": 0,
      "value": "Your billing frequency will soon be changed"
    }
  ],
  "commerce.commerce-subscription-scheduled-cycle-change-sp-ccp.email.contact-us": [
    {
      "type": 0,
      "value": "If you have any questions concerning this change, please contact us."
    }
  ],
  "commerce.commerce-subscription-scheduled-cycle-change-sp-ccp.email.request-to-change-bill-freq": [
    {
      "type": 0,
      "value": "We received a request to change the billing frequency for your Statuspage subscription "
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-scheduled-cycle-change-sp-ccp.email.when-will-cycle-change": [
    {
      "type": 0,
      "value": "We’ll change your "
    },
    {
      "type": 1,
      "value": "oldBillingCycleName"
    },
    {
      "type": 0,
      "value": " subscription to "
    },
    {
      "type": 1,
      "value": "newBillingCycleName"
    },
    {
      "type": 0,
      "value": " subscription at the end of your current billing cycle."
    }
  ],
  "commerce.commerce-subscription-scheduled-cycle-change-sp-ccp.message-template.email.subject": [
    {
      "type": 0,
      "value": "Your request to change your billing frequency"
    }
  ],
  "commerce.commerce-subscription-scheduled-downgrade-ccp-g.direcct-customer.view-subscription": [
    {
      "type": 0,
      "value": "You can view or cancel your subscription at any time from your site’s "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Administration"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " at "
    },
    {
      "type": 1,
      "value": "billingUrlLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-scheduled-downgrade-ccp-g.direct.email.body.caption": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription will move to the "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan"
    }
  ],
  "commerce.commerce-subscription-scheduled-downgrade-ccp-g.direct.email.body.subscription-downgraded-message": [
    {
      "type": 0,
      "value": "As requested, your "
    },
    {
      "type": 1,
      "value": "oldOfferingName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription is scheduled to move to the "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan. Any extra usage from your previous plan will be reflected on your next bill."
    }
  ],
  "commerce.commerce-subscription-scheduled-downgrade-ccp-g.message-template.email.direct-customer.subject": [
    {
      "type": 0,
      "value": "You’re scheduled for "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    }
  ],
  "commerce.commerce-subscription-scheduled-downgrade-ccp-g.message-template.email.partner.body.change-subscription": [
    {
      "type": 0,
      "value": "Change the subscription by visiting the "
    },
    {
      "type": 1,
      "value": "ppcHomePage"
    }
  ],
  "commerce.commerce-subscription-scheduled-downgrade-ccp-g.message-template.email.partner.subject": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": " is scheduled for "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan"
    }
  ],
  "commerce.commerce-subscription-scheduled-downgrade-ccp-g.partner.change-subscription": [
    {
      "type": 0,
      "value": "Your customer contact can cancel the subscription at any time from "
    },
    {
      "type": 1,
      "value": "redirectionUrl"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-scheduled-downgrade-ccp-g.partner.email.body.caption": [
    {
      "type": 0,
      "value": "Your customer's "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription will move to the "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan"
    }
  ],
  "commerce.commerce-subscription-scheduled-downgrade-ccp-g.partner.email.body.subscription-downgraded-message": [
    {
      "type": 0,
      "value": "As requested, your customer’s "
    },
    {
      "type": 1,
      "value": "oldOfferingName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription is scheduled to move to the "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan. Any extra usage from the previous plan will be reflected on the next bill."
    }
  ],
  "commerce.commerce-subscription-scheduled-downgrade-ccp.direcct-customer.view-subscription": [
    {
      "type": 0,
      "value": "You can view or cancel your subscription at any time from your site’s "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Administration"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " at "
    },
    {
      "type": 1,
      "value": "billingUrlLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-scheduled-downgrade-ccp.direct.email.body.caption": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription will move to the "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan"
    }
  ],
  "commerce.commerce-subscription-scheduled-downgrade-ccp.direct.email.body.subscription-downgraded-message": [
    {
      "type": 0,
      "value": "As requested, your "
    },
    {
      "type": 1,
      "value": "oldOfferingName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription is scheduled to move to the "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan. Any extra usage from your previous plan will be reflected on your next bill."
    }
  ],
  "commerce.commerce-subscription-scheduled-downgrade-ccp.email.dc.ubp-enforcement": [
    {
      "type": 0,
      "value": "Remember, if your organization admin has enabled extra usage, any usage above the allowance may incur extra usage charges, which will be added to your bill each month. Organization admins can set and adjust usage limits anytime. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Find out more about usage charges and billing"
        }
      ],
      "type": 8,
      "value": "UsageChargesAndBillingLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-scheduled-downgrade-ccp.email.partner.ubp-enforcement": [
    {
      "type": 0,
      "value": "Remember, if your customer exceeds their allowance for their plan, extra usage charges will be added to their next invoice. Organization admins can set and adjust usage limits anytime. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Find out more about usage charges and billing"
        }
      ],
      "type": 8,
      "value": "UsageChargesAndBillingLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-scheduled-downgrade-ccp.message-template.email.direct-customer.subject": [
    {
      "type": 0,
      "value": "You’re scheduled for "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    }
  ],
  "commerce.commerce-subscription-scheduled-downgrade-ccp.message-template.email.partner.body.change-subscription": [
    {
      "type": 0,
      "value": "Change the subscription by visiting the "
    },
    {
      "type": 1,
      "value": "ppcHomePage"
    }
  ],
  "commerce.commerce-subscription-scheduled-downgrade-ccp.message-template.email.partner.ppc-url": [
    {
      "type": 0,
      "value": "Partner Purchasing Center"
    }
  ],
  "commerce.commerce-subscription-scheduled-downgrade-ccp.message-template.email.partner.subject": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": " is scheduled for "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan"
    }
  ],
  "commerce.commerce-subscription-scheduled-downgrade-ccp.partner.change-subscription": [
    {
      "type": 0,
      "value": "Your customer contact can cancel the subscription at any time from "
    },
    {
      "type": 1,
      "value": "redirectionUrl"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-scheduled-downgrade-ccp.partner.email.body.caption": [
    {
      "type": 0,
      "value": "Your customer's "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription will move to the "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan"
    }
  ],
  "commerce.commerce-subscription-scheduled-downgrade-ccp.partner.email.body.subscription-downgraded-message": [
    {
      "type": 0,
      "value": "As requested, your customer’s "
    },
    {
      "type": 1,
      "value": "oldOfferingName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription is scheduled to move to the "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan. Any extra usage from the previous plan will be reflected on the next bill."
    }
  ],
  "commerce.commerce-subscription-skip-trial-ccp.email.body.caption": [
    {
      "type": 0,
      "value": "Welcome to the "
    },
    {
      "type": 1,
      "value": "newPricingPlanName"
    },
    {
      "type": 0,
      "value": " plan for "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-skip-trial-ccp.email.body.charge-chosen-payment-method": [
    {
      "type": 0,
      "value": "We'll charge your chosen payment method within 24 hours and send you a payment confirmation along with your invoice"
    }
  ],
  "commerce.commerce-subscription-skip-trial-ccp.email.body.direct-customer.atlassian-admin-link": [
    {
      "type": 0,
      "value": "admin.atlassian.com"
    }
  ],
  "commerce.commerce-subscription-skip-trial-ccp.email.body.direct-customer.caption": [
    {
      "type": 0,
      "value": "Welcome to your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan"
    }
  ],
  "commerce.commerce-subscription-skip-trial-ccp.email.body.direct-customer.decision": [
    {
      "type": 0,
      "value": "If you decide that this isn’t for you, "
    },
    {
      "type": 1,
      "value": "content"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "atlassianAdminLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-skip-trial-ccp.email.body.direct-customer.decision.has-multiple-offering": [
    {
      "type": 0,
      "value": "you can change your plan from"
    }
  ],
  "commerce.commerce-subscription-skip-trial-ccp.email.body.direct-customer.decision.has-single-offering": [
    {
      "type": 0,
      "value": "you can cancel anytime from"
    }
  ],
  "commerce.commerce-subscription-skip-trial-ccp.email.body.direct-customer.great-news": [
    {
      "type": 0,
      "value": "Great news — your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " subscription is now up and running. Here are the details:"
    }
  ],
  "commerce.commerce-subscription-skip-trial-ccp.email.body.great-news": [
    {
      "type": 0,
      "value": "Great news - you’re now on a "
    },
    {
      "type": 1,
      "value": "newPricingPlanName"
    },
    {
      "type": 0,
      "value": ", "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription ("
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": ")."
    }
  ],
  "commerce.commerce-subscription-skip-trial-ccp.email.body.how-addon-billed": [
    {
      "type": 0,
      "value": "Find out more about "
    },
    {
      "type": 1,
      "value": "manageAddonLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-skip-trial-ccp.email.body.manage-addon-link": [
    {
      "type": 0,
      "value": "how add-ons are billed"
    }
  ],
  "commerce.commerce-subscription-skip-trial-ccp.email.body.on-pricing-plan": [
    {
      "type": 0,
      "value": " on "
    },
    {
      "type": 1,
      "value": "newPricingPlan"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-skip-trial-ccp.email.body.partner.atlassian-admin-link": [
    {
      "type": 0,
      "value": "admin.atlassian.com/billing/partner-managed-subscriptions"
    }
  ],
  "commerce.commerce-subscription-skip-trial-ccp.email.body.partner.caption": [
    {
      "type": 0,
      "value": "Welcome to "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan"
    }
  ],
  "commerce.commerce-subscription-skip-trial-ccp.email.body.partner.decision": [
    {
      "type": 0,
      "value": "If your customer decides this isn’t for them, they can "
    },
    {
      "type": 1,
      "value": "content"
    },
    {
      "type": 0,
      "value": " at any time from "
    },
    {
      "type": 1,
      "value": "atlassianAdminLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-skip-trial-ccp.email.body.partner.decision.has-multiple-offering": [
    {
      "type": 0,
      "value": "change their plan"
    }
  ],
  "commerce.commerce-subscription-skip-trial-ccp.email.body.partner.decision.has-single-offering": [
    {
      "type": 0,
      "value": "cancel the subscription"
    }
  ],
  "commerce.commerce-subscription-skip-trial-ccp.email.body.partner.great-news": [
    {
      "type": 0,
      "value": "Great news — "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " subscription"
    },
    {
      "type": 1,
      "value": "companyName"
    },
    {
      "type": 0,
      "value": " is now up and running. Here are the details:"
    }
  ],
  "commerce.commerce-subscription-skip-trial-ccp.personal-information": [
    {
      "type": 0,
      "value": "Remember - your invoice contains personal information such as your address and other billing admin details, so you should only share it with trusted sources."
    }
  ],
  "commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.change-plan": [
    {
      "type": 0,
      "value": "Change plan"
    }
  ],
  "commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.change-plan-and-upgrade": [
    {
      "type": 0,
      "value": " and upgrade your subscription. Don’t forget to add your payment details so you can use "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " without any interruptions."
    }
  ],
  "commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.manage-subscription-button": [
    {
      "type": 0,
      "value": "Manage subscription"
    }
  ],
  "commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.no-payment-info": [
    {
      "type": 0,
      "value": "Since we dont have your complete billing information, we moved you to the Free plan. You can continue using "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " but with limited features."
    }
  ],
  "commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.product-info": [
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "oldPricingPlanName"
    },
    {
      "type": 0,
      "value": " ("
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.title": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription is now on the Free plan"
    }
  ],
  "commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.to-get-back-go-to": [
    {
      "type": 0,
      "value": "Want to go back on the "
    },
    {
      "type": 1,
      "value": "oldPricingPlanName"
    },
    {
      "type": 0,
      "value": " plan? Select "
    }
  ],
  "commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.trial-has-ended": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "oldPricingPlanName"
    },
    {
      "type": 0,
      "value": " trial for "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " has ended. We hope you enjoyed it!"
    }
  ],
  "commerce.commerce-subscription-transferred-ccp-g.message-template.email.transferred-to-billing-account.transferred": [
    {
      "type": 0,
      "value": "We've successfully transferred the requested subscription to your Billing Account, "
    },
    {
      "type": 1,
      "value": "transferredToBillingAccountName"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-transferred-ccp.message-template.email.direct-customer.transferred-to-billing-account.can-now-manage": [
    {
      "type": 0,
      "value": "You can now manage this subscription — or access quotes, orders, and invoices — from "
    },
    {
      "type": 1,
      "value": "transferredToBillingAccountName"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-transferred-ccp.message-template.email.direct-customer.transferred-to-billing-account.uninterrupted-service": [
    {
      "type": 0,
      "value": "To ensure uninterrupted access to your subscriptions, add your payment details before your bill end date."
    }
  ],
  "commerce.commerce-subscription-transferred-ccp.message-template.email.partner-manage-subscriptions": [
    {
      "type": 0,
      "value": "Your customer contact can view and cancel the subscription by going to "
    },
    {
      "type": 1,
      "value": "redirectionUrl"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-transferred-ccp.message-template.email.subject.direct-customer.transferred-from-billing-account": [
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription removed from your account"
    }
  ],
  "commerce.commerce-subscription-transferred-ccp.message-template.email.subject.direct-customer.transferred-to-billing-account": [
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription added to your account"
    }
  ],
  "commerce.commerce-subscription-transferred-ccp.message-template.email.subject.partner.transferred-from-billing-account": [
    {
      "options": {
        "other": {
          "value": [
            {
              "type": 1,
              "value": "entitlementNumber"
            },
            {
              "type": 0,
              "value": ": "
            },
            {
              "type": 1,
              "value": "productName"
            },
            {
              "type": 0,
              "value": " subscription removed from billing account"
            }
          ]
        },
        "yes": {
          "value": [
            {
              "type": 1,
              "value": "customerCompanyName"
            },
            {
              "type": 0,
              "value": " - "
            },
            {
              "type": 1,
              "value": "entitlementNumber"
            },
            {
              "type": 0,
              "value": ": "
            },
            {
              "type": 1,
              "value": "productName"
            },
            {
              "type": 0,
              "value": " subscription removed from billing account"
            }
          ]
        }
      },
      "type": 5,
      "value": "hasCustomerCompanyName"
    }
  ],
  "commerce.commerce-subscription-transferred-ccp.message-template.email.subject.partner.transferred-to-billing-account": [
    {
      "options": {
        "other": {
          "value": [
            {
              "type": 1,
              "value": "entitlementNumber"
            },
            {
              "type": 0,
              "value": ": "
            },
            {
              "type": 1,
              "value": "productName"
            },
            {
              "type": 0,
              "value": " subscription added to your billing account"
            }
          ]
        },
        "yes": {
          "value": [
            {
              "type": 1,
              "value": "customerCompanyName"
            },
            {
              "type": 0,
              "value": " - "
            },
            {
              "type": 1,
              "value": "entitlementNumber"
            },
            {
              "type": 0,
              "value": ": "
            },
            {
              "type": 1,
              "value": "productName"
            },
            {
              "type": 0,
              "value": " subscription added to your billing account"
            }
          ]
        }
      },
      "type": 5,
      "value": "hasCustomerCompanyName"
    }
  ],
  "commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-from-billing-account.can-not-manage": [
    {
      "type": 0,
      "value": "You can no longer manage this subscription — or access quotes, orders, and invoices — from "
    },
    {
      "type": 1,
      "value": "transferredFromBillingAccountName"
    },
    {
      "type": 0,
      "value": ". However, all the invoices up to the date of transfer are still available."
    }
  ],
  "commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-from-billing-account.caption": [
    {
      "type": 0,
      "value": "Subscription removed from billing account"
    }
  ],
  "commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-from-billing-account.product-transferred-info": [
    {
      "type": 0,
      "value": "If you had any other product and subscriptions on the same site that belonged to the same product family,\n\t\t\tthey need to be billed together. That means we’ve transferred them too."
    }
  ],
  "commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-from-billing-account.transferred": [
    {
      "type": 0,
      "value": "We've successfully transferred the requested subscription from your Billing Account, "
    },
    {
      "type": 1,
      "value": "transferredFromBillingAccountName"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-to-billing-account.caption": [
    {
      "type": 0,
      "value": "Subscription added to your billing account"
    }
  ],
  "commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-to-billing-account.product-transferred-info": [
    {
      "type": 0,
      "value": "If the billing account "
    },
    {
      "type": 1,
      "value": "transferredFromBillingAccountName"
    },
    {
      "type": 0,
      "value": " had any other product and subscriptions on the same site that belonged to the same product family, they need to be billed together. That means we’ve transferred them too."
    }
  ],
  "commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-to-billing-account.transferred": [
    {
      "type": 0,
      "value": "We’ve successfully transferred the requested subscription to your Billing Account, "
    },
    {
      "type": 1,
      "value": "transferredToBillingAccountName"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-to-customer-billing-account.caption": [
    {
      "type": 0,
      "value": "Subscription transferred to your billing account"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp-g.message-template.email.body.rovo-dev-credit-usage": [
    {
      "type": 0,
      "value": "Rovo Dev credit usage"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp-g.message-template.email.body.rovo-dev-credits-usage-details": [
    {
      "type": 0,
      "value": "Each month, any usage over the allocated amount will be billed at USD 0.01 per extra Rovo Dev credit, which will be added to your next invoice. Don’t worry — we’ve set an extra usage limit of 2,000 Rovo Dev credits per user, which means extra usage charges per user is currently limited to USD 20 (unless it’s already been adjusted). To keep spending predictable, organization admins can adjust this limit or disable extra usage anytime in Atlassian Administration. You can view usage details in your billing account. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "More about Rovo Dev billing"
        }
      ],
      "type": 8,
      "value": "SubscriptionAndBillingSupportUrl"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp-g.message-template.email.body.rovo-dev-credits-usage-details-partner": [
    {
      "type": 0,
      "value": "Each month, any usage over the allocated amount will be billed at USD 0.01 per extra Rovo Dev credit, which will be added to the next invoice. We’ve set an extra usage limit of 2,000 Rovo Dev credits per user, which means extra usage charges per user is currently limited to USD 20 (unless it’s already been adjusted). To keep spending predictable, organization admins can adjust this limit or disable extra usage anytime in Atlassian Administration. "
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.direct.email.body.trial-ended-message": [
    {
      "type": 0,
      "value": "We hope you enjoyed your free trial of "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": ". Your paid plan has now started from "
    },
    {
      "type": 1,
      "value": "billingStartDate"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.direct.email.body.we-will-charge-you": [
    {
      "type": 0,
      "value": "We’ll charge you for your "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan and send you an invoice within 24 hours along with payment confirmation."
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.direct.email.caption": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " free trial has ended"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.direct.email.subject": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " free trial has ended"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.body.partner.subscription-includes": [
    {
      "type": 0,
      "value": "The subscription also includes the following:"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.body.rovo-dev-credit-usage": [
    {
      "type": 0,
      "value": "Rovo Dev credit usage"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.body.rovo-dev-credits-usage-details": [
    {
      "type": 0,
      "value": "Each month, any usage over the allocated amount will be billed at USD 0.01 per extra Rovo Dev credit, which will be added to your next invoice. Don’t worry — we’ve set an extra usage limit of 2,000 Rovo Dev credits per user, which means extra usage charges per user is currently limited to USD 20 (unless it’s already been adjusted). To keep spending predictable, organization admins can adjust this limit or disable extra usage anytime in Atlassian Administration. You can view usage details in your billing account. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "More about Rovo Dev billing"
        }
      ],
      "type": 8,
      "value": "SubscriptionAndBillingSupportUrl"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.body.rovo-dev-credits-usage-details-partner": [
    {
      "type": 0,
      "value": "Each month, any usage over the allocated amount will be billed at USD 0.01 per extra Rovo Dev credit, which will be added to the next invoice. We’ve set an extra usage limit of 2,000 Rovo Dev credits per user, which means extra usage charges per user is currently limited to USD 20 (unless it’s already been adjusted). To keep spending predictable, organization admins can adjust this limit or disable extra usage anytime in Atlassian Administration. "
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.confluence-price-decrease.row.one.description": [
    {
      "type": 0,
      "value": "Bundle Confluence with Jira, Loom, and Rovo"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.confluence-price-decrease.row.three.title": [
    {
      "type": 0,
      "value": "Switch back anytime"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.confluence-price-decrease.row.two.description": [
    {
      "type": 0,
      "value": "Pay less for all four apps than you currently pay for Confluence"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.confluence-price-decrease.title": [
    {
      "type": 0,
      "value": "Want to pay less for Confluence?"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.confluence-price-increase.row.one.description": [
    {
      "type": 0,
      "value": "of apps, Jira, Confluence, Loom, and Rovo"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.confluence-price-increase.row.one.title": [
    {
      "type": 0,
      "value": "One collection"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.confluence-price-increase.row.three.description": [
    {
      "type": 0,
      "value": "to make sure AI is as useful as it can be"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.confluence-price-increase.row.three.title": [
    {
      "type": 0,
      "value": "More context"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.confluence-price-increase.row.two.description": [
    {
      "type": 0,
      "value": "to instantly create more pages and whiteboards"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.confluence-price-increase.row.two.title": [
    {
      "type": 0,
      "value": "More AI credits"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.confluence-price-increase.title": [
    {
      "type": 0,
      "value": "Take your pages to the next level"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.cta.explore": [
    {
      "type": 0,
      "value": "Explore Teamwork collection"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.cta.see-pricing": [
    {
      "type": 0,
      "value": "See pricing"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.jira-price-decrease.row.one.description": [
    {
      "type": 0,
      "value": "Bundle Jira with Confluence, Loom, and Rovo"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.jira-price-decrease.row.three.title": [
    {
      "type": 0,
      "value": "Switch back anytime"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.jira-price-decrease.row.two.description": [
    {
      "type": 0,
      "value": "Pay less for all four apps than you currently pay for Jira"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.jira-price-decrease.title": [
    {
      "type": 0,
      "value": "Want to pay less for Jira?"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.jira-price-increase.row.one.description": [
    {
      "type": 0,
      "value": "of apps, Jira, Confluence, Loom, and Rovo"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.jira-price-increase.row.one.title": [
    {
      "type": 0,
      "value": "One collection"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.jira-price-increase.row.three.description": [
    {
      "type": 0,
      "value": "to instantly create work in bulk"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.jira-price-increase.row.three.title": [
    {
      "type": 0,
      "value": "More agents"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.jira-price-increase.row.two.description": [
    {
      "type": 0,
      "value": "to automatically triage more work"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.jira-price-increase.row.two.title": [
    {
      "type": 0,
      "value": "More AI credits"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.jira-price-increase.title": [
    {
      "type": 0,
      "value": "Take your projects to the next level"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.loom-business-and-ai.row.one.description": [
    {
      "type": 0,
      "value": "of apps, Jira, Confluence, Loom, and Rovo"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.loom-business-and-ai.row.one.title": [
    {
      "type": 0,
      "value": "One collection"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.loom-business-and-ai.row.three.description": [
    {
      "type": 0,
      "value": "for less than you think"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.loom-business-and-ai.row.three.title": [
    {
      "type": 0,
      "value": "All in one place"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.loom-business-and-ai.row.two.description": [
    {
      "type": 0,
      "value": "to easily connect Loom with your other tools"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.loom-business-and-ai.row.two.title": [
    {
      "type": 0,
      "value": "More AI credits"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.loom-business-and-ai.title": [
    {
      "type": 0,
      "value": "Get more from Loom with the full collection"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.loom-business.row.one.title": [
    {
      "type": 0,
      "value": "Bundle Loom with Jira, Confluence, and Rovo"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.loom-business.row.three.title": [
    {
      "type": 0,
      "value": "Switch back anytime"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.loom-business.row.two.title": [
    {
      "type": 0,
      "value": "Pay less for all four apps than you currently pay for Loom"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.loom-business.title": [
    {
      "type": 0,
      "value": "Want to pay less for Loom?"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.partner.email.body.trial-ended-message": [
    {
      "type": 0,
      "value": "The free "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan trial for the following product has ended, and the paid period has started from "
    },
    {
      "type": 1,
      "value": "billingStartDate"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.partner.email.body.we-will-charge-you": [
    {
      "type": 0,
      "value": "We’ll charge the chosen payment method and send you an invoice soon, along with the payment confirmation."
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.partner.email.caption": [
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " trial has ended"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.partner.email.caption.upsell-twc": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan is active"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.partner.email.subject": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": " - "
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": ": Free "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " has ended"
    }
  ],
  "commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.partner.email.subject.without-company-name": [
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": ": Free "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " has ended"
    }
  ],
  "commerce.commerce-subscription-trial-ended-opt-out-ccp.email.caption": [
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "toOfferingName"
    },
    {
      "type": 0,
      "value": " trial has ended"
    }
  ],
  "commerce.commerce-subscription-trial-ended-opt-out-ccp.email.moved-back-old-plan": [
    {
      "type": 0,
      "value": "The subscription will be moved back to the "
    },
    {
      "type": 1,
      "value": "fromOfferingName"
    },
    {
      "type": 0,
      "value": " plan. You don't have to pay any additional charges for the trial period used as we continued your billing per your "
    },
    {
      "type": 1,
      "value": "toOfferingName"
    },
    {
      "type": 0,
      "value": " plan while on trial. If you were initially on the Free plan, you won't be charged anything. "
    }
  ],
  "commerce.commerce-subscription-trial-ended-opt-out-ccp.email.subscription-opted-out-from-to": [
    {
      "type": 0,
      "value": "As requested, we've ended the no-cost "
    },
    {
      "type": 1,
      "value": "toOfferingName"
    },
    {
      "type": 0,
      "value": " trial of the following product:"
    }
  ],
  "commerce.commerce-subscription-trial-ended-opt-out-ccp.message-template.email.body.view-subscription": [
    {
      "type": 0,
      "value": "If needed, you can always restart the trial from our "
    },
    {
      "type": 1,
      "value": "ppcSubscriptionLink"
    }
  ],
  "commerce.commerce-subscription-trial-ended-opt-out-ccp.message-template.email.subject": [
    {
      "type": 1,
      "value": "companyName"
    },
    {
      "type": 0,
      "value": " - "
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": ": "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "toOfferingName"
    },
    {
      "type": 0,
      "value": " trial ended on request"
    }
  ],
  "commerce.commerce-subscription-trial-ended-paid-to-paid-ccp.message-template.email.body.trial-ended-message": [
    {
      "type": 0,
      "value": "The no-cost "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan trial for the following product has ended."
    }
  ],
  "commerce.commerce-subscription-trial-ended-paid-to-paid-ccp.message-template.email.body.upgrade-offering-message": [
    {
      "type": 0,
      "value": "The subscription is now upgraded from a "
    },
    {
      "type": 1,
      "value": "fromOfferingName"
    },
    {
      "type": 0,
      "value": " paid plan to a "
    },
    {
      "type": 1,
      "value": "toOfferingName"
    },
    {
      "type": 0,
      "value": " paid plan:"
    }
  ],
  "commerce.commerce-subscription-trial-ended-paid-to-paid-ccp.message-template.email.body.view-subscription": [
    {
      "type": 0,
      "value": "To view the subscription, visit our "
    },
    {
      "type": 1,
      "value": "ppcSubscriptionLink"
    }
  ],
  "commerce.commerce-subscription-trial-ended-paid-to-paid-ccp.message-template.email.body.we-will-charge-message": [
    {
      "type": 0,
      "value": "We’ll charge you for a "
    },
    {
      "type": 1,
      "value": "toOfferingName"
    },
    {
      "type": 0,
      "value": " plan and send you an invoice within 24 hours along with the payment confirmation. You may first be charged a prorated amount to align your bill date with your previous plan. Any remaining days of the "
    },
    {
      "type": 1,
      "value": "fromOfferingName"
    },
    {
      "type": 0,
      "value": " plan will be adjusted as credits in your invoice."
    }
  ],
  "commerce.commerce-subscription-trial-ended-paid-to-paid-ccp.message-template.email.caption": [
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " paid plan has started"
    }
  ],
  "commerce.commerce-subscription-trial-ended-paid-to-paid-ccp.message-template.email.subject": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": " - "
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": ": No cost "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "fromOfferingName"
    },
    {
      "type": 0,
      "value": " trial period has ended"
    }
  ],
  "commerce.commerce-subscription-trial-started-digest.message-template.email.body.ba-add-payment": [
    {
      "type": 0,
      "value": "For a seamless transition when your trial ends, you’ll need to add payment details before "
    },
    {
      "type": 1,
      "value": "trialEndDateBold"
    },
    {
      "type": 0,
      "value": ". "
    }
  ],
  "commerce.commerce-subscription-trial-started-digest.message-template.email.body.bu-add-payment": [
    {
      "type": 0,
      "value": "For a seamless transition when your trial ends, your billing admin will need to add payment details before "
    },
    {
      "type": 1,
      "value": "trialEndDateBold"
    },
    {
      "type": 0,
      "value": ". "
    }
  ],
  "commerce.commerce-subscription-trial-started-digest.message-template.email.body.cancel": [
    {
      "type": 0,
      "value": "If you decide this isn’t for you, you can cancel your subscription before your trial ends by logging in to your account."
    }
  ],
  "commerce.commerce-subscription-trial-started-digest.message-template.email.body.caption": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offering"
    },
    {
      "type": 0,
      "value": " trial has started"
    }
  ],
  "commerce.commerce-subscription-trial-started-digest.message-template.email.body.on-trial": [
    {
      "type": 0,
      "value": "Good news — you're now on a free "
    },
    {
      "type": 1,
      "value": "trialLength"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offering"
    },
    {
      "type": 0,
      "value": " trial. Your trial ends on "
    },
    {
      "type": 1,
      "value": "trialEndDateBold"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-trial-started-digest.message-template.email.body.subscription-details": [
    {
      "type": 0,
      "value": "Here are the subscription details:"
    }
  ],
  "commerce.commerce-subscription-trial-started-digest.message-template.email.body.trial-auto-convert": [
    {
      "type": 0,
      "value": "Your trial will be automatically converted to the paid plan once your trial ends."
    }
  ],
  "commerce.commerce-subscription-trial-started-digest.message-template.email.subject": [
    {
      "type": 0,
      "value": "Your new "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " trial"
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.caption.lets-make-it-official": [
    {
      "type": 0,
      "value": "Let’s make it official"
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.caption.time-flies": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " trial is coming to an end"
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.add-payment": [
    {
      "type": 0,
      "value": "If you want to continue with the paid plan, you’ll need to add payment details before "
    },
    {
      "type": 1,
      "value": "trialEndDate"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.auto-conversion": [
    {
      "type": 0,
      "value": "If you want to continue, you don’t need to do anything. When your trial ends, we’ll charge the payment method you chose when you signed up."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.auto-conversion-off": [
    {
      "type": 0,
      "value": "Your subscription will be deactivated. "
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.auto-conversion-off-upgrade-trial": [
    {
      "type": 0,
      "value": "You’ll be moved back to the "
    },
    {
      "type": 1,
      "value": "oldOfferingName"
    },
    {
      "type": 0,
      "value": " plan. "
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.change-or-cancel-plan": [
    {
      "type": 0,
      "value": "You can change or cancel your subscription before your trial ends by going to "
    },
    {
      "type": 1,
      "value": "changePlanLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.deactivate-if-payment-not-added": [
    {
      "type": 0,
      "value": "If you don’t add your payment details before your trial ends, your subscription will be deactivated."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.downgrade-or-deactivate-if-payment-not-added": [
    {
      "type": 0,
      "value": "If you don’t add your payment details before your trial ends, we’ll move you to the Free plan — as long as you meet the user limit requirements. If not, your subscription will be deactivated."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.downgrade-or-deactivate-if-payment-not-added-v2": [
    {
      "type": 0,
      "value": "If you don’t add your payment details before your trial ends, we’ll move you to the Free plan — as long as you meet the limit requirements. If not, your subscription will be deactivated."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.extend-trial": [
    {
      "type": 0,
      "value": "If you’d like to extend your trial, you’ll need to contact us at "
    },
    {
      "type": 1,
      "value": "salesOpsSupportEmail"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.reminder-trial-ending": [
    {
      "type": 0,
      "value": "Heads up — your trial ends on "
    },
    {
      "type": 1,
      "value": "trialEndDate"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.scheduled-for-cancellation": [
    {
      "type": 0,
      "value": "You can undo the cancellation by "
    },
    {
      "type": 1,
      "value": "contactingUs"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.trial-will-end": [
    {
      "type": 0,
      "value": "We hope you're enjoying your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " trial."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.trial-will-end-twc": [
    {
      "type": 0,
      "value": "We hope you're enjoying your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " trial and your team's making the most of the increased collaboration."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.features.your-features-include": [
    {
      "children": [
        {
          "type": 0,
          "value": "Your features include:"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.headline-body.end-of-trial-with-pde": [
    {
      "type": 0,
      "value": "Your subscription begins on "
    },
    {
      "type": 1,
      "value": "subscriptionStartDate"
    },
    {
      "type": 0,
      "value": ". Learn about your plan’s features and see what they can do for you."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.headline-caption.end-of-trial-with-pde": [
    {
      "type": 0,
      "value": "Ready for your next chapter?"
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.auto-conversion": [
    {
      "type": 0,
      "value": "If your customer wants to continue on this plan, you don’t need to do anything. When the trial ends, we’ll charge the payment method you chose when you signed up."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.auto-conversion-off": [
    {
      "type": 0,
      "value": "When the trial ends, the subscription will be deactivated. "
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.auto-conversion-off-upgrade-trial": [
    {
      "type": 0,
      "value": "The subscription will move back to the "
    },
    {
      "type": 1,
      "value": "oldOfferingName"
    },
    {
      "type": 0,
      "value": " plan. "
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.auto-conversion-upgrade-trial": [
    {
      "type": 0,
      "value": "If your customer wants to continue on this plan, you don’t need to do anything. When the trial ends, the subscription will be moved to the "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan and charged on the next bill date."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.deactivate-if-payment-not-added": [
    {
      "type": 0,
      "value": "To continue, add payment details (if you haven’t already) before your trial ends to avoid deactivation."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.downgrade-or-deactivate-if-payment-not-added": [
    {
      "type": 0,
      "value": "To continue with the paid plan, add payment details (if you haven’t already) before your trial ends to avoid downgrading to the Free plan or deactivation."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.extend-trial": [
    {
      "type": 0,
      "value": "To extend the trial, "
    },
    {
      "type": 1,
      "value": "reachOutTous"
    },
    {
      "type": 0,
      "value": " before the trial end date. You may also request a quote, valid until the trial expiry date."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.reach-out-to-us": [
    {
      "type": 0,
      "value": "reach out to us"
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.reminder-trial-ending": [
    {
      "type": 0,
      "value": "Heads up — your customer's "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " trial for "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " ends on "
    },
    {
      "type": 1,
      "value": "trialEndDate"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.scheduled-for-cancellation": [
    {
      "type": 0,
      "value": "The trial is scheduled for cancellation. If your customer wants to undo the cancellation, "
    },
    {
      "type": 1,
      "value": "contactUs"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.body.intro": [
    {
      "type": 0,
      "value": "Your trial will end in 3 days. Add your payment details now so you don’t lose your features."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.body.refund-policy": [
    {
      "children": [
        {
          "type": 0,
          "value": "Switch plans anytime."
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Refund within 30 days of initial purchase if you change your mind."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.body.title": [
    {
      "type": 0,
      "value": "Keep what’s working for you"
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.confluence.premium.permissions": [
    {
      "type": 0,
      "value": "You’ll no longer be able to choose who can view, edit, or comment on pages."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.confluence.premium.rovo": [
    {
      "type": 0,
      "value": "You won’t be able to use Rovo (AI) features anymore, like search, chat, or content help."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.confluence.premium.whiteboards": [
    {
      "type": 0,
      "value": "Whiteboards are great for planning and brainstorming, but Free only allows 3 per person."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.confluence.standard.permissions": [
    {
      "type": 0,
      "value": "You’ll no longer be able to choose who can view, edit, or comment on pages."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.confluence.standard.rovo": [
    {
      "type": 0,
      "value": "You won’t be able to use Rovo (AI) features anymore, like search, chat, or content help."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.confluence.standard.users": [
    {
      "type": 0,
      "value": "The user limit will drop from unlimited to 10 people."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.confluence.standard.users.above-limit": [
    {
      "type": 0,
      "value": "The user limit will drop to 10 people. You have "
    },
    {
      "type": 1,
      "value": "userCount"
    },
    {
      "type": 0,
      "value": " people, so your site may be deactivated."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jira.premium.permissions": [
    {
      "type": 0,
      "value": "You won’t be able to set rules on who can create, view, or comment on work items."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jira.premium.plans": [
    {
      "type": 0,
      "value": "Without cross-project plans, you won’t be able to see status or problems across teams."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jira.premium.rovo": [
    {
      "type": 0,
      "value": "You won’t be able to use Rovo (AI) features anymore, like search, chat or agents."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jira.standard.permissions": [
    {
      "type": 0,
      "value": "You won’t be able to set rules on who can create, view, or comment on work items."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jira.standard.rovo": [
    {
      "type": 0,
      "value": "You won’t be able to use Rovo (AI) features anymore, like search, chat or agents."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jira.standard.users": [
    {
      "type": 0,
      "value": "The user limit will drop from unlimited to 10 people."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jira.standard.users.above-limit": [
    {
      "type": 0,
      "value": "The user limit will drop to 10 people. You have "
    },
    {
      "type": 1,
      "value": "userCount"
    },
    {
      "type": 0,
      "value": " people, so your site may be deactivated."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jpd.premium.roadmaps": [
    {
      "type": 0,
      "value": "Cross-project roadmaps won’t be available, so you can’t see all ideas in one view."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jpd.premium.rovo": [
    {
      "type": 0,
      "value": "You won’t be able to use Rovo (AI) features anymore, like search, chat, or content help."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jpd.premium.view-restrictions": [
    {
      "type": 0,
      "value": "You won’t be able to control who can see, edit, or create views."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jpd.standard.published-view": [
    {
      "type": 0,
      "value": "You won’t be able to publish and share your plans with people unless they’re signed in."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jpd.standard.storage": [
    {
      "type": 0,
      "value": "Storage will drop from 250 GB to 2 GB, which will limit your ability to upload files."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jpd.standard.users": [
    {
      "type": 0,
      "value": "The user limit will drop from unlimited to 3."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jpd.standard.users.above-limit": [
    {
      "type": 0,
      "value": "The user limit will drop to 3 creators. You have "
    },
    {
      "type": 1,
      "value": "userCount"
    },
    {
      "type": 0,
      "value": " people, so your site may be deactivated."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.add-payment": [
    {
      "type": 0,
      "value": "Add payment details before "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " trial ends"
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.end-of-trial-with-pde": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " trial is ending"
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.mpucup": [
    {
      "type": 0,
      "value": "Payment required to keep your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription"
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.mpucup.no-product-name": [
    {
      "type": 0,
      "value": "Payment required to keep your subscription"
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.partner.add-payment": [
    {
      "options": {
        "other": {
          "value": [
            {
              "type": 1,
              "value": "entitlementNumber"
            },
            {
              "type": 0,
              "value": ": Add payment details before "
            },
            {
              "type": 1,
              "value": "productName"
            },
            {
              "type": 0,
              "value": " "
            },
            {
              "type": 1,
              "value": "offeringName"
            },
            {
              "type": 0,
              "value": " trial ends"
            }
          ]
        },
        "yes": {
          "value": [
            {
              "type": 1,
              "value": "customerCompanyName"
            },
            {
              "type": 0,
              "value": " "
            },
            {
              "type": 1,
              "value": "entitlementNumber"
            },
            {
              "type": 0,
              "value": ": Add payment details before "
            },
            {
              "type": 1,
              "value": "productName"
            },
            {
              "type": 0,
              "value": " "
            },
            {
              "type": 1,
              "value": "offeringName"
            },
            {
              "type": 0,
              "value": " trial ends"
            }
          ]
        }
      },
      "type": 5,
      "value": "hasCustomerCompanyName"
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.partner.trial-ends-soon": [
    {
      "options": {
        "other": {
          "value": [
            {
              "type": 1,
              "value": "entitlementNumber"
            },
            {
              "type": 0,
              "value": ": "
            },
            {
              "type": 1,
              "value": "productName"
            },
            {
              "type": 0,
              "value": " "
            },
            {
              "type": 1,
              "value": "offeringName"
            },
            {
              "type": 0,
              "value": " trial ends soon"
            }
          ]
        },
        "yes": {
          "value": [
            {
              "type": 1,
              "value": "customerCompanyName"
            },
            {
              "type": 0,
              "value": " "
            },
            {
              "type": 1,
              "value": "entitlementNumber"
            },
            {
              "type": 0,
              "value": ": "
            },
            {
              "type": 1,
              "value": "productName"
            },
            {
              "type": 0,
              "value": " "
            },
            {
              "type": 1,
              "value": "offeringName"
            },
            {
              "type": 0,
              "value": " trial ends soon"
            }
          ]
        }
      },
      "type": 5,
      "value": "hasCustomerCompanyName"
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.personalised-no-pde": [
    {
      "type": 0,
      "value": "Don’t lose your features - add payment details today"
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.trial-ends-soon": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " trial ends soon"
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.message-template.email.title": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " trial is ending"
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.mpucup.email.add-payment-details-before-trial-ends": [
    {
      "type": 0,
      "value": "Add payment details before your trial ends on "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "trialEndDate"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " to keep all your users and features. If you don't add payment details or reduce your user count to 10 or fewer by "
    },
    {
      "type": 1,
      "value": "trialEndDate"
    },
    {
      "type": 0,
      "value": ", you will lose access to "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " and your data will be permanently deleted."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.mpucup.email.add-payment-details-before-trial-ends-within-limit": [
    {
      "type": 0,
      "value": "Add payment details before your trial ends on "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "trialEndDate"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " to keep all your features. If you don't add payment details by "
    },
    {
      "type": 1,
      "value": "trialEndDate"
    },
    {
      "type": 0,
      "value": ", you will lose access to "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " Standard."
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.mpucup.email.caption": [
    {
      "type": 0,
      "value": "Add payment details to keep your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription"
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.mpucup.email.what-you-need-to-do": [
    {
      "type": 0,
      "value": "What you need to do"
    }
  ],
  "commerce.commerce-subscription-trial-will-end-ccp.mpucup.email.your-trial-ends-in-days": [
    {
      "type": 0,
      "value": "Your free "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " Standard trial ends in "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "3 days"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ". Add payment details now to ensure your team has uninterrupted access."
    }
  ],
  "commerce.commerce-subscription-upcoming-renewal-ccp.email.add-payment-details": [
    {
      "type": 0,
      "value": "We noticed that we don't have your payment details on file. Add payment details before the renewal date to avoid any disruptions to your subscription."
    }
  ],
  "commerce.commerce-subscription-upcoming-renewal-ccp.email.caption": [
    {
      "type": 0,
      "value": "Your upcoming renewal"
    }
  ],
  "commerce.commerce-subscription-upcoming-renewal-ccp.email.payment-method-charged": [
    {
      "type": 0,
      "value": "We’ll charge your chosen payment method at this time. If you want to use a different payment method, update your details before the renewal date."
    }
  ],
  "commerce.commerce-subscription-upcoming-renewal-ccp.email.renewal-reminder": [
    {
      "type": 0,
      "value": "This is a friendly reminder that your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription will renew on "
    },
    {
      "type": 1,
      "value": "renewalDate"
    },
    {
      "type": 0,
      "value": ". Here are the details:"
    }
  ],
  "commerce.commerce-subscription-upcoming-renewal-ccp.message-template.email.subject": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription renews soon"
    }
  ],
  "commerce.commerce-subscription-upgrade-ccp-g.direct.email.body.caption": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription has moved to the "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan"
    }
  ],
  "commerce.commerce-subscription-upgrade-ccp-g.direct.email.body.subscription-upgrade-message": [
    {
      "type": 0,
      "value": "As requested, your "
    },
    {
      "type": 1,
      "value": "oldOfferingName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription has moved to the "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan. Any extra usage from your previous plan will be charged to your existing payment method."
    }
  ],
  "commerce.commerce-subscription-upgrade-ccp-g.direct.message-template.email.subject": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " plan has been upgraded"
    }
  ],
  "commerce.commerce-subscription-upgrade-ccp-g.partner.email.body.caption": [
    {
      "type": 0,
      "value": "Your customer's "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription has moved to the "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan"
    }
  ],
  "commerce.commerce-subscription-upgrade-ccp-g.partner.email.body.subscription-upgrade-message": [
    {
      "type": 0,
      "value": "As requested, your "
    },
    {
      "type": 1,
      "value": "oldOfferingName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription has moved to the "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan. Any extra usage from your previous plan will be charged to the existing payment method."
    }
  ],
  "commerce.commerce-subscription-upgrade-ccp-g.partner.message-template.email.subject": [
    {
      "type": 1,
      "value": "companyName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": " is now on "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan"
    }
  ],
  "commerce.commerce-subscription-upgrade-ccp.direct.email.body.caption": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription has moved to the "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan"
    }
  ],
  "commerce.commerce-subscription-upgrade-ccp.direct.email.body.subscription-upgrade-message": [
    {
      "type": 0,
      "value": "As requested, your "
    },
    {
      "type": 1,
      "value": "oldOfferingName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription has moved to the "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan. Any extra usage from your previous plan will be charged to your existing payment method."
    }
  ],
  "commerce.commerce-subscription-upgrade-ccp.direct.message-template.email.subject": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " plan has been upgraded"
    }
  ],
  "commerce.commerce-subscription-upgrade-ccp.email.dc.ubp-enforcement": [
    {
      "type": 0,
      "value": "Remember, if your organization admin has enabled extra usage, any usage above the allowance may incur extra usage charges, which will be added to your bill each month. Organization admins can set and adjust usage limits anytime. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Find out more about usage charges and billing"
        }
      ],
      "type": 8,
      "value": "UsageChargesAndBillingLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-upgrade-ccp.email.partner.ubp-enforcement": [
    {
      "type": 0,
      "value": "Remember, if your customer exceeds their allowance for their plan, extra usage charges will be added to their next invoice. Organization admins can set and adjust usage limits anytime. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Find out more about usage charges and billing"
        }
      ],
      "type": 8,
      "value": "UsageChargesAndBillingLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-upgrade-ccp.partner.email.body.caption": [
    {
      "type": 0,
      "value": "Your customer's "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription has moved to the "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan"
    }
  ],
  "commerce.commerce-subscription-upgrade-ccp.partner.email.body.subscription-upgrade-message": [
    {
      "type": 0,
      "value": "As requested, your "
    },
    {
      "type": 1,
      "value": "oldOfferingName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription has moved to the "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan. Any extra usage from your previous plan will be charged to the existing payment method."
    }
  ],
  "commerce.commerce-subscription-upgrade-ccp.partner.message-template.email.subject": [
    {
      "type": 1,
      "value": "companyName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": " is now on "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan"
    }
  ],
  "commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.dc.info-message": [
    {
      "type": 0,
      "value": "As requested, your "
    },
    {
      "type": 1,
      "value": "previousOfferingName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription has moved to the "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan."
    }
  ],
  "commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.dc.metered-billing": [
    {
      "type": 0,
      "value": "Remember, you can only use up to the included quantity for each quota type. If you want a higher included quantity or the option to use extra, you’ll need to upgrade to a paid plan."
    }
  ],
  "commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.dc.metered.upgrade-trial-opt-out": [
    {
      "type": 0,
      "value": "Remember, if you go over the included quantity for any of the quota types on your subscription, extra usage charges will be added to your next invoice."
    }
  ],
  "commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.dc.metered.upgrade-trial-opt-out.ubp5-enforcement": [
    {
      "type": 0,
      "value": "Remember, if you go over the included quantity or allowance for any of the usage types on your subscription, extra usage charges will be added to your next invoice. Organization admins can set and adjust usage limits anytime."
    }
  ],
  "commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.partner.info-message": [
    {
      "type": 0,
      "value": "As requested, your customer’s "
    },
    {
      "type": 1,
      "value": "previousOfferingName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription has moved to the "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan."
    }
  ],
  "commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.partner.metered-billing": [
    {
      "type": 0,
      "value": "Remember, if your customer wants a higher included quantity, or wants the option to use extra, they’ll need to upgrade to a paid plan."
    }
  ],
  "commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.partner.metered.upgrade-trial-opt-out": [
    {
      "type": 0,
      "value": "Remember, if your customer goes over the included quantity for any of the quota types on the subscription, extra usage charges will be added to their next invoice."
    }
  ],
  "commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.partner.metered.upgrade-trial-opt-out.ubp5-enforcement": [
    {
      "type": 0,
      "value": "Remember, if your customer goes over the included quantity or allowance for any of the usage types on the subscription, extra usage charges will be added to their next invoice. You can set and adjust usage limits anytime."
    }
  ],
  "commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.message-template.dc.email.caption": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription has moved to the "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan"
    }
  ],
  "commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.message-template.dc.email.subject": [
    {
      "type": 0,
      "value": "You’re now on "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan"
    }
  ],
  "commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.message-template.email.partner.body.change-subscription": [
    {
      "type": 0,
      "value": "Change the subscription by visiting the "
    },
    {
      "type": 1,
      "value": "ppcSubscriptionsPageLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.message-template.partner.email.caption": [
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription has moved to the "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan"
    }
  ],
  "commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.message-template.partner.email.subject": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": " is now on the "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan"
    }
  ],
  "commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.dc.info-message": [
    {
      "type": 0,
      "value": "As requested, your "
    },
    {
      "type": 1,
      "value": "previousOfferingName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription has moved to the "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan."
    }
  ],
  "commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.dc.metered-billing": [
    {
      "type": 0,
      "value": "Remember, you can only use up to the included quantity for each quota type. If you want a higher included quantity or the option to use extra, you’ll need to upgrade to a paid plan."
    }
  ],
  "commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.dc.metered.upgrade-trial-opt-out": [
    {
      "type": 0,
      "value": "Remember, if you go over the included quantity for any of the quota types on your subscription, extra usage charges will be added to your next invoice."
    }
  ],
  "commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.dc.metered.upgrade-trial-opt-out.ubp5-enforcement": [
    {
      "type": 0,
      "value": "Remember, if your organization admin has enabled extra usage, any usage above the allowance may incur extra usage charges, which will be added to your bill at the end of your bill cycle. Organization admins can set and adjust usage limits anytime. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Find out more about usage charges and billing"
        }
      ],
      "type": 8,
      "value": "UsageChargesAndBillingLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.partner.info-message": [
    {
      "type": 0,
      "value": "As requested, your customer’s "
    },
    {
      "type": 1,
      "value": "previousOfferingName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription has moved to the "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan."
    }
  ],
  "commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.partner.metered-billing": [
    {
      "type": 0,
      "value": "Remember, if your customer wants a higher included quantity, or wants the option to use extra, they’ll need to upgrade to a paid plan."
    }
  ],
  "commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.partner.metered.upgrade-trial-opt-out": [
    {
      "type": 0,
      "value": "Remember, if your customer goes over the included quantity for any of the quota types on the subscription, extra usage charges will be added to their next invoice."
    }
  ],
  "commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.partner.metered.upgrade-trial-opt-out.ubp5-enforcement": [
    {
      "type": 0,
      "value": "Remember, any usage above the allowance may incur extra usage charges, which will be added to your customer's bill at the end of the bill cycle. Organization admins can set and adjust usage limits anytime. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Find out more about usage charges and billing"
        }
      ],
      "type": 8,
      "value": "UsageChargesAndBillingLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-upgrade-trial-opt-out-ccp.message-template.dc.email.caption": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription has moved to the "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan"
    }
  ],
  "commerce.commerce-subscription-upgrade-trial-opt-out-ccp.message-template.dc.email.subject": [
    {
      "type": 0,
      "value": "You’re now on "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan"
    }
  ],
  "commerce.commerce-subscription-upgrade-trial-opt-out-ccp.message-template.email.partner.body.change-subscription": [
    {
      "type": 0,
      "value": "Change the subscription by visiting the "
    },
    {
      "type": 1,
      "value": "ppcSubscriptionsPageLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-subscription-upgrade-trial-opt-out-ccp.message-template.partner.email.caption": [
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription has moved to the "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan"
    }
  ],
  "commerce.commerce-subscription-upgrade-trial-opt-out-ccp.message-template.partner.email.subject": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": " is now on the "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan"
    }
  ],
  "commerce.commerce-trial-extension-ad.created-date-bold.key": [
    {
      "type": 0,
      "value": "Created date: "
    }
  ],
  "commerce.commerce-trial-extension-ad.created-date-value": [
    {
      "type": 1,
      "value": "createdDate"
    }
  ],
  "commerce.commerce-trial-extension-ad.created-date.key": [
    {
      "type": 1,
      "value": "createdDateKey"
    }
  ],
  "commerce.commerce-trial-extension-ad.email.approved": [
    {
      "type": 1,
      "value": "initiatorName"
    },
    {
      "type": 0,
      "value": " has approved the request."
    }
  ],
  "commerce.commerce-trial-extension-ad.email.caption": [
    {
      "type": 0,
      "value": "Trial Extension "
    },
    {
      "type": 1,
      "value": "requestId"
    }
  ],
  "commerce.commerce-trial-extension-ad.email.declined": [
    {
      "type": 1,
      "value": "initiatorName"
    },
    {
      "type": 0,
      "value": " has declined the request. The request us now closed."
    }
  ],
  "commerce.commerce-trial-extension-ad.email.default": [
    {
      "type": 0,
      "value": "Your request for a trial extension has been received and is being processed."
    }
  ],
  "commerce.commerce-trial-extension-ad.email.in-review": [
    {
      "type": 1,
      "value": "initiatorName"
    },
    {
      "type": 0,
      "value": " is the assignee of the approval request."
    }
  ],
  "commerce.commerce-trial-extension-ad.email.reasons-provided": [
    {
      "type": 1,
      "value": "initiatorName"
    },
    {
      "type": 0,
      "value": " has provided supporting reasons."
    }
  ],
  "commerce.commerce-trial-extension-ad.email.reasons-requested": [
    {
      "type": 1,
      "value": "initiatorName"
    },
    {
      "type": 0,
      "value": " has requested supporting reasons."
    }
  ],
  "commerce.commerce-trial-extension-ad.email.request-cancelled": [
    {
      "type": 1,
      "value": "initiatorName"
    },
    {
      "type": 0,
      "value": " has cancelled the request. The request us now closed."
    }
  ],
  "commerce.commerce-trial-extension-ad.email.waiting-for-review": [
    {
      "type": 1,
      "value": "initiatorName"
    },
    {
      "type": 0,
      "value": " has submitted a new Trial Extension request."
    }
  ],
  "commerce.commerce-trial-extension-ad.initiator-id-bold.key": [
    {
      "type": 0,
      "value": "Initiator: "
    }
  ],
  "commerce.commerce-trial-extension-ad.initiator-id-value": [
    {
      "type": 1,
      "value": "initiator"
    }
  ],
  "commerce.commerce-trial-extension-ad.initiator-id.key": [
    {
      "type": 1,
      "value": "initiatorKey"
    }
  ],
  "commerce.commerce-trial-extension-ad.message-template.email.subject": [
    {
      "type": 0,
      "value": "Trial Extension "
    },
    {
      "type": 1,
      "value": "requestId"
    }
  ],
  "commerce.commerce-trial-extension-ad.request-id-bold.key": [
    {
      "type": 0,
      "value": "Request ID: "
    }
  ],
  "commerce.commerce-trial-extension-ad.request-id-value": [
    {
      "type": 1,
      "value": "requestId"
    }
  ],
  "commerce.commerce-trial-extension-ad.request-id.key": [
    {
      "type": 1,
      "value": "requestIdKey"
    }
  ],
  "commerce.commerce-trial-extension-ad.status-bold.key": [
    {
      "type": 0,
      "value": "Status: "
    }
  ],
  "commerce.commerce-trial-extension-ad.status-value": [
    {
      "type": 1,
      "value": "status"
    }
  ],
  "commerce.commerce-trial-extension-ad.status.key": [
    {
      "type": 1,
      "value": "statusKey"
    }
  ],
  "commerce.commerce-trial-extension-ad.subscription-bold.key": [
    {
      "type": 0,
      "value": "Subscription: "
    }
  ],
  "commerce.commerce-trial-extension-ad.subscription-value": [
    {
      "type": 1,
      "value": "entitlementNumber"
    }
  ],
  "commerce.commerce-trial-extension-ad.subscription.key": [
    {
      "type": 1,
      "value": "subscriptionKey"
    }
  ],
  "commerce.commerce-trial-extension-ad.support-ticket-id-bold.key": [
    {
      "type": 0,
      "value": "Support Ticket: "
    }
  ],
  "commerce.commerce-trial-extension-ad.support-ticket-id-value": [
    {
      "type": 1,
      "value": "supportTicket"
    }
  ],
  "commerce.commerce-trial-extension-ad.support-ticket-id.key": [
    {
      "type": 1,
      "value": "supportTicketKey"
    }
  ],
  "commerce.commerce-trial-extension-ad.total-trial-length-bold.key": [
    {
      "type": 0,
      "value": "Total days on trial so far: "
    }
  ],
  "commerce.commerce-trial-extension-ad.total-trial-length-value": [
    {
      "type": 1,
      "value": "currentTotalTrialLength"
    }
  ],
  "commerce.commerce-trial-extension-ad.total-trial-length.key": [
    {
      "type": 1,
      "value": "totalTrialLengthKey"
    }
  ],
  "commerce.commerce-trial-extension-ad.trial-length-bold.key": [
    {
      "type": 0,
      "value": "Request: "
    }
  ],
  "commerce.commerce-trial-extension-ad.trial-length-value": [
    {
      "type": 0,
      "value": "Extend trial for "
    },
    {
      "type": 1,
      "value": "netTrialDays"
    },
    {
      "type": 0,
      "value": " days"
    }
  ],
  "commerce.commerce-trial-extension-ad.trial-length.key": [
    {
      "type": 1,
      "value": "requestKey"
    }
  ],
  "commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.body.billable-usage-notice": [
    {
      "type": 0,
      "value": "Any usage beyond your allowance is considered extra usage. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "You won’t be billed for your extra usage at this time."
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "billingUrl"
    }
  ],
  "commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.body.billing-faq-url": [
    {
      "type": 0,
      "value": "When and how will I be billed?"
    }
  ],
  "commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.body.cta.view-usage": [
    {
      "type": 0,
      "value": "View usage"
    }
  ],
  "commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.body.disabled": [
    {
      "type": 0,
      "value": "An admin has disabled extra usage for "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " on your organization."
    }
  ],
  "commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.body.enabled": [
    {
      "type": 0,
      "value": "An admin has enabled extra usage for "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " on your organization."
    }
  ],
  "commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.body.limit-policy": [
    {
      "type": 0,
      "value": "Organization and billing admins can adjust this limit anytime."
    }
  ],
  "commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.body.limit-set": [
    {
      "type": 0,
      "value": "An admin has set the "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " limit on your organization. Your organization now allows monthly usage up to "
    },
    {
      "type": 1,
      "value": "limit"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.body.visit-admin": [
    {
      "type": 0,
      "value": "Visit Atlassian Administration to get more details on "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " usage in your organization."
    }
  ],
  "commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.subject.disabled": [
    {
      "type": 0,
      "value": "Extra "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " usage has been disabled"
    }
  ],
  "commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.subject.enabled": [
    {
      "type": 0,
      "value": "Extra "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " usage has been enabled"
    }
  ],
  "commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.body.billable-usage-notice": [
    {
      "type": 0,
      "value": "Any usage beyond your allowance is considered extra usage. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "You won’t be billed for your extra usage at this time."
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "billingUrl"
    }
  ],
  "commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.body.billing-faq-url": [
    {
      "type": 0,
      "value": "When and how will I be billed?"
    }
  ],
  "commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.body.policy": [
    {
      "type": 0,
      "value": "Organization and billing admins can adjust this limit anytime."
    }
  ],
  "commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.body.set": [
    {
      "type": 0,
      "value": "An admin has set the "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " limit on your organization. Your organization now allows monthly usage up to "
    },
    {
      "type": 1,
      "value": "limit"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.body.updated": [
    {
      "type": 0,
      "value": "An admin has updated the "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " limit on your organization. Your extra usage limit for "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " is now "
    },
    {
      "type": 1,
      "value": "limit"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.body.updated.unlimited": [
    {
      "type": 0,
      "value": "An admin has updated the "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " limit on your organization. Your extra usage for "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " has no set limit."
    }
  ],
  "commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.body.visit-admin": [
    {
      "type": 0,
      "value": "Visit Atlassian Administration to get more details on "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " usage in your organization."
    }
  ],
  "commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.caption.set": [
    {
      "type": 0,
      "value": "New "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " usage limit set"
    }
  ],
  "commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.caption.updated": [
    {
      "type": 0,
      "value": "New "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " usage limit updated"
    }
  ],
  "commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.subject.set": [
    {
      "type": 0,
      "value": "New "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " usage limit set"
    }
  ],
  "commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.subject.updated": [
    {
      "type": 0,
      "value": "New "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " usage limit updated"
    }
  ],
  "commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.email.body.cta.view-usage": [
    {
      "type": 0,
      "value": "View usage"
    }
  ],
  "commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.body.billable-usage-notice": [
    {
      "type": 0,
      "value": "Any usage beyond your customer's allowance is considered extra usage. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "You won’t be billed for your extra usage at this time."
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "billingUrl"
    }
  ],
  "commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.body.billing-faq-url": [
    {
      "type": 0,
      "value": "When and how will they be billed?"
    }
  ],
  "commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.body.policy": [
    {
      "type": 0,
      "value": "Organization and billing admins can adjust this limit anytime."
    }
  ],
  "commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.body.set": [
    {
      "type": 0,
      "value": "An admin has set the "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " limit for your customer's organization. They can now use up to "
    },
    {
      "type": 1,
      "value": "limit"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.body.updated": [
    {
      "type": 0,
      "value": "An admin has updated the "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " limit for your customer's organization. Your customer's extra usage limit for "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " is now "
    },
    {
      "type": 1,
      "value": "limit"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.body.updated.unlimited": [
    {
      "type": 0,
      "value": "An admin has updated the "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " limit for your customer's organization. Your customer's extra usage for "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " has no set limit."
    }
  ],
  "commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.body.visit-ppc": [
    {
      "type": 0,
      "value": "Visit PPC to get more details on your customer's "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " usage."
    }
  ],
  "commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.caption.set": [
    {
      "type": 0,
      "value": "Your customer's "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " usage limit has been set"
    }
  ],
  "commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.caption.updated": [
    {
      "type": 0,
      "value": "Your customer's "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " usage limit has been updated"
    }
  ],
  "commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.subject.set": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": ": New "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " usage limit set"
    }
  ],
  "commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.subject.set.without-company-name": [
    {
      "type": 0,
      "value": "New "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " usage limit set"
    }
  ],
  "commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.subject.updated": [
    {
      "type": 1,
      "value": "customerCompanyName"
    },
    {
      "type": 0,
      "value": ": New "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " usage limit updated"
    }
  ],
  "commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.subject.updated.without-company-name": [
    {
      "type": 0,
      "value": "New "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " usage limit updated"
    }
  ],
  "commerce.commerce-write-off-email-ccp.message-template.email.caption": [
    {
      "type": 0,
      "value": "Your invoice has been written off"
    }
  ],
  "commerce.commerce-write-off-email-ccp.message-template.email.no-refund": [
    {
      "type": 0,
      "value": "Please note that this credit note will not result in any refund since it is generated against an unpaid invoice."
    }
  ],
  "commerce.commerce-write-off-email-ccp.message-template.email.processed-write-off": [
    {
      "type": 0,
      "value": "We've processed a write-off for invoice "
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": ". If the invoice used any account balance, this has been returned to your account."
    }
  ],
  "commerce.commerce-write-off-email-ccp.message-template.email.subject": [
    {
      "type": 0,
      "value": "Write-off processed for invoice "
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    }
  ],
  "commerce.commerce.commerce-ship-to-party-archival-ccp.email.body.caption": [
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ": Sold to address deactivated"
    }
  ],
  "commerce.common-ui.manage-subscription-from-ppc-homepage": [
    {
      "type": 0,
      "value": "You can manage the subscription from our "
    },
    {
      "type": 1,
      "value": "partnerPurchasingCenterLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.common-ui.ppc": [
    {
      "type": 0,
      "value": "Partner Purchasing Center"
    }
  ],
  "commerce.common.atlassian-privacy-policy": [
    {
      "type": 0,
      "value": "Atlassian Privacy Policy"
    }
  ],
  "commerce.common.contact-us-to-talk-or-downgrade-to-free": [
    {
      "type": 1,
      "value": "contactUs"
    },
    {
      "type": 0,
      "value": " to talk about your situation, or "
    },
    {
      "type": 1,
      "value": "downGradeToFreePlan"
    },
    {
      "type": 0,
      "value": ". We suggest you export your data before your subscription gets canceled. For more information, see our "
    },
    {
      "type": 1,
      "value": "dataStorageFAQs"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.common.contact-your-bank-for-more-info": [
    {
      "type": 0,
      "value": "Contact your bank if you need more information about the issue."
    }
  ],
  "commerce.common.contacting-us": [
    {
      "type": 0,
      "value": "contacting us"
    }
  ],
  "commerce.common.data-retention-and-backup-policy": [
    {
      "type": 0,
      "value": "data retention and backup policies"
    }
  ],
  "commerce.common.data-storage-faqs": [
    {
      "type": 0,
      "value": "Data Storage FAQs"
    }
  ],
  "commerce.common.downgrade-to-a-free-plan": [
    {
      "type": 0,
      "value": "downgrade to a free plan"
    }
  ],
  "commerce.common.email.atl-logo.alt-text": [
    {
      "type": 0,
      "value": "Atlassian logo"
    }
  ],
  "commerce.common.email.billing-url": [
    {
      "type": 1,
      "value": "url"
    }
  ],
  "commerce.common.email.bitbucket-logo.alt-text": [
    {
      "type": 0,
      "value": "Bitbucket logo"
    }
  ],
  "commerce.common.email.compass-logo.alt-text": [
    {
      "type": 0,
      "value": "Compass logo"
    }
  ],
  "commerce.common.email.confluence-logo.alt-text": [
    {
      "type": 0,
      "value": "Confluence logo"
    }
  ],
  "commerce.common.email.csm-logo.alt-text": [
    {
      "type": 0,
      "value": "Customer Service Management logo"
    }
  ],
  "commerce.common.email.dx-logo.alt-text": [
    {
      "type": 0,
      "value": "DX logo"
    }
  ],
  "commerce.common.email.focus-logo.alt-text": [
    {
      "type": 0,
      "value": "Focus logo"
    }
  ],
  "commerce.common.email.guard-logo.alt-text": [
    {
      "type": 0,
      "value": "Guard logo"
    }
  ],
  "commerce.common.email.jpd-logo.alt-text": [
    {
      "type": 0,
      "value": "Jira Product Discovery logo"
    }
  ],
  "commerce.common.email.jsm-logo.alt-text": [
    {
      "type": 0,
      "value": "Jira Service Management logo"
    }
  ],
  "commerce.common.email.loom-logo.alt-text": [
    {
      "type": 0,
      "value": "Loom logo"
    }
  ],
  "commerce.common.email.rovo-dev-logo.alt-text": [
    {
      "type": 0,
      "value": "Rovo Dev logo"
    }
  ],
  "commerce.common.email.rovo-logo.alt-text": [
    {
      "type": 0,
      "value": "Rovo logo"
    }
  ],
  "commerce.common.email.siteAdmin": [
    {
      "type": 0,
      "value": "Administration"
    }
  ],
  "commerce.common.email.talent-logo.alt-text": [
    {
      "type": 0,
      "value": "Talent logo"
    }
  ],
  "commerce.common.if-you-are-unable-to-pay": [
    {
      "type": 0,
      "value": "If you're unable to make payments:"
    }
  ],
  "commerce.common.jira-logo.alt-text": [
    {
      "type": 0,
      "value": "Jira logo"
    }
  ],
  "commerce.common.manage-subscription-document-link": [
    {
      "type": 0,
      "value": "Manage your subscription for Standard and Premium plans"
    }
  ],
  "commerce.common.subscriptiom-reactivation-link": [
    {
      "type": 0,
      "value": "reactivate your subscription"
    }
  ],
  "commerce.common.view-subscription": [
    {
      "type": 0,
      "value": "You can view your subscription details from your site’s "
    },
    {
      "type": 1,
      "value": "siteAdmin"
    },
    {
      "type": 0,
      "value": " at "
    },
    {
      "type": 1,
      "value": "billingUrl"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.email.body.what-happens-if-your-customer-uses-extra": [
    {
      "type": 0,
      "value": "Remember, if your customer goes over the included quantity for any of the quota types on the subscription, extra usage charges will be added to their next invoice."
    }
  ],
  "commerce.email.changed-your-mind": [
    {
      "type": 0,
      "value": "Changed your mind?"
    }
  ],
  "commerce.email.cms.learn-more": [
    {
      "type": 0,
      "value": "Pay later by invoice."
    }
  ],
  "commerce.email.current-plan-details": [
    {
      "type": 0,
      "value": "More information about your current plan"
    }
  ],
  "commerce.email.dont-want-continue": [
    {
      "type": 0,
      "value": "Don't want to continue with the subscription?"
    }
  ],
  "commerce.email.dont-want-to-cancel": [
    {
      "type": 0,
      "value": "Don't want to cancel?"
    }
  ],
  "commerce.email.extra-usage-charge-for-metered-billing": [
    {
      "type": 0,
      "value": "Remember, if the included quantity or allowance for any of the usage types on the subscription are exceeded each billing cycle, extra usage charges will be added to the next invoice. "
    },
    {
      "type": 1,
      "value": "SubscriptionAndBillingSupportUrl"
    }
  ],
  "commerce.email.how-to": [
    {
      "type": 0,
      "value": "How to pay your invoices"
    }
  ],
  "commerce.email.included-products": [
    {
      "type": 0,
      "value": "Included products:"
    }
  ],
  "commerce.email.last-page": [
    {
      "type": 0,
      "value": "The last page of your invoice includes Atlassian’s account details and instructions on how to pay."
    }
  ],
  "commerce.email.list.billing-account": [
    {
      "type": 0,
      "value": "Billing account: "
    },
    {
      "type": 1,
      "value": "transactionAccountNum"
    }
  ],
  "commerce.email.list.credit-limit": [
    {
      "type": 0,
      "value": "Credit limit: "
    },
    {
      "type": 1,
      "value": "creditLimitFormatted"
    }
  ],
  "commerce.email.list.payment-method": [
    {
      "type": 0,
      "value": "Payment method: Pay later by invoice"
    }
  ],
  "commerce.email.list.payment-terms": [
    {
      "type": 0,
      "value": "Payment terms: "
    },
    {
      "type": 1,
      "value": "netTermsDuration"
    }
  ],
  "commerce.email.list.taxId": [
    {
      "type": 1,
      "value": "identifierName"
    },
    {
      "type": 0,
      "value": ": "
    },
    {
      "type": 1,
      "value": "id"
    }
  ],
  "commerce.email.new-plan-includes": [
    {
      "type": 0,
      "value": "Your new plan includes:"
    }
  ],
  "commerce.email.payment-days": [
    {
      "type": 0,
      "value": "You’ll have "
    },
    {
      "type": 1,
      "value": "netTermsDuration"
    },
    {
      "type": 0,
      "value": " days from the order invoice date to send your payment to Atlassian. You can pay using bank transfer or ACH/check (U.S. banks). "
    }
  ],
  "commerce.email.subscription-and-billing-support-url": [
    {
      "type": 0,
      "value": "More about how billing works."
    }
  ],
  "commerce.email.subscription-details": [
    {
      "type": 0,
      "value": "Here are the subscription details:"
    }
  ],
  "commerce.email.subscription-includes": [
    {
      "type": 0,
      "value": "Your subscription includes:"
    }
  ],
  "commerce.email.subscription-includes-quotes": [
    {
      "type": 0,
      "value": "The subscription also includes the following quotas:"
    }
  ],
  "commerce.email.subscription-list-title": [
    {
      "type": 0,
      "value": "Subscription list:"
    }
  ],
  "commerce.email.teamwork-collection": [
    {
      "type": 0,
      "value": "Teamwork Collection can make it easy for your whole organization to work more effectively together - "
    },
    {
      "type": 1,
      "value": "findOut"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.email.teamwork-collection.find-out": [
    {
      "type": 0,
      "value": "find out more about Atlassian collections"
    }
  ],
  "commerce.email.the.new-plan-includes": [
    {
      "type": 0,
      "value": "The new plan includes:"
    }
  ],
  "commerce.email.trial-ends": [
    {
      "type": 0,
      "value": "What happens when the trial ends?"
    }
  ],
  "commerce.email.view-subscription": [
    {
      "type": 0,
      "value": "View subscription"
    }
  ],
  "commerce.email.view-usage": [
    {
      "type": 0,
      "value": "View usage"
    }
  ],
  "commerce.email.want-to-keep your subscription": [
    {
      "type": 0,
      "value": "Want to keep your subscription?"
    }
  ],
  "commerce.email.what-do-i-need-to-do": [
    {
      "type": 0,
      "value": "What do I need to do?"
    }
  ],
  "commerce.email.what-do-you-need-to-do": [
    {
      "type": 0,
      "value": "What you need to do:"
    }
  ],
  "commerce.email.what-happens-when-trial-ends": [
    {
      "type": 0,
      "value": "What happens when the trial ends?"
    }
  ],
  "commerce.email.whats-next": [
    {
      "type": 0,
      "value": "What’s next?"
    }
  ],
  "commerce.learn-more": [
    {
      "type": 0,
      "value": "To learn more, see "
    },
    {
      "type": 1,
      "value": "learnMore"
    }
  ],
  "commerce.list.payment-terms": [
    {
      "type": 0,
      "value": "Payment terms: Net-"
    },
    {
      "type": 1,
      "value": "netTermsDuration"
    }
  ],
  "commerce.message-template.email.explore-all-features-button.explore-all-features": [
    {
      "type": 0,
      "value": "Explore all features"
    }
  ],
  "commerce.message-template.email.features-list.confluence.premium.analytics": [
    {
      "children": [
        {
          "type": 0,
          "value": "Analytics:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " See who has viewed a page and when"
    }
  ],
  "commerce.message-template.email.features-list.confluence.premium.atlassian-intelligence": [
    {
      "children": [
        {
          "type": 0,
          "value": "Atlassian intelligence:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Speed up your day-to-day work"
    }
  ],
  "commerce.message-template.email.features-list.confluence.premium.unlimited-users": [
    {
      "children": [
        {
          "type": 0,
          "value": "Unlimited users:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Add as many people as you need"
    }
  ],
  "commerce.message-template.email.features-list.confluence.standard.page-insights": [
    {
      "children": [
        {
          "type": 0,
          "value": "Page insights:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " See engagement data, like page views"
    }
  ],
  "commerce.message-template.email.features-list.confluence.standard.page-permissions": [
    {
      "children": [
        {
          "type": 0,
          "value": "Page permissions:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Choose who can view, edit, and comment"
    }
  ],
  "commerce.message-template.email.features-list.confluence.standard.unlimited-users": [
    {
      "children": [
        {
          "type": 0,
          "value": "Unlimited users:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Add as many people as you need"
    }
  ],
  "commerce.message-template.email.features-list.jira.premium.atlassian-intelligence": [
    {
      "children": [
        {
          "type": 0,
          "value": "Atlassian intelligence:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Speed up your day-to-day work"
    }
  ],
  "commerce.message-template.email.features-list.jira.premium.cross-team-planning": [
    {
      "children": [
        {
          "type": 0,
          "value": "Cross-team planning:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " See all projects and timelines in one place"
    }
  ],
  "commerce.message-template.email.features-list.jira.premium.unlimited-users": [
    {
      "children": [
        {
          "type": 0,
          "value": "Unlimited users:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Add as many people as you need"
    }
  ],
  "commerce.message-template.email.features-list.jira.standard.automation": [
    {
      "children": [
        {
          "type": 0,
          "value": "Automation:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Speed up your work and remove human error"
    }
  ],
  "commerce.message-template.email.features-list.jira.standard.data-residency": [
    {
      "children": [
        {
          "type": 0,
          "value": "Data residency:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Choose where your data is stored"
    }
  ],
  "commerce.message-template.email.features-list.jira.standard.unlimited-users": [
    {
      "children": [
        {
          "type": 0,
          "value": "Unlimited users:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Add as many people as you need"
    }
  ],
  "commerce.message-template.email.features-list.jpd.premium.atlassian-intelligence": [
    {
      "children": [
        {
          "type": 0,
          "value": "Atlassian intelligence:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Speed up your day-to-day work"
    }
  ],
  "commerce.message-template.email.features-list.jpd.premium.roadmaps": [
    {
      "children": [
        {
          "type": 0,
          "value": "Roadmaps:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " See multiple roadmaps in a single view"
    }
  ],
  "commerce.message-template.email.features-list.jpd.premium.unlimited-creators": [
    {
      "children": [
        {
          "type": 0,
          "value": "Unlimited creators:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " People who can create and manage projects"
    }
  ],
  "commerce.message-template.email.features-list.jpd.standard.automation": [
    {
      "children": [
        {
          "type": 0,
          "value": "Automation:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Speed up work and reduce human error"
    }
  ],
  "commerce.message-template.email.features-list.jpd.standard.published-views": [
    {
      "children": [
        {
          "type": 0,
          "value": "Published views:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Share read-only views with anyone"
    }
  ],
  "commerce.message-template.email.features-list.jpd.standard.unlimited-creators": [
    {
      "children": [
        {
          "type": 0,
          "value": "Unlimited creators:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " People who can create and manage projects"
    }
  ],
  "commerce.message-template.email.features-list.jsm.premium.ai-features": [
    {
      "children": [
        {
          "type": 0,
          "value": "AI features:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " AI-powered agents, search, and chat"
    }
  ],
  "commerce.message-template.email.features-list.jsm.premium.change-automation": [
    {
      "children": [
        {
          "type": 0,
          "value": "Change automation:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Gate deploys and automate record creation"
    }
  ],
  "commerce.message-template.email.features-list.jsm.premium.unlimited-agents": [
    {
      "children": [
        {
          "type": 0,
          "value": "Unlimited agents:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Grow your team, with no cap on customers"
    }
  ],
  "commerce.message-template.email.features-list.jsm.standard.branded-help-center": [
    {
      "children": [
        {
          "type": 0,
          "value": "Branded help center:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Use your company's branding and URLs"
    }
  ],
  "commerce.message-template.email.features-list.jsm.standard.enhanced-support": [
    {
      "children": [
        {
          "type": 0,
          "value": "Enhanced support:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Get business hour support from our experts"
    }
  ],
  "commerce.message-template.email.features-list.jsm.standard.unlimited-agents": [
    {
      "children": [
        {
          "type": 0,
          "value": "Unlimited agents:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Grow your team, with no cap on customers"
    }
  ],
  "commerce.message-template.email.features-list.loom.business-ai.advanced-editing": [
    {
      "children": [
        {
          "type": 0,
          "value": "Advanced editing:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Trim, stitch, remove silence and filler words"
    }
  ],
  "commerce.message-template.email.features-list.loom.business-ai.unlimited-recording-time": [
    {
      "children": [
        {
          "type": 0,
          "value": "Unlimited recording time:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Record for as long as you want"
    }
  ],
  "commerce.message-template.email.features-list.loom.business-ai.unlimited-videos": [
    {
      "children": [
        {
          "type": 0,
          "value": "Unlimited videos:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Record as many videos as you want"
    }
  ],
  "commerce.message-template.email.features-list.loom.business.editing": [
    {
      "children": [
        {
          "type": 0,
          "value": "Editing:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Trim out mistakes or stitch multiple videos together"
    }
  ],
  "commerce.message-template.email.features-list.loom.business.unlimited-recording-time": [
    {
      "children": [
        {
          "type": 0,
          "value": "Unlimited recording time:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Record for as long as you want"
    }
  ],
  "commerce.message-template.email.features-list.loom.business.unlimited-videos": [
    {
      "children": [
        {
          "type": 0,
          "value": "Unlimited videos:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Record as many videos as you want"
    }
  ],
  "commerce.message-template.email.features-list.service-collection.premium.advanced-aiops": [
    {
      "children": [
        {
          "type": 0,
          "value": "Advanced AIOps:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Fast alert grouping, incident creation, and more"
    }
  ],
  "commerce.message-template.email.features-list.service-collection.premium.ai-agents": [
    {
      "children": [
        {
          "type": 0,
          "value": "AI agents:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Save time and use AI for basic conversational support"
    }
  ],
  "commerce.message-template.email.features-list.service-collection.premium.asset-management": [
    {
      "children": [
        {
          "type": 0,
          "value": "Asset management:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Manage the lifecycle of assets and services"
    }
  ],
  "commerce.message-template.email.features-list.service-collection.standard.ai-powered-agents": [
    {
      "children": [
        {
          "type": 0,
          "value": "AI-powered agents:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Automate support, resolve requests faster"
    }
  ],
  "commerce.message-template.email.features-list.service-collection.standard.custom-help-center": [
    {
      "children": [
        {
          "type": 0,
          "value": "Custom help center:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Deliver a seamless support experience"
    }
  ],
  "commerce.message-template.email.features-list.service-collection.standard.unlimited-emails": [
    {
      "children": [
        {
          "type": 0,
          "value": "Unlimited emails:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Talk to customers as much as you need"
    }
  ],
  "commerce.message-template.email.upgrade-benefits.compass.body.customizations": [
    {
      "type": 0,
      "value": "More customizations"
    }
  ],
  "commerce.message-template.email.upgrade-benefits.compass.body.increased-user-limits": [
    {
      "type": 0,
      "value": "Increased user limits"
    }
  ],
  "commerce.message-template.email.upgrade-benefits.compass.body.reusable-templates": [
    {
      "type": 0,
      "value": "20 reusable templates"
    }
  ],
  "commerce.message-template.email.upgrade-benefits.service-collection.body.agents-and-customers": [
    {
      "type": 0,
      "value": "Up to 20,000 agents and unlimited customers"
    }
  ],
  "commerce.message-template.email.upgrade-benefits.service-collection.body.ai-powered-support": [
    {
      "type": 0,
      "value": "AI-powered employee support, operations, and customer service"
    }
  ],
  "commerce.message-template.email.upgrade-benefits.service-collection.body.audit-logs-data-residency": [
    {
      "type": 0,
      "value": "Audit logs and multi-region data residency"
    }
  ],
  "commerce.message-template.email.upgrade-benefits.service-collection.body.custom-help-center": [
    {
      "type": 0,
      "value": "Custom-branded help center"
    }
  ],
  "commerce.message-template.email.upgrade-benefits.service-collection.body.storage": [
    {
      "type": 0,
      "value": "250 GB of storage"
    }
  ],
  "commerce.message-template.email.upgrade-benefits.service-collection.body.team-experts": [
    {
      "type": 0,
      "value": "9 to 5 support from Atlassian's team of experts"
    }
  ],
  "commerce.message-template.email.upgrade-benefits.service-collection.body.unlimited-email-notifications": [
    {
      "type": 0,
      "value": "Unlimited email notifications"
    }
  ],
  "commerce.message-template.email.upgrade-benifits.compass.body.storage": [
    {
      "type": 0,
      "value": "One year of data retention"
    }
  ],
  "commerce.message-template.email.upgrade-benifits.compass.body.team-experts": [
    {
      "type": 0,
      "value": "9 to 5 support from Atlassian’s team of experts"
    }
  ],
  "commerce.message-template.email.upgrade-benifits.confluence.body.increased-user-limits": [
    {
      "type": 0,
      "value": "Increased user limits"
    }
  ],
  "commerce.message-template.email.upgrade-benifits.confluence.body.page-analytics": [
    {
      "type": 0,
      "value": "Page analytics"
    }
  ],
  "commerce.message-template.email.upgrade-benifits.confluence.body.space-and-page-permissions": [
    {
      "type": 0,
      "value": "Space and page permissions"
    }
  ],
  "commerce.message-template.email.upgrade-benifits.confluence.body.storage": [
    {
      "type": 0,
      "value": "250 GB of storage"
    }
  ],
  "commerce.message-template.email.upgrade-benifits.confluence.body.team-experts": [
    {
      "type": 0,
      "value": "9 to 5 support from Atlassian’s team of experts"
    }
  ],
  "commerce.message-template.email.upgrade-benifits.jira.body.create-issues": [
    {
      "type": 0,
      "value": "Anonymous access to let external users view and create issues"
    }
  ],
  "commerce.message-template.email.upgrade-benifits.jira.body.increased-user-limits": [
    {
      "type": 0,
      "value": "Increased user limits"
    }
  ],
  "commerce.message-template.email.upgrade-benifits.jira.body.issue-permissions": [
    {
      "type": 0,
      "value": "Advanced project and issue permissions"
    }
  ],
  "commerce.message-template.email.upgrade-benifits.jira.body.storage": [
    {
      "type": 0,
      "value": "250 GB of storage"
    }
  ],
  "commerce.message-template.email.upgrade-benifits.jira.body.team-experts": [
    {
      "type": 0,
      "value": "9 to 5 support from Atlassian’s team of experts"
    }
  ],
  "commerce.message-template.email.upgrade-benifits.jpd.body.custom-project-roles": [
    {
      "type": 0,
      "value": "Custom project roles"
    }
  ],
  "commerce.message-template.email.upgrade-benifits.jpd.body.storage": [
    {
      "type": 0,
      "value": "250 GB of storage"
    }
  ],
  "commerce.message-template.email.upgrade-benifits.jpd.body.team-experts": [
    {
      "type": 0,
      "value": "9 to 5 support from Atlassian’s team of experts"
    }
  ],
  "commerce.message-template.email.upgrade-benifits.jpd.body.unlimited-creators": [
    {
      "type": 0,
      "value": "Unlimited creators"
    }
  ],
  "commerce.message-template.email.upgrade-benifits.jsm.body.automation-rules-per-month": [
    {
      "type": 0,
      "value": "500 project automation rules per month"
    }
  ],
  "commerce.message-template.email.upgrade-benifits.jsm.body.increased-user-limits": [
    {
      "type": 0,
      "value": "Increased user limits"
    }
  ],
  "commerce.message-template.email.upgrade-benifits.jsm.body.storage": [
    {
      "type": 0,
      "value": "250 GB of storage"
    }
  ],
  "commerce.message-template.email.upgrade-benifits.jsm.body.team-experts": [
    {
      "type": 0,
      "value": "9 to 5 support from Atlassian’s team of experts"
    }
  ],
  "commerce.message-template.email.upgrade-benifits.jsm.body.track-changes": [
    {
      "type": 0,
      "value": "Audit logs to troubleshoot and track changes"
    }
  ],
  "commerce.message-template.next-steps": [
    {
      "type": 0,
      "value": "Next steps:"
    }
  ],
  "commerce.message-template.start-set-up": [
    {
      "type": 0,
      "value": "Start set up"
    }
  ],
  "commerce.next-bill-estimate-common.key": [
    {
      "type": 0,
      "value": "Next estimated bill (prorated):"
    }
  ],
  "commerce.partner-manage-subscriptions": [
    {
      "type": 0,
      "value": "Your customer contact can cancel the subscription at any time from "
    },
    {
      "type": 1,
      "value": "redirectionUrl"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.partner-name.key": [
    {
      "type": 0,
      "value": "Atlassian billing partner:"
    }
  ],
  "commerce.partner-name.value": [
    {
      "type": 1,
      "value": "partnerName"
    }
  ],
  "commerce.payment-option-details": [
    {
      "type": 0,
      "value": "This payment option allows you to buy your Atlassian products now, and pay within\n    \t\t\t\t"
    },
    {
      "type": 1,
      "value": "netTermsDuration"
    },
    {
      "type": 0,
      "value": " days."
    }
  ],
  "commerce.requested-by-common.key": [
    {
      "type": 0,
      "value": "Requested by:"
    }
  ],
  "commerce.requested-by-common.value": [
    {
      "type": 1,
      "value": "orderPlacedBy"
    }
  ],
  "commerce.requested-by-common.value-with-email": [
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": " ("
    },
    {
      "type": 1,
      "value": "emailLink"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "commerce.requested-by-common.value-without-email": [
    {
      "type": 1,
      "value": "name"
    }
  ],
  "commerce.reseller-manage-subscriptions": [
    {
      "type": 0,
      "value": "Your customer contact can cancel the subscription at any time from the "
    },
    {
      "type": 1,
      "value": "redirectionUrl"
    },
    {
      "type": 0,
      "value": " page."
    }
  ],
  "commerce.reseller-manage-subscriptions-subscription-overview": [
    {
      "type": 0,
      "value": "Subscription overview"
    }
  ],
  "commerce.servco-post-auto-uplift-email-notification.email.banner-alt": [
    {
      "type": 0,
      "value": "Service Collection"
    }
  ],
  "commerce.servco-post-auto-uplift-email-notification.email.button-v2": [
    {
      "type": 0,
      "value": "See details"
    }
  ],
  "commerce.servco-post-auto-uplift-email-notification.email.csm-label": [
    {
      "type": 0,
      "value": "Customer Service Management"
    }
  ],
  "commerce.servco-post-auto-uplift-email-notification.email.heading": [
    {
      "type": 0,
      "value": "Jira Service Management is now part of Service Collection"
    }
  ],
  "commerce.servco-post-auto-uplift-email-notification.email.help-message": [
    {
      "type": 0,
      "value": "If you have any questions or need assistance exploring the new features, please don't hesitate to reach out."
    }
  ],
  "commerce.servco-post-auto-uplift-email-notification.email.instruction-how-to-add-label": [
    {
      "type": 0,
      "value": "Ready to add to your sites. "
    },
    {
      "type": 1,
      "value": "viewInstructions"
    }
  ],
  "commerce.servco-post-auto-uplift-email-notification.email.instructions.url": [
    {
      "type": 0,
      "value": "View Instructions"
    }
  ],
  "commerce.servco-post-auto-uplift-email-notification.email.intro": [
    {
      "type": 0,
      "value": "We're excited to announce that as of "
    },
    {
      "type": 1,
      "value": "month"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "day"
    },
    {
      "type": 0,
      "value": ", "
    },
    {
      "type": 1,
      "value": "year"
    },
    {
      "type": 0,
      "value": ", your Jira Service Management has become part of Service Collection. Try the new Customer Service Management app and enjoy extra features, with no changes to your Jira Service Management."
    }
  ],
  "commerce.servco-post-auto-uplift-email-notification.email.jsm-label": [
    {
      "type": 0,
      "value": "JSM"
    }
  ],
  "commerce.servco-post-auto-uplift-email-notification.email.jsm-label.v2": [
    {
      "type": 0,
      "value": "Jira Service Management"
    }
  ],
  "commerce.servco-post-auto-uplift-email-notification.email.new-app-label": [
    {
      "type": 0,
      "value": "New app"
    }
  ],
  "commerce.servco-post-auto-uplift-email-notification.email.on-your-entitlement": [
    {
      "type": 0,
      "value": "On your entitlement:"
    }
  ],
  "commerce.servco-post-auto-uplift-email-notification.email.received-because": [
    {
      "type": 0,
      "value": "You received this email because you're an admin for "
    },
    {
      "type": 1,
      "value": "orgName"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "commerce.servco-post-auto-uplift-email-notification.email.sent-by": [
    {
      "type": 0,
      "value": "This message was sent to you by Atlassian Administration."
    }
  ],
  "commerce.servco-post-auto-uplift-email-notification.message-template.email.subject": [
    {
      "type": 0,
      "value": "Jira Service Management has moved to Service Collection"
    }
  ],
  "commerce.ship-to-information.address-key": [
    {
      "type": 0,
      "value": "Address:"
    }
  ],
  "commerce.ship-to-information.address-value": [
    {
      "type": 1,
      "value": "soldToAddress"
    }
  ],
  "commerce.ship-to-information.company-name-key": [
    {
      "type": 0,
      "value": "Company:"
    }
  ],
  "commerce.ship-to-information.company-name-key-alt-customer": [
    {
      "type": 0,
      "value": "Customer:"
    }
  ],
  "commerce.ship-to-information.company-name-value": [
    {
      "type": 1,
      "value": "soldToCompanyName"
    }
  ],
  "commerce.ship-to-information.end-customer-contact-key": [
    {
      "type": 0,
      "value": "Customer contact:"
    }
  ],
  "commerce.ship-to-information.end-customer-contact-value": [
    {
      "type": 1,
      "value": "endCustomerContacts"
    }
  ],
  "commerce.ship-to-information.invoice-number-key": [
    {
      "type": 0,
      "value": "Invoice number:"
    }
  ],
  "commerce.ship-to-information.invoice-number-value": [
    {
      "type": 1,
      "value": "invoiceNumber"
    }
  ],
  "commerce.subscription-common.entitlement-details": [
    {
      "type": 0,
      "value": "("
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "commerce.subscription-common.entitlement-details-with-org-name": [
    {
      "type": 0,
      "value": "("
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": ") | "
    },
    {
      "type": 1,
      "value": "orgName"
    }
  ],
  "commerce.subscription-common.entitlement-details-with-site-url": [
    {
      "type": 0,
      "value": "("
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": " | "
    },
    {
      "type": 1,
      "value": "siteURL"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "commerce.subscription-common.entitlement-details-without-orgName": [
    {
      "type": 0,
      "value": "("
    },
    {
      "type": 1,
      "value": "entitlementNumber"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "commerce.subscription-common.key": [
    {
      "type": 0,
      "value": "Subscription:"
    }
  ],
  "commerce.subscription-common.new-quote-total-key": [
    {
      "type": 0,
      "value": "New quote total:"
    }
  ],
  "commerce.subscription-common.old-quote-total-key": [
    {
      "type": 0,
      "value": "Old quote total:"
    }
  ],
  "commerce.subscription-common.quote-number-key": [
    {
      "type": 0,
      "value": "Quote:"
    }
  ],
  "commerce.subscription-common.quote-number-value": [
    {
      "type": 1,
      "value": "quoteNumber"
    }
  ],
  "commerce.subscription-common.quote-total-key": [
    {
      "type": 0,
      "value": "Quote total:"
    }
  ],
  "commerce.subscription-common.quote-total-value": [
    {
      "type": 1,
      "value": "currency"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "amount"
    }
  ],
  "commerce.subscription-common.value-with-offering": [
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "entitlementDetails"
    }
  ],
  "commerce.subscription-common.value-with-offering-without-entitlement": [
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " "
    }
  ],
  "commerce.subscription-common.value-with-pricing-plan": [
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "pricingPlanName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "entitlementDetails"
    }
  ],
  "commerce.subscription-common.value-with-product": [
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "entitlementDetails"
    }
  ],
  "commerce.test-message.email.body": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "commerce.test-message.email.body.hello": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "commerce.test-message.email.body.regards": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "commerce.test-message.email.body.signoff": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "common.cloud-payment-retry-actions.admin-hub-url": [
    {
      "type": 0,
      "value": "admin.atlassian.com"
    }
  ],
  "common.cloud-payment-retry-actions.atlassian-administration": [
    {
      "type": 0,
      "value": "Atlassian administration"
    }
  ],
  "common.cloud-payment-retry-actions.billing-console-url": [
    {
      "type": 0,
      "value": "admin.atlassian.com/billing"
    }
  ],
  "common.cloud-payment-retry-actions.billing-overview": [
    {
      "type": 0,
      "value": "Billing overview"
    }
  ],
  "common.cloud-payment-retry-actions.change-plan": [
    {
      "type": 0,
      "value": "Change plan"
    }
  ],
  "common.cloud-payment-retry-actions.contact-supportt": [
    {
      "type": 0,
      "value": "If you need to speak to our team, you may "
    },
    {
      "type": 1,
      "value": "element"
    },
    {
      "type": 0,
      "value": " to the Atlassian Support Team."
    }
  ],
  "common.cloud-payment-retry-actions.contact-us-heading": [
    {
      "type": 0,
      "value": "Contact us:"
    }
  ],
  "common.cloud-payment-retry-actions.data-storage-faq": [
    {
      "type": 0,
      "value": "Data Storage FAQs"
    }
  ],
  "common.cloud-payment-retry-actions.downgrade-heading": [
    {
      "type": 0,
      "value": "Downgrade to a Free plan:"
    }
  ],
  "common.cloud-payment-retry-actions.export-data": [
    {
      "type": 0,
      "value": "We advise you to export your business data from your Atlassian instance. For more information, see our "
    },
    {
      "type": 1,
      "value": "element"
    }
  ],
  "common.cloud-payment-retry-actions.export-data-heading": [
    {
      "type": 0,
      "value": "Export your data:"
    }
  ],
  "common.cloud-payment-retry-actions.free": [
    {
      "type": 0,
      "value": "Free"
    }
  ],
  "common.cloud-payment-retry-actions.free-plan-change": [
    {
      "type": 0,
      "value": "Change to the Free plan at "
    },
    {
      "type": 1,
      "value": "link"
    },
    {
      "type": 0,
      "value": ". In "
    },
    {
      "type": 1,
      "value": "billingOverview"
    },
    {
      "type": 0,
      "value": ", select "
    },
    {
      "type": 1,
      "value": "manage"
    },
    {
      "type": 0,
      "value": " in the "
    },
    {
      "type": 1,
      "value": "subscriptions"
    },
    {
      "type": 0,
      "value": " section. In "
    },
    {
      "type": 1,
      "value": "subscriptionDetails"
    },
    {
      "type": 0,
      "value": ", select "
    },
    {
      "type": 1,
      "value": "manage"
    },
    {
      "type": 0,
      "value": " for your product. In "
    },
    {
      "type": 1,
      "value": "subscriptionDetails"
    },
    {
      "type": 0,
      "value": ", select "
    },
    {
      "type": 1,
      "value": "planChange"
    },
    {
      "type": 0,
      "value": ". Select the "
    },
    {
      "type": 1,
      "value": "free"
    },
    {
      "type": 0,
      "value": " plan and confirm"
    }
  ],
  "common.cloud-payment-retry-actions.here-are-actions": [
    {
      "type": 0,
      "value": "Here are some actions we suggest you take:"
    }
  ],
  "common.cloud-payment-retry-actions.manage": [
    {
      "type": 0,
      "value": "Manage"
    }
  ],
  "common.cloud-payment-retry-actions.manage-users": [
    {
      "type": 0,
      "value": "Manage users"
    }
  ],
  "common.cloud-payment-retry-actions.reduce-users": [
    {
      "type": 0,
      "value": "If applicable, you'll first need to reduce users to 10 or fewer (three agents or fewer for Jira Service Management). Go to your site's admin at "
    },
    {
      "type": 1,
      "value": "link"
    },
    {
      "type": 0,
      "value": ". In "
    },
    {
      "type": 1,
      "value": "admin"
    },
    {
      "type": 0,
      "value": ", select "
    },
    {
      "type": 1,
      "value": "manage"
    },
    {
      "type": 0,
      "value": ". Find users you want to remove, and select "
    },
    {
      "type": 1,
      "value": "showDetails"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "common.cloud-payment-retry-actions.show-details": [
    {
      "type": 0,
      "value": "Show details &gt; Actions &gt; Remove user"
    }
  ],
  "common.cloud-payment-retry-actions.submit-ticket": [
    {
      "type": 0,
      "value": "Submit a ticket"
    }
  ],
  "common.cloud-payment-retry-actions.subscription-details": [
    {
      "type": 0,
      "value": "Subscription details"
    }
  ],
  "common.cloud-payment-retry-actions.subscriptions": [
    {
      "type": 0,
      "value": "Subscriptions"
    }
  ],
  "common.cloud-payment-retry-actions.what-if-unable": [
    {
      "type": 0,
      "value": "What if I'm unable to make payments?"
    }
  ],
  "common.invoice.manage-subscriptions.partner-info": [
    {
      "type": 0,
      "value": "To manage subscriptions, visit our Partner Purchasing Center (PPC)."
    }
  ],
  "common.invoice.manage-subscriptions.subscription-info": [
    {
      "type": 0,
      "value": "To view or manage your invoices and subscription, go to your site's Administration."
    }
  ],
  "post-office.commerce-access-invalid-payment-hams.caption": [
    {
      "type": 0,
      "value": "Action needed: Retry your payment with 3DS authentication"
    }
  ],
  "post-office.commerce-access-invalid-payment-hams.error-message.access": [
    {
      "type": 0,
      "value": "We couldn’t process your payment for Atlassian Access since we need your help to complete 3-D Secure (3DS) authentication. 3DS is a mechanism that makes your online card transactions more secure."
    }
  ],
  "post-office.commerce-access-invalid-payment-hams.error-message.bitbucket": [
    {
      "type": 0,
      "value": "We couldn’t process your payment for Bitbucket ("
    },
    {
      "type": 1,
      "value": "bbAccountName"
    },
    {
      "type": 0,
      "value": ") since we need your help to complete 3-D Secure (3DS) authentication. 3DS is a mechanism that makes your online card transactions more secure."
    }
  ],
  "post-office.commerce-access-invalid-payment-hams.error-message.cloud": [
    {
      "type": 0,
      "value": "We couldn't process your payment for Atlassian Cloud since we need your help to complete 3-D Secure (3DS) authentication. 3DS is a mechanism that makes your online card transactions more secure."
    }
  ],
  "post-office.commerce-access-invalid-payment-hams.error-message.server": [
    {
      "type": 0,
      "value": "We couldn’t process your payment for "
    },
    {
      "type": 1,
      "value": "productInfoString"
    },
    {
      "type": 0,
      "value": " since we need your help to complete 3-D Secure (3DS) authentication. 3DS is a mechanism that makes your online card transactions more secure."
    }
  ],
  "post-office.commerce-access-invalid-payment-hams.retry-button": [
    {
      "type": 0,
      "value": "Retry Payment"
    }
  ],
  "post-office.commerce-access-invalid-payment-hams.retry-message": [
    {
      "type": 0,
      "value": "Please retry making the payment and complete 3DS authentication. You may be asked to verify through an app, enter a confirmation code sent to your phone, or asked to authenticate in a different way."
    }
  ],
  "post-office.commerce-common.Contact-us": [
    {
      "type": 0,
      "value": "Contact us"
    }
  ],
  "post-office.commerce-common.atlassian-support-team": [
    {
      "type": 0,
      "value": "Atlassian Support Team"
    }
  ],
  "post-office.commerce-common.auto-upgrade-subscription-details.plan.label": [
    {
      "type": 0,
      "value": "Plan"
    }
  ],
  "post-office.commerce-common.auto-upgrade-subscription-details.plan.value": [
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " Standard ("
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " user"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " users"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "userCount"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "post-office.commerce-common.auto-upgrade-subscription-details.plan.value.no-user-count": [
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " Standard"
    }
  ],
  "post-office.commerce-common.auto-upgrade-subscription-details.switch-back-to-free.heading": [
    {
      "type": 0,
      "value": "Not ready to upgrade?"
    }
  ],
  "post-office.commerce-common.auto-upgrade-subscription-details.switch-back-to-free.switch-back-to-free-admin": [
    {
      "type": 0,
      "value": "You can switch back to a Free plan by "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "reducing your user count"
        }
      ],
      "type": 8,
      "value": "link"
    },
    {
      "type": 0,
      "value": " to 10 or fewer."
    }
  ],
  "post-office.commerce-common.auto-upgrade-subscription-details.switch-back-to-free.switch-back-to-free-non-admin": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " admin can switch back to a Free plan by reducing your user count to 10 or fewer."
    }
  ],
  "post-office.commerce-common.blocks.regards": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "post-office.commerce-common.blocks.thanks": [
    {
      "type": 0,
      "value": "Thanks,"
    }
  ],
  "post-office.commerce-common.cheers": [
    {
      "type": 0,
      "value": "Cheers,"
    }
  ],
  "post-office.commerce-common.cheers.from-atlassian-team": [
    {
      "type": 0,
      "value": "The Atlassian team"
    }
  ],
  "post-office.commerce-common.cheers.from-atlassians": [
    {
      "type": 0,
      "value": "The Atlassians"
    }
  ],
  "post-office.commerce-common.choose-plan-link": [
    {
      "type": 0,
      "value": "Choose plan"
    }
  ],
  "post-office.commerce-common.choose-plan.billing-console": [
    {
      "type": 0,
      "value": "Keep Premium plan"
    }
  ],
  "post-office.commerce-common.choose-plan.choose-plan.billing-console": [
    {
      "type": 0,
      "value": "Choose plan"
    }
  ],
  "post-office.commerce-common.consumption.included-quantity-details": [
    {
      "type": 1,
      "value": "includedQuantity"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "includedQuantityUnit"
    }
  ],
  "post-office.commerce-common.consumption.summary-included-quantity": [
    {
      "type": 0,
      "value": "Included quantity"
    }
  ],
  "post-office.commerce-common.consumptionl.summary-consumed-quantity": [
    {
      "type": 0,
      "value": "Consumed quantity"
    }
  ],
  "post-office.commerce-common.consumptionl.summary-consumed-quantity-details": [
    {
      "type": 1,
      "value": "consumedQuantity"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "consumedQuantityUnit"
    }
  ],
  "post-office.commerce-common.consumptionl.summary.consumption-percentage": [
    {
      "type": 1,
      "value": "usageMilestone"
    },
    {
      "type": 0,
      "value": "% consumed"
    }
  ],
  "post-office.commerce-common.contact-support-button.partner": [
    {
      "type": 0,
      "value": "Contact Support"
    }
  ],
  "post-office.commerce-common.contact-us": [
    {
      "type": 0,
      "value": "contact us"
    }
  ],
  "post-office.commerce-common.email-header-v2.atlassian-logo-alt": [
    {
      "type": 0,
      "value": "Atlassian Jira"
    }
  ],
  "post-office.commerce-common.email-header-v2.atlassian-logo-alt-confluence": [
    {
      "type": 0,
      "value": "Atlassian Confluence"
    }
  ],
  "post-office.commerce-common.email-header-v2.atlassian-logo-alt-jira-product-discovery": [
    {
      "type": 0,
      "value": "Atlassian Jira Product Discovery"
    }
  ],
  "post-office.commerce-common.email-header-v2.atlassian-logo-alt-jira-service-management": [
    {
      "type": 0,
      "value": "Atlassian Jira Service Management"
    }
  ],
  "post-office.commerce-common.email-header-v2.atlassian-logo-alt-loom": [
    {
      "type": 0,
      "value": "Atlassian Loom"
    }
  ],
  "post-office.commerce-common.email-header-v2.atlassian-logo-alt-service-collection": [
    {
      "type": 0,
      "value": "Atlassian Service Collection"
    }
  ],
  "post-office.commerce-common.email-header-v3.atlassian-logo-alt": [
    {
      "type": 0,
      "value": "Atlassian Jira"
    }
  ],
  "post-office.commerce-common.email-header-v3.atlassian-logo-alt-confluence": [
    {
      "type": 0,
      "value": "Atlassian Confluence"
    }
  ],
  "post-office.commerce-common.email-header-v3.atlassian-logo-alt-jira-product-discovery": [
    {
      "type": 0,
      "value": "Atlassian Jira Product Discovery"
    }
  ],
  "post-office.commerce-common.email-header-v3.atlassian-logo-alt-loom": [
    {
      "type": 0,
      "value": "Atlassian Loom"
    }
  ],
  "post-office.commerce-common.email-header-v3.atlassian-logo-alt-teamwork-collection": [
    {
      "type": 0,
      "value": "Atlassian Teamwork Collection"
    }
  ],
  "post-office.commerce-common.email-header.atlassian-logo-alt": [
    {
      "type": 0,
      "value": "Atlassian"
    }
  ],
  "post-office.commerce-common.email.plan-section.description.end-of-trial-with-pde": [
    {
      "children": [
        {
          "type": 0,
          "value": "Switch plans anytime."
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " 30-day money back guarantee if you forget to cancel."
    }
  ],
  "post-office.commerce-common.email.plan-section.explore-plan.link-description.end-of-trial-with-pde": [
    {
      "children": [
        {
          "type": 0,
          "value": "Explore all plans →"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "post-office.commerce-common.email.subscription-details-section.billing-cycle-subtitle.end-of-trial-with-pde": [
    {
      "type": 0,
      "value": "Billing cycle"
    }
  ],
  "post-office.commerce-common.email.subscription-details-section.first-bill-estimate-subtitle.end-of-trial-with-pde": [
    {
      "type": 0,
      "value": "First bill estimate"
    }
  ],
  "post-office.commerce-common.email.subscription-details-section.first-bill-estimate-suffix.end-of-trial-with-pde": [
    {
      "type": 0,
      "value": " (Excludes taxes)"
    }
  ],
  "post-office.commerce-common.email.subscription-details-section.plan-subtitle.end-of-trial-with-pde": [
    {
      "type": 0,
      "value": "Plan"
    }
  ],
  "post-office.commerce-common.email.subscription-details-section.title.end-of-trial-with-pde": [
    {
      "type": 0,
      "value": "Subscription details"
    }
  ],
  "post-office.commerce-common.email.subscription-details-section.trial-ends-subtitle.end-of-trial-with-pde": [
    {
      "type": 0,
      "value": "Trial ends"
    }
  ],
  "post-office.commerce-common.email.subscription.deactivate-consequence-section.deactivate-info": [
    {
      "type": 0,
      "value": "Add payment details before your trial ends on "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "trialEndDate"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " to keep all your users and features. If you don’t add payment details or reduce your user count to "
    },
    {
      "type": 1,
      "value": "ceiling"
    },
    {
      "type": 0,
      "value": " or fewer by "
    },
    {
      "type": 1,
      "value": "trialEndDate"
    },
    {
      "type": 0,
      "value": ", you will lose access to "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " and your data will be permanently deleted."
    }
  ],
  "post-office.commerce-common.email.subscription.deactivate-consequence-section.what-to-do-question": [
    {
      "type": 0,
      "value": "What do I need to do?"
    }
  ],
  "post-office.commerce-common.email.subscription.description.end-of-trial-with-pde": [
    {
      "type": 0,
      "value": "When your trial ends, we’ll charge the payment method you chose when you signed up."
    }
  ],
  "post-office.commerce-common.email.subscription.downgrade-consequence-section.downgrade-info": [
    {
      "type": 0,
      "value": "If you don’t add payment details you’ll downgrade to the Free plan and lose access to your "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan features."
    }
  ],
  "post-office.commerce-common.email.subscription.downgrade-consequence-section.features-question": [
    {
      "type": 0,
      "value": "Which other features will I lose access to?"
    }
  ],
  "post-office.commerce-common.email.subscription.headline.end-of-trial-with-pde": [
    {
      "type": 0,
      "value": "You don't need to do anything"
    }
  ],
  "post-office.commerce-common.email.subscription.other-features-you-lose.confluence-premium": [
    {
      "type": 0,
      "value": "Comparison between Premium and Free plans. Key differences are unlimited whiteboards, page insights, and access to Rovo on Premium."
    }
  ],
  "post-office.commerce-common.email.subscription.other-features-you-lose.confluence-standard": [
    {
      "type": 0,
      "value": "Comparison between Standard and Free plans. Key differences are unlimited users, page insights, and access to Rovo on Standard."
    }
  ],
  "post-office.commerce-common.email.subscription.other-features-you-lose.jira-premium": [
    {
      "type": 0,
      "value": "Comparison between Premium and Free plans. Key differences are plans for multiple projects, ability to assign roles, and access to Rovo on Premium."
    }
  ],
  "post-office.commerce-common.email.subscription.other-features-you-lose.jira-standard": [
    {
      "type": 0,
      "value": "Comparison between Standard and Free plans. Key differences are unlimited users, ability to assign roles, and access to Rovo on Standard."
    }
  ],
  "post-office.commerce-common.email.subscription.other-features-you-lose.jpd-premium": [
    {
      "type": 0,
      "value": "Comparison between Premium and Free plans. Key differences are roadmaps for multiple spaces, ability to assign roles, and access to Rovo on Premium."
    }
  ],
  "post-office.commerce-common.email.subscription.other-features-you-lose.jpd-standard": [
    {
      "type": 0,
      "value": "Comparison between Standard and Free plans. Key differences are unlimited users and ability to assign roles on Standard."
    }
  ],
  "post-office.commerce-common.email.subscription.payment-details.keep-your-plan": [
    {
      "type": 0,
      "value": "Keep "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan"
    }
  ],
  "post-office.commerce-common.email.subscription.tick-circle-green-icon.end-of-trial-with-pde": [
    {
      "type": 0,
      "value": "Green tick circle icon for the billing section"
    }
  ],
  "post-office.commerce-common.features-image.confluence-premium": [
    {
      "type": 0,
      "value": "Confluence Premium Features"
    }
  ],
  "post-office.commerce-common.features-image.confluence-standard": [
    {
      "type": 0,
      "value": "Confluence Standard Features"
    }
  ],
  "post-office.commerce-common.features-image.jira-premium": [
    {
      "type": 0,
      "value": "Jira Premium Features"
    }
  ],
  "post-office.commerce-common.features-image.jira-product-discovery-premium": [
    {
      "type": 0,
      "value": "Jira Product Discovery Premium Features"
    }
  ],
  "post-office.commerce-common.features-image.jira-product-discovery-standard": [
    {
      "type": 0,
      "value": "Jira Product Discovery Standard Features"
    }
  ],
  "post-office.commerce-common.features-image.jira-service-management-premium": [
    {
      "type": 0,
      "value": "Jira Service Management Premium Features"
    }
  ],
  "post-office.commerce-common.features-image.jira-service-management-standard": [
    {
      "type": 0,
      "value": "Jira Service Management Standard Features"
    }
  ],
  "post-office.commerce-common.features-image.jira-standard": [
    {
      "type": 0,
      "value": "Jira Standard Features"
    }
  ],
  "post-office.commerce-common.features-image.loom-business": [
    {
      "type": 0,
      "value": "Loom Business Features"
    }
  ],
  "post-office.commerce-common.features-image.loom-business-ai": [
    {
      "type": 0,
      "value": "Loom Business + AI Features"
    }
  ],
  "post-office.commerce-common.features-image.service-collection-premium": [
    {
      "type": 0,
      "value": "Service Collection Premium Features"
    }
  ],
  "post-office.commerce-common.features-image.service-collection-standard": [
    {
      "type": 0,
      "value": "Service Collection Standard Features"
    }
  ],
  "post-office.commerce-common.footer-v2.ai-disclaimer": [
    {
      "type": 0,
      "value": "Some content in this email has been generated by AI."
    }
  ],
  "post-office.commerce-common.footer-v2.atlassian-logo-alt": [
    {
      "type": 0,
      "value": "Atlassian"
    }
  ],
  "post-office.commerce-common.footer-v2.copyright": [
    {
      "type": 0,
      "value": "Copyright "
    },
    {
      "type": 1,
      "value": "year"
    },
    {
      "type": 0,
      "value": " Atlassian Pty Ltd. All rights reserved. "
    }
  ],
  "post-office.commerce-common.footer-v2.dot-separator": [
    {
      "type": 0,
      "value": "•"
    }
  ],
  "post-office.commerce-common.footer-v2.facebook-alt-text": [
    {
      "type": 0,
      "value": "Facebook"
    }
  ],
  "post-office.commerce-common.footer-v2.facebook-title": [
    {
      "type": 0,
      "value": "Facebook"
    }
  ],
  "post-office.commerce-common.footer-v2.footer-links.contact-us": [
    {
      "type": 1,
      "value": "contactLink"
    }
  ],
  "post-office.commerce-common.footer-v2.footer-links.privacy-policy": [
    {
      "type": 1,
      "value": "privacyPolicy"
    }
  ],
  "post-office.commerce-common.footer-v2.footer-links.read-our-blog": [
    {
      "type": 1,
      "value": "thirdText"
    }
  ],
  "post-office.commerce-common.footer-v2.linkedin-alt-text": [
    {
      "type": 0,
      "value": "LinkedIn"
    }
  ],
  "post-office.commerce-common.footer-v2.linkedin-title": [
    {
      "type": 0,
      "value": "LinkedIn"
    }
  ],
  "post-office.commerce-common.footer-v2.office-address": [
    {
      "type": 0,
      "value": "341 George Street, Sydney, NSW, 2000, Australia"
    }
  ],
  "post-office.commerce-common.footer-v2.partner-portal": [
    {
      "type": 0,
      "value": "Partner Portal"
    }
  ],
  "post-office.commerce-common.footer-v2.privacy-policy": [
    {
      "type": 0,
      "value": "Privacy Policy"
    }
  ],
  "post-office.commerce-common.footer-v2.read-our-blog": [
    {
      "type": 0,
      "value": "Read our blog"
    }
  ],
  "post-office.commerce-common.footer-v2.unsubscribe": [
    {
      "children": [
        {
          "type": 0,
          "value": "Unsubscribe"
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": " to opt out of future emails like this"
    }
  ],
  "post-office.commerce-common.footer-v2.x-alt-text": [
    {
      "type": 0,
      "value": "X"
    }
  ],
  "post-office.commerce-common.footer-v2.x-title": [
    {
      "type": 0,
      "value": "X"
    }
  ],
  "post-office.commerce-common.footer-v2.youtube-alt-text": [
    {
      "type": 0,
      "value": "Youtube"
    }
  ],
  "post-office.commerce-common.footer-v2.youtube-title": [
    {
      "type": 0,
      "value": "Youtube"
    }
  ],
  "post-office.commerce-common.footer.atlassian-logo-alt": [
    {
      "type": 0,
      "value": "Atlassian"
    }
  ],
  "post-office.commerce-common.footer.contact-us": [
    {
      "type": 0,
      "value": " Contact us • "
    }
  ],
  "post-office.commerce-common.footer.copyright": [
    {
      "type": 0,
      "value": "Copyright "
    },
    {
      "type": 1,
      "value": "year"
    },
    {
      "type": 0,
      "value": " Atlassian Pty Ltd. All rights reserved. "
    }
  ],
  "post-office.commerce-common.footer.facebook-alt-text": [
    {
      "type": 0,
      "value": "Facebook"
    }
  ],
  "post-office.commerce-common.footer.facebook-title": [
    {
      "type": 0,
      "value": "Facebook"
    }
  ],
  "post-office.commerce-common.footer.footer-links.contact-us": [
    {
      "type": 1,
      "value": "contactLink"
    }
  ],
  "post-office.commerce-common.footer.footer-links.privacy-policy": [
    {
      "type": 1,
      "value": "privacyPolicy"
    }
  ],
  "post-office.commerce-common.footer.footer-links.read-our-blog": [
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "thirdText"
    }
  ],
  "post-office.commerce-common.footer.linkedin-alt-text": [
    {
      "type": 0,
      "value": "LinkedIn"
    }
  ],
  "post-office.commerce-common.footer.linkedin-title": [
    {
      "type": 0,
      "value": "LinkedIn"
    }
  ],
  "post-office.commerce-common.footer.office-address": [
    {
      "type": 0,
      "value": "341 George Street, Sydney, NSW, 2000, Australia"
    }
  ],
  "post-office.commerce-common.footer.office-address.we-are-located-at": [
    {
      "type": 0,
      "value": "We are located at "
    }
  ],
  "post-office.commerce-common.footer.partner-portal": [
    {
      "type": 0,
      "value": "Partner Portal"
    }
  ],
  "post-office.commerce-common.footer.privacy-policy": [
    {
      "type": 0,
      "value": "Privacy Policy • "
    }
  ],
  "post-office.commerce-common.footer.read-our-blog": [
    {
      "type": 0,
      "value": "Read our blog"
    }
  ],
  "post-office.commerce-common.footer.twitter-alt-text": [
    {
      "type": 0,
      "value": "Twitter"
    }
  ],
  "post-office.commerce-common.footer.twitter-title": [
    {
      "type": 0,
      "value": "Twitter"
    }
  ],
  "post-office.commerce-common.formal-goodbye": [
    {
      "type": 0,
      "value": "Please "
    },
    {
      "type": 1,
      "value": "contactUsLink"
    },
    {
      "type": 0,
      "value": " with any questions, we're always happy to help."
    }
  ],
  "post-office.commerce-common.formal-goodbye.contact-representative": [
    {
      "type": 0,
      "value": "Contact your Atlassian representative if you have any questions."
    }
  ],
  "post-office.commerce-common.formal-thank-you": [
    {
      "type": 0,
      "value": "Thank you for taking action at your earliest convenience."
    }
  ],
  "post-office.commerce-common.get-in-touch": [
    {
      "type": 0,
      "value": "Have a question? We're here to help. "
    },
    {
      "type": 1,
      "value": "getInTouchLink"
    }
  ],
  "post-office.commerce-common.need-help-with-contact-us": [
    {
      "type": 0,
      "value": "Need help with plans and billing? "
    },
    {
      "type": 1,
      "value": "contactUs"
    }
  ],
  "post-office.commerce-common.not-personal-greetings": [
    {
      "type": 0,
      "value": "Hi,"
    }
  ],
  "post-office.commerce-common.payment-details.add": [
    {
      "type": 0,
      "value": "Add payment details"
    }
  ],
  "post-office.commerce-common.payment-details.add.v2": [
    {
      "type": 0,
      "value": "explore your plan options"
    }
  ],
  "post-office.commerce-common.payment-details.update": [
    {
      "type": 0,
      "value": "Update payment details"
    }
  ],
  "post-office.commerce-common.personal-greetings": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "post-office.commerce-common.product.entitlement-number.billing-cycle": [
    {
      "type": 0,
      "value": "Billing cycle: "
    },
    {
      "type": 1,
      "value": "billingCycle"
    }
  ],
  "post-office.commerce-common.product.entitlement-number.requested-by-email-id": [
    {
      "type": 0,
      "value": "Requested by: "
    },
    {
      "type": 1,
      "value": "requestedByEmailId"
    }
  ],
  "post-office.commerce-common.product.entitlement-number.site-url.no-translate": [
    {
      "options": {
        "other": {
          "value": [
            {
              "type": 1,
              "value": "entitlementNumber"
            }
          ]
        },
        "true": {
          "value": [
            {
              "type": 1,
              "value": "entitlementNumber"
            },
            {
              "type": 0,
              "value": " | "
            },
            {
              "type": 1,
              "value": "siteUrl"
            }
          ]
        }
      },
      "type": 5,
      "value": "hasSiteUrl"
    }
  ],
  "post-office.commerce-common.product.entitlement-number.users-count": [
    {
      "type": 1,
      "value": "chargeElement"
    },
    {
      "type": 0,
      "value": "s: "
    },
    {
      "type": 1,
      "value": "usersCount"
    }
  ],
  "post-office.commerce-common.product.product-title.no-translate": [
    {
      "options": {
        "other": {
          "value": [
            {
              "type": 1,
              "value": "productName"
            }
          ]
        },
        "true": {
          "value": [
            {
              "type": 1,
              "value": "productName"
            },
            {
              "type": 0,
              "value": " ("
            },
            {
              "type": 1,
              "value": "offeringName"
            },
            {
              "type": 0,
              "value": ")"
            }
          ]
        }
      },
      "type": 5,
      "value": "hasOfferingName"
    }
  ],
  "post-office.commerce-common.subscription-context.cbp-allowance-detail-asset-credits": [
    {
      "children": [
        {
          "type": 0,
          "value": "Assets objects:"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "value"
    }
  ],
  "post-office.commerce-common.subscription-context.cbp-allowance-detail-asset-credits-with-unit": [
    {
      "children": [
        {
          "type": 0,
          "value": "Assets objects:"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "unit"
    }
  ],
  "post-office.commerce-common.subscription-context.cbp-allowance-detail-automation-credits": [
    {
      "children": [
        {
          "type": 0,
          "value": "Automation steps:"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": "/month"
    }
  ],
  "post-office.commerce-common.subscription-context.cbp-allowance-detail-automation-credits-with-unit": [
    {
      "children": [
        {
          "type": 0,
          "value": "Automation steps:"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "unit"
    },
    {
      "type": 0,
      "value": "/month"
    }
  ],
  "post-office.commerce-common.subscription-context.cbp-allowance-detail-bitbucket-build-time": [
    {
      "children": [
        {
          "type": 0,
          "value": "Bitbucket build minutes:"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": "/month"
    }
  ],
  "post-office.commerce-common.subscription-context.cbp-allowance-detail-bitbucket-build-time-with-unit": [
    {
      "children": [
        {
          "type": 0,
          "value": "Bitbucket build minutes:"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "unit"
    },
    {
      "type": 0,
      "value": "/month"
    }
  ],
  "post-office.commerce-common.subscription-context.cbp-allowance-detail-bitbucket-lfs-storage": [
    {
      "children": [
        {
          "type": 0,
          "value": "Bitbucket Git LFS:"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "value"
    }
  ],
  "post-office.commerce-common.subscription-context.cbp-allowance-detail-bitbucket-lfs-storage-with-unit": [
    {
      "children": [
        {
          "type": 0,
          "value": "Bitbucket Git LFS:"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "unit"
    }
  ],
  "post-office.commerce-common.subscription-context.cbp-allowance-detail-bitbucket-package-network": [
    {
      "children": [
        {
          "type": 0,
          "value": "Bitbucket package network:"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": "/month"
    }
  ],
  "post-office.commerce-common.subscription-context.cbp-allowance-detail-bitbucket-package-network-with-unit": [
    {
      "children": [
        {
          "type": 0,
          "value": "Bitbucket package network:"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "unit"
    },
    {
      "type": 0,
      "value": "/month"
    }
  ],
  "post-office.commerce-common.subscription-context.cbp-allowance-detail-bitbucket-package-storage": [
    {
      "children": [
        {
          "type": 0,
          "value": "Bitbucket package storage:"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "value"
    }
  ],
  "post-office.commerce-common.subscription-context.cbp-allowance-detail-bitbucket-package-storage-with-unit": [
    {
      "children": [
        {
          "type": 0,
          "value": "Bitbucket package storage:"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "unit"
    }
  ],
  "post-office.commerce-common.subscription-context.cbp-allowance-detail-build-time": [
    {
      "children": [
        {
          "type": 0,
          "value": "Bitbucket build minutes:"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "value"
    }
  ],
  "post-office.commerce-common.subscription-context.cbp-allowance-detail-build-time-with-unit": [
    {
      "children": [
        {
          "type": 0,
          "value": "Bitbucket build minutes:"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "unit"
    }
  ],
  "post-office.commerce-common.subscription-context.cbp-allowance-detail-csm-resolution": [
    {
      "children": [
        {
          "type": 0,
          "value": "AI agent resolutions:"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": "/month"
    }
  ],
  "post-office.commerce-common.subscription-context.cbp-allowance-detail-csm-resolution-with-unit": [
    {
      "children": [
        {
          "type": 0,
          "value": "AI agent resolutions:"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "unit"
    },
    {
      "type": 0,
      "value": "/month"
    }
  ],
  "post-office.commerce-common.subscription-context.cbp-allowance-detail-indexed-objects": [
    {
      "children": [
        {
          "type": 0,
          "value": "Indexed objects:"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": "/month"
    }
  ],
  "post-office.commerce-common.subscription-context.cbp-allowance-detail-indexed-objects-with-unit": [
    {
      "children": [
        {
          "type": 0,
          "value": "Indexed objects:"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "unit"
    },
    {
      "type": 0,
      "value": "/month"
    }
  ],
  "post-office.commerce-common.subscription-context.cbp-allowance-detail-lfs-storage": [
    {
      "children": [
        {
          "type": 0,
          "value": "Bitbucket Git LFS:"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "value"
    }
  ],
  "post-office.commerce-common.subscription-context.cbp-allowance-detail-lfs-storage-with-unit": [
    {
      "children": [
        {
          "type": 0,
          "value": "Bitbucket Git LFS:"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "unit"
    }
  ],
  "post-office.commerce-common.subscription-context.cbp-allowance-detail-package-network": [
    {
      "children": [
        {
          "type": 0,
          "value": "Bitbucket package network:"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "value"
    }
  ],
  "post-office.commerce-common.subscription-context.cbp-allowance-detail-package-network-with-unit": [
    {
      "children": [
        {
          "type": 0,
          "value": "Bitbucket package network:"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "unit"
    }
  ],
  "post-office.commerce-common.subscription-context.cbp-allowance-detail-package-storage": [
    {
      "children": [
        {
          "type": 0,
          "value": "Bitbucket package storage:"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "value"
    }
  ],
  "post-office.commerce-common.subscription-context.cbp-allowance-detail-package-storage-with-unit": [
    {
      "children": [
        {
          "type": 0,
          "value": "Bitbucket package storage:"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "unit"
    }
  ],
  "post-office.commerce-common.subscription-context.cbp-allowance-detail-rovo-dev-credits": [
    {
      "children": [
        {
          "type": 0,
          "value": "Rovo credits:"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": "/month"
    }
  ],
  "post-office.commerce-common.subscription-context.cbp-allowance-detail-rovo-dev-credits-with-unit": [
    {
      "children": [
        {
          "type": 0,
          "value": "Rovo credits:"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "unit"
    },
    {
      "type": 0,
      "value": "/month"
    }
  ],
  "post-office.commerce-common.subscription-context.cbp-allowance-detail-runners-concurrency-limit": [
    {
      "children": [
        {
          "type": 0,
          "value": "Pipeline runners:"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "value"
    }
  ],
  "post-office.commerce-common.subscription-context.cbp-allowance-detail-runners-concurrency-limit-with-unit": [
    {
      "children": [
        {
          "type": 0,
          "value": "Pipeline runners:"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "unit"
    }
  ],
  "post-office.commerce-common.subscription-product-details.bill-estimate-and-currency": [
    {
      "type": 1,
      "value": "currency"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "amountExcludingTax"
    }
  ],
  "post-office.commerce-common.subscription-product-details.bill-estimate-title": [
    {
      "type": 0,
      "value": "Total bill estimate"
    }
  ],
  "post-office.commerce-common.subscription-product-details.entitlement-number.no-translate": [
    {
      "type": 1,
      "value": "entitlementNumber"
    }
  ],
  "post-office.commerce-common.subscription-product-details.exclude-taxes": [
    {
      "type": 0,
      "value": "(excludes taxes)"
    }
  ],
  "post-office.commerce-common.subscription-product-details.offering-name.user-size.billing-cycle.no-translate": [
    {
      "type": 1,
      "value": "siteDetails"
    }
  ],
  "post-office.commerce-common.subscription-product-details.product-name.no-translate": [
    {
      "type": 1,
      "value": "productName"
    }
  ],
  "post-office.commerce-common.subscription-product-details.site-url.no-translate": [
    {
      "type": 1,
      "value": "siteURL"
    }
  ],
  "post-office.commerce-common.subscription.atlassian-guard-standard": [
    {
      "type": 0,
      "value": "Atlassian Guard Standard"
    }
  ],
  "post-office.commerce-common.subscription.atlassian-rovo": [
    {
      "type": 0,
      "value": "Atlassian Rovo"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-asset-credits": [
    {
      "type": 0,
      "value": "Assets objects: "
    },
    {
      "type": 1,
      "value": "value"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-asset-credits-label": [
    {
      "type": 0,
      "value": "Assets objects"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-asset-credits-with-unit": [
    {
      "type": 0,
      "value": "Assets objects: "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "unit"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-automation-credits": [
    {
      "type": 0,
      "value": "Automation steps: "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": "/month"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-automation-credits-label": [
    {
      "type": 0,
      "value": "Automation steps"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-automation-credits-with-unit": [
    {
      "type": 0,
      "value": "Automation steps: "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "unit"
    },
    {
      "type": 0,
      "value": "/month"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-build-time": [
    {
      "type": 0,
      "value": "Bitbucket build minutes: "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": "/month"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-build-time-label": [
    {
      "type": 0,
      "value": "Bitbucket build minutes"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-build-time-with-unit": [
    {
      "type": 0,
      "value": "Bitbucket build minutes: "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "unit"
    },
    {
      "type": 0,
      "value": "/month"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-lfs-storage": [
    {
      "type": 0,
      "value": "Bitbucket Git LFS: "
    },
    {
      "type": 1,
      "value": "value"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-lfs-storage-label": [
    {
      "type": 0,
      "value": "Bitbucket Git LFS"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-lfs-storage-with-unit": [
    {
      "type": 0,
      "value": "Bitbucket Git LFS: "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "unit"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-package-network": [
    {
      "type": 0,
      "value": "Bitbucket package network: "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": "/month"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-package-network-label": [
    {
      "type": 0,
      "value": "Bitbucket package network"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-package-network-with-unit": [
    {
      "type": 0,
      "value": "Bitbucket package network: "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "unit"
    },
    {
      "type": 0,
      "value": "/month"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-package-storage": [
    {
      "type": 0,
      "value": "Bitbucket package storage: "
    },
    {
      "type": 1,
      "value": "value"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-package-storage-label": [
    {
      "type": 0,
      "value": "Bitbucket package storage"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-package-storage-with-unit": [
    {
      "type": 0,
      "value": "Bitbucket package storage: "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "unit"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-build-time": [
    {
      "type": 0,
      "value": "Bitbucket build minutes: "
    },
    {
      "type": 1,
      "value": "value"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-build-time-label": [
    {
      "type": 0,
      "value": "Bitbucket build minutes"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-build-time-with-unit": [
    {
      "type": 0,
      "value": "Bitbucket build minutes: "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "unit"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-csm-resolution": [
    {
      "type": 0,
      "value": "AI agent resolutions: "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": "/month"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-csm-resolution-label": [
    {
      "type": 0,
      "value": "AI agent resolutions"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-csm-resolution-with-unit": [
    {
      "type": 0,
      "value": "AI agent resolutions: "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "unit"
    },
    {
      "type": 0,
      "value": "/month"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-default-value-with-unit": [
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "unit"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-indexed-objects": [
    {
      "type": 0,
      "value": "Indexed objects: "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": "/month"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-indexed-objects-label": [
    {
      "type": 0,
      "value": "Indexed objects"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-indexed-objects-with-unit": [
    {
      "type": 0,
      "value": "Indexed objects: "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "unit"
    },
    {
      "type": 0,
      "value": "/month"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-lfs-storage": [
    {
      "type": 0,
      "value": "Bitbucket Git LFS: "
    },
    {
      "type": 1,
      "value": "value"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-lfs-storage-label": [
    {
      "type": 0,
      "value": "Bitbucket Git LFS"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-lfs-storage-with-unit": [
    {
      "type": 0,
      "value": "Bitbucket Git LFS: "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "unit"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-package-network": [
    {
      "type": 0,
      "value": "Bitbucket package network: "
    },
    {
      "type": 1,
      "value": "value"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-package-network-label": [
    {
      "type": 0,
      "value": "Bitbucket package network"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-package-network-with-unit": [
    {
      "type": 0,
      "value": "Bitbucket package network: "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "unit"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-package-storage": [
    {
      "type": 0,
      "value": "Bitbucket package storage: "
    },
    {
      "type": 1,
      "value": "value"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-package-storage-label": [
    {
      "type": 0,
      "value": "Bitbucket package storage"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-package-storage-with-unit": [
    {
      "type": 0,
      "value": "Bitbucket package storage: "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "unit"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-per-month-value": [
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": " / month"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-per-month-value-with-unit": [
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "unit"
    },
    {
      "type": 0,
      "value": " / month"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-per-user-per-month-value": [
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": " per user / month"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-per-user-per-month-value-with-unit": [
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "unit"
    },
    {
      "type": 0,
      "value": " per user / month"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-rovo-dev-credits": [
    {
      "type": 0,
      "value": "Rovo credits: "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": "/month"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-rovo-dev-credits-label": [
    {
      "type": 0,
      "value": "Rovo credits"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-rovo-dev-credits-with-unit": [
    {
      "type": 0,
      "value": "Rovo credits: "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "unit"
    },
    {
      "type": 0,
      "value": "/month"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-runners-concurrency-limit": [
    {
      "type": 0,
      "value": "Pipeline runners: "
    },
    {
      "type": 1,
      "value": "value"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-runners-concurrency-limit-label": [
    {
      "type": 0,
      "value": "Pipeline runners"
    }
  ],
  "post-office.commerce-common.subscription.cbp-allowance-detail-runners-concurrency-limit-with-unit": [
    {
      "type": 0,
      "value": "Pipeline runners: "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "unit"
    }
  ],
  "post-office.commerce-common.subscription.cbp-charge-element-package-network": [
    {
      "children": [
        {
          "type": 0,
          "value": "Network traffic:"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "unit"
    }
  ],
  "post-office.commerce-common.subscription.cbp-charge-element-package-storage": [
    {
      "children": [
        {
          "type": 0,
          "value": "Package storage:"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "unit"
    }
  ],
  "post-office.commerce-common.subscription.cbp-charge-element-rovo-dev-credits": [
    {
      "children": [
        {
          "type": 0,
          "value": "Rovo Dev credits:"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": " credits per user"
    }
  ],
  "post-office.commerce-common.subscription.cbp-charge-element-runners": [
    {
      "children": [
        {
          "type": 0,
          "value": "Pipeline runners:"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "unit"
    }
  ],
  "post-office.commerce-common.subscription.cbp-charge-element-storage": [
    {
      "children": [
        {
          "type": 0,
          "value": "Storage (Git LFS):"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "unit"
    }
  ],
  "post-office.commerce-common.subscription.cbp-charge-element-storage-minutes": [
    {
      "children": [
        {
          "type": 0,
          "value": "Build minutes:"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "value"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "unit"
    }
  ],
  "post-office.commerce-common.subscription.free-access": [
    {
      "type": 0,
      "value": "Free access to:"
    }
  ],
  "post-office.commerce-common.subscription.included-apps": [
    {
      "type": 0,
      "value": "Included apps:"
    }
  ],
  "post-office.commerce-common.subscription.pooled-allocation.per-user-month": [
    {
      "type": 1,
      "value": "credits"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "chargeElementName"
    },
    {
      "type": 0,
      "value": " per user/month"
    }
  ],
  "post-office.commerce-common.subscription.product-title.no-translate": [
    {
      "type": 1,
      "value": "productName"
    }
  ],
  "post-office.commerce-common.subscription.product.billing-admin-partner-contextual-info.address.no-translate": [
    {
      "type": 0,
      "value": "Address: "
    },
    {
      "type": 1,
      "value": "address"
    }
  ],
  "post-office.commerce-common.subscription.product.billing-admin-partner-contextual-info.company.no-translate": [
    {
      "type": 0,
      "value": "Company: "
    },
    {
      "type": 1,
      "value": "companyName"
    }
  ],
  "post-office.commerce-common.subscription.product.billing-admin-partner-contextual-info.customer-contact.no-translate": [
    {
      "type": 0,
      "value": "Customer contact: "
    },
    {
      "type": 1,
      "value": "customerContact"
    }
  ],
  "post-office.commerce-common.subscription.product.billing-cycle.no-translate": [
    {
      "type": 0,
      "value": "| "
    },
    {
      "type": 1,
      "value": "billingCycle"
    }
  ],
  "post-office.commerce-common.subscription.product.billing-user-partner-contextual-info.partner-name.no-translate": [
    {
      "type": 0,
      "value": "Atlassian billing partner: "
    },
    {
      "type": 1,
      "value": "billingPartner"
    }
  ],
  "post-office.commerce-common.subscription.product.charge quantities.no-translate": [
    {
      "type": 0,
      "value": "| "
    },
    {
      "type": 1,
      "value": "usageQuantity"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "chargeElement"
    },
    {
      "type": 0,
      "value": "s "
    }
  ],
  "post-office.commerce-common.subscription.product.entitlement-number.no-translate": [
    {
      "type": 1,
      "value": "entitlementNumber"
    }
  ],
  "post-office.commerce-common.subscription.product.offering-name.no-translate": [
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " "
    }
  ],
  "post-office.commerce-common.subscription.product.site-url.no-translate": [
    {
      "type": 1,
      "value": "siteUrl"
    }
  ],
  "post-office.commerce-common.subscription.rovo-dev-credit-allocation.per-user": [
    {
      "type": 1,
      "value": "credits"
    },
    {
      "type": 0,
      "value": " Rovo Dev credits per user"
    }
  ],
  "post-office.commerce-common.subscriptions-change-plan": [
    {
      "type": 0,
      "value": "Subscriptions"
    }
  ],
  "post-office.commerce-common.subscriptions.excludes-taxes": [
    {
      "type": 0,
      "value": "(excludes taxes)"
    }
  ],
  "post-office.commerce-common.subscriptions.this-payment-is-for": [
    {
      "type": 0,
      "value": "This payment is for:"
    }
  ],
  "post-office.commerce-common.subscriptions.total-bill-estimate": [
    {
      "type": 0,
      "value": "Total bill estimate:"
    }
  ],
  "post-office.commerce-common.subscriptions.total-bill-estimate-after-trial": [
    {
      "type": 0,
      "value": "Total bill estimate after trial ends:"
    }
  ],
  "post-office.commerce-common.subscriptions.your-estimated-bill-is": [
    {
      "type": 0,
      "value": "Your estimated bill is:"
    }
  ],
  "post-office.commerce-common.the-atlassian-team": [
    {
      "type": 0,
      "value": "The Atlassian team"
    }
  ],
  "post-office.commerce-common.view-subscription.billing-console": [
    {
      "type": 0,
      "value": "View subscription"
    }
  ],
  "post-office.commerce-decoupled-offering-ccp.button.review-bill": [
    {
      "type": 0,
      "value": "Review your new bill"
    }
  ],
  "post-office.commerce-decoupled-offering-ccp.marketplace-details-guide": [
    {
      "type": 0,
      "value": "how Marketplace apps are billed"
    }
  ],
  "post-office.commerce-order-fulfilled-ccp.email.billing-account.other-host-type": [
    {
      "type": 0,
      "value": "billing account"
    }
  ],
  "post-office.commerce-order-fulfilled-ccp.email.billing-url": [
    {
      "type": 1,
      "value": "url"
    }
  ],
  "post-office.commerce-order-fulfilled-ccp.email.cmk.support-url": [
    {
      "type": 0,
      "value": "page"
    }
  ],
  "post-office.commerce-order-fulfilled-ccp.email.direct-customer.get-started": [
    {
      "type": 0,
      "value": "get started"
    }
  ],
  "post-office.commerce-order-fulfilled-ccp.email.siteAdmin.cloud": [
    {
      "type": 0,
      "value": "site’s "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Administration"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "post-office.commerce-order-fulfilled-ccp.email.support-url": [
    {
      "type": 0,
      "value": "billing support"
    }
  ],
  "post-office.commerce-order-fulfilled-from-quote-ccp.email.billing-url": [
    {
      "type": 1,
      "value": "url"
    }
  ],
  "post-office.commerce-order-fulfilled-from-quote-ccp.email.get-started": [
    {
      "type": 0,
      "value": "get started"
    }
  ],
  "post-office.commerce-order-fulfilled-from-quote-ccp.email.siteAdmin": [
    {
      "type": 0,
      "value": "Administration"
    }
  ],
  "post-office.commerce-order-fulfilled-from-quote-ccp.email.support-url": [
    {
      "type": 1,
      "value": "url"
    }
  ],
  "post-office.commerce-order-fulfilled-from-quote-ccp.email.view-quote-url": [
    {
      "type": 0,
      "value": "Learn more"
    }
  ],
  "post-office.commerce-payment-failure-hams.email.support.additional_actions": [
    {
      "type": 0,
      "value": "additional actions"
    }
  ],
  "post-office.commerce-payment-failure-hams.email.title.check-payment-details": [
    {
      "type": 0,
      "value": "Action needed: Please update your payment details"
    }
  ],
  "post-office.commerce-payment-failure-hams.email.title.expiration": [
    {
      "type": 0,
      "value": "This doesn't have to be a goodbye"
    }
  ],
  "post-office.commerce-payment-failure-hams.email.title.expired": [
    {
      "type": 0,
      "value": "Your Atlassian subscription has expired"
    }
  ],
  "post-office.commerce-payment-failure-hams.email.title.make-it-official": [
    {
      "type": 0,
      "value": "Let's make it official!"
    }
  ],
  "post-office.commerce-payment-failure-hams.email.title.trial-check-payment-details": [
    {
      "type": 0,
      "value": "Action needed: Please update your payment details"
    }
  ],
  "post-office.commerce-payment-failure-hams.email.title.trial-end": [
    {
      "type": 0,
      "value": "Your trial has ended. What's next?"
    }
  ],
  "post-office.commerce-subscription-auto-downgrade-ccp.bac-banner.body": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " has been downgraded to the Free plan."
    }
  ],
  "post-office.commerce-subscription-auto-downgrade-ccp.bac-banner.restore-plan": [
    {
      "type": 0,
      "value": "Restore "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan"
    }
  ],
  "post-office.commerce-subscription-auto-downgrade-ccp.bac-banner.title": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " trial has ended"
    }
  ],
  "post-office.commerce-subscription-paid-trials-auto-conversion-off-ccp.email.partner.set-up": [
    {
      "type": 0,
      "value": "set up the collection"
    }
  ],
  "post-office.commerce-subscription-paid-trials-ccp.email.direct-customer.set-up": [
    {
      "type": 0,
      "value": "set up your collection"
    }
  ],
  "post-office.commerce-subscription-paid-trials-ccp.email.partner.set-up": [
    {
      "type": 0,
      "value": "sets up the collection"
    }
  ],
  "post-office.commerce.star-email-template.body.agent-limit": [
    {
      "type": 0,
      "value": "Get "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "unlimited agents"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "250 GB file storage"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "post-office.commerce.star-email-template.body.ai-triage": [
    {
      "type": 0,
      "value": "Use "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "AI"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " to triage requests from portal, email, and chat"
    }
  ],
  "post-office.commerce.star-email-template.body.ai-written-support": [
    {
      "type": 0,
      "value": "Power your Rovo agent with "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "AI written support articles"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "post-office.commerce.star-email-template.body.assets": [
    {
      "type": 0,
      "value": "Track business "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "assets"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " and link them to work items"
    }
  ],
  "post-office.commerce.star-email-template.body.auto": [
    {
      "type": 0,
      "value": "You've reached the agent limit for your Free plan, so we've upgraded you to our "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "14-day free trial"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " of the "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Standard"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " plan."
    }
  ],
  "post-office.commerce.star-email-template.body.auto.change-your-mind": [
    {
      "type": 0,
      "value": "If you change your mind, get refunded in the first 30 days of your purchase. You can also "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "cancel or switch back to the Free plan"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " anytime by reducing your usage to be within its limits."
    }
  ],
  "post-office.commerce.star-email-template.body.auto.storage": [
    {
      "type": 0,
      "value": "You've reached the 2 GB storage limit for your Free plan, so we've upgraded you to our "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "14-day free trial"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " of the "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Standard"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " plan."
    }
  ],
  "post-office.commerce.star-email-template.body.billing-date-with-pde": [
    {
      "type": 0,
      "value": "You won't be charged until your next billing date on "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "nextBillTimestamp"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ". We'll remind you 3 days before your trial ends."
    }
  ],
  "post-office.commerce.star-email-template.body.billing-date-without-pde": [
    {
      "type": 0,
      "value": "To continue with Standard, add payment details by "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "nextBillTimestamp"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ". We'll remind you 3 days before your trial ends."
    }
  ],
  "post-office.commerce.star-email-template.body.direct": [
    {
      "type": 0,
      "value": "You're currently on a "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "14-day free trial"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " of our "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Standard plan"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ". Dive in to manage requests, incidents, changes and assets. All in one place, with the power of AI."
    }
  ],
  "post-office.commerce.star-email-template.body.manual": [
    {
      "type": 0,
      "value": "Enjoy your "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "14-day free trial"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " of our "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Standard plan"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " with brand new benefits like AI, Assets, higher automation limits and unlimited agents."
    }
  ],
  "post-office.commerce.star-email-template.body.manual-direct.change-your-mind": [
    {
      "type": 0,
      "value": "If you change your mind, get refunded in the first 30 days of your purchase. You can also "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "cancel or switch back to the Free plan"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " anytime."
    }
  ],
  "post-office.commerce.star-email-template.body.rovo-ai-agents": [
    {
      "type": 0,
      "value": "Resolve requests and incidents faster with "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Rovo AI agents"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "post-office.commerce.star-email-template.body.rovo-ai-agents-direct": [
    {
      "type": 0,
      "value": "Resolve requests and incidents faster with "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "AI agents"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "post-office.commerce.star-email-template.button.explore-standard-direct": [
    {
      "type": 0,
      "value": "Explore your new service space"
    }
  ],
  "post-office.commerce.star-email-template.button.explore-standard-manual-auto": [
    {
      "type": 0,
      "value": "Explore Standard"
    }
  ],
  "post-office.commerce.star-email-template.caption.add-payment-details-button": [
    {
      "type": 0,
      "value": "Add Payment Details"
    }
  ],
  "post-office.commerce.star-email-template.caption.billing": [
    {
      "type": 0,
      "value": "What happens to your billing?"
    }
  ],
  "post-office.commerce.star-email-template.caption.heading.auto": [
    {
      "type": 0,
      "value": "👋 Say hello to unlimited agents"
    }
  ],
  "post-office.commerce.star-email-template.caption.heading.auto.storage": [
    {
      "type": 0,
      "value": "👋 Say hello to more storage"
    }
  ],
  "post-office.commerce.star-email-template.caption.heading.welcome.manual-direct": [
    {
      "type": 0,
      "value": "🎉 Welcome to Service Collection Standard"
    }
  ],
  "post-office.commerce.star-email-template.link.explore-plans": [
    {
      "type": 0,
      "value": "Explore all plans"
    }
  ],
  "post-office.commerce.star-email-template.subject.auto-upgrade": [
    {
      "type": 0,
      "value": "You've been upgraded to our Standard plan - free for 14 days"
    }
  ],
  "post-office.commerce.star-email-template.subject.direct-trial": [
    {
      "type": 0,
      "value": "Welcome to your Service Collection "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan!"
    }
  ],
  "post-office.commerce.star-email-template.subject.manual-trial": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " day"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " days"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "trialDaysLeft"
    },
    {
      "type": 0,
      "value": " free trial of our "
    },
    {
      "type": 1,
      "value": "offeringName"
    },
    {
      "type": 0,
      "value": " plan has started"
    }
  ],
  "post-office.commerce.star-email-template.subscription.excludes-taxes": [
    {
      "type": 0,
      "value": "(Excludes Taxes)"
    }
  ],
  "post-office.commerce.star-email-template.subscription.header": [
    {
      "type": 0,
      "value": "Subscription Details"
    }
  ],
  "post-office.commerce.star-email-template.subscription.header-no-payment": [
    {
      "type": 0,
      "value": "Trial details"
    }
  ],
  "post-office.commerce.star-email-template.subscription.included-apps": [
    {
      "type": 0,
      "value": "Included apps:"
    }
  ],
  "post-office.commerce.star-email-template.subscription.next-bill-date": [
    {
      "type": 0,
      "value": "Next bill date"
    }
  ],
  "post-office.commerce.star-email-template.subscription.next-bill-estimate": [
    {
      "type": 0,
      "value": "Next bill estimate"
    }
  ],
  "post-office.commerce.star-email-template.subscription.next-bill-estimate-no-payment": [
    {
      "type": 0,
      "value": "Estimated first bill"
    }
  ],
  "post-office.commerce.star-email-template.subscription.trial-end-date": [
    {
      "type": 0,
      "value": "Trial ends"
    }
  ],
  "post-office.commerce.star-email-template.subscription.users": [
    {
      "type": 1,
      "value": "count"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 0,
              "value": "user"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "users"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    }
  ],
  "post-office.star-email-template.email-header-alt": [
    {
      "type": 0,
      "value": "Service Collection"
    }
  ],
  "post-office.star-email-template.email-header-subtitle": [
    {
      "type": 0,
      "value": "Includes:"
    }
  ],
  "post-office.star-email-template.footer.ai-disclaimer": [
    {
      "type": 0,
      "value": "Some content in this email has been generated by AI."
    }
  ],
  "post-office.star-email-template.footer.atlassian-logo-alt": [
    {
      "type": 0,
      "value": "Atlassian"
    }
  ],
  "post-office.star-email-template.footer.copyright": [
    {
      "type": 0,
      "value": "Copyright "
    },
    {
      "type": 1,
      "value": "year"
    },
    {
      "type": 0,
      "value": " Atlassian Pty Ltd. All rights reserved. "
    }
  ],
  "post-office.star-email-template.footer.dot-separator": [
    {
      "type": 0,
      "value": "•"
    }
  ],
  "post-office.star-email-template.footer.facebook-alt-text": [
    {
      "type": 0,
      "value": "Facebook"
    }
  ],
  "post-office.star-email-template.footer.facebook-title": [
    {
      "type": 0,
      "value": "Facebook"
    }
  ],
  "post-office.star-email-template.footer.linkedin-alt-text": [
    {
      "type": 0,
      "value": "LinkedIn"
    }
  ],
  "post-office.star-email-template.footer.linkedin-title": [
    {
      "type": 0,
      "value": "LinkedIn"
    }
  ],
  "post-office.star-email-template.footer.office-address": [
    {
      "type": 0,
      "value": "341 George Street, Sydney, NSW, 2000, Australia"
    }
  ],
  "post-office.star-email-template.footer.partner-portal": [
    {
      "type": 0,
      "value": "Partner Portal"
    }
  ],
  "post-office.star-email-template.footer.privacy-policy": [
    {
      "type": 0,
      "value": "Privacy Policy"
    }
  ],
  "post-office.star-email-template.footer.read-our-blog": [
    {
      "type": 0,
      "value": "Read our blog"
    }
  ],
  "post-office.star-email-template.footer.unsubscribe": [
    {
      "children": [
        {
          "type": 0,
          "value": "Unsubscribe"
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": " to opt out of future emails like this"
    }
  ],
  "post-office.star-email-template.footer.x-alt-text": [
    {
      "type": 0,
      "value": "X"
    }
  ],
  "post-office.star-email-template.footer.x-title": [
    {
      "type": 0,
      "value": "X"
    }
  ],
  "post-office.star-email-template.footer.youtube-alt-text": [
    {
      "type": 0,
      "value": "Youtube"
    }
  ],
  "post-office.star-email-template.footer.youtube-title": [
    {
      "type": 0,
      "value": "Youtube"
    }
  ]
}